var _defineProperty = require("/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/createClass");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/*! For license information please see georaster-layer-for-leaflet.min.js.LICENSE.txt */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("leaflet")) : "function" == typeof define && define.amd ? define(["leaflet"], e) : "object" == typeof exports ? exports.GeoRasterLayer = e(require("leaflet")) : t.GeoRasterLayer = e(t.L);
}(self, function (t) {
  return function () {
    var e = {
        774: function _(t, e, n) {
          var r;
          t = n.nmd(t), function () {
            var n,
              a,
              i,
              o,
              s,
              l,
              h,
              u,
              c,
              f,
              d,
              _,
              p,
              y,
              _g2,
              _m2,
              v,
              x,
              b,
              k,
              M,
              w,
              C,
              E,
              S,
              A,
              I,
              O,
              j,
              N,
              G,
              D,
              R,
              L,
              P,
              T,
              B,
              Q,
              F,
              q,
              U,
              z,
              H,
              Z,
              X,
              J,
              W,
              V,
              Y,
              K,
              $,
              tt,
              et,
              nt,
              rt,
              at,
              it,
              ot,
              st,
              lt,
              ht,
              ut,
              ct,
              ft,
              dt,
              _t,
              pt,
              yt,
              gt,
              mt,
              vt,
              xt,
              bt,
              kt,
              Mt,
              wt,
              Ct,
              Et,
              St,
              At,
              It = [].slice;
            wt = function () {
              var t, e, n, r, a;
              for (t = {}, r = 0, e = (a = "Boolean Number String Function Array Date RegExp Undefined Null".split(" ")).length; r < e; r++) {
                n = a[r], t["[object " + n + "]"] = n.toLowerCase();
              }
              return function (e) {
                var n;
                return n = Object.prototype.toString.call(e), t[n] || "object";
              };
            }(), W = function W(t, e, n) {
              return null == e && (e = 0), null == n && (n = 1), t < e && (t = e), t > n && (t = n), t;
            }, Ct = function Ct(t) {
              return t.length >= 3 ? Array.prototype.slice.call(t) : t[0];
            }, M = function M(t) {
              var e, n;
              for (t._clipped = !1, t._unclipped = t.slice(0), e = n = 0; n < 3; e = ++n) {
                e < 3 ? ((t[e] < 0 || t[e] > 255) && (t._clipped = !0), t[e] < 0 && (t[e] = 0), t[e] > 255 && (t[e] = 255)) : 3 === e && (t[e] < 0 && (t[e] = 0), t[e] > 1 && (t[e] = 1));
              }
              return t._clipped || delete t._unclipped, t;
            }, o = Math.PI, vt = Math.round, C = Math.cos, O = Math.floor, rt = Math.pow, V = Math.log, bt = Math.sin, kt = Math.sqrt, y = Math.atan2, $ = Math.max, p = Math.abs, h = 2 * o, s = o / 3, a = o / 180, l = 180 / o, k = function k() {
              return arguments[0] instanceof n ? arguments[0] : function (t, e, n) {
                n.prototype = t.prototype;
                var r = new n(),
                  a = t.apply(r, e);
                return Object(a) === a ? a : r;
              }(n, arguments, function () {});
            }, k.default = k, _ = [], null !== t && null != t.exports && (t.exports = k), void 0 === (r = function () {
              return k;
            }.apply(e, [])) || (t.exports = r), k.version = "1.4.1", d = {}, c = [], f = !1, n = function () {
              function t() {
                var t, e, n, r, a, i, o, s, l;
                for (i = this, e = [], s = 0, r = arguments.length; s < r; s++) {
                  null != (t = arguments[s]) && e.push(t);
                }
                if (e.length > 1 && (o = e[e.length - 1]), null != d[o]) i._rgb = M(d[o](Ct(e.slice(0, -1))));else {
                  for (f || (c = c.sort(function (t, e) {
                    return e.p - t.p;
                  }), f = !0), l = 0, a = c.length; l < a && !(o = (n = c[l]).test.apply(n, e)); l++) {
                    ;
                  }
                  o && (i._rgb = M(d[o].apply(d, e)));
                }
                null == i._rgb && console.warn("unknown format: " + e), null == i._rgb && (i._rgb = [0, 0, 0]), 3 === i._rgb.length && i._rgb.push(1);
              }
              return t.prototype.toString = function () {
                return this.hex();
              }, t;
            }(), k._input = d, k.brewer = x = {
              OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"],
              PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"],
              BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"],
              Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"],
              BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"],
              YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"],
              YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"],
              Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"],
              RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"],
              Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"],
              YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"],
              Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"],
              GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"],
              Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
              YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"],
              PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"],
              Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"],
              PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"],
              Viridis: ["#440154", "#482777", "#3f4a8a", "#31678e", "#26838f", "#1f9d8a", "#6cce5a", "#b6de2b", "#fee825"],
              Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
              RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
              RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
              PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"],
              PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
              RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
              BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"],
              RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],
              PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],
              Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
              Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"],
              Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"],
              Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"],
              Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"],
              Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"],
              Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"],
              Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"]
            }, function () {
              var t, e;
              for (t in e = [], x) {
                e.push(x[t.toLowerCase()] = x[t]);
              }
            }(), k.colors = Et = {
              aliceblue: "#f0f8ff",
              antiquewhite: "#faebd7",
              aqua: "#00ffff",
              aquamarine: "#7fffd4",
              azure: "#f0ffff",
              beige: "#f5f5dc",
              bisque: "#ffe4c4",
              black: "#000000",
              blanchedalmond: "#ffebcd",
              blue: "#0000ff",
              blueviolet: "#8a2be2",
              brown: "#a52a2a",
              burlywood: "#deb887",
              cadetblue: "#5f9ea0",
              chartreuse: "#7fff00",
              chocolate: "#d2691e",
              coral: "#ff7f50",
              cornflower: "#6495ed",
              cornflowerblue: "#6495ed",
              cornsilk: "#fff8dc",
              crimson: "#dc143c",
              cyan: "#00ffff",
              darkblue: "#00008b",
              darkcyan: "#008b8b",
              darkgoldenrod: "#b8860b",
              darkgray: "#a9a9a9",
              darkgreen: "#006400",
              darkgrey: "#a9a9a9",
              darkkhaki: "#bdb76b",
              darkmagenta: "#8b008b",
              darkolivegreen: "#556b2f",
              darkorange: "#ff8c00",
              darkorchid: "#9932cc",
              darkred: "#8b0000",
              darksalmon: "#e9967a",
              darkseagreen: "#8fbc8f",
              darkslateblue: "#483d8b",
              darkslategray: "#2f4f4f",
              darkslategrey: "#2f4f4f",
              darkturquoise: "#00ced1",
              darkviolet: "#9400d3",
              deeppink: "#ff1493",
              deepskyblue: "#00bfff",
              dimgray: "#696969",
              dimgrey: "#696969",
              dodgerblue: "#1e90ff",
              firebrick: "#b22222",
              floralwhite: "#fffaf0",
              forestgreen: "#228b22",
              fuchsia: "#ff00ff",
              gainsboro: "#dcdcdc",
              ghostwhite: "#f8f8ff",
              gold: "#ffd700",
              goldenrod: "#daa520",
              gray: "#808080",
              green: "#008000",
              greenyellow: "#adff2f",
              grey: "#808080",
              honeydew: "#f0fff0",
              hotpink: "#ff69b4",
              indianred: "#cd5c5c",
              indigo: "#4b0082",
              ivory: "#fffff0",
              khaki: "#f0e68c",
              laserlemon: "#ffff54",
              lavender: "#e6e6fa",
              lavenderblush: "#fff0f5",
              lawngreen: "#7cfc00",
              lemonchiffon: "#fffacd",
              lightblue: "#add8e6",
              lightcoral: "#f08080",
              lightcyan: "#e0ffff",
              lightgoldenrod: "#fafad2",
              lightgoldenrodyellow: "#fafad2",
              lightgray: "#d3d3d3",
              lightgreen: "#90ee90",
              lightgrey: "#d3d3d3",
              lightpink: "#ffb6c1",
              lightsalmon: "#ffa07a",
              lightseagreen: "#20b2aa",
              lightskyblue: "#87cefa",
              lightslategray: "#778899",
              lightslategrey: "#778899",
              lightsteelblue: "#b0c4de",
              lightyellow: "#ffffe0",
              lime: "#00ff00",
              limegreen: "#32cd32",
              linen: "#faf0e6",
              magenta: "#ff00ff",
              maroon: "#800000",
              maroon2: "#7f0000",
              maroon3: "#b03060",
              mediumaquamarine: "#66cdaa",
              mediumblue: "#0000cd",
              mediumorchid: "#ba55d3",
              mediumpurple: "#9370db",
              mediumseagreen: "#3cb371",
              mediumslateblue: "#7b68ee",
              mediumspringgreen: "#00fa9a",
              mediumturquoise: "#48d1cc",
              mediumvioletred: "#c71585",
              midnightblue: "#191970",
              mintcream: "#f5fffa",
              mistyrose: "#ffe4e1",
              moccasin: "#ffe4b5",
              navajowhite: "#ffdead",
              navy: "#000080",
              oldlace: "#fdf5e6",
              olive: "#808000",
              olivedrab: "#6b8e23",
              orange: "#ffa500",
              orangered: "#ff4500",
              orchid: "#da70d6",
              palegoldenrod: "#eee8aa",
              palegreen: "#98fb98",
              paleturquoise: "#afeeee",
              palevioletred: "#db7093",
              papayawhip: "#ffefd5",
              peachpuff: "#ffdab9",
              peru: "#cd853f",
              pink: "#ffc0cb",
              plum: "#dda0dd",
              powderblue: "#b0e0e6",
              purple: "#800080",
              purple2: "#7f007f",
              purple3: "#a020f0",
              rebeccapurple: "#663399",
              red: "#ff0000",
              rosybrown: "#bc8f8f",
              royalblue: "#4169e1",
              saddlebrown: "#8b4513",
              salmon: "#fa8072",
              sandybrown: "#f4a460",
              seagreen: "#2e8b57",
              seashell: "#fff5ee",
              sienna: "#a0522d",
              silver: "#c0c0c0",
              skyblue: "#87ceeb",
              slateblue: "#6a5acd",
              slategray: "#708090",
              slategrey: "#708090",
              snow: "#fffafa",
              springgreen: "#00ff7f",
              steelblue: "#4682b4",
              tan: "#d2b48c",
              teal: "#008080",
              thistle: "#d8bfd8",
              tomato: "#ff6347",
              turquoise: "#40e0d0",
              violet: "#ee82ee",
              wheat: "#f5deb3",
              white: "#ffffff",
              whitesmoke: "#f5f5f5",
              yellow: "#ffff00",
              yellowgreen: "#9acd32"
            }, z = function z() {
              var t, e, n, r, a, o, s;
              return r = (e = Ct(arguments))[0], t = e[1], n = e[2], o = (r + 16) / 116, a = isNaN(t) ? o : o + t / 500, s = isNaN(n) ? o : o - n / 200, o = i.Yn * H(o), a = i.Xn * H(a), s = i.Zn * H(s), [At(3.2404542 * a - 1.5371385 * o - .4985314 * s), At(-.969266 * a + 1.8760108 * o + .041556 * s), n = At(.0556434 * a - .2040259 * o + 1.0572252 * s), e.length > 3 ? e[3] : 1];
            }, At = function At(t) {
              return 255 * (t <= .00304 ? 12.92 * t : 1.055 * rt(t, 1 / 2.4) - .055);
            }, H = function H(t) {
              return t > i.t1 ? t * t * t : i.t2 * (t - i.t0);
            }, i = {
              Kn: 18,
              Xn: .95047,
              Yn: 1,
              Zn: 1.08883,
              t0: .137931034,
              t1: .206896552,
              t2: .12841855,
              t3: .008856452
            }, ct = function ct() {
              var t, e, n, r, a, i, o;
              return n = (r = Ct(arguments))[0], e = r[1], t = r[2], i = (a = yt(n, e, t))[0], [116 * (o = a[1]) - 16, 500 * (i - o), 200 * (o - a[2])];
            }, gt = function gt(t) {
              return (t /= 255) <= .04045 ? t / 12.92 : rt((t + .055) / 1.055, 2.4);
            }, St = function St(t) {
              return t > i.t3 ? rt(t, 1 / 3) : t / i.t2 + i.t0;
            }, yt = function yt() {
              var t, e, n, r;
              return n = (r = Ct(arguments))[0], e = r[1], t = r[2], n = gt(n), e = gt(e), t = gt(t), [St((.4124564 * n + .3575761 * e + .1804375 * t) / i.Xn), St((.2126729 * n + .7151522 * e + .072175 * t) / i.Yn), St((.0193339 * n + .119192 * e + .9503041 * t) / i.Zn)];
            }, k.lab = function () {
              return function (t, e, n) {
                n.prototype = t.prototype;
                var r = new n(),
                  a = t.apply(r, e);
                return Object(a) === a ? a : r;
              }(n, It.call(arguments).concat(["lab"]), function () {});
            }, d.lab = z, n.prototype.lab = function () {
              return ct(this._rgb);
            }, _g2 = function g(t) {
              var e, n, r, a, i, o, s, l, h, u, c;
              return 2 === (t = function () {
                var e, n, r;
                for (r = [], n = 0, e = t.length; n < e; n++) {
                  a = t[n], r.push(k(a));
                }
                return r;
              }()).length ? (h = function () {
                var e, n, r;
                for (r = [], n = 0, e = t.length; n < e; n++) {
                  a = t[n], r.push(a.lab());
                }
                return r;
              }(), i = h[0], o = h[1], e = function e(t) {
                var e, n;
                return n = function () {
                  var n, r;
                  for (r = [], e = n = 0; n <= 2; e = ++n) {
                    r.push(i[e] + t * (o[e] - i[e]));
                  }
                  return r;
                }(), k.lab.apply(k, n);
              }) : 3 === t.length ? (u = function () {
                var e, n, r;
                for (r = [], n = 0, e = t.length; n < e; n++) {
                  a = t[n], r.push(a.lab());
                }
                return r;
              }(), i = u[0], o = u[1], s = u[2], e = function e(t) {
                var e, n;
                return n = function () {
                  var n, r;
                  for (r = [], e = n = 0; n <= 2; e = ++n) {
                    r.push((1 - t) * (1 - t) * i[e] + 2 * (1 - t) * t * o[e] + t * t * s[e]);
                  }
                  return r;
                }(), k.lab.apply(k, n);
              }) : 4 === t.length ? (c = function () {
                var e, n, r;
                for (r = [], n = 0, e = t.length; n < e; n++) {
                  a = t[n], r.push(a.lab());
                }
                return r;
              }(), i = c[0], o = c[1], s = c[2], l = c[3], e = function e(t) {
                var e, n;
                return n = function () {
                  var n, r;
                  for (r = [], e = n = 0; n <= 2; e = ++n) {
                    r.push((1 - t) * (1 - t) * (1 - t) * i[e] + 3 * (1 - t) * (1 - t) * t * o[e] + 3 * (1 - t) * t * t * s[e] + t * t * t * l[e]);
                  }
                  return r;
                }(), k.lab.apply(k, n);
              }) : 5 === t.length && (n = _g2(t.slice(0, 3)), r = _g2(t.slice(2, 5)), e = function e(t) {
                return t < .5 ? n(2 * t) : r(2 * (t - .5));
              }), e;
            }, k.bezier = function (t) {
              var e;
              return (e = _g2(t)).scale = function () {
                return k.scale(e);
              }, e;
            }, k.cubehelix = function (t, e, n, r, a) {
              var i, o, s;
              return null == t && (t = 300), null == e && (e = -1.5), null == n && (n = 1), null == r && (r = 1), null == a && (a = [0, 1]), i = 0, "array" === wt(a) ? o = a[1] - a[0] : (o = 0, a = [a, a]), (s = function s(_s2) {
                var l, u, c, f, d;
                return l = h * ((t + 120) / 360 + e * _s2), f = rt(a[0] + o * _s2, r), u = (0 !== i ? n[0] + _s2 * i : n) * f * (1 - f) / 2, c = C(l), d = bt(l), k(M([255 * (f + u * (-.14861 * c + 1.78277 * d)), 255 * (f + u * (-.29227 * c - .90649 * d)), 255 * (f + u * (1.97294 * c)), 1]));
              }).start = function (e) {
                return null == e ? t : (t = e, s);
              }, s.rotations = function (t) {
                return null == t ? e : (e = t, s);
              }, s.gamma = function (t) {
                return null == t ? r : (r = t, s);
              }, s.hue = function (t) {
                return null == t ? n : ("array" === wt(n = t) ? 0 == (i = n[1] - n[0]) && (n = n[1]) : i = 0, s);
              }, s.lightness = function (t) {
                return null == t ? a : ("array" === wt(t) ? (a = t, o = t[1] - t[0]) : (a = [t, t], o = 0), s);
              }, s.scale = function () {
                return k.scale(s);
              }, s.hue(n), s;
            }, k.random = function () {
              var t, e;
              for (t = "#", e = 0; e < 6; ++e) {
                t += "0123456789abcdef".charAt(O(16 * Math.random()));
              }
              return new n(t);
            }, _ = [], P = function P(t, e, n, r) {
              var a, i, o, s;
              for (null == n && (n = .5), null == r && (r = "rgb"), "object" !== wt(t) && (t = k(t)), "object" !== wt(e) && (e = k(e)), o = 0, i = _.length; o < i; o++) {
                if (r === (a = _[o])[0]) {
                  s = a[1](t, e, n, r);
                  break;
                }
              }
              if (null == s) throw "color mode " + r + " is not supported";
              return s.alpha(t.alpha() + n * (e.alpha() - t.alpha()));
            }, k.interpolate = P, n.prototype.interpolate = function (t, e, n) {
              return P(this, t, e, n);
            }, k.mix = P, n.prototype.mix = n.prototype.interpolate, d.rgb = function () {
              var t, e, n, r;
              for (t in n = [], e = Ct(arguments)) {
                r = e[t], n.push(r);
              }
              return n;
            }, k.rgb = function () {
              return function (t, e, n) {
                n.prototype = t.prototype;
                var r = new n(),
                  a = t.apply(r, e);
                return Object(a) === a ? a : r;
              }(n, It.call(arguments).concat(["rgb"]), function () {});
            }, n.prototype.rgb = function (t) {
              return null == t && (t = !0), t ? this._rgb.map(Math.round).slice(0, 3) : this._rgb.slice(0, 3);
            }, n.prototype.rgba = function (t) {
              return null == t && (t = !0), t ? [Math.round(this._rgb[0]), Math.round(this._rgb[1]), Math.round(this._rgb[2]), this._rgb[3]] : this._rgb.slice(0);
            }, c.push({
              p: 3,
              test: function test(t) {
                var e;
                return e = Ct(arguments), "array" === wt(e) && 3 === e.length || 4 === e.length && "number" === wt(e[3]) && e[3] >= 0 && e[3] <= 1 ? "rgb" : void 0;
              }
            }), d.lrgb = d.rgb, Q = function Q(t, e, r, a) {
              var i, o;
              return i = t._rgb, o = e._rgb, new n(kt(rt(i[0], 2) * (1 - r) + rt(o[0], 2) * r), kt(rt(i[1], 2) * (1 - r) + rt(o[1], 2) * r), kt(rt(i[2], 2) * (1 - r) + rt(o[2], 2) * r), a);
            }, u = function u(t) {
              var e, r, a, i, o;
              for (e = 1 / t.length, o = [0, 0, 0, 0], a = 0, r = t.length; a < r; a++) {
                i = t[a]._rgb, o[0] += rt(i[0], 2) * e, o[1] += rt(i[1], 2) * e, o[2] += rt(i[2], 2) * e, o[3] += i[3] * e;
              }
              return o[0] = kt(o[0]), o[1] = kt(o[1]), o[2] = kt(o[2]), o[3] > 1 && (o[3] = 1), new n(M(o));
            }, _.push(["lrgb", Q]), k.average = function (t, e) {
              var n, r, a, i, s, l, h, c, f, d, _, p, g;
              if (null == e && (e = "rgb"), f = t.length, t = t.map(function (t) {
                return k(t);
              }), h = t.splice(0, 1)[0], "lrgb" === e) return u(t);
              for (c in i = [], s = 0, l = 0, p = h.get(e)) {
                p[c] = p[c] || 0, i.push(isNaN(p[c]) ? 0 : 1), "h" !== e.charAt(c) || isNaN(p[c]) || (n = p[c] / 180 * o, s += C(n), l += bt(n));
              }
              for (r = h.alpha(), _ = 0, d = t.length; _ < d; _++) {
                for (c in g = (a = t[_]).get(e), r += a.alpha(), p) {
                  isNaN(g[c]) || (i[c] += 1, "h" === e.charAt(c) ? (n = g[c] / 180 * o, s += C(n), l += bt(n)) : p[c] += g[c]);
                }
              }
              for (c in p) {
                if ("h" === e.charAt(c)) {
                  for (n = y(l / i[c], s / i[c]) / o * 180; n < 0;) {
                    n += 360;
                  }
                  for (; n >= 360;) {
                    n -= 360;
                  }
                  p[c] = n;
                } else p[c] = p[c] / i[c];
              }
              return k(p, e).alpha(r / f);
            }, N = function N(t) {
              var e, n;
              if (t.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) return 4 !== t.length && 7 !== t.length || (t = t.substr(1)), 3 === t.length && (t = (t = t.split(""))[0] + t[0] + t[1] + t[1] + t[2] + t[2]), [(n = parseInt(t, 16)) >> 16, n >> 8 & 255, 255 & n, 1];
              if (t.match(/^#?([A-Fa-f0-9]{8})$/)) return 9 === t.length && (t = t.substr(1)), [(n = parseInt(t, 16)) >> 24 & 255, n >> 16 & 255, n >> 8 & 255, vt((255 & n) / 255 * 100) / 100];
              if (null != d.css && (e = d.css(t))) return e;
              throw "unknown color: " + t;
            }, st = function st(t, e) {
              var n, r, a, i, o, s;
              return null == e && (e = "auto"), o = t[0], a = t[1], r = t[2], n = t[3], "auto" === e && (e = n < 1 ? "rgba" : "rgb"), o = Math.round(o), a = Math.round(a), r = Math.round(r), s = (s = "000000" + (o << 16 | a << 8 | r).toString(16)).substr(s.length - 6), i = (i = "0" + vt(255 * n).toString(16)).substr(i.length - 2), "#" + function () {
                switch (e.toLowerCase()) {
                  case "rgba":
                    return s + i;
                  case "argb":
                    return i + s;
                  default:
                    return s;
                }
              }();
            }, d.hex = function (t) {
              return N(t);
            }, k.hex = function () {
              return function (t, e, n) {
                n.prototype = t.prototype;
                var r = new n(),
                  a = t.apply(r, e);
                return Object(a) === a ? a : r;
              }(n, It.call(arguments).concat(["hex"]), function () {});
            }, n.prototype.hex = function (t) {
              return null == t && (t = "auto"), st(this._rgb, t);
            }, c.push({
              p: 4,
              test: function test(t) {
                if (1 === arguments.length && "string" === wt(t)) return "hex";
              }
            }), R = function R() {
              var t, e, n, r, a, i, o, s, l, h, u, c, f, d;
              if (a = (t = Ct(arguments))[0], u = t[1], o = t[2], 0 === u) l = r = e = 255 * o;else {
                for (n = [0, 0, 0], c = 2 * o - (f = o < .5 ? o * (1 + u) : o + u - o * u), (d = [0, 0, 0])[0] = (a /= 360) + 1 / 3, d[1] = a, d[2] = a - 1 / 3, i = s = 0; s <= 2; i = ++s) {
                  d[i] < 0 && (d[i] += 1), d[i] > 1 && (d[i] -= 1), 6 * d[i] < 1 ? n[i] = c + 6 * (f - c) * d[i] : 2 * d[i] < 1 ? n[i] = f : 3 * d[i] < 2 ? n[i] = c + (f - c) * (2 / 3 - d[i]) * 6 : n[i] = c;
                }
                l = (h = [vt(255 * n[0]), vt(255 * n[1]), vt(255 * n[2])])[0], r = h[1], e = h[2];
              }
              return t.length > 3 ? [l, r, e, t[3]] : [l, r, e];
            }, ht = function ht(t, e, n) {
              var r, a, i, o, s;
              return void 0 !== t && t.length >= 3 && (t = (o = t)[0], e = o[1], n = o[2]), t /= 255, e /= 255, n /= 255, i = Math.min(t, e, n), a = (($ = Math.max(t, e, n)) + i) / 2, $ === i ? (s = 0, r = Number.NaN) : s = a < .5 ? ($ - i) / ($ + i) : ($ - i) / (2 - $ - i), t === $ ? r = (e - n) / ($ - i) : e === $ ? r = 2 + (n - t) / ($ - i) : n === $ && (r = 4 + (t - e) / ($ - i)), (r *= 60) < 0 && (r += 360), [r, s, a];
            }, k.hsl = function () {
              return function (t, e, n) {
                n.prototype = t.prototype;
                var r = new n(),
                  a = t.apply(r, e);
                return Object(a) === a ? a : r;
              }(n, It.call(arguments).concat(["hsl"]), function () {});
            }, d.hsl = R, n.prototype.hsl = function () {
              return ht(this._rgb);
            }, L = function L() {
              var t, e, n, r, a, i, o, s, l, h, u, c, f, d, _, p, y, g;
              if (a = (t = Ct(arguments))[0], p = t[1], g = t[2], g *= 255, 0 === p) l = r = e = g;else switch (360 === a && (a = 0), a > 360 && (a -= 360), a < 0 && (a += 360), o = g * (1 - p), s = g * (1 - p * (n = (a /= 60) - (i = O(a)))), y = g * (1 - p * (1 - n)), i) {
                case 0:
                  l = (h = [g, y, o])[0], r = h[1], e = h[2];
                  break;
                case 1:
                  l = (u = [s, g, o])[0], r = u[1], e = u[2];
                  break;
                case 2:
                  l = (c = [o, g, y])[0], r = c[1], e = c[2];
                  break;
                case 3:
                  l = (f = [o, s, g])[0], r = f[1], e = f[2];
                  break;
                case 4:
                  l = (d = [y, o, g])[0], r = d[1], e = d[2];
                  break;
                case 5:
                  l = (_ = [g, o, s])[0], r = _[1], e = _[2];
              }
              return [l, r, e, t.length > 3 ? t[3] : 1];
            }, ut = function ut() {
              var t, e, n, r, a, i, o, s, l;
              return i = (o = Ct(arguments))[0], n = o[1], t = o[2], a = Math.min(i, n, t), e = ($ = Math.max(i, n, t)) - a, l = $ / 255, 0 === $ ? (r = Number.NaN, s = 0) : (s = e / $, i === $ && (r = (n - t) / e), n === $ && (r = 2 + (t - i) / e), t === $ && (r = 4 + (i - n) / e), (r *= 60) < 0 && (r += 360)), [r, s, l];
            }, k.hsv = function () {
              return function (t, e, n) {
                n.prototype = t.prototype;
                var r = new n(),
                  a = t.apply(r, e);
                return Object(a) === a ? a : r;
              }(n, It.call(arguments).concat(["hsv"]), function () {});
            }, d.hsv = L, n.prototype.hsv = function () {
              return ut(this._rgb);
            }, et = function et(t) {
              return "number" === wt(t) && t >= 0 && t <= 16777215 ? [t >> 16, t >> 8 & 255, 255 & t, 1] : (console.warn("unknown num color: " + t), [0, 0, 0, 1]);
            }, _t = function _t() {
              var t;
              return ((t = Ct(arguments))[0] << 16) + (t[1] << 8) + t[2];
            }, k.num = function (t) {
              return new n(t, "num");
            }, n.prototype.num = function (t) {
              return null == t && (t = "rgb"), _t(this._rgb, t);
            }, d.num = et, c.push({
              p: 1,
              test: function test(t) {
                if (1 === arguments.length && "number" === wt(t) && t >= 0 && t <= 16777215) return "num";
              }
            }), j = function j() {
              var t, e, n, r, a, i, o, s, l, h, u, c, f, d, _, p, y, g, m, v;
              if (s = (n = Ct(arguments))[0], a = n[1], e = n[2], o = o / 100 * 255, t = 255 * (a /= 100), 0 === a) c = o = r = e;else switch (360 === s && (s = 0), s > 360 && (s -= 360), s < 0 && (s += 360), u = (h = e * (1 - a)) + t * (1 - (i = (s /= 60) - (l = O(s)))), m = h + t * i, v = h + t, l) {
                case 0:
                  c = (f = [v, m, h])[0], o = f[1], r = f[2];
                  break;
                case 1:
                  c = (d = [u, v, h])[0], o = d[1], r = d[2];
                  break;
                case 2:
                  c = (_ = [h, v, m])[0], o = _[1], r = _[2];
                  break;
                case 3:
                  c = (p = [h, u, v])[0], o = p[1], r = p[2];
                  break;
                case 4:
                  c = (y = [m, h, v])[0], o = y[1], r = y[2];
                  break;
                case 5:
                  c = (g = [v, h, u])[0], o = g[1], r = g[2];
              }
              return [c, o, r, n.length > 3 ? n[3] : 1];
            }, ot = function ot() {
              var t, e, n, r, a, i, o, s, l;
              return s = (l = Ct(arguments))[0], a = l[1], e = l[2], o = Math.min(s, a, e), n = 100 * (r = ($ = Math.max(s, a, e)) - o) / 255, t = o / (255 - r) * 100, 0 === r ? i = Number.NaN : (s === $ && (i = (a - e) / r), a === $ && (i = 2 + (e - s) / r), e === $ && (i = 4 + (s - a) / r), (i *= 60) < 0 && (i += 360)), [i, n, t];
            }, k.hcg = function () {
              return function (t, e, n) {
                n.prototype = t.prototype;
                var r = new n(),
                  a = t.apply(r, e);
                return Object(a) === a ? a : r;
              }(n, It.call(arguments).concat(["hcg"]), function () {});
            }, d.hcg = j, n.prototype.hcg = function () {
              return ot(this._rgb);
            }, E = function E(t) {
              var e, n, r, a, i, o, s, l;
              if (t = t.toLowerCase(), null != k.colors && k.colors[t]) return N(k.colors[t]);
              if (i = t.match(/rgb\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*\)/)) {
                for (s = i.slice(1, 4), a = o = 0; o <= 2; a = ++o) {
                  s[a] = +s[a];
                }
                s[3] = 1;
              } else if (i = t.match(/rgba\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*,\s*([01]|[01]?\.\d+)\)/)) for (s = i.slice(1, 5), a = l = 0; l <= 3; a = ++l) {
                s[a] = +s[a];
              } else if (i = t.match(/rgb\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
                for (s = i.slice(1, 4), a = e = 0; e <= 2; a = ++e) {
                  s[a] = vt(2.55 * s[a]);
                }
                s[3] = 1;
              } else if (i = t.match(/rgba\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
                for (s = i.slice(1, 5), a = n = 0; n <= 2; a = ++n) {
                  s[a] = vt(2.55 * s[a]);
                }
                s[3] = +s[3];
              } else (i = t.match(/hsl\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) ? ((r = i.slice(1, 4))[1] *= .01, r[2] *= .01, (s = R(r))[3] = 1) : (i = t.match(/hsla\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) && ((r = i.slice(1, 4))[1] *= .01, r[2] *= .01, (s = R(r))[3] = +i[4]);
              return s;
            }, it = function it(t) {
              var e;
              return "rgb" == (e = t[3] < 1 ? "rgba" : "rgb") ? e + "(" + t.slice(0, 3).map(vt).join(",") + ")" : "rgba" === e ? e + "(" + t.slice(0, 3).map(vt).join(",") + "," + t[3] + ")" : void 0;
            }, mt = function mt(t) {
              return vt(100 * t) / 100;
            }, D = function D(t, e) {
              var n;
              return n = e < 1 ? "hsla" : "hsl", t[0] = mt(t[0] || 0), t[1] = mt(100 * t[1]) + "%", t[2] = mt(100 * t[2]) + "%", "hsla" === n && (t[3] = e), n + "(" + t.join(",") + ")";
            }, d.css = function (t) {
              return E(t);
            }, k.css = function () {
              return function (t, e, n) {
                n.prototype = t.prototype;
                var r = new n(),
                  a = t.apply(r, e);
                return Object(a) === a ? a : r;
              }(n, It.call(arguments).concat(["css"]), function () {});
            }, n.prototype.css = function (t) {
              return null == t && (t = "rgb"), "rgb" === t.slice(0, 3) ? it(this._rgb) : "hsl" === t.slice(0, 3) ? D(this.hsl(), this.alpha()) : void 0;
            }, d.named = function (t) {
              return N(Et[t]);
            }, c.push({
              p: 5,
              test: function test(t) {
                if (1 === arguments.length && null != Et[t]) return "named";
              }
            }), n.prototype.name = function (t) {
              var e, n;
              for (n in arguments.length && (Et[t] && (this._rgb = N(Et[t])), this._rgb[3] = 1), e = this.hex("rgb"), Et) {
                if (e === Et[n]) return n;
              }
              return e;
            }, Z = function Z() {
              var t, e, n, r;
              return n = (r = Ct(arguments))[0], t = r[1], e = r[2], [n, C(e *= a) * t, bt(e) * t];
            }, X = function X() {
              var t, e, n, r, a, i, o, s, l;
              return o = (n = Ct(arguments))[0], a = n[1], i = n[2], t = (s = Z(o, a, i))[0], e = s[1], r = s[2], [(l = z(t, e, r))[0], l[1], r = l[2], n.length > 3 ? n[3] : 1];
            }, U = function U() {
              var t, e, n, r, a, i;
              return a = (i = Ct(arguments))[0], t = i[1], e = i[2], n = kt(t * t + e * e), r = (y(e, t) * l + 360) % 360, 0 === vt(1e4 * n) && (r = Number.NaN), [a, n, r];
            }, ft = function ft() {
              var t, e, n, r, a, i, o;
              return a = (i = Ct(arguments))[0], n = i[1], e = i[2], r = (o = ct(a, n, e))[0], t = o[1], e = o[2], U(r, t, e);
            }, k.lch = function () {
              var t;
              return t = Ct(arguments), new n(t, "lch");
            }, k.hcl = function () {
              var t;
              return t = Ct(arguments), new n(t, "hcl");
            }, d.lch = X, d.hcl = function () {
              var t, e, n, r;
              return e = (r = Ct(arguments))[0], t = r[1], n = r[2], X([n, t, e]);
            }, n.prototype.lch = function () {
              return ft(this._rgb);
            }, n.prototype.hcl = function () {
              return ft(this._rgb).reverse();
            }, at = function at(t) {
              var e, n, r, a, i, o;
              return null == t && (t = "rgb"), i = (o = Ct(arguments))[0], r = o[1], e = o[2], r /= 255, e /= 255, [(1 - (i /= 255) - (a = 1 - Math.max(i, Math.max(r, e)))) * (n = a < 1 ? 1 / (1 - a) : 0), (1 - r - a) * n, (1 - e - a) * n, a];
            }, w = function w() {
              var t, e, n, r, a, i;
              return n = (e = Ct(arguments))[0], a = e[1], i = e[2], r = e[3], t = e.length > 4 ? e[4] : 1, 1 === r ? [0, 0, 0, t] : [n >= 1 ? 0 : 255 * (1 - n) * (1 - r), a >= 1 ? 0 : 255 * (1 - a) * (1 - r), i >= 1 ? 0 : 255 * (1 - i) * (1 - r), t];
            }, d.cmyk = function () {
              return w(Ct(arguments));
            }, k.cmyk = function () {
              return function (t, e, n) {
                n.prototype = t.prototype;
                var r = new n(),
                  a = t.apply(r, e);
                return Object(a) === a ? a : r;
              }(n, It.call(arguments).concat(["cmyk"]), function () {});
            }, n.prototype.cmyk = function () {
              return at(this._rgb);
            }, d.gl = function () {
              var t, e, n, r, a;
              for (r = function () {
                var t, n;
                for (e in n = [], t = Ct(arguments)) {
                  a = t[e], n.push(a);
                }
                return n;
              }.apply(this, arguments), t = n = 0; n <= 2; t = ++n) {
                r[t] *= 255;
              }
              return r;
            }, k.gl = function () {
              return function (t, e, n) {
                n.prototype = t.prototype;
                var r = new n(),
                  a = t.apply(r, e);
                return Object(a) === a ? a : r;
              }(n, It.call(arguments).concat(["gl"]), function () {});
            }, n.prototype.gl = function () {
              var t;
              return [(t = this._rgb)[0] / 255, t[1] / 255, t[2] / 255, t[3]];
            }, dt = function dt(t, e, n) {
              var r;
              return t = (r = Ct(arguments))[0], e = r[1], n = r[2], .2126 * (t = Y(t)) + .7152 * (e = Y(e)) + .0722 * Y(n);
            }, Y = function Y(t) {
              return (t /= 255) <= .03928 ? t / 12.92 : rt((t + .055) / 1.055, 2.4);
            }, q = function q(t, e, r, a) {
              var i, o;
              return i = t._rgb, o = e._rgb, new n(i[0] + r * (o[0] - i[0]), i[1] + r * (o[1] - i[1]), i[2] + r * (o[2] - i[2]), a);
            }, _.push(["rgb", q]), n.prototype.luminance = function (t, e) {
              var n, r, a, i, _o2;
              return null == e && (e = "rgb"), arguments.length ? (i = this._rgb, 0 === t ? i = [0, 0, 0, this._rgb[3]] : 1 === t ? i = [255, 255, 255, this[3]] : (n = dt(this._rgb), r = 1e-7, a = 20, _o2 = function o(n, i) {
                var s, l;
                return s = (l = n.interpolate(i, .5, e)).luminance(), Math.abs(t - s) < r || !a-- ? l : s > t ? _o2(n, l) : _o2(l, i);
              }, i = n > t ? _o2(k("black"), this).rgba() : _o2(this, k("white")).rgba()), k(i).alpha(this.alpha())) : dt(this._rgb);
            }, Mt = function Mt(t) {
              var e, n, r, a;
              return (a = t / 100) < 66 ? (r = 255, n = -155.25485562709179 - .44596950469579133 * (n = a - 2) + 104.49216199393888 * V(n), e = a < 20 ? 0 : .8274096064007395 * (e = a - 10) - 254.76935184120902 + 115.67994401066147 * V(e)) : (r = 351.97690566805693 + .114206453784165 * (r = a - 55) - 40.25366309332127 * V(r), n = 325.4494125711974 + .07943456536662342 * (n = a - 50) - 28.0852963507957 * V(n), e = 255), [r, n, e];
            }, pt = function pt() {
              var t, e, n, r, a, i, o, s;
              for (a = (i = Ct(arguments))[0], i[1], t = i[2], r = 1e3, n = 4e4, e = .4; n - r > e;) {
                (o = Mt(s = .5 * (n + r)))[2] / o[0] >= t / a ? n = s : r = s;
              }
              return vt(s);
            }, k.temperature = k.kelvin = function () {
              return function (t, e, n) {
                n.prototype = t.prototype;
                var r = new n(),
                  a = t.apply(r, e);
                return Object(a) === a ? a : r;
              }(n, It.call(arguments).concat(["temperature"]), function () {});
            }, d.temperature = d.kelvin = d.K = Mt, n.prototype.temperature = function () {
              return pt(this._rgb);
            }, n.prototype.kelvin = n.prototype.temperature, k.contrast = function (t, e) {
              var r, a, i, o;
              return "string" !== (i = wt(t)) && "number" !== i || (t = new n(t)), "string" !== (o = wt(e)) && "number" !== o || (e = new n(e)), (r = t.luminance()) > (a = e.luminance()) ? (r + .05) / (a + .05) : (a + .05) / (r + .05);
            }, k.distance = function (t, e, r) {
              var a, i, o, s, l, h, u;
              for (i in null == r && (r = "lab"), "string" !== (l = wt(t)) && "number" !== l || (t = new n(t)), "string" !== (h = wt(e)) && "number" !== h || (e = new n(e)), o = t.get(r), s = e.get(r), u = 0, o) {
                u += (a = (o[i] || 0) - (s[i] || 0)) * a;
              }
              return Math.sqrt(u);
            }, k.deltaE = function (t, e, r, a) {
              var i, s, l, h, u, c, f, d, _, g, m, v, x, b, k, M, w, E, S, A, I, O, j, N;
              for (null == r && (r = 1), null == a && (a = 1), "string" !== (k = wt(t)) && "number" !== k || (t = new n(t)), "string" !== (M = wt(e)) && "number" !== M || (e = new n(e)), i = (w = t.lab())[0], l = w[1], u = w[2], s = (E = e.lab())[0], h = E[1], c = E[2], f = kt(l * l + u * u), d = kt(h * h + c * c), A = i < 16 ? .511 : .040975 * i / (1 + .01765 * i), S = .0638 * f / (1 + .0131 * f) + .638, b = f < 1e-6 ? 0 : 180 * y(u, l) / o; b < 0;) {
                b += 360;
              }
              for (; b >= 360;) {
                b -= 360;
              }
              return I = b >= 164 && b <= 345 ? .56 + p(.2 * C(o * (b + 168) / 180)) : .36 + p(.4 * C(o * (b + 35) / 180)), x = kt((_ = f * f * f * f) / (_ + 1900)), kt((O = (i - s) / (r * A)) * O + (j = (v = f - d) / (a * S)) * j + ((g = l - h) * g + (m = u - c) * m - v * v) / ((N = S * (x * I + 1 - x)) * N));
            }, n.prototype.get = function (t) {
              var e, n, r, a, i;
              return r = (a = t.split("."))[0], e = a[1], i = this[r](), e ? (n = r.indexOf(e)) > -1 ? i[n] : console.warn("unknown channel " + e + " in mode " + r) : i;
            }, n.prototype.set = function (t, e) {
              var n, r, a, i, o;
              if (a = (i = t.split("."))[0], n = i[1]) {
                if (o = this[a](), (r = a.indexOf(n)) > -1) {
                  if ("string" === wt(e)) switch (e.charAt(0)) {
                    case "+":
                    case "-":
                      o[r] += +e;
                      break;
                    case "*":
                      o[r] *= +e.substr(1);
                      break;
                    case "/":
                      o[r] /= +e.substr(1);
                      break;
                    default:
                      o[r] = +e;
                  } else o[r] = e;
                } else console.warn("unknown channel " + n + " in mode " + a);
              } else o = e;
              return k(o, a).alpha(this.alpha());
            }, n.prototype.clipped = function () {
              return this._rgb._clipped || !1;
            }, n.prototype.alpha = function (t) {
              return arguments.length ? k.rgb([this._rgb[0], this._rgb[1], this._rgb[2], t]) : this._rgb[3];
            }, n.prototype.darken = function (t) {
              var e;
              return null == t && (t = 1), (e = this.lab())[0] -= i.Kn * t, k.lab(e).alpha(this.alpha());
            }, n.prototype.brighten = function (t) {
              return null == t && (t = 1), this.darken(-t);
            }, n.prototype.darker = n.prototype.darken, n.prototype.brighter = n.prototype.brighten, n.prototype.saturate = function (t) {
              var e;
              return null == t && (t = 1), (e = this.lch())[1] += t * i.Kn, e[1] < 0 && (e[1] = 0), k.lch(e).alpha(this.alpha());
            }, n.prototype.desaturate = function (t) {
              return null == t && (t = 1), this.saturate(-t);
            }, n.prototype.premultiply = function () {
              var t, e;
              return e = this.rgb(), t = this.alpha(), k(e[0] * t, e[1] * t, e[2] * t, t);
            }, tt = function tt(t, e) {
              return t * e / 255;
            }, S = function S(t, e) {
              return t > e ? e : t;
            }, J = function J(t, e) {
              return t > e ? t : e;
            }, xt = function xt(t, e) {
              return 255 * (1 - (1 - t / 255) * (1 - e / 255));
            }, nt = function nt(t, e) {
              return e < 128 ? 2 * t * e / 255 : 255 * (1 - 2 * (1 - t / 255) * (1 - e / 255));
            }, b = function b(t, e) {
              return 255 * (1 - (1 - e / 255) / (t / 255));
            }, A = function A(t, e) {
              return 255 === t || (t = e / 255 * 255 / (1 - t / 255)) > 255 ? 255 : t;
            }, (_m2 = function m(t, e, n) {
              if (!_m2[n]) throw "unknown blend mode " + n;
              return _m2[n](t, e);
            }).normal = (v = function v(t) {
              return function (e, n) {
                var r, a;
                return r = k(n).rgb(), a = k(e).rgb(), k(t(r, a), "rgb");
              };
            })((I = function I(t) {
              return function (e, n) {
                var r, a, i;
                for (i = [], r = a = 0; a <= 3; r = ++a) {
                  i[r] = t(e[r], n[r]);
                }
                return i;
              };
            })(function (t, e) {
              return t;
            })), _m2.multiply = v(I(tt)), _m2.screen = v(I(xt)), _m2.overlay = v(I(nt)), _m2.darken = v(I(S)), _m2.lighten = v(I(J)), _m2.dodge = v(I(A)), _m2.burn = v(I(b)), k.blend = _m2, k.analyze = function (t) {
              var e, n, r, a;
              for (r = {
                min: Number.MAX_VALUE,
                max: -1 * Number.MAX_VALUE,
                sum: 0,
                values: [],
                count: 0
              }, n = 0, e = t.length; n < e; n++) {
                null == (a = t[n]) || isNaN(a) || (r.values.push(a), r.sum += a, a < r.min && (r.min = a), a > r.max && (r.max = a), r.count += 1);
              }
              return r.domain = [r.min, r.max], r.limits = function (t, e) {
                return k.limits(r, t, e);
              }, r;
            }, k.scale = function (t, e) {
              var n, r, a, i, o, s, l, h, u, c, f, d, _, p, y, g, m, v, x, b, M;
              return u = "rgb", c = k("#ccc"), p = 0, o = [0, 1], _ = [], d = [0, 0], n = !1, a = [], f = !1, h = 0, l = 1, i = !1, r = {}, y = !0, s = 1, b = function b(t) {
                var e, n, r, i, o, s;
                if (null == t && (t = ["#fff", "#000"]), null != t && "string" === wt(t) && null != k.brewer && (t = k.brewer[t] || k.brewer[t.toLowerCase()] || t), "array" === wt(t)) {
                  for (1 === t.length && (t = [t[0], t[0]]), e = r = 0, i = (t = t.slice(0)).length - 1; 0 <= i ? r <= i : r >= i; e = 0 <= i ? ++r : --r) {
                    n = t[e], "string" === wt(n) && (t[e] = k(n));
                  }
                  for (_.length = 0, e = s = 0, o = t.length - 1; 0 <= o ? s <= o : s >= o; e = 0 <= o ? ++s : --s) {
                    _.push(e / (t.length - 1));
                  }
                }
                return x(), a = t;
              }, m = function m(t) {
                var e, r;
                if (null != n) {
                  for (r = n.length - 1, e = 0; e < r && t >= n[e];) {
                    e++;
                  }
                  return e - 1;
                }
                return 0;
              }, M = function M(t) {
                return t;
              }, v = function v(t, e) {
                var i, o, f, p, g, v, x;
                if (null == e && (e = !1), isNaN(t) || null === t) return c;
                if (x = e ? t : n && n.length > 2 ? m(t) / (n.length - 2) : l !== h ? (t - h) / (l - h) : 1, e || (x = M(x)), 1 !== s && (x = rt(x, s)), x = d[0] + x * (1 - d[0] - d[1]), x = Math.min(1, Math.max(0, x)), f = Math.floor(1e4 * x), y && r[f]) i = r[f];else {
                  if ("array" === wt(a)) for (o = p = 0, v = _.length - 1; 0 <= v ? p <= v : p >= v; o = 0 <= v ? ++p : --p) {
                    if (x <= (g = _[o])) {
                      i = a[o];
                      break;
                    }
                    if (x >= g && o === _.length - 1) {
                      i = a[o];
                      break;
                    }
                    if (x > g && x < _[o + 1]) {
                      x = (x - g) / (_[o + 1] - g), i = k.interpolate(a[o], a[o + 1], x, u);
                      break;
                    }
                  } else "function" === wt(a) && (i = a(x));
                  y && (r[f] = i);
                }
                return i;
              }, x = function x() {
                return r = {};
              }, b(t), (g = function g(t) {
                var e;
                return e = k(v(t)), f && e[f] ? e[f]() : e;
              }).classes = function (t) {
                var e;
                return null != t ? ("array" === wt(t) ? (n = t, o = [t[0], t[t.length - 1]]) : (e = k.analyze(o), n = 0 === t ? [e.min, e.max] : k.limits(e, "e", t)), g) : n;
              }, g.domain = function (t) {
                var e, n, r, i, s, u, c;
                if (!arguments.length) return o;
                if (h = t[0], l = t[t.length - 1], _ = [], r = a.length, t.length === r && h !== l) for (s = 0, i = t.length; s < i; s++) {
                  n = t[s], _.push((n - h) / (l - h));
                } else for (e = c = 0, u = r - 1; 0 <= u ? c <= u : c >= u; e = 0 <= u ? ++c : --c) {
                  _.push(e / (r - 1));
                }
                return o = [h, l], g;
              }, g.mode = function (t) {
                return arguments.length ? (u = t, x(), g) : u;
              }, g.range = function (t, e) {
                return b(t), g;
              }, g.out = function (t) {
                return f = t, g;
              }, g.spread = function (t) {
                return arguments.length ? (p = t, g) : p;
              }, g.correctLightness = function (t) {
                return null == t && (t = !0), i = t, x(), M = i ? function (t) {
                  var e, n, r, a, i, o, s, l;
                  for (o = (e = v(0, !0).lab()[0]) > (n = v(1, !0).lab()[0]), r = v(t, !0).lab()[0] - (a = e + (n - e) * t), s = 0, l = 1, i = 20; Math.abs(r) > .01 && i-- > 0;) {
                    o && (r *= -1), r < 0 ? (s = t, t += .5 * (l - t)) : (l = t, t += .5 * (s - t)), r = v(t, !0).lab()[0] - a;
                  }
                  return t;
                } : function (t) {
                  return t;
                }, g;
              }, g.padding = function (t) {
                return null != t ? ("number" === wt(t) && (t = [t, t]), d = t, g) : d;
              }, g.colors = function (e, r) {
                var i, s, l, h, u, c, f, d;
                if (arguments.length < 2 && (r = "hex"), u = [], 0 === arguments.length) u = a.slice(0);else if (1 === e) u = [g(.5)];else if (e > 1) s = o[0], i = o[1] - s, u = function () {
                  c = [];
                  for (var t = 0; 0 <= e ? t < e : t > e; 0 <= e ? t++ : t--) {
                    c.push(t);
                  }
                  return c;
                }.apply(this).map(function (t) {
                  return g(s + t / (e - 1) * i);
                });else {
                  if (t = [], f = [], n && n.length > 2) for (l = d = 1, h = n.length; 1 <= h ? d < h : d > h; l = 1 <= h ? ++d : --d) {
                    f.push(.5 * (n[l - 1] + n[l]));
                  } else f = o;
                  u = f.map(function (t) {
                    return g(t);
                  });
                }
                return k[r] && (u = u.map(function (t) {
                  return t[r]();
                })), u;
              }, g.cache = function (t) {
                return null != t ? (y = t, g) : y;
              }, g.gamma = function (t) {
                return null != t ? (s = t, g) : s;
              }, g.nodata = function (t) {
                return null != t ? (c = k(t), g) : c;
              }, g;
            }, null == k.scales && (k.scales = {}), k.scales.cool = function () {
              return k.scale([k.hsl(180, 1, .9), k.hsl(250, .7, .4)]);
            }, k.scales.hot = function () {
              return k.scale(["#000", "#f00", "#ff0", "#fff"], [0, .25, .75, 1]).mode("rgb");
            }, k.analyze = function (t, e, n) {
              var r, a, i, o, s, l;
              if (s = {
                min: Number.MAX_VALUE,
                max: -1 * Number.MAX_VALUE,
                sum: 0,
                values: [],
                count: 0
              }, null == n && (n = function n() {
                return !0;
              }), r = function r(t) {
                null == t || isNaN(t) || (s.values.push(t), s.sum += t, t < s.min && (s.min = t), t > s.max && (s.max = t), s.count += 1);
              }, l = function l(t, a) {
                if (n(t, a)) return null != e && "function" === wt(e) ? r(e(t)) : null != e && "string" === wt(e) || "number" === wt(e) ? r(t[e]) : r(t);
              }, "array" === wt(t)) for (o = 0, i = t.length; o < i; o++) {
                l(t[o]);
              } else for (a in t) {
                l(t[a], a);
              }
              return s.domain = [s.min, s.max], s.limits = function (t, e) {
                return k.limits(s, t, e);
              }, s;
            }, k.limits = function (t, e, n) {
              var r, a, i, o, s, l, h, u, c, f, d, _, y, g, m, v, x, b, M, w, C, E, S, A, I, j, N, G, D, R, L, P, T, B, Q, F, q, U, z, H, Z, X, J, W, Y, K, tt, et, nt, at, it, ot, st, lt, ht;
              if (null == e && (e = "equal"), null == n && (n = 7), "array" === wt(t) && (t = k.analyze(t)), I = t.min, $ = t.max, t.sum, lt = t.values.sort(function (t, e) {
                return t - e;
              }), 1 === n) return [I, $];
              if (S = [], "c" === e.substr(0, 1) && (S.push(I), S.push($)), "e" === e.substr(0, 1)) {
                for (S.push(I), w = L = 1, Q = n - 1; 1 <= Q ? L <= Q : L >= Q; w = 1 <= Q ? ++L : --L) {
                  S.push(I + w / n * ($ - I));
                }
                S.push($);
              } else if ("l" === e.substr(0, 1)) {
                if (I <= 0) throw "Logarithmic scales are only possible for values > 0";
                for (j = Math.LOG10E * V(I), A = Math.LOG10E * V($), S.push(I), w = ht = 1, F = n - 1; 1 <= F ? ht <= F : ht >= F; w = 1 <= F ? ++ht : --ht) {
                  S.push(rt(10, j + w / n * (A - j)));
                }
                S.push($);
              } else if ("q" === e.substr(0, 1)) {
                for (S.push(I), w = r = 1, X = n - 1; 1 <= X ? r <= X : r >= X; w = 1 <= X ? ++r : --r) {
                  P = (lt.length - 1) * w / n, (T = O(P)) === P ? S.push(lt[T]) : (B = P - T, S.push(lt[T] * (1 - B) + lt[T + 1] * B));
                }
                S.push($);
              } else if ("k" === e.substr(0, 1)) {
                for (G = lt.length, g = new Array(G), b = new Array(n), at = !0, D = 0, v = null, (v = []).push(I), w = a = 1, J = n - 1; 1 <= J ? a <= J : a >= J; w = 1 <= J ? ++a : --a) {
                  v.push(I + w / n * ($ - I));
                }
                for (v.push($); at;) {
                  for (C = i = 0, W = n - 1; 0 <= W ? i <= W : i >= W; C = 0 <= W ? ++i : --i) {
                    b[C] = 0;
                  }
                  for (w = o = 0, Y = G - 1; 0 <= Y ? o <= Y : o >= Y; w = 0 <= Y ? ++o : --o) {
                    for (st = lt[w], N = Number.MAX_VALUE, C = s = 0, K = n - 1; 0 <= K ? s <= K : s >= K; C = 0 <= K ? ++s : --s) {
                      (M = p(v[C] - st)) < N && (N = M, m = C);
                    }
                    b[m]++, g[w] = m;
                  }
                  for (R = new Array(n), C = l = 0, tt = n - 1; 0 <= tt ? l <= tt : l >= tt; C = 0 <= tt ? ++l : --l) {
                    R[C] = null;
                  }
                  for (w = h = 0, et = G - 1; 0 <= et ? h <= et : h >= et; w = 0 <= et ? ++h : --h) {
                    null === R[x = g[w]] ? R[x] = lt[w] : R[x] += lt[w];
                  }
                  for (C = u = 0, nt = n - 1; 0 <= nt ? u <= nt : u >= nt; C = 0 <= nt ? ++u : --u) {
                    R[C] *= 1 / b[C];
                  }
                  for (at = !1, C = c = 0, q = n - 1; 0 <= q ? c <= q : c >= q; C = 0 <= q ? ++c : --c) {
                    if (R[C] !== v[w]) {
                      at = !0;
                      break;
                    }
                  }
                  v = R, ++D > 200 && (at = !1);
                }
                for (E = {}, C = f = 0, U = n - 1; 0 <= U ? f <= U : f >= U; C = 0 <= U ? ++f : --f) {
                  E[C] = [];
                }
                for (w = d = 0, z = G - 1; 0 <= z ? d <= z : d >= z; w = 0 <= z ? ++d : --d) {
                  E[x = g[w]].push(lt[w]);
                }
                for (it = [], C = _ = 0, H = n - 1; 0 <= H ? _ <= H : _ >= H; C = 0 <= H ? ++_ : --_) {
                  it.push(E[C][0]), it.push(E[C][E[C].length - 1]);
                }
                for (it = it.sort(function (t, e) {
                  return t - e;
                }), S.push(it[0]), w = y = 1, Z = it.length - 1; y <= Z; w = y += 2) {
                  ot = it[w], isNaN(ot) || -1 !== S.indexOf(ot) || S.push(ot);
                }
              }
              return S;
            }, G = function G(t, e, n) {
              var r, a, i, o;
              return t = (r = Ct(arguments))[0], e = r[1], n = r[2], isNaN(t) && (t = 0), (t /= 360) < 1 / 3 ? i = 1 - ((a = (1 - e) / 3) + (o = (1 + e * C(h * t) / C(s - h * t)) / 3)) : t < 2 / 3 ? a = 1 - ((o = (1 - e) / 3) + (i = (1 + e * C(h * (t -= 1 / 3)) / C(s - h * t)) / 3)) : o = 1 - ((i = (1 - e) / 3) + (a = (1 + e * C(h * (t -= 2 / 3)) / C(s - h * t)) / 3)), [255 * (o = W(n * o * 3)), 255 * (i = W(n * i * 3)), 255 * (a = W(n * a * 3)), r.length > 3 ? r[3] : 1];
            }, lt = function lt() {
              var t, e, n, r, a, i, o;
              return a = (i = Ct(arguments))[0], e = i[1], t = i[2], h = 2 * Math.PI, a /= 255, e /= 255, t /= 255, 0 == (o = 1 - Math.min(a, e, t) / (r = (a + e + t) / 3)) ? n = 0 : (n = (a - e + (a - t)) / 2, n /= Math.sqrt((a - e) * (a - e) + (a - t) * (e - t)), n = Math.acos(n), t > e && (n = h - n), n /= h), [360 * n, o, r];
            }, k.hsi = function () {
              return function (t, e, n) {
                n.prototype = t.prototype;
                var r = new n(),
                  a = t.apply(r, e);
                return Object(a) === a ? a : r;
              }(n, It.call(arguments).concat(["hsi"]), function () {});
            }, d.hsi = G, n.prototype.hsi = function () {
              return lt(this._rgb);
            }, T = function T(t, e, n, r) {
              var a, i, o, s, l, h, u, c, f, d;
              return "hsl" === r ? (f = t.hsl(), d = e.hsl()) : "hsv" === r ? (f = t.hsv(), d = e.hsv()) : "hcg" === r ? (f = t.hcg(), d = e.hcg()) : "hsi" === r ? (f = t.hsi(), d = e.hsi()) : "lch" !== r && "hcl" !== r || (r = "hcl", f = t.hcl(), d = e.hcl()), "h" === r.substr(0, 1) && (i = f[0], u = f[1], s = f[2], o = d[0], c = d[1], l = d[2]), isNaN(i) || isNaN(o) ? isNaN(i) ? isNaN(o) ? a = Number.NaN : (a = o, 1 !== s && 0 !== s || "hsv" === r || (h = c)) : (a = i, 1 !== l && 0 !== l || "hsv" === r || (h = u)) : a = i + n * (o > i && o - i > 180 ? o - (i + 360) : o < i && i - o > 180 ? o + 360 - i : o - i), null == h && (h = u + n * (c - u)), k[r](a, h, s + n * (l - s));
            }, F = function F(t, e, n, r) {
              var a, i;
              return a = t.num(), i = e.num(), k.num(a + (i - a) * n, "num");
            }, (_ = _.concat(function () {
              var t, e, n, r;
              for (r = [], e = 0, t = (n = ["hsv", "hsl", "hsi", "hcl", "lch", "hcg"]).length; e < t; e++) {
                K = n[e], r.push([K, T]);
              }
              return r;
            }())).push(["num", F]), B = function B(t, e, r, a) {
              var i, o;
              return i = t.lab(), o = e.lab(), new n(i[0] + r * (o[0] - i[0]), i[1] + r * (o[1] - i[1]), i[2] + r * (o[2] - i[2]), a);
            }, _.push(["lab", B]);
          }.call(this);
        },
        7249: function _(t, e, n) {
          function r(t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
              if (null != n) {
                var r,
                  a,
                  i = [],
                  o = !0,
                  s = !1;
                try {
                  for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                    ;
                  }
                } catch (t) {
                  s = !0, a = t;
                } finally {
                  try {
                    o || null == n.return || n.return();
                  } finally {
                    if (s) throw a;
                  }
                }
                return i;
              }
            }(t, e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return a(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(t, e) : void 0;
              }
            }(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function a(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          var i = n(3199),
            o = n(8489),
            s = n(3377),
            l = n(4502),
            h = n(5118),
            u = n(7122),
            c = n(2767),
            f = n(5382),
            d = n(2026),
            _ = n(9537),
            p = n(5355);
          t.exports = function (t) {
            var e = t.raster_bbox,
              n = t.raster_height,
              a = t.raster_width,
              y = t.pixel_height,
              g = t.pixel_width,
              m = t.geometry,
              v = t.per_pixel,
              x = t.per_row_segment,
              b = r(e, 4),
              k = b[0],
              M = (b[1], b[2], b[3]),
              w = [];
            if (0 !== n) {
              for (var C = 0; C < n; C++) {
                var E = M - y * C - y / 2,
                  S = i([k, E], [k + 1, E]);
                w.push(S);
              }
              f(m).map(u).forEach(function (t) {
                for (var u = p(n).map(function () {
                    return [];
                  }), f = t.length, m = 0; m < f; m++) {
                  var b = t[m],
                    M = r(b, 2),
                    C = M[0],
                    E = M[1],
                    S = r(C, 2),
                    A = S[0],
                    I = S[1],
                    O = r(E, 2),
                    j = O[0],
                    N = O[1],
                    G = Math.sign(N - I),
                    D = I === N,
                    R = A === j,
                    L = I,
                    P = i(C, E),
                    T = Math.min(I, N),
                    B = Math.max(I, N),
                    Q = void 0,
                    F = void 0,
                    q = void 0,
                    U = void 0;
                  if (A < j) {
                    var z = r(C, 2);
                    Q = z[0], F = z[1];
                    var H = r(E, 2);
                    U = H[0], q = H[1];
                  } else {
                    var Z = r(E, 2);
                    Q = Z[0], F = Z[1];
                    var X = r(C, 2);
                    U = X[0], q = X[1];
                  }
                  if (void 0 === Q) throw Error("startLng is " + Q);
                  var J = Math.round((e[3] - .5 * y - F) / y),
                    W = Math.round((e[3] - .5 * y - q) / y),
                    V = void 0,
                    Y = void 0;
                  J < W ? (V = J, Y = W) : (V = W, Y = J), V = s(V, 0, n - 1), Y = s(Y, 0, n - 1);
                  for (var K = V; K < Y + 1; K++) {
                    var $ = w[K];
                    if (void 0 === $) throw console.error("j:", K), console.error("imageLines:", w), Error("imageLines");
                    var tt = -1 * $.c,
                      et = I === tt,
                      nt = N === tt,
                      rt = !nt,
                      at = void 0,
                      it = void 0;
                    if (D) {
                      if (L !== tt) continue;
                      at = Q, it = U;
                    } else if (R) tt >= T && tt <= B && (at = Q, it = U);else if (et) at = it = A;else if (nt) at = it = j;else try {
                      at = it = c(P, $).x;
                    } catch (t) {
                      throw t;
                    }
                    at && it && (D || at >= Q && it <= U && tt <= B && tt >= T) && u[K].push({
                      direction: G,
                      index: m,
                      edge: b,
                      endsOnLine: nt,
                      endsOffLine: rt,
                      horizontal: D,
                      startsOnLine: et,
                      vertical: R,
                      xmin: at,
                      xmax: it,
                      imageLineY: tt
                    });
                  }
                }
                u.map(function (t, e) {
                  if (t.length > 0) {
                    var n = h(t, f).map(o),
                      i = r(_(n, function (t) {
                        return t.through;
                      }), 2),
                      s = i[0],
                      u = i[1];
                    if (s.length % 2 == 1) throw Error("throughs.length for " + e + " is odd with " + s.length);
                    var c = u.map(function (t) {
                      return [t.xmin, t.xmax];
                    });
                    s.sort(function (t, e) {
                      return t.xmin - e.xmin;
                    });
                    var p = l(s).map(function (t) {
                      var e = r(t, 2),
                        n = e[0],
                        a = e[1];
                      return [n.xmin, a.xmax];
                    });
                    c = c.concat(p), (c = d(c)).forEach(function (t) {
                      var n = r(t, 2),
                        i = n[0],
                        o = n[1],
                        s = Math.round((i - (k + .5 * g)) / g),
                        l = Math.round((o - (k + .5 * g)) / g);
                      if (!(s >= a || l < 0)) {
                        var h = Math.max(s, 0),
                          u = Math.min(l, a - 1);
                        if (x && x({
                          row: e,
                          columns: [h, u]
                        }), v) for (var c = h; c <= u; c++) {
                          v({
                            row: e,
                            column: c
                          });
                        }
                      }
                    });
                  }
                });
              });
            }
          };
        },
        4252: function _(t, e, n) {
          function r(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          var a = n(7249),
            i = n(8607),
            o = n(7687);
          t.exports = function (t) {
            var e,
              n,
              s = t.debug,
              l = void 0 !== s && s,
              h = t.raster_bbox,
              u = t.raster_height,
              c = t.raster_width,
              f = t.pixel_height,
              d = t.pixel_width,
              _ = t.geometry,
              p = t.per_pixel,
              y = t.per_row_segment,
              g = (n = 4, function (t) {
                if (Array.isArray(t)) return t;
              }(e = h) || function (t, e) {
                var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != n) {
                  var r,
                    a,
                    i = [],
                    o = !0,
                    s = !1;
                  try {
                    for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                      ;
                    }
                  } catch (t) {
                    s = !0, a = t;
                  } finally {
                    try {
                      o || null == n.return || n.return();
                    } finally {
                      if (s) throw a;
                    }
                  }
                  return i;
                }
              }(e, n) || function (t, e) {
                if (t) {
                  if ("string" == typeof t) return r(t, e);
                  var n = Object.prototype.toString.call(t).slice(8, -1);
                  return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(t, e) : void 0;
                }
              }(e, n) || function () {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }()),
              m = g[0],
              v = g[1],
              x = g[2],
              b = g[3];
            null == f && (f = (b - v) / u), null == d && (d = (x - m) / c);
            var k = new Array(u);
            a({
              raster_bbox: h,
              raster_height: u,
              raster_width: c,
              pixel_height: f,
              pixel_width: d,
              geometry: _,
              per_pixel: p,
              per_row_segment: function per_row_segment(t) {
                var e = t.row,
                  n = t.columns;
                k[e] || (k[e] = []), k[e].push(n), y && y({
                  row: e,
                  columns: n
                });
              }
            });
            for (var M = 0; M < k.length; M++) {
              var w = k[M];
              w && (w.sort(function (t, e) {
                return t === e ? t[1] - e[1] : t[0] - e[0];
              }), k[M] = o(w));
            }
            return l && i(insides), {
              rows: k
            };
          };
        },
        8489: function _(t) {
          t.exports = function (t) {
            try {
              var e,
                n,
                r,
                a = t.length,
                i = t[0];
              if (1 === a) e = !0, n = i.xmin, r = i.xmax;else {
                var o = t[a - 1];
                e = i.direction === o.direction, n = Math.min(i.xmin, o.xmin), r = Math.max(i.xmax, o.xmax);
              }
              if (void 0 === n || void 0 === r || void 0 === e || isNaN(n) || isNaN(r)) throw Error("categorizeIntersection failed with xmin", n, "and xmax", r);
              return {
                xmin: n,
                xmax: r,
                through: e
              };
            } catch (e) {
              throw console.error("[categorizeIntersection] segments:", t), console.error("[categorizeIntersection]", e), e;
            }
          };
        },
        8607: function _(t) {
          function e(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          t.exports = function (t) {
            t.forEach(function (t, n) {
              for (var r = 0; r < t.length; r++) {
                var a = t[r],
                  i = (u = 2, function (t) {
                    if (Array.isArray(t)) return t;
                  }(h = a) || function (t, e) {
                    var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                    if (null != n) {
                      var r,
                        a,
                        i = [],
                        o = !0,
                        s = !1;
                      try {
                        for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                          ;
                        }
                      } catch (t) {
                        s = !0, a = t;
                      } finally {
                        try {
                          o || null == n.return || n.return();
                        } finally {
                          if (s) throw a;
                        }
                      }
                      return i;
                    }
                  }(h, u) || function (t, n) {
                    if (t) {
                      if ("string" == typeof t) return e(t, n);
                      var r = Object.prototype.toString.call(t).slice(8, -1);
                      return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? e(t, n) : void 0;
                    }
                  }(h, u) || function () {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }()),
                  o = i[0],
                  s = i[1];
                o > s && console.warn("[dufour-peyton-intersection] uh oh, encountered invalid range", a, "at row index", n, "with ranges", t);
                for (var l = r + 1; l < t.length; l++) {
                  l[0] <= s && console.warn("[dufour-peyton-intersection] encountered range problem on row index", n, ":", t);
                }
              }
              var h, u;
            });
          };
        },
        3377: function _(t) {
          t.exports = function (t, e, n) {
            return t < e ? e : t > n ? n : t;
          };
        },
        5118: function _(t, e, n) {
          var r = n(7606);
          t.exports = function (t, e) {
            try {
              var n = r(t, function (t) {
                return t.endsOffLine;
              });
              if (n.length >= 2) {
                var a = n[0],
                  i = a[0],
                  o = n[n.length - 1],
                  s = o[o.length - 1];
                s.index === e - 1 && 0 === i.index && s.endsOnLine && (n[0] = n.pop().concat(a));
              }
              return n;
            } catch (t) {
              console.error("[clusterLineSegments]", t);
            }
          };
        },
        7606: function _(t) {
          t.exports = function (t, e) {
            try {
              for (var n = t.length, r = [], a = [], i = 0; i < n; i++) {
                var o = t[i];
                a.push(o), e(o) && (r.push(a), a = []);
              }
              return a.length > 0 && r.push(a), r;
            } catch (t) {
              console.error("[cluster]:", t);
            }
          };
        },
        4502: function _(t) {
          t.exports = function (t) {
            for (var e = [], n = t.length, r = 0; r < n; r += 2) {
              e.push([t[r], t[r + 1]]);
            }
            return e;
          };
        },
        8723: function _(t) {
          t.exports = function (t, e) {
            t.forEach(function (t) {
              for (var n = 1; n < t.length; n++) {
                var r = t[n - 1],
                  a = t[n];
                e([r, a], n - 1);
              }
            });
          };
        },
        4323: function _(t, e, n) {
          var r = n(9281);
          t.exports = function t(e, n) {
            if ("FeatureCollection" === e.type) e.features.forEach(function (e) {
              return t(e, n);
            });else if ("Feature" === e.type) t(e.geometry, n);else if ("Polygon" === e.type) t(e.coordinates, n);else if ("MultiPolygon" === e.type) e.coordinates.forEach(function (t) {
              n(t);
            });else if (Array.isArray(e)) {
              var a = r(e);
              4 === a ? e.forEach(function (t) {
                n(t);
              }) : 3 === a && n(e);
            }
          };
        },
        6252: function _(t, e, n) {
          function r(t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
              if (null != n) {
                var r,
                  a,
                  i = [],
                  o = !0,
                  s = !1;
                try {
                  for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                    ;
                  }
                } catch (t) {
                  s = !0, a = t;
                } finally {
                  try {
                    o || null == n.return || n.return();
                  } finally {
                    if (s) throw a;
                  }
                }
                return i;
              }
            }(t, e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return a(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(t, e) : void 0;
              }
            }(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function a(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          var i = n(4323);
          t.exports = function (t) {
            var e, n, a, o;
            return i(t, function (t) {
              var i,
                s = t[0],
                l = s.length - 1;
              for (void 0 === e ? (e = a = s[0][0], n = o = s[0][1], i = 1) : i = 0; i <= l; i++) {
                var h = r(s[i], 2),
                  u = h[0],
                  c = h[1];
                u < e ? e = u : u > a && (a = u), c < n ? n = c : c > o && (o = c);
              }
            }), [e, n, a, o];
          };
        },
        7122: function _(t, e, n) {
          var r = n(8723);
          t.exports = function (t) {
            var e = [];
            return r(t, function (t) {
              return e.push(t);
            }), e;
          };
        },
        2767: function _(t) {
          t.exports = function (t, e) {
            var n = t.a * e.b - e.a * t.b;
            if (n) return {
              x: (e.b * t.c - t.b * e.c) / n,
              y: (t.a * e.c - e.a * t.c) / n
            };
          };
        },
        3199: function _(t) {
          function e(t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
              if (null != n) {
                var r,
                  a,
                  i = [],
                  o = !0,
                  s = !1;
                try {
                  for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                    ;
                  }
                } catch (t) {
                  s = !0, a = t;
                } finally {
                  try {
                    o || null == n.return || n.return();
                  } finally {
                    if (s) throw a;
                  }
                }
                return i;
              }
            }(t, e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return n(t, e);
                var r = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(t, e) : void 0;
              }
            }(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function n(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          t.exports = function (t, n) {
            var r = e(t, 2),
              a = r[0],
              i = r[1],
              o = e(n, 2),
              s = o[0],
              l = o[1] - i,
              h = a - s;
            return {
              a: l,
              b: h,
              c: l * a + h * i
            };
          };
        },
        5382: function _(t, e, n) {
          var r = n(4323);
          t.exports = function (t) {
            var e = [];
            return r(t, function (t) {
              return e.push(t);
            }), e;
          };
        },
        6664: function _(t, e, n) {
          var r;
          function a(t) {
            return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, a(t);
          }
          t = n.nmd(t);
          var i = n(8489),
            o = n(3377),
            s = n(7606),
            l = n(5118),
            h = n(4252),
            u = n(7249),
            c = n(4502),
            f = n(6252),
            d = n(5382),
            _ = {
              calculate: h,
              calculateCore: u,
              categorizeIntersection: i,
              clamp: o,
              cluster: s,
              clusterLineSegments: l,
              couple: c,
              eachEdge: n(8723),
              getBoundingBox: f,
              getIntersectionOfTwoLines: n(2767),
              getLineFromPoints: n(3199),
              getPolygons: d,
              mergeRanges: n(2026),
              partition: n(9537),
              range: n(5355)
            };
          void 0 === (r = function () {
            return _;
          }.call(e, n, e, t)) || (t.exports = r), "object" === a(t) && (t.exports = _), "object" == ("undefined" == typeof self ? "undefined" : a(self)) && (self.dufour_peyton_intersection = _), "object" == ("undefined" == typeof window ? "undefined" : a(window)) && (window.dufour_peyton_intersection = _);
        },
        7687: function _(t) {
          function e(t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
              if (null != n) {
                var r,
                  a,
                  i = [],
                  o = !0,
                  s = !1;
                try {
                  for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                    ;
                  }
                } catch (t) {
                  s = !0, a = t;
                } finally {
                  try {
                    o || null == n.return || n.return();
                  } finally {
                    if (s) throw a;
                  }
                }
                return i;
              }
            }(t, e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return n(t, e);
                var r = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(t, e) : void 0;
              }
            }(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function n(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          t.exports = function (t) {
            var n = t.length;
            if (n > 0) {
              for (var r = t[0], a = r[1], i = [r], o = 1; o < n; o++) {
                var s = t[o],
                  l = e(s, 2),
                  h = l[0],
                  u = l[1];
                h <= a + 1 ? i[i.length - 1][1] = u : i.push(s), a = u;
              }
              return i;
            }
          };
        },
        2026: function _(t) {
          function e(t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
              if (null != n) {
                var r,
                  a,
                  i = [],
                  o = !0,
                  s = !1;
                try {
                  for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                    ;
                  }
                } catch (t) {
                  s = !0, a = t;
                } finally {
                  try {
                    o || null == n.return || n.return();
                  } finally {
                    if (s) throw a;
                  }
                }
                return i;
              }
            }(t, e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return n(t, e);
                var r = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(t, e) : void 0;
              }
            }(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function n(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          t.exports = function (t) {
            var n = t.length;
            if (n > 0) {
              for (var r = t[0], a = r[1], i = [r], o = 1; o < n; o++) {
                var s = t[o],
                  l = e(s, 2),
                  h = l[0],
                  u = l[1];
                h <= a ? i[i.length - 1][1] = u : i.push(s), a = u;
              }
              return i;
            }
          };
        },
        9537: function _(t) {
          t.exports = function (t, e) {
            for (var n = [], r = [], a = t.length, i = 0; i < a; i++) {
              var o = t[i];
              e(o) ? n.push(o) : r.push(o);
            }
            return [n, r];
          };
        },
        5355: function _(t) {
          t.exports = function (t) {
            for (var e = new Array(t), n = 0; n < t; n++) {
              e[n] = n;
            }
            return e;
          };
        },
        89: function _(t) {
          function e(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          function n(t) {
            var n = t.data,
              r = t.data_bbox,
              a = t.data_height,
              i = t.data_width,
              o = t.data_srs,
              s = (t.debug, t.geomask),
              l = t.mask,
              h = t.mask_srs,
              u = t.reproject,
              c = t.strategy,
              f = void 0 === c ? "outside" : c;
            if (t.edition, !["inside", "outside"].includes(f)) throw new Error('[geocanvas] strategy can be either "inside" or "outside". you provided "'.concat(f, '"'));
            s[f]({
              raster_bbox: r,
              raster_height: a,
              raster_width: i,
              raster_srs: o,
              mask: l,
              mask_srs: h,
              reproject: u
            }).rows.forEach(function (t, r) {
              if (t) {
                var a = 4 * r * i;
                t.forEach(function (t) {
                  for (var r = (h = 2, function (t) {
                      if (Array.isArray(t)) return t;
                    }(l = t) || function (t, e) {
                      var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                      if (null != n) {
                        var r,
                          a,
                          i = [],
                          o = !0,
                          s = !1;
                        try {
                          for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                            ;
                          }
                        } catch (t) {
                          s = !0, a = t;
                        } finally {
                          try {
                            o || null == n.return || n.return();
                          } finally {
                            if (s) throw a;
                          }
                        }
                        return i;
                      }
                    }(l, h) || function (t, n) {
                      if (t) {
                        if ("string" == typeof t) return e(t, n);
                        var r = Object.prototype.toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? e(t, n) : void 0;
                      }
                    }(l, h) || function () {
                      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }()), i = r[0], o = r[1], s = i; s <= o; s++) {
                    n[a + 4 * s + 3] = 0;
                  }
                  var l, h;
                });
              }
            });
          }
          t.exports = {
            maskImageData: n,
            maskCanvas: function maskCanvas(t) {
              var e = t.canvas,
                r = t.canvas_bbox,
                a = t.canvas_srs,
                i = t.geomask,
                o = t.mask,
                s = t.mask_srs,
                l = t.reproject,
                h = t.strategy,
                u = void 0 === h ? "outside" : h,
                c = (t.edition, t.debug),
                f = void 0 !== c && c;
              if (f && console.log("[geocanvas] starting to mask canvas"), !["inside", "outside"].includes(u)) throw new Error('[geocanvas] strategy can be either "inside" or "outside". you provided "'.concat(u, '"'));
              var d = e.getContext("2d"),
                _ = e.height,
                p = e.width;
              f && console.log("[geocanvas] canvas height is ".concat(_, " pixels")), f && console.log("[geocanvas] canvas width is ".concat(p, " pixels"));
              var y = d.getImageData(0, 0, p, _);
              return n({
                data: y.data,
                data_bbox: r,
                data_height: _,
                data_srs: a,
                data_width: p,
                debug: f,
                geomask: i,
                mask: o,
                mask_srs: s,
                reproject: l,
                strategy: u
              }), f && console.log("[geocanvas] image data after masking:", y), d.putImageData(y, 0, 0), f && console.log("[geocanvas] put image data back"), e;
            }
          };
        },
        7942: function _(t, e, n) {
          var r;
          function a(t) {
            return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, a(t);
          }
          function i(t, e) {
            var n = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(t);
              e && (r = r.filter(function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function o(t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2 ? i(Object(n), !0).forEach(function (e) {
                s(t, e, n[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
              });
            }
            return t;
          }
          function s(t, e, n) {
            return e in t ? Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[e] = n, t;
          }
          t = n.nmd(t);
          var l = n(2091),
            h = n(89),
            u = {
              maskImageData: function maskImageData(t) {
                return h.maskImageData(o(o({}, t), {}, {
                  edition: "full",
                  geomask: l
                }));
              },
              maskCanvas: function maskCanvas(t) {
                return h.maskCanvas(o(o({}, t), {}, {
                  edition: "full",
                  geomask: l
                }));
              }
            };
          void 0 === (r = function () {
            return u;
          }.call(e, n, e, t)) || (t.exports = r), "object" === a(t) && (t.exports = u), "object" === ("undefined" == typeof self ? "undefined" : a(self)) && (self.geocanvas = u), "object" === ("undefined" == typeof window ? "undefined" : a(window)) && (window.geocanvas = u);
        },
        2091: function _(t, e, n) {
          function r(t) {
            return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, r(t);
          }
          function a(t, e) {
            var n = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(t);
              e && (r = r.filter(function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function i(t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2 ? a(Object(n), !0).forEach(function (e) {
                o(t, e, n[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
              });
            }
            return t;
          }
          function o(t, e, n) {
            return e in t ? Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[e] = n, t;
          }
          t = n.nmd(t);
          var s = n(2962),
            l = n(9768);
          function h(t) {
            var e = t.debug,
              n = void 0 !== e && e,
              r = t.fname,
              a = t.raster_bbox,
              i = t.raster_srs,
              o = t.raster_height,
              h = t.raster_width,
              u = t.pixel_height,
              c = t.pixel_width,
              f = t.mask,
              d = t.mask_srs;
            return i !== d && (f = l(f, {
              from: d,
              to: i
            })), s[r]({
              debug: n,
              raster_bbox: a,
              raster_height: o,
              raster_width: h,
              pixel_height: u,
              pixel_width: c,
              mask: f
            });
          }
          var u = {
            inside: function inside(t) {
              return h(i(i({}, t), {}, {
                fname: "inside"
              }));
            },
            outside: function outside(t) {
              return h(i(i({}, t), {}, {
                fname: "outside"
              }));
            }
          };
          "object" === r(t) && (t.exports = u);
        },
        2962: function _(t, e, n) {
          function r(t) {
            return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, r(t);
          }
          function a(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          t = n.nmd(t);
          var i = n(6664),
            o = n(2676),
            s = n(8615),
            l = n(1398),
            h = n(1959);
          function u(t) {
            t.rows.forEach(function (t, e) {
              t && t.forEach(function (t, n) {
                var r,
                  i,
                  o = (i = 2, function (t) {
                    if (Array.isArray(t)) return t;
                  }(r = t) || function (t, e) {
                    var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                    if (null != n) {
                      var r,
                        a,
                        i = [],
                        o = !0,
                        s = !1;
                      try {
                        for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                          ;
                        }
                      } catch (t) {
                        s = !0, a = t;
                      } finally {
                        try {
                          o || null == n.return || n.return();
                        } finally {
                          if (s) throw a;
                        }
                      }
                      return i;
                    }
                  }(r, i) || function (t, e) {
                    if (t) {
                      if ("string" == typeof t) return a(t, e);
                      var n = Object.prototype.toString.call(t).slice(8, -1);
                      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(t, e) : void 0;
                    }
                  }(r, i) || function () {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }());
                if (o[0] > o[1]) throw Error("uh oh: invalid segment at row ".concat(e, ", segment ").concat(n));
              });
            });
          }
          function c(t) {
            var e = t.debug,
              n = void 0 !== e && e,
              r = t.raster_bbox,
              a = t.raster_height,
              h = t.raster_width,
              c = t.pixel_height,
              f = t.pixel_width,
              d = t.mask,
              _ = t.reproject;
            "function" == typeof _ && (d = l(d, {
              in_place: !1,
              reproject: _
            })), void 0 === c && (c = Number(s(o(r[3].toString(), r[1].toString()), a.toString()))), void 0 === f && (f = Number(s(o(r[2].toString(), r[0].toString()), h.toString())));
            var p = i.calculate({
              raster_bbox: r,
              raster_height: a,
              raster_width: h,
              pixel_height: c,
              pixel_width: f,
              geometry: d
            }).rows;
            return n && u({
              rows: p
            }), {
              rows: p
            };
          }
          var f = {
            inside: c,
            outside: function outside(t) {
              var e = t.debug,
                n = void 0 !== e && e,
                r = t.raster_bbox,
                a = t.raster_height,
                i = t.raster_width,
                f = t.pixel_height,
                d = t.pixel_width,
                _ = t.mask,
                p = t.reproject;
              "function" == typeof p && (_ = l(_, {
                in_place: !1,
                reproject: p
              })), void 0 === f && (f = Number(s(o(r[3].toString(), r[1].toString()), a.toString()))), void 0 === d && (d = Number(s(o(r[2].toString(), r[0].toString()), i.toString())));
              var y = c({
                debug: n,
                raster_bbox: r,
                raster_height: a,
                raster_width: i,
                pixel_height: f,
                pixel_width: d,
                mask: _
              }).rows;
              n && u({
                rows: y
              });
              for (var g = i - 1, m = [], v = 0; v < y.length; v++) {
                var x = y[v];
                Array.isArray(x) && 0 !== x.length ? m.push(h({
                  segments: x,
                  min: 0,
                  max: g,
                  debug: !1
                })) : m.push([[0, g]]);
              }
              return n && u({
                rows: m
              }), {
                rows: m
              };
            }
          };
          "object" === r(t) && (t.exports = f);
        },
        9281: function _(t) {
          t.exports = function (t) {
            for (var e = function e(t) {
                return Array.isArray(t) || t instanceof Int8Array || t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array || t instanceof BigInt64Array || t instanceof BigUint64Array;
              }, n = 0, r = t; e(r);) {
              n++, r = r[0];
            }
            return n;
          };
        },
        8180: function _(t, e, n) {
          var r, a, i, o;
          function s(t) {
            return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, s(t);
          }
          t = n.nmd(t), "undefined" != typeof self && self, o = function o() {
            return function (t) {
              var e = {};
              function n(r) {
                if (e[r]) return e[r].exports;
                var a = e[r] = {
                  i: r,
                  l: !1,
                  exports: {}
                };
                return t[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
              }
              return n.m = t, n.c = e, n.d = function (t, e, r) {
                n.o(t, e) || Object.defineProperty(t, e, {
                  enumerable: !0,
                  get: r
                });
              }, n.r = function (t) {
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                  value: "Module"
                }), Object.defineProperty(t, "__esModule", {
                  value: !0
                });
              }, n.t = function (t, e) {
                if (1 & e && (t = n(t)), 8 & e) return t;
                if (4 & e && "object" == s(t) && t && t.__esModule) return t;
                var r = Object.create(null);
                if (n.r(r), Object.defineProperty(r, "default", {
                  enumerable: !0,
                  value: t
                }), 2 & e && "string" != typeof t) for (var a in t) {
                  n.d(r, a, function (e) {
                    return t[e];
                  }.bind(null, a));
                }
                return r;
              }, n.n = function (t) {
                var e = t && t.__esModule ? function () {
                  return t.default;
                } : function () {
                  return t;
                };
                return n.d(e, "a", e), e;
              }, n.o = function (t, e) {
                return Object.prototype.hasOwnProperty.call(t, e);
              }, n.p = "", n(n.s = 1);
            }([function (t, e, n) {
              var r = n(5);
              t.exports = function (t, e, n) {
                var a = n && n.debug || !1,
                  i = n && n.startIndex || 0;
                a && console.log("starting findTag with", e, " and ", n);
                var o = r(t, "<".concat(e, "[ >]"), i);
                if (a && console.log("start:", o), -1 !== o) {
                  var s = o + e.length + r(t.slice(o + e.length), "[ /]" + e + ">", 0) + 1 + e.length + 1;
                  if (a && console.log("end:", s), -1 !== s) {
                    var l = t.slice(o, s);
                    return {
                      inner: l.slice(l.indexOf(">") + 1, l.lastIndexOf("<")),
                      outer: l,
                      start: o,
                      end: s
                    };
                  }
                }
              };
            }, function (t, e, n) {
              var r = n(2),
                a = n(0),
                i = n(6),
                o = n(12).default,
                s = n(7),
                l = n(8),
                h = (l.ARRAY_TYPE, l.EXCLUDED_FORMATS),
                u = l.BYTES_PER_VALUE,
                c = l.DATA_VIEW_READER_NAME,
                f = l.FORMATS,
                d = l.HASHED_FIELDS,
                _ = l.NUM_FIELDS,
                p = (l.NUM_HASHED_FIELDS, l.UNSUPPORTED_MSG),
                y = f.ESRI_WKT,
                g = f.GEOSERVER,
                m = f.MAPFILE,
                v = f.MAPNIK,
                x = f.OGC_GML,
                b = f.OGC_XML,
                k = f.OGC_WKT,
                M = f.POSTGIS,
                w = f.PROJ_4,
                C = f.PROJ_4_JS,
                E = n(9),
                S = new DataView(E),
                A = n(11).hash,
                I = ["PROJECTEDCRS", "PROJCRS", "GEOGCS", "GEOCCS", "PROJCS", "LOCAL_CS", "GEODCRS", "GEODETICCRS", "GEODETICDATUM", "ENGCRS", "ENGINEERINGCRS"];
              function O(t) {
                return function (t) {
                  return !(!(t = t.trim()).startsWith("PROJCS[") && !t.startsWith("GEOGCS[")) && I.some(function (e) {
                    return t.includes(e);
                  });
                }(t) ? t.includes("AUTHORITY") ? k : y : t.includes("gml:ProjectedCRS") || t.includes("gml:GeodeticCRS") || t.includes("gml:GeographicCRS") ? t.includes("gml:srsID") ? b : x : t.startsWith("+proj=") ? w : t.startsWith('proj4.defs("EPSG:') ? C : /^\d{1,6}\=(PROJCS|GEOGCS)/.test(t) ? g : t.startsWith("PROJECTION") && t.endsWith("END") ? m : t.endsWith("</Map>") ? v : t.startsWith("INSERT") ? M : "SOMETHING ELSE";
              }
              function j(t, e, n) {
                n && console.log("looking up " + e);
                var r = A(t);
                n && console.log("hashed:", r);
                var a = d.indexOf(e) + 1;
                n && console.log("offset:", a);
                for (var i = a * u; i < E.byteLength; i += _ * u) {
                  if (r === S[c](i, !0)) return S[c](i - a * u, !0);
                }
              }
              function N(t, e) {
                var n = !(!e || !e.debug) && e.debug,
                  l = O(t);
                if (n && console.log("dataType:", l), n && console.log("EXCLUDED_FORMATS:", h), h.includes(l.toLowerCase())) throw new Error(p.replace("{}", l));
                if (l === k) {
                  var u = o(t);
                  if (n && console.log("parsed:", u), u.AUTHORITY) {
                    var c = u.AUTHORITY;
                    return Number(c.epsg || c.EPSG);
                  }
                } else {
                  if (l == y) {
                    var f = o(t);
                    if (n && console.log("parsed:", f), f.name.match(/^WGS_1984_UTM_Zone_\d{1,2}(N|S)$/)) {
                      var d = f.name.split("_").pop(),
                        _ = d.substring(0, d.length - 1),
                        E = "N" == d.substr(-1) ? 6 : 7;
                      return Number.parseInt("32" + E + _);
                    }
                    return j(t = s(t), y, !1);
                  }
                  if (l === x) {
                    var S = a(t, "gml:identifier", {
                      debug: n
                    }).inner;
                    return Number(S.replace("urn:ogc:def:crs:EPSG::", ""));
                  }
                  if (l === b) return Number(r(t, ["gml:srsID", "gml:name"], {
                    debug: n
                  }).inner);
                  if (l === w) {
                    if (t.startsWith("+proj=utm")) {
                      var A = t.split(" ").find(function (t) {
                          return t.startsWith("+zone=");
                        }).split("=")[1],
                        I = t.includes("+south") ? "7" : "6";
                      return Number.parseInt("32" + I + A);
                    }
                    return j(t, w);
                  }
                  if (l === C) return Number(t.substring(17, t.indexOf('"', 17)));
                  if (l === g) return Number(t.match(/^\d{1,6}/)[0]);
                  if (l === m) {
                    if (t.includes("init=epsg:")) return Number.parseInt(/("init\=epsg:)(\d{1,10})(")/.exec(t)[2]);
                    if (t.includes('"proj=utm"')) {
                      var G = /("zone\=)(\d{1,2})(")/.exec(t)[2],
                        D = t.includes('"south"') ? "7" : "6";
                      return Number.parseInt("32" + D + G);
                    }
                    return j(t, m);
                  }
                  if (l === v) {
                    var R = a(t, "Map");
                    return N(i(R.outer, "srs"));
                  }
                  if (l === M) return Number(t.substring(t.indexOf("values (") + 8, t.indexOf("EPSG") - 3).trim());
                }
              }
              void 0 !== t.exports && (t.exports = N), "undefined" != typeof window ? window.getEPSGCode = N : "undefined" != typeof self && (self.getEPSGCode = N);
            }, function (t, e, n) {
              var r = n(3);
              t.exports = function (t, e, n) {
                var a = n && n.debug || !1,
                  i = r(t, e, {
                    debug: a,
                    returnOnFirst: !0
                  });
                return Array.isArray(i) && 1 === i.length ? i[0] : void 0;
              };
            }, function (t, e, n) {
              var r = n(4);
              t.exports = function (t, e, n) {
                var a = n && n.debug || !1,
                  i = n && n.returnOnFirst || !1,
                  o = r(t, e.shift(), {
                    debug: a
                  });
                a && console.log("first tags are:", o);
                for (var l = 0; l < e.length; l++) {
                  for (var h = e[l], u = [], c = function c(t) {
                      var n = o[t],
                        s = r(n.outer, h, {
                          debug: a,
                          startIndex: 1
                        });
                      if (s.length > 0) {
                        if (s.forEach(function (t) {
                          t.start += n.start, t.end += n.start;
                        }), i && l === e.length - 1) return {
                          v: [s[0]]
                        };
                        u = u.concat(s);
                      }
                    }, f = 0; f < o.length; f++) {
                    var d = c(f);
                    if ("object" === s(d)) return d.v;
                  }
                  o = u;
                }
                return o;
              };
            }, function (t, e, n) {
              var r = n(0);
              t.exports = function (t, e, n) {
                for (var a, i = [], o = n && n.debug || !1, s = n && n.startIndex || 0; a = r(t, e, {
                  debug: o,
                  startIndex: s
                });) {
                  s = a.end, i.push(a);
                }
                return i;
              };
            }, function (t, e) {
              t.exports = function (t, e, n) {
                var r = new RegExp(e).exec(t.slice(n));
                return r ? n + r.index : -1;
              };
            }, function (t, e) {
              t.exports = function (t, e, n) {
                var r = n && n.debug || !1;
                r && console.log("getting " + e + " in " + t);
                var a = "object" == s(t) ? t.outer : t,
                  i = "".concat(e, '\\="(.*)"');
                r && console.log("pattern:", i);
                var o = new RegExp(i).exec(a);
                if (o) return o[1];
              };
            }, function (t, e) {
              t.exports = function (t) {
                return (t = t.replace('DATUM["D_', 'DATUM["')).replace(/\.\d{16,}/g, function (t) {
                  return t.substr(0, 16);
                });
              };
            }, function (t, e) {
              var n = ["esriwkt", "mapfile", "proj4"],
                r = n;
              "undefined" != typeof process && process.env;
              var a = [];
              "undefined" != typeof process && process.env, r.includes("esriwkt") || a.push("esriwkt"), r.includes("mapfile") || a.push("mapfile"), r.includes("proj4") || (a.push("mapnik"), a.push("proj4")), a.sort();
              var i = r.length,
                o = i + 1,
                s = Int16Array;
              t.exports = {
                ARRAY_TYPE: s,
                DATA_VIEW_READER_NAME: "getInt16",
                BYTES_PER_VALUE: 2,
                DEFAULT_HASHED_FIELDS: n,
                EXCLUDED_FORMATS: a,
                FORMATS: {
                  ESRI_WKT: "esriwkt",
                  GEOSERVER: "geoserver",
                  MAPFILE: "mapfile",
                  MAPNIK: "mapnik",
                  OGC_GML: "gml",
                  OGC_XML: "xml",
                  OGC_WKT: "wkt",
                  POSTGIS: "postgis",
                  PROJ_4: "proj4",
                  PROJ_4_JS: "js"
                },
                HASHED_FIELDS: r,
                NUM_HASHED_FIELDS: i,
                NUM_FIELDS: o,
                UNSUPPORTED_MSG: "[get-epsg-code] {} format not supported"
              };
            }, function (t, e, n) {
              t.exports = n(10)("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");
            }, function (t, e, n) {
              "use strict";

              t.exports = function (t) {
                for (var e = "undefined" != typeof window && "function" == typeof window.atob ? window.atob(t) : Buffer.from(t, "base64").toString("binary"), n = new Uint8Array(e.length), r = 0; r < e.length; ++r) {
                  n[r] = e.charCodeAt(r);
                }
                return n.buffer;
              };
            }, function (t, e) {
              t.exports = {
                hash: function hash(t) {
                  var e,
                    n = 0;
                  if (0 === (t = (t = t.trim()).replace(/  /g, " ")).length) return n;
                  for (t.length, e = 0; e < t.length; e++) {
                    n = (n << 5) - n + t.charCodeAt(e), n |= 0;
                  }
                  return Math.round(n / Math.pow(2, 16));
                }
              };
            }, function (t, e, n) {
              "use strict";

              n.r(e);
              var r = /\s/,
                a = /[A-Za-z]/,
                i = /[A-Za-z84]/,
                o = /[,\]]/,
                l = /[\d\.E\-\+]/;
              function h(t) {
                if ("string" != typeof t) throw new Error("not a string");
                this.text = t.trim(), this.level = 0, this.place = 0, this.root = null, this.stack = [], this.currentObject = null, this.state = 1;
              }
              function u(t, e, n) {
                Array.isArray(e) && (n.unshift(e), e = null);
                var r = e ? {} : t,
                  a = n.reduce(function (t, e) {
                    return c(e, t), t;
                  }, r);
                e && (t[e] = a);
              }
              function c(t, e) {
                if (Array.isArray(t)) {
                  var n,
                    r = t.shift();
                  if ("PARAMETER" === r && (r = t.shift()), 1 === t.length) return Array.isArray(t[0]) ? (e[r] = {}, void c(t[0], e[r])) : void (e[r] = t[0]);
                  if (t.length) {
                    if ("TOWGS84" !== r) switch (Array.isArray(r) || (e[r] = {}), r) {
                      case "UNIT":
                      case "PRIMEM":
                      case "VERT_DATUM":
                        return e[r] = {
                          name: t[0].toLowerCase(),
                          convert: t[1]
                        }, void (3 === t.length && c(t[2], e[r]));
                      case "SPHEROID":
                      case "ELLIPSOID":
                        return e[r] = {
                          name: t[0],
                          a: t[1],
                          rf: t[2]
                        }, void (4 === t.length && c(t[3], e[r]));
                      case "PROJECTEDCRS":
                      case "PROJCRS":
                      case "GEOGCS":
                      case "GEOCCS":
                      case "PROJCS":
                      case "LOCAL_CS":
                      case "GEODCRS":
                      case "GEODETICCRS":
                      case "GEODETICDATUM":
                      case "EDATUM":
                      case "ENGINEERINGDATUM":
                      case "VERT_CS":
                      case "VERTCRS":
                      case "VERTICALCRS":
                      case "COMPD_CS":
                      case "COMPOUNDCRS":
                      case "ENGINEERINGCRS":
                      case "ENGCRS":
                      case "FITTED_CS":
                      case "LOCAL_DATUM":
                      case "DATUM":
                        return t[0] = ["name", t[0]], void u(e, r, t);
                      default:
                        for (n = -1; ++n < t.length;) {
                          if (!Array.isArray(t[n])) return c(t, e[r]);
                        }
                        return u(e, r, t);
                    } else e[r] = t;
                  } else e[r] = !0;
                } else e[t] = !0;
              }
              function f(t) {
                return .017453292519943295 * t;
              }
              h.prototype.readCharicter = function () {
                var t = this.text[this.place++];
                if (4 !== this.state) for (; r.test(t);) {
                  if (this.place >= this.text.length) return;
                  t = this.text[this.place++];
                }
                switch (this.state) {
                  case 1:
                    return this.neutral(t);
                  case 2:
                    return this.keyword(t);
                  case 4:
                    return this.quoted(t);
                  case 5:
                    return this.afterquote(t);
                  case 3:
                    return this.number(t);
                  case -1:
                    return;
                }
              }, h.prototype.afterquote = function (t) {
                if ('"' === t) return this.word += '"', void (this.state = 4);
                if (o.test(t)) return this.word = this.word.trim(), void this.afterItem(t);
                throw new Error("havn't handled \"" + t + '" in afterquote yet, index ' + this.place);
              }, h.prototype.afterItem = function (t) {
                return "," === t ? (null !== this.word && this.currentObject.push(this.word), this.word = null, void (this.state = 1)) : "]" === t ? (this.level--, null !== this.word && (this.currentObject.push(this.word), this.word = null), this.state = 1, this.currentObject = this.stack.pop(), void (this.currentObject || (this.state = -1))) : void 0;
              }, h.prototype.number = function (t) {
                if (!l.test(t)) {
                  if (o.test(t)) return this.word = parseFloat(this.word), void this.afterItem(t);
                  throw new Error("havn't handled \"" + t + '" in number yet, index ' + this.place);
                }
                this.word += t;
              }, h.prototype.quoted = function (t) {
                '"' !== t ? this.word += t : this.state = 5;
              }, h.prototype.keyword = function (t) {
                if (i.test(t)) this.word += t;else {
                  if ("[" === t) {
                    var e = [];
                    return e.push(this.word), this.level++, null === this.root ? this.root = e : this.currentObject.push(e), this.stack.push(this.currentObject), this.currentObject = e, void (this.state = 1);
                  }
                  if (!o.test(t)) throw new Error("havn't handled \"" + t + '" in keyword yet, index ' + this.place);
                  this.afterItem(t);
                }
              }, h.prototype.neutral = function (t) {
                if (a.test(t)) return this.word = t, void (this.state = 2);
                if ('"' === t) return this.word = "", void (this.state = 4);
                if (l.test(t)) return this.word = t, void (this.state = 3);
                if (!o.test(t)) throw new Error("havn't handled \"" + t + '" in neutral yet, index ' + this.place);
                this.afterItem(t);
              }, h.prototype.output = function () {
                for (; this.place < this.text.length;) {
                  this.readCharicter();
                }
                if (-1 === this.state) return this.root;
                throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
              }, e.default = function (t) {
                var e = function (t) {
                    return new h(t).output();
                  }(t),
                  n = e.shift(),
                  r = e.shift();
                e.unshift(["name", r]), e.unshift(["type", n]);
                var a = {};
                return c(e, a), function (t) {
                  "GEOGCS" === t.type ? t.projName = "longlat" : "LOCAL_CS" === t.type ? (t.projName = "identity", t.local = !0) : "object" == s(t.PROJECTION) ? t.projName = Object.keys(t.PROJECTION)[0] : t.projName = t.PROJECTION, t.UNIT && (t.units = t.UNIT.name.toLowerCase(), "metre" === t.units && (t.units = "meter"), t.UNIT.convert && ("GEOGCS" === t.type ? t.DATUM && t.DATUM.SPHEROID && (t.to_meter = t.UNIT.convert * t.DATUM.SPHEROID.a) : t.to_meter = t.UNIT.convert));
                  var e = t.GEOGCS;
                  function n(e) {
                    return e * (t.to_meter || 1);
                  }
                  "GEOGCS" === t.type && (e = t), e && (e.DATUM ? t.datumCode = e.DATUM.name.toLowerCase() : t.datumCode = e.name.toLowerCase(), "d_" === t.datumCode.slice(0, 2) && (t.datumCode = t.datumCode.slice(2)), "new_zealand_geodetic_datum_1949" !== t.datumCode && "new_zealand_1949" !== t.datumCode || (t.datumCode = "nzgd49"), "wgs_1984" === t.datumCode && ("Mercator_Auxiliary_Sphere" === t.PROJECTION && (t.sphere = !0), t.datumCode = "wgs84"), "_ferro" === t.datumCode.slice(-6) && (t.datumCode = t.datumCode.slice(0, -6)), "_jakarta" === t.datumCode.slice(-8) && (t.datumCode = t.datumCode.slice(0, -8)), ~t.datumCode.indexOf("belge") && (t.datumCode = "rnb72"), e.DATUM && e.DATUM.SPHEROID && (t.ellps = e.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk"), "international" === t.ellps.toLowerCase().slice(0, 13) && (t.ellps = "intl"), t.a = e.DATUM.SPHEROID.a, t.rf = parseFloat(e.DATUM.SPHEROID.rf, 10)), e.DATUM && e.DATUM.TOWGS84 && (t.datum_params = e.DATUM.TOWGS84), ~t.datumCode.indexOf("osgb_1936") && (t.datumCode = "osgb36"), ~t.datumCode.indexOf("osni_1952") && (t.datumCode = "osni52"), (~t.datumCode.indexOf("tm65") || ~t.datumCode.indexOf("geodetic_datum_of_1965")) && (t.datumCode = "ire65"), "ch1903+" === t.datumCode && (t.datumCode = "ch1903"), ~t.datumCode.indexOf("israel") && (t.datumCode = "isr93")), t.b && !isFinite(t.b) && (t.b = t.a), [["standard_parallel_1", "Standard_Parallel_1"], ["standard_parallel_2", "Standard_Parallel_2"], ["false_easting", "False_Easting"], ["false_northing", "False_Northing"], ["central_meridian", "Central_Meridian"], ["latitude_of_origin", "Latitude_Of_Origin"], ["latitude_of_origin", "Central_Parallel"], ["scale_factor", "Scale_Factor"], ["k0", "scale_factor"], ["latitude_of_center", "Latitude_Of_Center"], ["latitude_of_center", "Latitude_of_center"], ["lat0", "latitude_of_center", f], ["longitude_of_center", "Longitude_Of_Center"], ["longitude_of_center", "Longitude_of_center"], ["longc", "longitude_of_center", f], ["x0", "false_easting", n], ["y0", "false_northing", n], ["long0", "central_meridian", f], ["lat0", "latitude_of_origin", f], ["lat0", "standard_parallel_1", f], ["lat1", "standard_parallel_1", f], ["lat2", "standard_parallel_2", f], ["azimuth", "Azimuth"], ["alpha", "azimuth", f], ["srsCode", "name"]].forEach(function (e) {
                    return n = t, a = (r = e)[0], i = r[1], void (!(a in n) && i in n && (n[a] = n[i], 3 === r.length && (n[a] = r[2](n[a]))));
                    var n, r, a, i;
                  }), t.long0 || !t.longc || "Albers_Conic_Equal_Area" !== t.projName && "Lambert_Azimuthal_Equal_Area" !== t.projName || (t.long0 = t.longc), t.lat_ts || !t.lat1 || "Stereographic_South_Pole" !== t.projName && "Polar Stereographic (variant B)" !== t.projName || (t.lat0 = f(t.lat1 > 0 ? 90 : -90), t.lat_ts = t.lat1);
                }(a), a;
              };
            }]);
          }, "object" == s(e) && "object" == s(t) ? t.exports = o() : (a = [], void 0 === (i = "function" == typeof (r = o) ? r.apply(e, a) : r) || (t.exports = i));
        },
        2835: function _(t, e, n) {
          function r(t) {
            return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, r(t);
          }
          function a(t) {
            try {
              t[Symbol.iterator] = function () {
                return this;
              };
            } catch (t) {}
          }
          function i(t) {
            t["@@iterator"] = function () {
              return this;
            };
          }
          function o(t) {
            var e = {
              next: t
            };
            return a(e), i(e), e;
          }
          function s(t) {
            try {
              return t.constructor.name.endsWith("Array");
            } catch (t) {
              return !1;
            }
          }
          function l(t) {
            try {
              return "function" == typeof t.next;
            } catch (t) {
              return !1;
            }
          }
          function h(t) {
            try {
              return "@@iterator" in t;
            } catch (t) {
              return !1;
            }
          }
          function u(t) {
            try {
              return Symbol.iterator in t.constructor.prototype;
            } catch (t) {
              return !1;
            }
          }
          function c(t) {
            try {
              return Symbol.iterator in t && "function" == typeof t.next && !1 === t.propertyIsEnumerable("next");
            } catch (t) {
              return !1;
            }
          }
          function f(t) {
            var e = t["@@iterator"];
            return l(e) ? e : "function" == typeof e ? e() : void 0;
          }
          function d(t) {
            var e = 0,
              n = t.length;
            return o(function () {
              return e++ < n ? {
                value: t[e],
                done: !1
              } : {
                done: !0
              };
            });
          }
          function _(t) {
            if (c(t)) return t;
            if (u(t)) return t[Symbol.iterator]();
            if (l(t)) return o(t.next);
            if (h(t)) return f(t);
            if ("string" == typeof t || s(t)) return d(t);
            throw "[iter-fun] unable to determine iterator";
          }
          "object" === r(t = n.nmd(t)) && (t.exports = {
            addSymbolIterator: a,
            addSymbolIteratorFallback: i,
            isIterator: c,
            isArray: s,
            hasNext: l,
            hasSymbolIterator: u,
            hasIterator: h,
            getIterator: f,
            createIterator: d,
            getOrCreateIterator: _,
            wrapNextFunction: o,
            zip: function zip(t) {
              return t = t.map(_), o(function () {
                var e = t.map(function (t) {
                  return t.next();
                });
                return e.every(function (t) {
                  return t.done;
                }) ? {
                  done: !0
                } : {
                  done: !1,
                  value: e.map(function (t) {
                    return t.value;
                  })
                };
              });
            }
          });
        },
        9507: function _(t, e, n) {
          var r = n(8465);
          t.exports = function (t) {
            return "-" === (t = r(t))[0] ? t.substring(1) : t;
          };
        },
        4019: function _(t, e, n) {
          var r = n(4661),
            a = n(8465),
            i = n(565),
            o = n(3776);
          t.exports = function (t, e) {
            t = a(t), e = a(e);
            var n = "-" !== t[0],
              s = "-" !== e[0];
            if (n && s) return i(t, e);
            if (!n && !s) return "-" + i(t.substring(1), e.substring(1));
            if (!n && s) switch (t = t.substring(1), r(t, e)) {
              case "=":
                return "0";
              case "<":
                return o(e, t);
              case ">":
                return "-" + o(t, e);
            } else if (n && !s) switch (e = e.substring(1), r(t, e)) {
              case "=":
                return "0";
              case "<":
                return "-" + o(e, t);
              case ">":
                return o(t, e);
            }
          };
        },
        8465: function _(t, e, n) {
          var r = n(4557);
          t.exports = function (t) {
            return "+" === t[0] && (t = t.substring(1)), (t = r(t)).replace(/^0+(?=\d)/, "");
          };
        },
        4661: function _(t, e, n) {
          n(8465), t.exports = function (t, e) {
            for (var n = t.length, r = e.length, a = t.indexOf("."), i = e.indexOf("."), o = -1 === a ? n : a, s = -1 === i ? r : i, l = o - s, h = l < 0 ? -1 * l : 0, u = l <= 0 ? 0 : l, c = Math.max(o, s) + 1 + Math.max(n - o, r - s) - 1, f = 0; f < c;) {
              var d = t[f - h] || "0",
                _ = e[f - u] || "0";
              if (d !== _) {
                if (d > _) return ">";
                if (d < _) return "<";
              }
              f++;
            }
            return "=";
          };
        },
        8615: function _(t, e, n) {
          var r = n(9507),
            a = n(8465),
            i = n(2062);
          t.exports = function (t, e, n) {
            t = a(t), e = a(e);
            var o = "-" !== t[0],
              s = "-" !== e[0],
              l = o !== s ? "-" : "";
            return o || (t = r(t)), s || (e = r(e)), l + i(t, e, n);
          };
        },
        4557: function _(t) {
          t.exports = function (t) {
            "+" === t[0] && (t = t.substring(1));
            var e = "-" === t[0] ? "-" : "";
            "-" === e && (t = t.substring(1));
            var n = t.indexOf("e");
            if (-1 === n) return e + t;
            var r = t.indexOf(".");
            -1 === r && (r = n);
            var a = Number(t.substring(n + 1)),
              i = t.substring(0, n).replace(".", ""),
              o = r + a,
              s = i.length;
            if (o >= s) {
              for (var l = o - s, h = i, u = 0; u < l; u++) {
                h += "0";
              }
              return e + h;
            }
            if (o < 0) {
              result = "0.";
              for (var c = 0; c > o; c--) {
                result += "0";
              }
              return result += i, e + result;
            }
            return e + i.substring(0, o) + "." + i.substring(o);
          };
        },
        565: function _(t) {
          t.exports = function (t, e) {
            var n = t.length,
              r = e.length,
              a = t.indexOf("."),
              i = e.indexOf("."),
              o = -1 === a ? n : a,
              s = -1 === i ? r : i,
              l = o - s,
              h = Math.max(o, s),
              u = Math.max(n - o - 1, r - s - 1),
              c = l < 0 ? -1 * l : 0,
              f = l <= 0 ? 0 : l,
              d = h + 1 + u - 1,
              _ = "",
              p = 0,
              y = d;
            if (u > 0) {
              for (; y > d - u;) {
                var g = t[y - c] || "0",
                  m = e[y - f] || "0",
                  v = Number(g) + Number(m) + p;
                v >= 10 ? (v -= 10, p = 1) : p = 0, "" === _ && 0 === v || (_ = v + _), y--;
              }
              _ && (_ = "." + _), y--;
            }
            if (h > 0) for (; y >= 0;) {
              var x = t[y - c] || "0",
                b = e[y - f] || "0",
                k = Number(x) + Number(b) + p;
              k >= 10 ? (k -= 10, p = 1) : p = 0, _ = k + _, y--;
            }
            return 1 === p && (_ = p + _), _;
          };
        },
        2062: function _(t, e, n) {
          var r = n(4661),
            a = n(4019),
            i = (n(129), n(2676)),
            o = n(5798);
          t.exports = function (t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              s = n.max_decimal_digits,
              l = void 0 === s ? 100 : s,
              h = n.ellipsis,
              u = void 0 !== h && h;
            "0" === t[0] && (t = t.substring(1)), "0" === e[0] && (e = e.substring(1));
            var c = t.indexOf("."),
              f = e.indexOf("."),
              d = -1 === c ? t.length : c,
              _ = -1 === f ? 0 : e.length - 1 - f,
              p = !1;
            t = t.replace(/\./, ""), e = e.replace(/\./, "");
            for (var y, g = t.length, m = "", v = "", x = -1 * _, b = 0, k = 0; k < g; k++) {
              var M = t[k];
              if (">" === (y = r(m += M, e))) {
                for (var w = 1, C = a(e, e), E = e; ">" !== r(C, m);) {
                  w++, E = C, C = a(C, e);
                }
                if (w = w.toString(), "" !== v) for (var S = w.length; S <= b; S++) {
                  v += "0";
                }
                v += w, m = i(m, E), b = 0;
              } else {
                if ("<" === y) {
                  "" === v && x++, b++;
                  continue;
                }
                if ("=" === y) {
                  if ("" !== v) for (var A = 0; A < b; A++) {
                    v += "0";
                  }
                  v += "1", m = "0", b = 0;
                }
              }
            }
            if (m.match(/^0+$/g)) "<" === y && (v += m.substring(0, m.length - 1));else {
              var I = {},
                O = d - x,
                j = v.length,
                N = O - j + l + 1;
              "" === v && (b = 0);
              for (var G = 0; G < N; G++) {
                if (m += "0", u) if (m in I) {
                  if (I[m]++, I[m] > 3) {
                    v += "...", p = !0;
                    break;
                  }
                } else I[m] = 1;
                var D = r(m, e);
                if (">" === D) {
                  for (var R = 1, L = a(e, e), P = e; ">" !== r(L, m);) {
                    R++, P = L, L = a(L, e);
                  }
                  for (var T = (R = R.toString()).length; T <= b; T++) {
                    v += "0";
                  }
                  if (v += R, "0" === (m = i(m, P))) break;
                  b = 0;
                } else {
                  if ("<" === D) {
                    b++;
                    continue;
                  }
                  if ("=" === D) {
                    for (var B = 0; B < b; B++) {
                      v += "0";
                    }
                    v += "1", b = 0;
                    break;
                  }
                }
              }
            }
            var Q,
              F = d - x,
              q = v.length;
            if (F === q) Q = 0;else if (F < 0) v = "0." + "0".repeat(Math.abs(F)) + v, Q = q - F;else if (F > q) {
              for (var U = q; U < F; U++) {
                v += "0";
              }
              Q = 0;
            } else F < q ? (v = v.substring(0, F) + "." + v.substring(F), Q = q - F) : 0 === F && (v = "0." + v, Q = q);
            if (v = (v = v.replace(/^0+/, "")).replace(/\.\d+0+$/, ""), !p) {
              var z = Q - l;
              z > 0 && (v = o(v.substring(0, v.length - z + 1)));
            }
            return "." === v[0] && (v = "0" + v), v;
          };
        },
        2325: function _(t) {
          function e(t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
              if (null != n) {
                var r,
                  a,
                  i = [],
                  o = !0,
                  s = !1;
                try {
                  for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                    ;
                  }
                } catch (t) {
                  s = !0, a = t;
                } finally {
                  try {
                    o || null == n.return || n.return();
                  } finally {
                    if (s) throw a;
                  }
                }
                return i;
              }
            }(t, e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return n(t, e);
                var r = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(t, e) : void 0;
              }
            }(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function n(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          t.exports = function (t, n) {
            if ("0" === t || "0" === n) return "0";
            var r = t.indexOf("."),
              a = n.indexOf("."),
              i = (-1 === r ? 0 : t.length - 1 - r) + (-1 === a ? 0 : n.length - 1 - a);
            t = t.replace(".", ""), n = n.replace(".", "");
            for (var o = t.length, s = n.length, l = [], h = o; h >= 0;) {
              var u = h,
                c = h -= 15,
                f = t.substring(c, u);
              l.push([Number(f), f.length]);
            }
            for (var d = [], _ = [], p = function p(t, r) {
                var a = n[t],
                  i = Number(a),
                  o = 0,
                  s = "",
                  h = l.length - 1;
                l.forEach(function (t, n) {
                  var r = e(t, 2),
                    a = r[0],
                    l = r[1],
                    u = (o + i * a).toString(),
                    c = u.length;
                  if (c > l && n !== h) {
                    var f = -1 * l;
                    s = u.slice(f) + s, o = Number(u.slice(0, f));
                  } else {
                    for (var d = l - c, _ = 0; _ < d; _++) {
                      u = "0" + u;
                    }
                    o = 0, s = u + s;
                  }
                }), s += "0".repeat(r), d.push(s), _.push([Array.from(s).map(function (t) {
                  return Number(t);
                }), s.length]);
              }, y = 0, g = s - 1; g >= 0; g--, y++) {
              p(g, y);
            }
            for (var m = d.length, v = _[_.length - 1][1] + m, x = "", b = 0, k = 0; k < v; k++) {
              for (var M = b, w = Math.min(k, m - 1), C = 0; C <= w; C++) {
                var E = e(_[C], 2),
                  S = E[0],
                  A = E[1] - 1 - k;
                A >= 0 && (M += S[A]);
              }
              M >= 10 ? (x = (M = M.toString())[M.length - 1] + x, b = Number(M.slice(0, -1))) : (x = M + x, b = 0);
            }
            if (0 === i) x = x.replace(/^0+/, "");else {
              var I = x.length - i;
              "." === (x = (x = (x = x.substring(0, I) + "." + x.substring(I)).replace(/^0+/, "")).replace(/\.?0+$/, ""))[0] && (x = "0" + x);
            }
            return x;
          };
        },
        3776: function _(t) {
          t.exports = function (t, e) {
            var n = t.length,
              r = e.length,
              a = t.indexOf("."),
              i = e.indexOf("."),
              o = -1 === a ? n : a,
              s = -1 === i ? r : i,
              l = o - s,
              h = Math.max(o, s),
              u = Math.max(n - o - 1, r - s - 1),
              c = l < 0 ? -1 * l : 0,
              f = l <= 0 ? 0 : l,
              d = h + 1 + u - 1,
              _ = "",
              p = 0,
              y = d;
            if (u > 0) {
              for (; y > d - u;) {
                var g = t[y - c] || "0";
                g -= p, p = 0;
                var m = g - (e[y - f] || "0");
                if (m < 0) for (; m < 0;) {
                  p++, m += 10;
                } else p && p--;
                "" === _ && 0 === m || (_ = m + _), y--;
              }
              "" !== _ && (_ = "." + _), y--;
            }
            if (h > 0) {
              for (; y > 0;) {
                var v = t[y - c] || "0";
                v -= p, p = 0;
                var x = v - (e[y - f] || "0");
                if (x < 0) for (; x < 0;) {
                  p++, x += 10;
                } else p && p--;
                _ = x + _, y--;
              }
              var b = t[0 - c] || "0",
                k = e[0 - f] || "0",
                M = Number(b) - (p > 0 ? 1 : 0) - Number(k);
              0 !== M && (_ = M + _), _ = _.replace(/^0+/, "");
            }
            return "." === _[0] && (_ = "0" + _), _;
          };
        },
        129: function _(t, e, n) {
          var r = n(9507),
            a = n(8465),
            i = n(4661),
            o = n(2325);
          t.exports = function (t, e) {
            t = a(t), e = a(e);
            var n = "-" !== t[0] != ("-" !== e[0]) ? "-" : "";
            if (t = r(t), e = r(e), "<" === i(t, e)) {
              var s = t;
              t = e, e = s;
            }
            return n + o(t, e);
          };
        },
        5798: function _(t) {
          var e = ["5", "6", "7", "8", "9"];
          t.exports = function (t) {
            "+" === t[0] && (t = t.substring(1));
            var n = t.length,
              r = "",
              a = t[t.length - 1];
            if (e.includes(a)) {
              var i;
              for (i = n - 2; i >= 0; i--) {
                var o = t[i];
                if ("." !== o && "-" !== o) {
                  var s = Number(o) + 1;
                  if (10 !== s) {
                    r = s + r;
                    break;
                  }
                  r = "0" + r;
                }
              }
              i > 0 && (r = t.substring(0, i) + r);
            } else r = t.substring(0, n - 1);
            return "." === r[r.length - 1] && (r = r.substring(0, r.length - 1)), r.indexOf(".") > -1 && (r = r.replace(/0+$/, "")), r;
          };
        },
        2676: function _(t, e, n) {
          var r = n(8465),
            a = n(4661),
            i = n(565),
            o = n(3776);
          t.exports = function (t, e) {
            t = r(t), e = r(e);
            var n = "-" !== t[0],
              s = "-" !== e[0];
            if (n) {
              if (s) {
                var l = a(t, e);
                return ">" === l ? o(t, e) : "<" === l ? "-" + o(e, t) : "0";
              }
              return i(t, e.substring(1));
            }
            if (s) return "-" + i(t.substring(1), e);
            t = t.substring(1), e = e.substring(1);
            var h = a(t, e);
            return ">" === h ? "-" + o(t, e) : "<" === h ? o(e, t) : "0";
          };
        },
        7481: function _(t, e, n) {
          "use strict";

          var r = n(6341);
          function a(t) {
            return "-" === (t = r(t))[0] ? t.substring(1) : t;
          }
          t.exports = a, t.exports.default = a;
        },
        9627: function _(t, e, n) {
          "use strict";

          var r = n(3679),
            a = n(6341),
            i = n(661),
            o = n(1934);
          function s(t, e) {
            t = a(t), e = a(e);
            var n = "-" !== t[0],
              s = "-" !== e[0];
            if (n && s) return i(t, e);
            if (!n && !s) return "-" + i(t.substring(1), e.substring(1));
            if (!n && s) switch (t = t.substring(1), r(t, e)) {
              case "=":
                return "0";
              case "<":
                return o(e, t);
              case ">":
                return "-" + o(t, e);
            } else if (n && !s) switch (e = e.substring(1), r(t, e)) {
              case "=":
                return "0";
              case "<":
                return "-" + o(e, t);
              case ">":
                return o(t, e);
            }
          }
          t.exports = s, t.exports.default = s;
        },
        6341: function _(t, e, n) {
          "use strict";

          var r = n(200);
          t.exports = function (t) {
            return "+" === t[0] && (t = t.substring(1)), (t = (t = r(t)).replace(/^0+(?=\d)/, "")).includes(".") && (t = t.replace(/\.?0+$/, "")), "" === t && (t = "0"), "-0" === t && (t = "0"), t;
          };
        },
        3679: function _(t) {
          "use strict";

          function e(t, e) {
            for (var n = t.length, r = e.length, a = t.indexOf("."), i = e.indexOf("."), o = -1 === a ? n : a, s = -1 === i ? r : i, l = o - s, h = l < 0 ? -1 * l : 0, u = l <= 0 ? 0 : l, c = Math.max(o, s) + 1 + Math.max(n - o, r - s) - 1, f = 0; f < c;) {
              var d = f - h,
                _ = d === o ? "." : t[d] || "0",
                p = f - u,
                y = p === s ? "." : e[p] || "0";
              if (_ !== y) {
                if (_ > y) return ">";
                if (_ < y) return "<";
              }
              f++;
            }
            return "=";
          }
          t.exports = e, t.exports.default = e;
        },
        4971: function _(t) {
          "use strict";

          var e = 9007199254740991,
            n = e.toString().length - 1;
          t.exports = {
            MAX_SAFE_INTEGER: e,
            MAX_SAFE_INTEGER_LENGTH: n
          };
        },
        7493: function _(t, e, n) {
          "use strict";

          var r = n(7481),
            a = n(6341),
            i = n(8430);
          function o(t, e, n) {
            if (t = a(t), "0" === (e = a(e))) throw new Error("[preciso] division by zero");
            if ("" === t || "0" === t) return "0";
            var o = "-" !== t[0],
              s = "-" !== e[0],
              l = o !== s ? "-" : "";
            return o || (t = r(t)), s || (e = r(e)), l + i(t, e, n);
          }
          t.exports = o, t.exports.default = o;
        },
        200: function _(t) {
          "use strict";

          function e(t) {
            "+" === t[0] && (t = t.substring(1));
            var e = "-" === t[0] ? "-" : "";
            "-" === e && (t = t.substring(1));
            var n = t.indexOf("e");
            if (-1 === n) return e + t;
            var r = t.indexOf(".");
            -1 === r && (r = n);
            var a = Number(t.substring(n + 1)),
              i = t.substring(0, n).replace(".", ""),
              o = r + a,
              s = i.length;
            if (o >= s) {
              for (var l = o - s, h = i, u = 0; u < l; u++) {
                h += "0";
              }
              return e + h;
            }
            if (o < 0) {
              for (var c = "0.", f = 0; f > o; f--) {
                c += "0";
              }
              return e + (c + i);
            }
            return e + i.substring(0, o) + "." + i.substring(o);
          }
          t.exports = e, t.exports.default = e;
        },
        661: function _(t, e, n) {
          "use strict";

          var r = n(4971).MAX_SAFE_INTEGER_LENGTH;
          function a(t, e) {
            var n = t.length,
              a = e.length,
              i = t.indexOf("."),
              o = e.indexOf("."),
              s = -1 === i ? n : i,
              l = -1 === o ? a : o;
            if (-1 === i && -1 === o && n < r && a < r) return (Number(t) + Number(e)).toFixed();
            var h = s - l,
              u = Math.max(s, l),
              c = Math.max(n - s - 1, a - l - 1),
              f = h < 0 ? -1 * h : 0,
              d = h <= 0 ? 0 : h,
              _ = u + 1 + c - 1,
              p = "",
              y = 0,
              g = _;
            if (c > 0) {
              for (; g > _ - c;) {
                var m = t[g - f] || "0",
                  v = e[g - d] || "0",
                  x = Number(m) + Number(v) + y;
                x >= 10 ? (x -= 10, y = 1) : y = 0, "" === p && 0 === x || (p = x + p), g--;
              }
              p && (p = "." + p), g--;
            }
            if (u > 0) for (; g >= 0;) {
              var b = t[g - f] || "0",
                k = e[g - d] || "0",
                M = Number(b) + Number(k) + y;
              M >= 10 ? (M -= 10, y = 1) : y = 0, p = M + p, g--;
            }
            return 1 === y && (p = y + p), "." === p[0] && (p = "0" + p), p;
          }
          t.exports = a, t.exports.default = a;
        },
        8430: function _(t, e, n) {
          "use strict";

          var r = n(3679),
            a = n(9627),
            i = n(8508),
            o = n(3708);
          function s(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              s = n.max_decimal_digits,
              l = void 0 === s ? 100 : s,
              h = n.ellipsis,
              u = void 0 !== h && h;
            "0" === t[0] && (t = t.substring(1)), "0" === e[0] && (e = e.substring(1));
            var c = t.indexOf("."),
              f = e.indexOf("."),
              d = -1 === c ? t.length : c,
              _ = -1 === f ? 0 : e.length - 1 - f,
              p = !1;
            t = t.replace(/\./, ""), e = e.replace(/\./, "");
            for (var y, g = t.length, m = "", v = "", x = -1 * _, b = 0, k = 0; k < g; k++) {
              var M = t[k];
              if (">" === (y = r(m += M, e))) {
                for (var w = 1, C = a(e, e), E = e; ">" !== r(C, m);) {
                  w++, E = C, C = a(C, e);
                }
                if (w = w.toString(), "" !== v) for (var S = w.length; S <= b; S++) {
                  v += "0";
                }
                v += w, m = i(m, E), b = 0;
              } else {
                if ("<" === y) {
                  "" === v && x++, b++;
                  continue;
                }
                if ("=" === y) {
                  if ("" !== v) for (var A = 0; A < b; A++) {
                    v += "0";
                  }
                  v += "1", m = "0", b = 0;
                }
              }
            }
            if (m.match(/^0+$/g)) "<" === y && (v += m.substring(0, m.length - 1));else {
              var I = {},
                O = d - x,
                j = v.length,
                N = O - j + l + 1;
              "" === v && (b = 0);
              for (var G = 0; G < N; G++) {
                if (m += "0", u) if (m in I) {
                  if (I[m]++, I[m] > 3) {
                    v += "...", p = !0;
                    break;
                  }
                } else I[m] = 1;
                var D = r(m, e);
                if (">" === D) {
                  for (var R = 1, L = a(e, e), P = e; ">" !== r(L, m);) {
                    R++, P = L, L = a(L, e);
                  }
                  for (var T = (R = R.toString()).length; T <= b; T++) {
                    v += "0";
                  }
                  if (v += R, "0" === (m = i(m, P))) break;
                  b = 0;
                } else {
                  if ("<" === D) {
                    b++;
                    continue;
                  }
                  if ("=" === D) {
                    for (var B = 0; B < b; B++) {
                      v += "0";
                    }
                    v += "1", b = 0;
                    break;
                  }
                }
              }
            }
            var Q,
              F = d - x,
              q = v.length;
            if (F === q) Q = 0;else if (F < 0) v = "0." + "0".repeat(Math.abs(F)) + v, Q = q - F;else if (F > q) {
              for (var U = q; U < F; U++) {
                v += "0";
              }
              Q = 0;
            } else F < q ? (v = v.substring(0, F) + "." + v.substring(F), Q = q - F) : 0 === F && (v = "0." + v, Q = q);
            if (v = (v = v.replace(/^0+/, "")).replace(/\.\d+0+$/, ""), !p) {
              var z = Q - l;
              z > 0 && (v = o(v.substring(0, v.length - z + 1)));
            }
            return "." === v[0] && (v = "0" + v), v;
          }
          t.exports = s, t.exports.default = s;
        },
        490: function _(t, e, n) {
          "use strict";

          function r(t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
              if (null != n) {
                var r,
                  a,
                  i = [],
                  o = !0,
                  s = !1;
                try {
                  for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                    ;
                  }
                } catch (t) {
                  s = !0, a = t;
                } finally {
                  try {
                    o || null == n.return || n.return();
                  } finally {
                    if (s) throw a;
                  }
                }
                return i;
              }
            }(t, e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return a(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(t, e) : void 0;
              }
            }(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function a(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          var i = n(4971).MAX_SAFE_INTEGER_LENGTH;
          function o(t, e) {
            if ("0" === t || "0" === e) return "0";
            var n = t.indexOf("."),
              a = e.indexOf("."),
              o = (-1 === n ? t.length : n) + (-1 === a ? e.length : a),
              s = (-1 === n ? 0 : t.length - 1 - n) + (-1 === a ? 0 : e.length - 1 - a);
            if (0 === s && o < i) return (Number(t) * Number(e)).toFixed(0);
            for (var l = t.replace(".", ""), h = e.replace(".", ""), u = l.length, c = h.length, f = [], d = u; d >= 0;) {
              var _ = d,
                p = d -= 15,
                y = l.substring(p, _);
              f.push([Number(y), y.length]);
            }
            for (var g = [], m = [], v = function v(t, e) {
                var n = h[t],
                  a = Number(n),
                  i = 0,
                  o = "",
                  s = f.length - 1;
                f.forEach(function (t, e) {
                  var n = r(t, 2),
                    l = n[0],
                    h = n[1],
                    u = (i + a * l).toString(),
                    c = u.length;
                  if (c > h && e !== s) {
                    var f = -1 * h;
                    o = u.slice(f) + o, i = Number(u.slice(0, f));
                  } else {
                    for (var d = h - c, _ = 0; _ < d; _++) {
                      u = "0" + u;
                    }
                    i = 0, o = u + o;
                  }
                }), o += "0".repeat(e), g.push(o), m.push([Array.from(o).map(function (t) {
                  return Number(t);
                }), o.length]);
              }, x = 0, b = c - 1; b >= 0; b--, x++) {
              v(b, x);
            }
            for (var k = g.length, M = m[m.length - 1][1] + k, w = "", C = 0, E = 0; E < M; E++) {
              for (var S = C, A = Math.min(E, k - 1), I = 0; I <= A; I++) {
                var O = r(m[I], 2),
                  j = O[0],
                  N = O[1] - 1 - E;
                N >= 0 && (S += j[N]);
              }
              S >= 10 ? (w = (S = S.toString())[S.length - 1] + w, C = Number(S.slice(0, -1))) : (w = S + w, C = 0);
            }
            if (0 === s) w = w.replace(/^0+/, "");else {
              var G = w.length - s;
              "." === (w = (w = (w = w.substring(0, G) + "." + w.substring(G)).replace(/^0+/, "")).replace(/\.?0+$/, ""))[0] && (w = "0" + w);
            }
            return w;
          }
          t.exports = o, t.exports.default = o;
        },
        1934: function _(t, e, n) {
          "use strict";

          var r = n(4971).MAX_SAFE_INTEGER_LENGTH;
          function a(t, e) {
            var n = t.length,
              a = e.length,
              i = t.indexOf("."),
              o = e.indexOf("."),
              s = -1 === i ? n : i,
              l = -1 === o ? a : o;
            if (-1 === i && -1 === o && n < r && a < r) return (Number(t) - Number(e)).toFixed();
            var h = s - l,
              u = Math.max(s, l),
              c = Math.max(n - s - 1, a - l - 1),
              f = h < 0 ? -1 * h : 0,
              d = h <= 0 ? 0 : h,
              _ = u + 1 + c - 1,
              p = "",
              y = 0,
              g = _;
            if (c > 0) {
              for (; g > _ - c;) {
                var m = t[g - f] || "0";
                m -= y, y = 0;
                var v = m - (e[g - d] || "0");
                if (v < 0) for (; v < 0;) {
                  y++, v += 10;
                } else y && y--;
                "" === p && 0 === v || (p = v + p), g--;
              }
              "" !== p && (p = "." + p), g--;
            }
            if (u > 0) {
              for (; g > 0;) {
                var x = t[g - f] || "0";
                x -= y, y = 0;
                var b = x - (e[g - d] || "0");
                if (b < 0) for (; b < 0;) {
                  y++, b += 10;
                } else y && y--;
                p = b + p, g--;
              }
              var k = t[0 - f] || "0",
                M = e[0 - d] || "0",
                w = Number(k) - (y > 0 ? 1 : 0) - Number(M);
              0 !== w && (p = w + p), p = p.replace(/^0+/, "");
            }
            return "." === p[0] && (p = "0" + p), p;
          }
          t.exports = a, t.exports.default = a;
        },
        5739: function _(t, e, n) {
          "use strict";

          var r = n(7481),
            a = n(6341),
            i = n(3679),
            o = n(490);
          function s(t, e) {
            t = a(t), e = a(e);
            var n = "-" !== t[0] != ("-" !== e[0]) ? "-" : "";
            if (t = r(t), e = r(e), "<" === i(t, e)) {
              var s = t;
              t = e, e = s;
            }
            return n + o(t, e);
          }
          t.exports = s, t.exports.default = s;
        },
        3708: function _(t, e, n) {
          "use strict";

          var r = n(9627),
            a = n(5161),
            i = ["5", "6", "7", "8", "9"];
          function o(t) {
            if (t.match(/\.9+$/)) return r(a(t), "1");
            "+" === t[0] && (t = t.substring(1));
            var e = t.length,
              n = "",
              o = t[t.length - 1];
            if (i.includes(o)) {
              var s;
              for (s = e - 2; s >= 0; s--) {
                var l = t[s];
                if ("." !== l && "-" !== l) {
                  var h = Number(l) + 1;
                  if (10 !== h) {
                    n = h + n;
                    break;
                  }
                  n = "0" + n;
                }
              }
              s > 0 && (n = t.substring(0, s) + n);
            } else n = t.substring(0, e - 1);
            return "." === n[n.length - 1] && (n = n.substring(0, n.length - 1)), n.indexOf(".") > -1 && (n = n.replace(/0+$/, "")), n;
          }
          t.exports = o, t.exports.default = o;
        },
        8508: function _(t, e, n) {
          "use strict";

          var r = n(6341),
            a = n(3679),
            i = n(661),
            o = n(1934);
          function s(t, e) {
            t = r(t), e = r(e);
            var n = "-" !== t[0],
              s = "-" !== e[0];
            if (n) {
              if (s) {
                var l = a(t, e);
                return ">" === l ? o(t, e) : "<" === l ? "-" + o(e, t) : "0";
              }
              return i(t, e.substring(1));
            }
            if (s) return "-" + i(t.substring(1), e);
            t = t.substring(1), e = e.substring(1);
            var h = a(t, e);
            return ">" === h ? "-" + o(t, e) : "<" === h ? o(e, t) : "0";
          }
          t.exports = s, t.exports.default = s;
        },
        5161: function _(t) {
          "use strict";

          function e(t) {
            return t.substring(0, t.indexOf("."));
          }
          t.exports = e, t.exports.default = e;
        },
        8896: function _(t, e, n) {
          function r(t) {
            return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, r(t);
          }
          var a = n(9052),
            i = n(9613);
          "object" === r(a) && "function" != typeof a.defs && "function" == typeof a.default && (a = a.default), a.defs(i), t.exports = a;
        },
        3759: function _(t, e, n) {
          var r;
          function a(t) {
            return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, a(t);
          }
          t = n.nmd(t);
          var i = n(9052),
            o = n(9613);
          "object" === a(i) && "function" != typeof i.defs && "function" == typeof i.default && (i = i.default), i.defs(o), void 0 === (r = function () {
            return i;
          }.call(e, n, e, t)) || (t.exports = r), "object" === a(t) && (t.exports = i, t.exports.default = i);
        },
        9260: function _(t, e, n) {
          var r;
          function a(t) {
            return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, a(t);
          }
          function i() {
            var t = [],
              e = function e(t) {
                return "object" === a(t) && 0 === Object.keys(t).length && "{}" === JSON.stringify(t);
              },
              n = function n(r) {
                if (r) {
                  if (Array.isArray(r)) return r.forEach(n);
                  r.default && (r = r.default), e(r) || t.push(r);
                }
              };
            if (Array.from(arguments).forEach(n), 0 === t.length) throw Error("[proj4-merge] merge called with zero instances of proj4");
            var r = t[0],
              i = t.slice(1);
            return i.forEach(function (t) {
              r.defs(Object.entries(t.defs));
            }), r;
          }
          t = n.nmd(t), void 0 === (r = function () {
            return i;
          }.call(e, n, e, t)) || (t.exports = r), "object" === a(t) && (t.exports = i, t.exports.default = i);
        },
        9052: function _(t, e, n) {
          "use strict";

          n.r(e), n.d(e, {
            default: function _default() {
              return qe;
            }
          });
          var r = 6378137,
            a = .0066943799901413165,
            i = 484813681109536e-20,
            o = Math.PI / 2,
            s = 1e-10,
            l = .017453292519943295,
            h = 57.29577951308232,
            u = Math.PI / 4,
            c = 2 * Math.PI,
            f = 3.14159265359,
            d = {
              greenwich: 0,
              lisbon: -9.131906111111,
              paris: 2.337229166667,
              bogota: -74.080916666667,
              madrid: -3.687938888889,
              rome: 12.452333333333,
              bern: 7.439583333333,
              jakarta: 106.807719444444,
              ferro: -17.666666666667,
              brussels: 4.367975,
              stockholm: 18.058277777778,
              athens: 23.7163375,
              oslo: 10.722916666667
            };
          var _ = {
            ft: {
              to_meter: .3048
            },
            "us-ft": {
              to_meter: 1200 / 3937
            }
          };
          var p = /[\s_\-\/\(\)]/g;
          function y(t, e) {
            if (t[e]) return t[e];
            for (var n, r = Object.keys(t), a = e.toLowerCase().replace(p, ""), i = -1; ++i < r.length;) {
              if ((n = r[i]).toLowerCase().replace(p, "") === a) return t[n];
            }
          }
          function g(t) {
            var e,
              n,
              r,
              _a2 = {},
              i = t.split("+").map(function (t) {
                return t.trim();
              }).filter(function (t) {
                return t;
              }).reduce(function (t, e) {
                var n = e.split("=");
                return n.push(!0), t[n[0].toLowerCase()] = n[1], t;
              }, {}),
              o = {
                proj: "projName",
                datum: "datumCode",
                rf: function rf(t) {
                  _a2.rf = parseFloat(t);
                },
                lat_0: function lat_0(t) {
                  _a2.lat0 = t * l;
                },
                lat_1: function lat_1(t) {
                  _a2.lat1 = t * l;
                },
                lat_2: function lat_2(t) {
                  _a2.lat2 = t * l;
                },
                lat_ts: function lat_ts(t) {
                  _a2.lat_ts = t * l;
                },
                lon_0: function lon_0(t) {
                  _a2.long0 = t * l;
                },
                lon_1: function lon_1(t) {
                  _a2.long1 = t * l;
                },
                lon_2: function lon_2(t) {
                  _a2.long2 = t * l;
                },
                alpha: function alpha(t) {
                  _a2.alpha = parseFloat(t) * l;
                },
                gamma: function gamma(t) {
                  _a2.rectified_grid_angle = parseFloat(t);
                },
                lonc: function lonc(t) {
                  _a2.longc = t * l;
                },
                x_0: function x_0(t) {
                  _a2.x0 = parseFloat(t);
                },
                y_0: function y_0(t) {
                  _a2.y0 = parseFloat(t);
                },
                k_0: function k_0(t) {
                  _a2.k0 = parseFloat(t);
                },
                k: function k(t) {
                  _a2.k0 = parseFloat(t);
                },
                a: function a(t) {
                  _a2.a = parseFloat(t);
                },
                b: function b(t) {
                  _a2.b = parseFloat(t);
                },
                r_a: function r_a() {
                  _a2.R_A = !0;
                },
                zone: function zone(t) {
                  _a2.zone = parseInt(t, 10);
                },
                south: function south() {
                  _a2.utmSouth = !0;
                },
                towgs84: function towgs84(t) {
                  _a2.datum_params = t.split(",").map(function (t) {
                    return parseFloat(t);
                  });
                },
                to_meter: function to_meter(t) {
                  _a2.to_meter = parseFloat(t);
                },
                units: function units(t) {
                  _a2.units = t;
                  var e = y(_, t);
                  e && (_a2.to_meter = e.to_meter);
                },
                from_greenwich: function from_greenwich(t) {
                  _a2.from_greenwich = t * l;
                },
                pm: function pm(t) {
                  var e = y(d, t);
                  _a2.from_greenwich = (e || parseFloat(t)) * l;
                },
                nadgrids: function nadgrids(t) {
                  "@null" === t ? _a2.datumCode = "none" : _a2.nadgrids = t;
                },
                axis: function axis(t) {
                  var e = "ewnsud";
                  3 === t.length && -1 !== e.indexOf(t.substr(0, 1)) && -1 !== e.indexOf(t.substr(1, 1)) && -1 !== e.indexOf(t.substr(2, 1)) && (_a2.axis = t);
                },
                approx: function approx() {
                  _a2.approx = !0;
                }
              };
            for (e in i) {
              n = i[e], e in o ? "function" == typeof (r = o[e]) ? r(n) : _a2[r] = n : _a2[e] = n;
            }
            return "string" == typeof _a2.datumCode && "WGS84" !== _a2.datumCode && (_a2.datumCode = _a2.datumCode.toLowerCase()), _a2;
          }
          var m = /\s/,
            v = /[A-Za-z]/,
            x = /[A-Za-z84_]/,
            b = /[,\]]/,
            k = /[\d\.E\-\+]/;
          function M(t) {
            if ("string" != typeof t) throw new Error("not a string");
            this.text = t.trim(), this.level = 0, this.place = 0, this.root = null, this.stack = [], this.currentObject = null, this.state = 1;
          }
          function w(t, e, n) {
            Array.isArray(e) && (n.unshift(e), e = null);
            var r = e ? {} : t,
              a = n.reduce(function (t, e) {
                return C(e, t), t;
              }, r);
            e && (t[e] = a);
          }
          function C(t, e) {
            if (Array.isArray(t)) {
              var n = t.shift();
              if ("PARAMETER" === n && (n = t.shift()), 1 === t.length) return Array.isArray(t[0]) ? (e[n] = {}, void C(t[0], e[n])) : void (e[n] = t[0]);
              if (t.length) {
                if ("TOWGS84" !== n) {
                  if ("AXIS" === n) return n in e || (e[n] = []), void e[n].push(t);
                  var r;
                  switch (Array.isArray(n) || (e[n] = {}), n) {
                    case "UNIT":
                    case "PRIMEM":
                    case "VERT_DATUM":
                      return e[n] = {
                        name: t[0].toLowerCase(),
                        convert: t[1]
                      }, void (3 === t.length && C(t[2], e[n]));
                    case "SPHEROID":
                    case "ELLIPSOID":
                      return e[n] = {
                        name: t[0],
                        a: t[1],
                        rf: t[2]
                      }, void (4 === t.length && C(t[3], e[n]));
                    case "PROJECTEDCRS":
                    case "PROJCRS":
                    case "GEOGCS":
                    case "GEOCCS":
                    case "PROJCS":
                    case "LOCAL_CS":
                    case "GEODCRS":
                    case "GEODETICCRS":
                    case "GEODETICDATUM":
                    case "EDATUM":
                    case "ENGINEERINGDATUM":
                    case "VERT_CS":
                    case "VERTCRS":
                    case "VERTICALCRS":
                    case "COMPD_CS":
                    case "COMPOUNDCRS":
                    case "ENGINEERINGCRS":
                    case "ENGCRS":
                    case "FITTED_CS":
                    case "LOCAL_DATUM":
                    case "DATUM":
                      return t[0] = ["name", t[0]], void w(e, n, t);
                    default:
                      for (r = -1; ++r < t.length;) {
                        if (!Array.isArray(t[r])) return C(t, e[n]);
                      }
                      return w(e, n, t);
                  }
                } else e[n] = t;
              } else e[n] = !0;
            } else e[t] = !0;
          }
          function E(t) {
            return E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, E(t);
          }
          function S(t) {
            return .017453292519943295 * t;
          }
          function A(t) {
            var e = new M(t).output(),
              n = e.shift(),
              r = e.shift();
            e.unshift(["name", r]), e.unshift(["type", n]);
            var a = {};
            return C(e, a), function (t) {
              if ("GEOGCS" === t.type ? t.projName = "longlat" : "LOCAL_CS" === t.type ? (t.projName = "identity", t.local = !0) : "object" === E(t.PROJECTION) ? t.projName = Object.keys(t.PROJECTION)[0] : t.projName = t.PROJECTION, t.AXIS) {
                for (var e = "", n = 0, r = t.AXIS.length; n < r; ++n) {
                  var a = [t.AXIS[n][0].toLowerCase(), t.AXIS[n][1].toLowerCase()];
                  -1 !== a[0].indexOf("north") || ("y" === a[0] || "lat" === a[0]) && "north" === a[1] ? e += "n" : -1 !== a[0].indexOf("south") || ("y" === a[0] || "lat" === a[0]) && "south" === a[1] ? e += "s" : -1 !== a[0].indexOf("east") || ("x" === a[0] || "lon" === a[0]) && "east" === a[1] ? e += "e" : -1 === a[0].indexOf("west") && ("x" !== a[0] && "lon" !== a[0] || "west" !== a[1]) || (e += "w");
                }
                2 === e.length && (e += "u"), 3 === e.length && (t.axis = e);
              }
              t.UNIT && (t.units = t.UNIT.name.toLowerCase(), "metre" === t.units && (t.units = "meter"), t.UNIT.convert && ("GEOGCS" === t.type ? t.DATUM && t.DATUM.SPHEROID && (t.to_meter = t.UNIT.convert * t.DATUM.SPHEROID.a) : t.to_meter = t.UNIT.convert));
              var i = t.GEOGCS;
              function o(e) {
                return e * (t.to_meter || 1);
              }
              "GEOGCS" === t.type && (i = t), i && (i.DATUM ? t.datumCode = i.DATUM.name.toLowerCase() : t.datumCode = i.name.toLowerCase(), "d_" === t.datumCode.slice(0, 2) && (t.datumCode = t.datumCode.slice(2)), "new_zealand_geodetic_datum_1949" !== t.datumCode && "new_zealand_1949" !== t.datumCode || (t.datumCode = "nzgd49"), "wgs_1984" !== t.datumCode && "world_geodetic_system_1984" !== t.datumCode || ("Mercator_Auxiliary_Sphere" === t.PROJECTION && (t.sphere = !0), t.datumCode = "wgs84"), "_ferro" === t.datumCode.slice(-6) && (t.datumCode = t.datumCode.slice(0, -6)), "_jakarta" === t.datumCode.slice(-8) && (t.datumCode = t.datumCode.slice(0, -8)), ~t.datumCode.indexOf("belge") && (t.datumCode = "rnb72"), i.DATUM && i.DATUM.SPHEROID && (t.ellps = i.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk"), "international" === t.ellps.toLowerCase().slice(0, 13) && (t.ellps = "intl"), t.a = i.DATUM.SPHEROID.a, t.rf = parseFloat(i.DATUM.SPHEROID.rf, 10)), i.DATUM && i.DATUM.TOWGS84 && (t.datum_params = i.DATUM.TOWGS84), ~t.datumCode.indexOf("osgb_1936") && (t.datumCode = "osgb36"), ~t.datumCode.indexOf("osni_1952") && (t.datumCode = "osni52"), (~t.datumCode.indexOf("tm65") || ~t.datumCode.indexOf("geodetic_datum_of_1965")) && (t.datumCode = "ire65"), "ch1903+" === t.datumCode && (t.datumCode = "ch1903"), ~t.datumCode.indexOf("israel") && (t.datumCode = "isr93")), t.b && !isFinite(t.b) && (t.b = t.a), [["standard_parallel_1", "Standard_Parallel_1"], ["standard_parallel_1", "Latitude of 1st standard parallel"], ["standard_parallel_2", "Standard_Parallel_2"], ["standard_parallel_2", "Latitude of 2nd standard parallel"], ["false_easting", "False_Easting"], ["false_easting", "False easting"], ["false-easting", "Easting at false origin"], ["false_northing", "False_Northing"], ["false_northing", "False northing"], ["false_northing", "Northing at false origin"], ["central_meridian", "Central_Meridian"], ["central_meridian", "Longitude of natural origin"], ["central_meridian", "Longitude of false origin"], ["latitude_of_origin", "Latitude_Of_Origin"], ["latitude_of_origin", "Central_Parallel"], ["latitude_of_origin", "Latitude of natural origin"], ["latitude_of_origin", "Latitude of false origin"], ["scale_factor", "Scale_Factor"], ["k0", "scale_factor"], ["latitude_of_center", "Latitude_Of_Center"], ["latitude_of_center", "Latitude_of_center"], ["lat0", "latitude_of_center", S], ["longitude_of_center", "Longitude_Of_Center"], ["longitude_of_center", "Longitude_of_center"], ["longc", "longitude_of_center", S], ["x0", "false_easting", o], ["y0", "false_northing", o], ["long0", "central_meridian", S], ["lat0", "latitude_of_origin", S], ["lat0", "standard_parallel_1", S], ["lat1", "standard_parallel_1", S], ["lat2", "standard_parallel_2", S], ["azimuth", "Azimuth"], ["alpha", "azimuth", S], ["srsCode", "name"]].forEach(function (e) {
                return function (t, e) {
                  var n = e[0],
                    r = e[1];
                  !(n in t) && r in t && (t[n] = t[r], 3 === e.length && (t[n] = e[2](t[n])));
                }(t, e);
              }), t.long0 || !t.longc || "Albers_Conic_Equal_Area" !== t.projName && "Lambert_Azimuthal_Equal_Area" !== t.projName || (t.long0 = t.longc), t.lat_ts || !t.lat1 || "Stereographic_South_Pole" !== t.projName && "Polar Stereographic (variant B)" !== t.projName || (t.lat0 = S(t.lat1 > 0 ? 90 : -90), t.lat_ts = t.lat1);
            }(a), a;
          }
          function I(t) {
            var e = this;
            if (2 === arguments.length) {
              var n = arguments[1];
              "string" == typeof n ? "+" === n.charAt(0) ? I[t] = g(arguments[1]) : I[t] = A(arguments[1]) : I[t] = n;
            } else if (1 === arguments.length) {
              if (Array.isArray(t)) return t.map(function (t) {
                Array.isArray(t) ? I.apply(e, t) : I(t);
              });
              if ("string" == typeof t) {
                if (t in I) return I[t];
              } else "EPSG" in t ? I["EPSG:" + t.EPSG] = t : "ESRI" in t ? I["ESRI:" + t.ESRI] = t : "IAU2000" in t ? I["IAU2000:" + t.IAU2000] = t : console.log(t);
              return;
            }
          }
          M.prototype.readCharicter = function () {
            var t = this.text[this.place++];
            if (4 !== this.state) for (; m.test(t);) {
              if (this.place >= this.text.length) return;
              t = this.text[this.place++];
            }
            switch (this.state) {
              case 1:
                return this.neutral(t);
              case 2:
                return this.keyword(t);
              case 4:
                return this.quoted(t);
              case 5:
                return this.afterquote(t);
              case 3:
                return this.number(t);
              case -1:
                return;
            }
          }, M.prototype.afterquote = function (t) {
            if ('"' === t) return this.word += '"', void (this.state = 4);
            if (b.test(t)) return this.word = this.word.trim(), void this.afterItem(t);
            throw new Error("havn't handled \"" + t + '" in afterquote yet, index ' + this.place);
          }, M.prototype.afterItem = function (t) {
            return "," === t ? (null !== this.word && this.currentObject.push(this.word), this.word = null, void (this.state = 1)) : "]" === t ? (this.level--, null !== this.word && (this.currentObject.push(this.word), this.word = null), this.state = 1, this.currentObject = this.stack.pop(), void (this.currentObject || (this.state = -1))) : void 0;
          }, M.prototype.number = function (t) {
            if (!k.test(t)) {
              if (b.test(t)) return this.word = parseFloat(this.word), void this.afterItem(t);
              throw new Error("havn't handled \"" + t + '" in number yet, index ' + this.place);
            }
            this.word += t;
          }, M.prototype.quoted = function (t) {
            '"' !== t ? this.word += t : this.state = 5;
          }, M.prototype.keyword = function (t) {
            if (x.test(t)) this.word += t;else {
              if ("[" === t) {
                var e = [];
                return e.push(this.word), this.level++, null === this.root ? this.root = e : this.currentObject.push(e), this.stack.push(this.currentObject), this.currentObject = e, void (this.state = 1);
              }
              if (!b.test(t)) throw new Error("havn't handled \"" + t + '" in keyword yet, index ' + this.place);
              this.afterItem(t);
            }
          }, M.prototype.neutral = function (t) {
            if (v.test(t)) return this.word = t, void (this.state = 2);
            if ('"' === t) return this.word = "", void (this.state = 4);
            if (k.test(t)) return this.word = t, void (this.state = 3);
            if (!b.test(t)) throw new Error("havn't handled \"" + t + '" in neutral yet, index ' + this.place);
            this.afterItem(t);
          }, M.prototype.output = function () {
            for (; this.place < this.text.length;) {
              this.readCharicter();
            }
            if (-1 === this.state) return this.root;
            throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
          }, function (t) {
            t("EPSG:4326", "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees"), t("EPSG:4269", "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees"), t("EPSG:3857", "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs"), t.WGS84 = t["EPSG:4326"], t["EPSG:3785"] = t["EPSG:3857"], t.GOOGLE = t["EPSG:3857"], t["EPSG:900913"] = t["EPSG:3857"], t["EPSG:102113"] = t["EPSG:3857"];
          }(I);
          var O = I;
          var j = ["PROJECTEDCRS", "PROJCRS", "GEOGCS", "GEOCCS", "PROJCS", "LOCAL_CS", "GEODCRS", "GEODETICCRS", "GEODETICDATUM", "ENGCRS", "ENGINEERINGCRS"],
            N = ["3857", "900913", "3785", "102113"];
          function G(t, e) {
            var n, r;
            if (t = t || {}, !e) return t;
            for (r in e) {
              void 0 !== (n = e[r]) && (t[r] = n);
            }
            return t;
          }
          function D(t, e, n) {
            var r = t * e;
            return n / Math.sqrt(1 - r * r);
          }
          function R(t) {
            return t < 0 ? -1 : 1;
          }
          function L(t) {
            return Math.abs(t) <= f ? t : t - R(t) * c;
          }
          function P(t, e, n) {
            var r = t * n,
              a = .5 * t;
            return r = Math.pow((1 - r) / (1 + r), a), Math.tan(.5 * (o - e)) / r;
          }
          function T(t, e) {
            for (var n, r, a = .5 * t, i = o - 2 * Math.atan(e), s = 0; s <= 15; s++) {
              if (n = t * Math.sin(i), i += r = o - 2 * Math.atan(e * Math.pow((1 - n) / (1 + n), a)) - i, Math.abs(r) <= 1e-10) return i;
            }
            return -9999;
          }
          function B(t) {
            return t;
          }
          var Q = [{
              init: function init() {
                var t = this.b / this.a;
                this.es = 1 - t * t, "x0" in this || (this.x0 = 0), "y0" in this || (this.y0 = 0), this.e = Math.sqrt(this.es), this.lat_ts ? this.sphere ? this.k0 = Math.cos(this.lat_ts) : this.k0 = D(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) : this.k0 || (this.k ? this.k0 = this.k : this.k0 = 1);
              },
              forward: function forward(t) {
                var e,
                  n,
                  r = t.x,
                  a = t.y;
                if (a * h > 90 && a * h < -90 && r * h > 180 && r * h < -180) return null;
                if (Math.abs(Math.abs(a) - o) <= s) return null;
                if (this.sphere) e = this.x0 + this.a * this.k0 * L(r - this.long0), n = this.y0 + this.a * this.k0 * Math.log(Math.tan(u + .5 * a));else {
                  var i = Math.sin(a),
                    l = P(this.e, a, i);
                  e = this.x0 + this.a * this.k0 * L(r - this.long0), n = this.y0 - this.a * this.k0 * Math.log(l);
                }
                return t.x = e, t.y = n, t;
              },
              inverse: function inverse(t) {
                var e,
                  n,
                  r = t.x - this.x0,
                  a = t.y - this.y0;
                if (this.sphere) n = o - 2 * Math.atan(Math.exp(-a / (this.a * this.k0)));else {
                  var i = Math.exp(-a / (this.a * this.k0));
                  if (-9999 === (n = T(this.e, i))) return null;
                }
                return e = L(this.long0 + r / (this.a * this.k0)), t.x = e, t.y = n, t;
              },
              names: ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "merc"]
            }, {
              init: function init() {},
              forward: B,
              inverse: B,
              names: ["longlat", "identity"]
            }],
            F = {},
            q = [];
          function U(t, e) {
            var n = q.length;
            return t.names ? (q[n] = t, t.names.forEach(function (t) {
              F[t.toLowerCase()] = n;
            }), this) : (console.log(e), !0);
          }
          var z = {
            start: function start() {
              Q.forEach(U);
            },
            add: U,
            get: function get(t) {
              if (!t) return !1;
              var e = t.toLowerCase();
              return void 0 !== F[e] && q[F[e]] ? q[F[e]] : void 0;
            }
          };
          var H = {
              MERIT: {
                a: 6378137,
                rf: 298.257,
                ellipseName: "MERIT 1983"
              },
              SGS85: {
                a: 6378136,
                rf: 298.257,
                ellipseName: "Soviet Geodetic System 85"
              },
              GRS80: {
                a: 6378137,
                rf: 298.257222101,
                ellipseName: "GRS 1980(IUGG, 1980)"
              },
              IAU76: {
                a: 6378140,
                rf: 298.257,
                ellipseName: "IAU 1976"
              },
              airy: {
                a: 6377563.396,
                b: 6356256.91,
                ellipseName: "Airy 1830"
              },
              APL4: {
                a: 6378137,
                rf: 298.25,
                ellipseName: "Appl. Physics. 1965"
              },
              NWL9D: {
                a: 6378145,
                rf: 298.25,
                ellipseName: "Naval Weapons Lab., 1965"
              },
              mod_airy: {
                a: 6377340.189,
                b: 6356034.446,
                ellipseName: "Modified Airy"
              },
              andrae: {
                a: 6377104.43,
                rf: 300,
                ellipseName: "Andrae 1876 (Den., Iclnd.)"
              },
              aust_SA: {
                a: 6378160,
                rf: 298.25,
                ellipseName: "Australian Natl & S. Amer. 1969"
              },
              GRS67: {
                a: 6378160,
                rf: 298.247167427,
                ellipseName: "GRS 67(IUGG 1967)"
              },
              bessel: {
                a: 6377397.155,
                rf: 299.1528128,
                ellipseName: "Bessel 1841"
              },
              bess_nam: {
                a: 6377483.865,
                rf: 299.1528128,
                ellipseName: "Bessel 1841 (Namibia)"
              },
              clrk66: {
                a: 6378206.4,
                b: 6356583.8,
                ellipseName: "Clarke 1866"
              },
              clrk80: {
                a: 6378249.145,
                rf: 293.4663,
                ellipseName: "Clarke 1880 mod."
              },
              clrk58: {
                a: 6378293.645208759,
                rf: 294.2606763692654,
                ellipseName: "Clarke 1858"
              },
              CPM: {
                a: 6375738.7,
                rf: 334.29,
                ellipseName: "Comm. des Poids et Mesures 1799"
              },
              delmbr: {
                a: 6376428,
                rf: 311.5,
                ellipseName: "Delambre 1810 (Belgium)"
              },
              engelis: {
                a: 6378136.05,
                rf: 298.2566,
                ellipseName: "Engelis 1985"
              },
              evrst30: {
                a: 6377276.345,
                rf: 300.8017,
                ellipseName: "Everest 1830"
              },
              evrst48: {
                a: 6377304.063,
                rf: 300.8017,
                ellipseName: "Everest 1948"
              },
              evrst56: {
                a: 6377301.243,
                rf: 300.8017,
                ellipseName: "Everest 1956"
              },
              evrst69: {
                a: 6377295.664,
                rf: 300.8017,
                ellipseName: "Everest 1969"
              },
              evrstSS: {
                a: 6377298.556,
                rf: 300.8017,
                ellipseName: "Everest (Sabah & Sarawak)"
              },
              fschr60: {
                a: 6378166,
                rf: 298.3,
                ellipseName: "Fischer (Mercury Datum) 1960"
              },
              fschr60m: {
                a: 6378155,
                rf: 298.3,
                ellipseName: "Fischer 1960"
              },
              fschr68: {
                a: 6378150,
                rf: 298.3,
                ellipseName: "Fischer 1968"
              },
              helmert: {
                a: 6378200,
                rf: 298.3,
                ellipseName: "Helmert 1906"
              },
              hough: {
                a: 6378270,
                rf: 297,
                ellipseName: "Hough"
              },
              intl: {
                a: 6378388,
                rf: 297,
                ellipseName: "International 1909 (Hayford)"
              },
              kaula: {
                a: 6378163,
                rf: 298.24,
                ellipseName: "Kaula 1961"
              },
              lerch: {
                a: 6378139,
                rf: 298.257,
                ellipseName: "Lerch 1979"
              },
              mprts: {
                a: 6397300,
                rf: 191,
                ellipseName: "Maupertius 1738"
              },
              new_intl: {
                a: 6378157.5,
                b: 6356772.2,
                ellipseName: "New International 1967"
              },
              plessis: {
                a: 6376523,
                rf: 6355863,
                ellipseName: "Plessis 1817 (France)"
              },
              krass: {
                a: 6378245,
                rf: 298.3,
                ellipseName: "Krassovsky, 1942"
              },
              SEasia: {
                a: 6378155,
                b: 6356773.3205,
                ellipseName: "Southeast Asia"
              },
              walbeck: {
                a: 6376896,
                b: 6355834.8467,
                ellipseName: "Walbeck"
              },
              WGS60: {
                a: 6378165,
                rf: 298.3,
                ellipseName: "WGS 60"
              },
              WGS66: {
                a: 6378145,
                rf: 298.25,
                ellipseName: "WGS 66"
              },
              WGS7: {
                a: 6378135,
                rf: 298.26,
                ellipseName: "WGS 72"
              }
            },
            Z = H.WGS84 = {
              a: 6378137,
              rf: 298.257223563,
              ellipseName: "WGS 84"
            };
          H.sphere = {
            a: 6370997,
            b: 6370997,
            ellipseName: "Normal Sphere (r=6370997)"
          };
          var X = {
            wgs84: {
              towgs84: "0,0,0",
              ellipse: "WGS84",
              datumName: "WGS84"
            },
            ch1903: {
              towgs84: "674.374,15.056,405.346",
              ellipse: "bessel",
              datumName: "swiss"
            },
            ggrs87: {
              towgs84: "-199.87,74.79,246.62",
              ellipse: "GRS80",
              datumName: "Greek_Geodetic_Reference_System_1987"
            },
            nad83: {
              towgs84: "0,0,0",
              ellipse: "GRS80",
              datumName: "North_American_Datum_1983"
            },
            nad27: {
              nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
              ellipse: "clrk66",
              datumName: "North_American_Datum_1927"
            },
            potsdam: {
              towgs84: "598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
              ellipse: "bessel",
              datumName: "Potsdam Rauenberg 1950 DHDN"
            },
            carthage: {
              towgs84: "-263.0,6.0,431.0",
              ellipse: "clark80",
              datumName: "Carthage 1934 Tunisia"
            },
            hermannskogel: {
              towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
              ellipse: "bessel",
              datumName: "Hermannskogel"
            },
            osni52: {
              towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
              ellipse: "airy",
              datumName: "Irish National"
            },
            ire65: {
              towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
              ellipse: "mod_airy",
              datumName: "Ireland 1965"
            },
            rassadiran: {
              towgs84: "-133.63,-157.5,-158.62",
              ellipse: "intl",
              datumName: "Rassadiran"
            },
            nzgd49: {
              towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
              ellipse: "intl",
              datumName: "New Zealand Geodetic Datum 1949"
            },
            osgb36: {
              towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
              ellipse: "airy",
              datumName: "Airy 1830"
            },
            s_jtsk: {
              towgs84: "589,76,480",
              ellipse: "bessel",
              datumName: "S-JTSK (Ferro)"
            },
            beduaram: {
              towgs84: "-106,-87,188",
              ellipse: "clrk80",
              datumName: "Beduaram"
            },
            gunung_segara: {
              towgs84: "-403,684,41",
              ellipse: "bessel",
              datumName: "Gunung Segara Jakarta"
            },
            rnb72: {
              towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
              ellipse: "intl",
              datumName: "Reseau National Belge 1972"
            }
          };
          var J = {};
          function W(t) {
            if (0 === t.length) return null;
            var e = "@" === t[0];
            return e && (t = t.slice(1)), "null" === t ? {
              name: "null",
              mandatory: !e,
              grid: null,
              isNull: !0
            } : {
              name: t,
              mandatory: !e,
              grid: J[t] || null,
              isNull: !1
            };
          }
          function V(t) {
            return t / 3600 * Math.PI / 180;
          }
          function Y(t, e, n) {
            return String.fromCharCode.apply(null, new Uint8Array(t.buffer.slice(e, n)));
          }
          function K(t) {
            return t.map(function (t) {
              return [V(t.longitudeShift), V(t.latitudeShift)];
            });
          }
          function $(t, e, n) {
            return {
              name: Y(t, e + 8, e + 16).trim(),
              parent: Y(t, e + 24, e + 24 + 8).trim(),
              lowerLatitude: t.getFloat64(e + 72, n),
              upperLatitude: t.getFloat64(e + 88, n),
              lowerLongitude: t.getFloat64(e + 104, n),
              upperLongitude: t.getFloat64(e + 120, n),
              latitudeInterval: t.getFloat64(e + 136, n),
              longitudeInterval: t.getFloat64(e + 152, n),
              gridNodeCount: t.getInt32(e + 168, n)
            };
          }
          function tt(t, e, n, r) {
            for (var a = e + 176, i = [], o = 0; o < n.gridNodeCount; o++) {
              var s = {
                latitudeShift: t.getFloat32(a + 16 * o, r),
                longitudeShift: t.getFloat32(a + 16 * o + 4, r),
                latitudeAccuracy: t.getFloat32(a + 16 * o + 8, r),
                longitudeAccuracy: t.getFloat32(a + 16 * o + 12, r)
              };
              i.push(s);
            }
            return i;
          }
          function et(t) {
            return et = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, et(t);
          }
          function nt(t, e) {
            if (!(this instanceof nt)) return new nt(t);
            e = e || function (t) {
              if (t) throw t;
            };
            var n = function (t) {
              if (!function (t) {
                return "string" == typeof t;
              }(t)) return t;
              if (function (t) {
                return t in O;
              }(t)) return O[t];
              if (function (t) {
                return j.some(function (e) {
                  return t.indexOf(e) > -1;
                });
              }(t)) {
                var e = A(t);
                if (function (t) {
                  var e = y(t, "authority");
                  if (e) {
                    var n = y(e, "epsg");
                    return n && N.indexOf(n) > -1;
                  }
                }(e)) return O["EPSG:3857"];
                var n = function (t) {
                  var e = y(t, "extension");
                  if (e) return y(e, "proj4");
                }(e);
                return n ? g(n) : e;
              }
              return function (t) {
                return "+" === t[0];
              }(t) ? g(t) : void 0;
            }(t);
            if ("object" === et(n)) {
              var r = nt.projections.get(n.projName);
              if (r) {
                if (n.datumCode && "none" !== n.datumCode) {
                  var a = y(X, n.datumCode);
                  a && (n.datum_params = n.datum_params || (a.towgs84 ? a.towgs84.split(",") : null), n.ellps = a.ellipse, n.datumName = a.datumName ? a.datumName : n.datumCode);
                }
                n.k0 = n.k0 || 1, n.axis = n.axis || "enu", n.ellps = n.ellps || "wgs84", n.lat1 = n.lat1 || n.lat0;
                var o,
                  l,
                  h,
                  u,
                  c,
                  f,
                  d = function (t, e, n, r, a) {
                    if (!t) {
                      var i = y(H, r);
                      i || (i = Z), t = i.a, e = i.b, n = i.rf;
                    }
                    return n && !e && (e = (1 - 1 / n) * t), (0 === n || Math.abs(t - e) < s) && (a = !0, e = t), {
                      a: t,
                      b: e,
                      rf: n,
                      sphere: a
                    };
                  }(n.a, n.b, n.rf, n.ellps, n.sphere),
                  _ = (o = d.a, l = d.b, d.rf, c = ((h = o * o) - (u = l * l)) / h, f = 0, n.R_A ? (h = (o *= 1 - c * (.16666666666666666 + c * (.04722222222222222 + .022156084656084655 * c))) * o, c = 0) : f = Math.sqrt(c), {
                    es: c,
                    e: f,
                    ep2: (h - u) / u
                  }),
                  p = function (t) {
                    return void 0 === t ? null : t.split(",").map(W);
                  }(n.nadgrids),
                  m = n.datum || function (t, e, n, r, a, o, s) {
                    var l = {};
                    return l.datum_type = void 0 === t || "none" === t ? 5 : 4, e && (l.datum_params = e.map(parseFloat), 0 === l.datum_params[0] && 0 === l.datum_params[1] && 0 === l.datum_params[2] || (l.datum_type = 1), l.datum_params.length > 3 && (0 === l.datum_params[3] && 0 === l.datum_params[4] && 0 === l.datum_params[5] && 0 === l.datum_params[6] || (l.datum_type = 2, l.datum_params[3] *= i, l.datum_params[4] *= i, l.datum_params[5] *= i, l.datum_params[6] = l.datum_params[6] / 1e6 + 1))), s && (l.datum_type = 3, l.grids = s), l.a = n, l.b = r, l.es = a, l.ep2 = o, l;
                  }(n.datumCode, n.datum_params, d.a, d.b, _.es, _.ep2, p);
                G(this, n), G(this, r), this.a = d.a, this.b = d.b, this.rf = d.rf, this.sphere = d.sphere, this.es = _.es, this.e = _.e, this.ep2 = _.ep2, this.datum = m, this.init(), e(null, this);
              } else e(t);
            } else e(t);
          }
          nt.projections = z, nt.projections.start();
          var rt = nt;
          function at(t, e, n) {
            var r,
              a,
              i,
              s,
              l = t.x,
              h = t.y,
              u = t.z ? t.z : 0;
            if (h < -o && h > -1.001 * o) h = -o;else if (h > o && h < 1.001 * o) h = o;else {
              if (h < -o) return {
                x: -1 / 0,
                y: -1 / 0,
                z: t.z
              };
              if (h > o) return {
                x: 1 / 0,
                y: 1 / 0,
                z: t.z
              };
            }
            return l > Math.PI && (l -= 2 * Math.PI), a = Math.sin(h), s = Math.cos(h), i = a * a, {
              x: ((r = n / Math.sqrt(1 - e * i)) + u) * s * Math.cos(l),
              y: (r + u) * s * Math.sin(l),
              z: (r * (1 - e) + u) * a
            };
          }
          function it(t, e, n, r) {
            var a,
              i,
              o,
              s,
              l,
              h,
              u,
              c,
              f,
              d,
              _,
              p,
              y,
              g,
              m,
              v = t.x,
              x = t.y,
              b = t.z ? t.z : 0;
            if (a = Math.sqrt(v * v + x * x), i = Math.sqrt(v * v + x * x + b * b), a / n < 1e-12) {
              if (g = 0, i / n < 1e-12) return m = -r, {
                x: t.x,
                y: t.y,
                z: t.z
              };
            } else g = Math.atan2(x, v);
            o = b / i, c = (s = a / i) * (1 - e) * (l = 1 / Math.sqrt(1 - e * (2 - e) * s * s)), f = o * l, y = 0;
            do {
              y++, h = e * (u = n / Math.sqrt(1 - e * f * f)) / (u + (m = a * c + b * f - u * (1 - e * f * f))), p = (_ = o * (l = 1 / Math.sqrt(1 - h * (2 - h) * s * s))) * c - (d = s * (1 - h) * l) * f, c = d, f = _;
            } while (p * p > 1e-24 && y < 30);
            return {
              x: g,
              y: Math.atan(_ / Math.abs(d)),
              z: m
            };
          }
          function ot(t) {
            return 1 === t || 2 === t;
          }
          function st(t, e, n) {
            if (null === t.grids || 0 === t.grids.length) return console.log("Grid shift grids not found"), -1;
            for (var r = {
                x: -n.x,
                y: n.y
              }, a = {
                x: Number.NaN,
                y: Number.NaN
              }, i = [], o = 0; o < t.grids.length; o++) {
              var s = t.grids[o];
              if (i.push(s.name), s.isNull) {
                a = r;
                break;
              }
              if (s.mandatory, null !== s.grid) {
                var l = s.grid.subgrids[0],
                  u = (Math.abs(l.del[1]) + Math.abs(l.del[0])) / 1e4,
                  c = l.ll[0] - u,
                  f = l.ll[1] - u,
                  d = l.ll[0] + (l.lim[0] - 1) * l.del[0] + u,
                  _ = l.ll[1] + (l.lim[1] - 1) * l.del[1] + u;
                if (!(f > r.y || c > r.x || _ < r.y || d < r.x || (a = lt(r, e, l), isNaN(a.x)))) break;
              } else if (s.mandatory) return console.log("Unable to find mandatory grid '" + s.name + "'"), -1;
            }
            return isNaN(a.x) ? (console.log("Failed to find a grid shift table for location '" + -r.x * h + " " + r.y * h + " tried: '" + i + "'"), -1) : (n.x = -a.x, n.y = a.y, 0);
          }
          function lt(t, e, n) {
            var r = {
              x: Number.NaN,
              y: Number.NaN
            };
            if (isNaN(t.x)) return r;
            var a = {
              x: t.x,
              y: t.y
            };
            a.x -= n.ll[0], a.y -= n.ll[1], a.x = L(a.x - Math.PI) + Math.PI;
            var i = ht(a, n);
            if (e) {
              if (isNaN(i.x)) return r;
              i.x = a.x - i.x, i.y = a.y - i.y;
              var o,
                s,
                l = 9;
              do {
                if (s = ht(i, n), isNaN(s.x)) {
                  console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
                  break;
                }
                o = {
                  x: a.x - (s.x + i.x),
                  y: a.y - (s.y + i.y)
                }, i.x += o.x, i.y += o.y;
              } while (l-- && Math.abs(o.x) > 1e-12 && Math.abs(o.y) > 1e-12);
              if (l < 0) return console.log("Inverse grid shift iterator failed to converge."), r;
              r.x = L(i.x + n.ll[0]), r.y = i.y + n.ll[1];
            } else isNaN(i.x) || (r.x = t.x + i.x, r.y = t.y + i.y);
            return r;
          }
          function ht(t, e) {
            var n,
              r = {
                x: t.x / e.del[0],
                y: t.y / e.del[1]
              },
              a = Math.floor(r.x),
              i = Math.floor(r.y),
              o = r.x - 1 * a,
              s = r.y - 1 * i,
              l = {
                x: Number.NaN,
                y: Number.NaN
              };
            if (a < 0 || a >= e.lim[0]) return l;
            if (i < 0 || i >= e.lim[1]) return l;
            n = i * e.lim[0] + a;
            var h = e.cvs[n][0],
              u = e.cvs[n][1];
            n++;
            var c = e.cvs[n][0],
              f = e.cvs[n][1];
            n += e.lim[0];
            var d = e.cvs[n][0],
              _ = e.cvs[n][1];
            n--;
            var p = e.cvs[n][0],
              y = e.cvs[n][1],
              g = o * s,
              m = o * (1 - s),
              v = (1 - o) * (1 - s),
              x = (1 - o) * s;
            return l.x = v * h + m * c + x * p + g * d, l.y = v * u + m * f + x * y + g * _, l;
          }
          function ut(t, e, n) {
            var r,
              a,
              i,
              o = n.x,
              s = n.y,
              l = n.z || 0,
              h = {};
            for (i = 0; i < 3; i++) {
              if (!e || 2 !== i || void 0 !== n.z) switch (0 === i ? (r = o, a = -1 !== "ew".indexOf(t.axis[i]) ? "x" : "y") : 1 === i ? (r = s, a = -1 !== "ns".indexOf(t.axis[i]) ? "y" : "x") : (r = l, a = "z"), t.axis[i]) {
                case "e":
                case "n":
                  h[a] = r;
                  break;
                case "w":
                case "s":
                  h[a] = -r;
                  break;
                case "u":
                  void 0 !== n[a] && (h.z = r);
                  break;
                case "d":
                  void 0 !== n[a] && (h.z = -r);
                  break;
                default:
                  return null;
              }
            }
            return h;
          }
          function ct(t) {
            var e = {
              x: t[0],
              y: t[1]
            };
            return t.length > 2 && (e.z = t[2]), t.length > 3 && (e.m = t[3]), e;
          }
          function ft(t) {
            if ("function" == typeof Number.isFinite) {
              if (Number.isFinite(t)) return;
              throw new TypeError("coordinates must be finite numbers");
            }
            if ("number" != typeof t || t != t || !isFinite(t)) throw new TypeError("coordinates must be finite numbers");
          }
          function dt(t, e, n, i) {
            var o;
            if (Array.isArray(n) && (n = ct(n)), function (t) {
              ft(t.x), ft(t.y);
            }(n), t.datum && e.datum && function (t, e) {
              return (1 === t.datum.datum_type || 2 === t.datum.datum_type) && "WGS84" !== e.datumCode || (1 === e.datum.datum_type || 2 === e.datum.datum_type) && "WGS84" !== t.datumCode;
            }(t, e) && (n = dt(t, o = new rt("WGS84"), n, i), t = o), i && "enu" !== t.axis && (n = ut(t, !1, n)), "longlat" === t.projName) n = {
              x: n.x * l,
              y: n.y * l,
              z: n.z || 0
            };else if (t.to_meter && (n = {
              x: n.x * t.to_meter,
              y: n.y * t.to_meter,
              z: n.z || 0
            }), !(n = t.inverse(n))) return;
            if (t.from_greenwich && (n.x += t.from_greenwich), n = function (t, e, n) {
              if (function (t, e) {
                return t.datum_type === e.datum_type && !(t.a !== e.a || Math.abs(t.es - e.es) > 5e-11) && (1 === t.datum_type ? t.datum_params[0] === e.datum_params[0] && t.datum_params[1] === e.datum_params[1] && t.datum_params[2] === e.datum_params[2] : 2 !== t.datum_type || t.datum_params[0] === e.datum_params[0] && t.datum_params[1] === e.datum_params[1] && t.datum_params[2] === e.datum_params[2] && t.datum_params[3] === e.datum_params[3] && t.datum_params[4] === e.datum_params[4] && t.datum_params[5] === e.datum_params[5] && t.datum_params[6] === e.datum_params[6]);
              }(t, e)) return n;
              if (5 === t.datum_type || 5 === e.datum_type) return n;
              var i = t.a,
                o = t.es;
              if (3 === t.datum_type) {
                if (0 !== st(t, !1, n)) return;
                i = r, o = a;
              }
              var s = e.a,
                l = e.b,
                h = e.es;
              return 3 === e.datum_type && (s = r, l = 6356752.314, h = a), o !== h || i !== s || ot(t.datum_type) || ot(e.datum_type) ? (n = at(n, o, i), ot(t.datum_type) && (n = function (t, e, n) {
                if (1 === e) return {
                  x: t.x + n[0],
                  y: t.y + n[1],
                  z: t.z + n[2]
                };
                if (2 === e) {
                  var r = n[0],
                    a = n[1],
                    i = n[2],
                    o = n[3],
                    s = n[4],
                    l = n[5],
                    h = n[6];
                  return {
                    x: h * (t.x - l * t.y + s * t.z) + r,
                    y: h * (l * t.x + t.y - o * t.z) + a,
                    z: h * (-s * t.x + o * t.y + t.z) + i
                  };
                }
              }(n, t.datum_type, t.datum_params)), ot(e.datum_type) && (n = function (t, e, n) {
                if (1 === e) return {
                  x: t.x - n[0],
                  y: t.y - n[1],
                  z: t.z - n[2]
                };
                if (2 === e) {
                  var r = n[0],
                    a = n[1],
                    i = n[2],
                    o = n[3],
                    s = n[4],
                    l = n[5],
                    h = n[6],
                    u = (t.x - r) / h,
                    c = (t.y - a) / h,
                    f = (t.z - i) / h;
                  return {
                    x: u + l * c - s * f,
                    y: -l * u + c + o * f,
                    z: s * u - o * c + f
                  };
                }
              }(n, e.datum_type, e.datum_params)), n = it(n, h, s, l), 3 !== e.datum_type || 0 === st(e, !0, n) ? n : void 0) : n;
            }(t.datum, e.datum, n)) return e.from_greenwich && (n = {
              x: n.x - e.from_greenwich,
              y: n.y,
              z: n.z || 0
            }), "longlat" === e.projName ? n = {
              x: n.x * h,
              y: n.y * h,
              z: n.z || 0
            } : (n = e.forward(n), e.to_meter && (n = {
              x: n.x / e.to_meter,
              y: n.y / e.to_meter,
              z: n.z || 0
            })), i && "enu" !== e.axis ? ut(e, !0, n) : n;
          }
          var _t = rt("WGS84");
          function pt(t, e, n, r) {
            var a, i, o;
            return Array.isArray(n) ? (a = dt(t, e, n, r) || {
              x: NaN,
              y: NaN
            }, n.length > 2 ? void 0 !== t.name && "geocent" === t.name || void 0 !== e.name && "geocent" === e.name ? "number" == typeof a.z ? [a.x, a.y, a.z].concat(n.splice(3)) : [a.x, a.y, n[2]].concat(n.splice(3)) : [a.x, a.y].concat(n.splice(2)) : [a.x, a.y]) : (i = dt(t, e, n, r), 2 === (o = Object.keys(n)).length || o.forEach(function (r) {
              if (void 0 !== t.name && "geocent" === t.name || void 0 !== e.name && "geocent" === e.name) {
                if ("x" === r || "y" === r || "z" === r) return;
              } else if ("x" === r || "y" === r) return;
              i[r] = n[r];
            }), i);
          }
          function yt(t) {
            return t instanceof rt ? t : t.oProj ? t.oProj : rt(t);
          }
          var gt = function gt(t, e, n) {
            t = yt(t);
            var r,
              a = !1;
            return void 0 === e ? (e = t, t = _t, a = !0) : (void 0 !== e.x || Array.isArray(e)) && (n = e, e = t, t = _t, a = !0), e = yt(e), n ? pt(t, e, n) : (r = {
              forward: function forward(n, r) {
                return pt(t, e, n, r);
              },
              inverse: function inverse(n, r) {
                return pt(e, t, n, r);
              }
            }, a && (r.oProj = e), r);
          };
          var mt = "AJSAJS",
            vt = "AFAFAF",
            xt = 65,
            bt = 73,
            kt = 79;
          var Mt = {
            forward: wt,
            inverse: function inverse(t) {
              var e = At(Ot(t.toUpperCase()));
              return e.lat && e.lon ? [e.lon, e.lat, e.lon, e.lat] : [e.left, e.bottom, e.right, e.top];
            },
            toPoint: Ct
          };
          function wt(t, e) {
            return e = e || 5, function (t, e) {
              var n,
                r,
                a,
                i,
                o,
                s,
                l,
                h,
                u,
                c,
                f,
                d = "00000" + t.easting,
                _ = "00000" + t.northing;
              return t.zoneNumber + t.zoneLetter + (u = t.easting, c = t.northing, f = It(t.zoneNumber), n = Math.floor(u / 1e5), r = Math.floor(c / 1e5) % 20, i = mt.charCodeAt(a = f - 1), o = vt.charCodeAt(a), h = !1, (s = i + n - 1) > 90 && (s = s - 90 + xt - 1, h = !0), (s === bt || i < bt && s > bt || (s > bt || i < bt) && h) && s++, (s === kt || i < kt && s > kt || (s > kt || i < kt) && h) && ++s === bt && s++, s > 90 && (s = s - 90 + xt - 1), (l = o + r) > 86 ? (l = l - 86 + xt - 1, h = !0) : h = !1, (l === bt || o < bt && l > bt || (l > bt || o < bt) && h) && l++, (l === kt || o < kt && l > kt || (l > kt || o < kt) && h) && ++l === bt && l++, l > 86 && (l = l - 86 + xt - 1), String.fromCharCode(s) + String.fromCharCode(l)) + d.substr(d.length - 5, e) + _.substr(_.length - 5, e);
            }(function (t) {
              var e,
                n,
                r,
                a,
                i,
                o,
                s,
                l = t.lat,
                h = t.lon,
                u = 6378137,
                c = .00669438,
                f = .9996,
                d = Et(l),
                _ = Et(h);
              s = Math.floor((h + 180) / 6) + 1, 180 === h && (s = 60), l >= 56 && l < 64 && h >= 3 && h < 12 && (s = 32), l >= 72 && l < 84 && (h >= 0 && h < 9 ? s = 31 : h >= 9 && h < 21 ? s = 33 : h >= 21 && h < 33 ? s = 35 : h >= 33 && h < 42 && (s = 37)), o = Et(6 * (s - 1) - 180 + 3), e = .006739496752268451, n = u / Math.sqrt(1 - c * Math.sin(d) * Math.sin(d)), r = Math.tan(d) * Math.tan(d), a = e * Math.cos(d) * Math.cos(d);
              var p,
                y,
                g = f * n * ((i = Math.cos(d) * (_ - o)) + (1 - r + a) * i * i * i / 6 + (5 - 18 * r + r * r + 72 * a - 58 * e) * i * i * i * i * i / 120) + 5e5,
                m = f * (u * (.9983242984503243 * d - .002514607064228144 * Math.sin(2 * d) + 2639046602129982e-21 * Math.sin(4 * d) - 3.418046101696858e-9 * Math.sin(6 * d)) + n * Math.tan(d) * (i * i / 2 + (5 - r + 9 * a + 4 * a * a) * i * i * i * i / 24 + (61 - 58 * r + r * r + 600 * a - 2.2240339282485886) * i * i * i * i * i * i / 720));
              return l < 0 && (m += 1e7), {
                northing: Math.round(m),
                easting: Math.round(g),
                zoneNumber: s,
                zoneLetter: (p = l, y = "Z", 84 >= p && p >= 72 ? y = "X" : 72 > p && p >= 64 ? y = "W" : 64 > p && p >= 56 ? y = "V" : 56 > p && p >= 48 ? y = "U" : 48 > p && p >= 40 ? y = "T" : 40 > p && p >= 32 ? y = "S" : 32 > p && p >= 24 ? y = "R" : 24 > p && p >= 16 ? y = "Q" : 16 > p && p >= 8 ? y = "P" : 8 > p && p >= 0 ? y = "N" : 0 > p && p >= -8 ? y = "M" : -8 > p && p >= -16 ? y = "L" : -16 > p && p >= -24 ? y = "K" : -24 > p && p >= -32 ? y = "J" : -32 > p && p >= -40 ? y = "H" : -40 > p && p >= -48 ? y = "G" : -48 > p && p >= -56 ? y = "F" : -56 > p && p >= -64 ? y = "E" : -64 > p && p >= -72 ? y = "D" : -72 > p && p >= -80 && (y = "C"), y)
              };
            }({
              lat: t[1],
              lon: t[0]
            }), e);
          }
          function Ct(t) {
            var e = At(Ot(t.toUpperCase()));
            return e.lat && e.lon ? [e.lon, e.lat] : [(e.left + e.right) / 2, (e.top + e.bottom) / 2];
          }
          function Et(t) {
            return t * (Math.PI / 180);
          }
          function St(t) {
            return t / Math.PI * 180;
          }
          function At(t) {
            var e = t.northing,
              n = t.easting,
              r = t.zoneLetter,
              a = t.zoneNumber;
            if (a < 0 || a > 60) return null;
            var i,
              o,
              s,
              l,
              h,
              u,
              c,
              f,
              d,
              _ = .9996,
              p = 6378137,
              y = .00669438,
              g = (1 - Math.sqrt(.99330562)) / (1 + Math.sqrt(.99330562)),
              m = n - 5e5,
              v = e;
            r < "N" && (v -= 1e7), c = 6 * (a - 1) - 180 + 3, i = .006739496752268451, d = (f = v / _ / 6367449.145945056) + (3 * g / 2 - 27 * g * g * g / 32) * Math.sin(2 * f) + (21 * g * g / 16 - 55 * g * g * g * g / 32) * Math.sin(4 * f) + 151 * g * g * g / 96 * Math.sin(6 * f), o = p / Math.sqrt(1 - y * Math.sin(d) * Math.sin(d)), s = Math.tan(d) * Math.tan(d), l = i * Math.cos(d) * Math.cos(d), h = .99330562 * p / Math.pow(1 - y * Math.sin(d) * Math.sin(d), 1.5), u = m / (o * _);
            var x = d - o * Math.tan(d) / h * (u * u / 2 - (5 + 3 * s + 10 * l - 4 * l * l - 9 * i) * u * u * u * u / 24 + (61 + 90 * s + 298 * l + 45 * s * s - 1.6983531815716497 - 3 * l * l) * u * u * u * u * u * u / 720);
            x = St(x);
            var b,
              k = (u - (1 + 2 * s + l) * u * u * u / 6 + (5 - 2 * l + 28 * s - 3 * l * l + 8 * i + 24 * s * s) * u * u * u * u * u / 120) / Math.cos(d);
            if (k = c + St(k), t.accuracy) {
              var M = At({
                northing: t.northing + t.accuracy,
                easting: t.easting + t.accuracy,
                zoneLetter: t.zoneLetter,
                zoneNumber: t.zoneNumber
              });
              b = {
                top: M.lat,
                right: M.lon,
                bottom: x,
                left: k
              };
            } else b = {
              lat: x,
              lon: k
            };
            return b;
          }
          function It(t) {
            var e = t % 6;
            return 0 === e && (e = 6), e;
          }
          function Ot(t) {
            if (t && 0 === t.length) throw "MGRSPoint coverting from nothing";
            for (var e, n = t.length, r = null, a = "", i = 0; !/[A-Z]/.test(e = t.charAt(i));) {
              if (i >= 2) throw "MGRSPoint bad conversion from: " + t;
              a += e, i++;
            }
            var o = parseInt(a, 10);
            if (0 === i || i + 3 > n) throw "MGRSPoint bad conversion from: " + t;
            var s = t.charAt(i++);
            if (s <= "A" || "B" === s || "Y" === s || s >= "Z" || "I" === s || "O" === s) throw "MGRSPoint zone letter " + s + " not handled: " + t;
            r = t.substring(i, i += 2);
            for (var l = It(o), h = function (t, e) {
                for (var n = mt.charCodeAt(e - 1), r = 1e5, a = !1; n !== t.charCodeAt(0);) {
                  if (++n === bt && n++, n === kt && n++, n > 90) {
                    if (a) throw "Bad character: " + t;
                    n = xt, a = !0;
                  }
                  r += 1e5;
                }
                return r;
              }(r.charAt(0), l), u = function (t, e) {
                if (t > "V") throw "MGRSPoint given invalid Northing " + t;
                for (var n = vt.charCodeAt(e - 1), r = 0, a = !1; n !== t.charCodeAt(0);) {
                  if (++n === bt && n++, n === kt && n++, n > 86) {
                    if (a) throw "Bad character: " + t;
                    n = xt, a = !0;
                  }
                  r += 1e5;
                }
                return r;
              }(r.charAt(1), l); u < jt(s);) {
              u += 2e6;
            }
            var c = n - i;
            if (c % 2 != 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + t;
            var f,
              d,
              _,
              p = c / 2,
              y = 0,
              g = 0;
            return p > 0 && (f = 1e5 / Math.pow(10, p), d = t.substring(i, i + p), y = parseFloat(d) * f, _ = t.substring(i + p), g = parseFloat(_) * f), {
              easting: y + h,
              northing: g + u,
              zoneLetter: s,
              zoneNumber: o,
              accuracy: f
            };
          }
          function jt(t) {
            var e;
            switch (t) {
              case "C":
                e = 11e5;
                break;
              case "D":
                e = 2e6;
                break;
              case "E":
                e = 28e5;
                break;
              case "F":
                e = 37e5;
                break;
              case "G":
                e = 46e5;
                break;
              case "H":
                e = 55e5;
                break;
              case "J":
                e = 64e5;
                break;
              case "K":
                e = 73e5;
                break;
              case "L":
                e = 82e5;
                break;
              case "M":
                e = 91e5;
                break;
              case "N":
                e = 0;
                break;
              case "P":
                e = 8e5;
                break;
              case "Q":
                e = 17e5;
                break;
              case "R":
                e = 26e5;
                break;
              case "S":
                e = 35e5;
                break;
              case "T":
                e = 44e5;
                break;
              case "U":
                e = 53e5;
                break;
              case "V":
                e = 62e5;
                break;
              case "W":
                e = 7e6;
                break;
              case "X":
                e = 79e5;
                break;
              default:
                e = -1;
            }
            if (e >= 0) return e;
            throw "Invalid zone letter: " + t;
          }
          function Nt(t) {
            return Nt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, Nt(t);
          }
          function Gt(t, e, n) {
            if (!(this instanceof Gt)) return new Gt(t, e, n);
            if (Array.isArray(t)) this.x = t[0], this.y = t[1], this.z = t[2] || 0;else if ("object" === Nt(t)) this.x = t.x, this.y = t.y, this.z = t.z || 0;else if ("string" == typeof t && void 0 === e) {
              var r = t.split(",");
              this.x = parseFloat(r[0], 10), this.y = parseFloat(r[1], 10), this.z = parseFloat(r[2], 10) || 0;
            } else this.x = t, this.y = e, this.z = n || 0;
            console.warn("proj4.Point will be removed in version 3, use proj4.toPoint");
          }
          Gt.fromMGRS = function (t) {
            return new Gt(Ct(t));
          }, Gt.prototype.toMGRS = function (t) {
            return wt([this.x, this.y], t);
          };
          var Dt = Gt;
          var Rt = .046875,
            Lt = .01953125,
            Pt = .01068115234375;
          function Tt(t) {
            var e = [];
            e[0] = 1 - t * (.25 + t * (Rt + t * (Lt + t * Pt))), e[1] = t * (.75 - t * (Rt + t * (Lt + t * Pt)));
            var n = t * t;
            return e[2] = n * (.46875 - t * (.013020833333333334 + .007120768229166667 * t)), n *= t, e[3] = n * (.3645833333333333 - .005696614583333333 * t), e[4] = n * t * .3076171875, e;
          }
          function Bt(t, e, n, r) {
            return n *= e, e *= e, r[0] * t - n * (r[1] + e * (r[2] + e * (r[3] + e * r[4])));
          }
          function Qt(t, e, n) {
            for (var r = 1 / (1 - e), a = t, i = 20; i; --i) {
              var o = Math.sin(a),
                l = 1 - e * o * o;
              if (a -= l = (Bt(a, o, Math.cos(a), n) - t) * (l * Math.sqrt(l)) * r, Math.abs(l) < s) return a;
            }
            return a;
          }
          var Ft = {
            init: function init() {
              this.x0 = void 0 !== this.x0 ? this.x0 : 0, this.y0 = void 0 !== this.y0 ? this.y0 : 0, this.long0 = void 0 !== this.long0 ? this.long0 : 0, this.lat0 = void 0 !== this.lat0 ? this.lat0 : 0, this.es && (this.en = Tt(this.es), this.ml0 = Bt(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en));
            },
            forward: function forward(t) {
              var e,
                n,
                r,
                a = t.x,
                i = t.y,
                o = L(a - this.long0),
                l = Math.sin(i),
                h = Math.cos(i);
              if (this.es) {
                var u = h * o,
                  c = Math.pow(u, 2),
                  f = this.ep2 * Math.pow(h, 2),
                  d = Math.pow(f, 2),
                  _ = Math.abs(h) > s ? Math.tan(i) : 0,
                  p = Math.pow(_, 2),
                  y = Math.pow(p, 2);
                e = 1 - this.es * Math.pow(l, 2), u /= Math.sqrt(e);
                var g = Bt(i, l, h, this.en);
                n = this.a * (this.k0 * u * (1 + c / 6 * (1 - p + f + c / 20 * (5 - 18 * p + y + 14 * f - 58 * p * f + c / 42 * (61 + 179 * y - y * p - 479 * p))))) + this.x0, r = this.a * (this.k0 * (g - this.ml0 + l * o * u / 2 * (1 + c / 12 * (5 - p + 9 * f + 4 * d + c / 30 * (61 + y - 58 * p + 270 * f - 330 * p * f + c / 56 * (1385 + 543 * y - y * p - 3111 * p)))))) + this.y0;
              } else {
                var m = h * Math.sin(o);
                if (Math.abs(Math.abs(m) - 1) < s) return 93;
                if (n = .5 * this.a * this.k0 * Math.log((1 + m) / (1 - m)) + this.x0, r = h * Math.cos(o) / Math.sqrt(1 - Math.pow(m, 2)), (m = Math.abs(r)) >= 1) {
                  if (m - 1 > s) return 93;
                  r = 0;
                } else r = Math.acos(r);
                i < 0 && (r = -r), r = this.a * this.k0 * (r - this.lat0) + this.y0;
              }
              return t.x = n, t.y = r, t;
            },
            inverse: function inverse(t) {
              var e,
                n,
                r,
                a,
                i = (t.x - this.x0) * (1 / this.a),
                l = (t.y - this.y0) * (1 / this.a);
              if (this.es) {
                if (n = Qt(e = this.ml0 + l / this.k0, this.es, this.en), Math.abs(n) < o) {
                  var h = Math.sin(n),
                    u = Math.cos(n),
                    c = Math.abs(u) > s ? Math.tan(n) : 0,
                    f = this.ep2 * Math.pow(u, 2),
                    d = Math.pow(f, 2),
                    _ = Math.pow(c, 2),
                    p = Math.pow(_, 2);
                  e = 1 - this.es * Math.pow(h, 2);
                  var y = i * Math.sqrt(e) / this.k0,
                    g = Math.pow(y, 2);
                  r = n - (e *= c) * g / (1 - this.es) * .5 * (1 - g / 12 * (5 + 3 * _ - 9 * f * _ + f - 4 * d - g / 30 * (61 + 90 * _ - 252 * f * _ + 45 * p + 46 * f - g / 56 * (1385 + 3633 * _ + 4095 * p + 1574 * p * _)))), a = L(this.long0 + y * (1 - g / 6 * (1 + 2 * _ + f - g / 20 * (5 + 28 * _ + 24 * p + 8 * f * _ + 6 * f - g / 42 * (61 + 662 * _ + 1320 * p + 720 * p * _)))) / u);
                } else r = o * R(l), a = 0;
              } else {
                var m = Math.exp(i / this.k0),
                  v = .5 * (m - 1 / m),
                  x = this.lat0 + l / this.k0,
                  b = Math.cos(x);
                e = Math.sqrt((1 - Math.pow(b, 2)) / (1 + Math.pow(v, 2))), r = Math.asin(e), l < 0 && (r = -r), a = 0 === v && 0 === b ? 0 : L(Math.atan2(v, b) + this.long0);
              }
              return t.x = a, t.y = r, t;
            },
            names: ["Fast_Transverse_Mercator", "Fast Transverse Mercator"]
          };
          function qt(t) {
            var e = Math.exp(t);
            return (e - 1 / e) / 2;
          }
          function Ut(t, e) {
            t = Math.abs(t), e = Math.abs(e);
            var n = Math.max(t, e),
              r = Math.min(t, e) / (n || 1);
            return n * Math.sqrt(1 + Math.pow(r, 2));
          }
          function zt(t, e) {
            for (var n, r = 2 * Math.cos(2 * e), a = t.length - 1, i = t[a], o = 0; --a >= 0;) {
              n = r * i - o + t[a], o = i, i = n;
            }
            return e + n * Math.sin(2 * e);
          }
          function Ht(t, e, n) {
            for (var r, a, i = Math.sin(e), o = Math.cos(e), s = qt(n), l = function (t) {
                var e = Math.exp(t);
                return (e + 1 / e) / 2;
              }(n), h = 2 * o * l, u = -2 * i * s, c = t.length - 1, f = t[c], d = 0, _ = 0, p = 0; --c >= 0;) {
              r = _, a = d, f = h * (_ = f) - r - u * (d = p) + t[c], p = u * _ - a + h * d;
            }
            return [(h = i * l) * f - (u = o * s) * p, h * p + u * f];
          }
          var Zt = {
              init: function init() {
                if (!this.approx && (isNaN(this.es) || this.es <= 0)) throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
                this.approx && (Ft.init.apply(this), this.forward = Ft.forward, this.inverse = Ft.inverse), this.x0 = void 0 !== this.x0 ? this.x0 : 0, this.y0 = void 0 !== this.y0 ? this.y0 : 0, this.long0 = void 0 !== this.long0 ? this.long0 : 0, this.lat0 = void 0 !== this.lat0 ? this.lat0 : 0, this.cgb = [], this.cbg = [], this.utg = [], this.gtu = [];
                var t = this.es / (1 + Math.sqrt(1 - this.es)),
                  e = t / (2 - t),
                  n = e;
                this.cgb[0] = e * (2 + e * (-2 / 3 + e * (e * (116 / 45 + e * (26 / 45 + e * (-2854 / 675))) - 2))), this.cbg[0] = e * (e * (2 / 3 + e * (4 / 3 + e * (-82 / 45 + e * (32 / 45 + e * (4642 / 4725))))) - 2), n *= e, this.cgb[1] = n * (7 / 3 + e * (e * (-227 / 45 + e * (2704 / 315 + e * (2323 / 945))) - 1.6)), this.cbg[1] = n * (5 / 3 + e * (-16 / 15 + e * (-13 / 9 + e * (904 / 315 + e * (-1522 / 945))))), n *= e, this.cgb[2] = n * (56 / 15 + e * (-136 / 35 + e * (-1262 / 105 + e * (73814 / 2835)))), this.cbg[2] = n * (-26 / 15 + e * (34 / 21 + e * (1.6 + e * (-12686 / 2835)))), n *= e, this.cgb[3] = n * (4279 / 630 + e * (-332 / 35 + e * (-399572 / 14175))), this.cbg[3] = n * (1237 / 630 + e * (e * (-24832 / 14175) - 2.4)), n *= e, this.cgb[4] = n * (4174 / 315 + e * (-144838 / 6237)), this.cbg[4] = n * (-734 / 315 + e * (109598 / 31185)), n *= e, this.cgb[5] = n * (601676 / 22275), this.cbg[5] = n * (444337 / 155925), n = Math.pow(e, 2), this.Qn = this.k0 / (1 + e) * (1 + n * (1 / 4 + n * (1 / 64 + n / 256))), this.utg[0] = e * (e * (2 / 3 + e * (-37 / 96 + e * (1 / 360 + e * (81 / 512 + e * (-96199 / 604800))))) - .5), this.gtu[0] = e * (.5 + e * (-2 / 3 + e * (5 / 16 + e * (41 / 180 + e * (-127 / 288 + e * (7891 / 37800)))))), this.utg[1] = n * (-1 / 48 + e * (-1 / 15 + e * (437 / 1440 + e * (-46 / 105 + e * (1118711 / 3870720))))), this.gtu[1] = n * (13 / 48 + e * (e * (557 / 1440 + e * (281 / 630 + e * (-1983433 / 1935360))) - .6)), n *= e, this.utg[2] = n * (-17 / 480 + e * (37 / 840 + e * (209 / 4480 + e * (-5569 / 90720)))), this.gtu[2] = n * (61 / 240 + e * (-103 / 140 + e * (15061 / 26880 + e * (167603 / 181440)))), n *= e, this.utg[3] = n * (-4397 / 161280 + e * (11 / 504 + e * (830251 / 7257600))), this.gtu[3] = n * (49561 / 161280 + e * (-179 / 168 + e * (6601661 / 7257600))), n *= e, this.utg[4] = n * (-4583 / 161280 + e * (108847 / 3991680)), this.gtu[4] = n * (34729 / 80640 + e * (-3418889 / 1995840)), n *= e, this.utg[5] = n * (-20648693 / 638668800), this.gtu[5] = .6650675310896665 * n;
                var r = zt(this.cbg, this.lat0);
                this.Zb = -this.Qn * (r + function (t, e) {
                  for (var n, r = 2 * Math.cos(e), a = t.length - 1, i = t[a], o = 0; --a >= 0;) {
                    n = r * i - o + t[a], o = i, i = n;
                  }
                  return Math.sin(e) * n;
                }(this.gtu, 2 * r));
              },
              forward: function forward(t) {
                var e = L(t.x - this.long0),
                  n = t.y;
                n = zt(this.cbg, n);
                var r = Math.sin(n),
                  a = Math.cos(n),
                  i = Math.sin(e),
                  o = Math.cos(e);
                n = Math.atan2(r, o * a), e = Math.atan2(i * a, Ut(r, a * o)), e = function (t) {
                  var e = Math.abs(t);
                  return e = function (t) {
                    var e = 1 + t,
                      n = e - 1;
                    return 0 === n ? t : t * Math.log(e) / n;
                  }(e * (1 + e / (Ut(1, e) + 1))), t < 0 ? -e : e;
                }(Math.tan(e));
                var s,
                  l,
                  h = Ht(this.gtu, 2 * n, 2 * e);
                return n += h[0], e += h[1], Math.abs(e) <= 2.623395162778 ? (s = this.a * (this.Qn * e) + this.x0, l = this.a * (this.Qn * n + this.Zb) + this.y0) : (s = 1 / 0, l = 1 / 0), t.x = s, t.y = l, t;
              },
              inverse: function inverse(t) {
                var e,
                  n,
                  r = (t.x - this.x0) * (1 / this.a),
                  a = (t.y - this.y0) * (1 / this.a);
                if (a = (a - this.Zb) / this.Qn, r /= this.Qn, Math.abs(r) <= 2.623395162778) {
                  var i = Ht(this.utg, 2 * a, 2 * r);
                  a += i[0], r += i[1], r = Math.atan(qt(r));
                  var o = Math.sin(a),
                    s = Math.cos(a),
                    l = Math.sin(r),
                    h = Math.cos(r);
                  a = Math.atan2(o * h, Ut(l, h * s)), e = L((r = Math.atan2(l, h * s)) + this.long0), n = zt(this.cgb, a);
                } else e = 1 / 0, n = 1 / 0;
                return t.x = e, t.y = n, t;
              },
              names: ["Extended_Transverse_Mercator", "Extended Transverse Mercator", "etmerc", "Transverse_Mercator", "Transverse Mercator", "tmerc"]
            },
            Xt = {
              init: function init() {
                var t = function (t, e) {
                  if (void 0 === t) {
                    if ((t = Math.floor(30 * (L(e) + Math.PI) / Math.PI) + 1) < 0) return 0;
                    if (t > 60) return 60;
                  }
                  return t;
                }(this.zone, this.long0);
                if (void 0 === t) throw new Error("unknown utm zone");
                this.lat0 = 0, this.long0 = (6 * Math.abs(t) - 183) * l, this.x0 = 5e5, this.y0 = this.utmSouth ? 1e7 : 0, this.k0 = .9996, Zt.init.apply(this), this.forward = Zt.forward, this.inverse = Zt.inverse;
              },
              names: ["Universal Transverse Mercator System", "utm"],
              dependsOn: "etmerc"
            };
          function Jt(t, e) {
            return Math.pow((1 - t) / (1 + t), e);
          }
          var Wt = {
              init: function init() {
                var t = Math.sin(this.lat0),
                  e = Math.cos(this.lat0);
                e *= e, this.rc = Math.sqrt(1 - this.es) / (1 - this.es * t * t), this.C = Math.sqrt(1 + this.es * e * e / (1 - this.es)), this.phic0 = Math.asin(t / this.C), this.ratexp = .5 * this.C * this.e, this.K = Math.tan(.5 * this.phic0 + u) / (Math.pow(Math.tan(.5 * this.lat0 + u), this.C) * Jt(this.e * t, this.ratexp));
              },
              forward: function forward(t) {
                var e = t.x,
                  n = t.y;
                return t.y = 2 * Math.atan(this.K * Math.pow(Math.tan(.5 * n + u), this.C) * Jt(this.e * Math.sin(n), this.ratexp)) - o, t.x = this.C * e, t;
              },
              inverse: function inverse(t) {
                for (var e = t.x / this.C, n = t.y, r = Math.pow(Math.tan(.5 * n + u) / this.K, 1 / this.C), a = 20; a > 0 && (n = 2 * Math.atan(r * Jt(this.e * Math.sin(t.y), -.5 * this.e)) - o, !(Math.abs(n - t.y) < 1e-14)); --a) {
                  t.y = n;
                }
                return a ? (t.x = e, t.y = n, t) : null;
              },
              names: ["gauss"]
            },
            Vt = {
              init: function init() {
                Wt.init.apply(this), this.rc && (this.sinc0 = Math.sin(this.phic0), this.cosc0 = Math.cos(this.phic0), this.R2 = 2 * this.rc, this.title || (this.title = "Oblique Stereographic Alternative"));
              },
              forward: function forward(t) {
                var e, n, r, a;
                return t.x = L(t.x - this.long0), Wt.forward.apply(this, [t]), e = Math.sin(t.y), n = Math.cos(t.y), r = Math.cos(t.x), a = this.k0 * this.R2 / (1 + this.sinc0 * e + this.cosc0 * n * r), t.x = a * n * Math.sin(t.x), t.y = a * (this.cosc0 * e - this.sinc0 * n * r), t.x = this.a * t.x + this.x0, t.y = this.a * t.y + this.y0, t;
              },
              inverse: function inverse(t) {
                var e, n, r, a, i;
                if (t.x = (t.x - this.x0) / this.a, t.y = (t.y - this.y0) / this.a, t.x /= this.k0, t.y /= this.k0, i = Math.sqrt(t.x * t.x + t.y * t.y)) {
                  var o = 2 * Math.atan2(i, this.R2);
                  e = Math.sin(o), n = Math.cos(o), a = Math.asin(n * this.sinc0 + t.y * e * this.cosc0 / i), r = Math.atan2(t.x * e, i * this.cosc0 * n - t.y * this.sinc0 * e);
                } else a = this.phic0, r = 0;
                return t.x = r, t.y = a, Wt.inverse.apply(this, [t]), t.x = L(t.x + this.long0), t;
              },
              names: ["Stereographic_North_Pole", "Oblique_Stereographic", "Polar_Stereographic", "sterea", "Oblique Stereographic Alternative", "Double_Stereographic"]
            },
            Yt = {
              init: function init() {
                this.coslat0 = Math.cos(this.lat0), this.sinlat0 = Math.sin(this.lat0), this.sphere ? 1 === this.k0 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= s && (this.k0 = .5 * (1 + R(this.lat0) * Math.sin(this.lat_ts))) : (Math.abs(this.coslat0) <= s && (this.lat0 > 0 ? this.con = 1 : this.con = -1), this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e)), 1 === this.k0 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= s && (this.k0 = .5 * this.cons * D(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / P(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts))), this.ms1 = D(this.e, this.sinlat0, this.coslat0), this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - o, this.cosX0 = Math.cos(this.X0), this.sinX0 = Math.sin(this.X0));
              },
              forward: function forward(t) {
                var e,
                  n,
                  r,
                  a,
                  i,
                  l,
                  h = t.x,
                  u = t.y,
                  c = Math.sin(u),
                  f = Math.cos(u),
                  d = L(h - this.long0);
                return Math.abs(Math.abs(h - this.long0) - Math.PI) <= s && Math.abs(u + this.lat0) <= s ? (t.x = NaN, t.y = NaN, t) : this.sphere ? (e = 2 * this.k0 / (1 + this.sinlat0 * c + this.coslat0 * f * Math.cos(d)), t.x = this.a * e * f * Math.sin(d) + this.x0, t.y = this.a * e * (this.coslat0 * c - this.sinlat0 * f * Math.cos(d)) + this.y0, t) : (n = 2 * Math.atan(this.ssfn_(u, c, this.e)) - o, a = Math.cos(n), r = Math.sin(n), Math.abs(this.coslat0) <= s ? (i = P(this.e, u * this.con, this.con * c), l = 2 * this.a * this.k0 * i / this.cons, t.x = this.x0 + l * Math.sin(h - this.long0), t.y = this.y0 - this.con * l * Math.cos(h - this.long0), t) : (Math.abs(this.sinlat0) < s ? (e = 2 * this.a * this.k0 / (1 + a * Math.cos(d)), t.y = e * r) : (e = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * r + this.cosX0 * a * Math.cos(d))), t.y = e * (this.cosX0 * r - this.sinX0 * a * Math.cos(d)) + this.y0), t.x = e * a * Math.sin(d) + this.x0, t));
              },
              inverse: function inverse(t) {
                var e, n, r, a, i;
                t.x -= this.x0, t.y -= this.y0;
                var l = Math.sqrt(t.x * t.x + t.y * t.y);
                if (this.sphere) {
                  var h = 2 * Math.atan(l / (2 * this.a * this.k0));
                  return e = this.long0, n = this.lat0, l <= s ? (t.x = e, t.y = n, t) : (n = Math.asin(Math.cos(h) * this.sinlat0 + t.y * Math.sin(h) * this.coslat0 / l), e = Math.abs(this.coslat0) < s ? this.lat0 > 0 ? L(this.long0 + Math.atan2(t.x, -1 * t.y)) : L(this.long0 + Math.atan2(t.x, t.y)) : L(this.long0 + Math.atan2(t.x * Math.sin(h), l * this.coslat0 * Math.cos(h) - t.y * this.sinlat0 * Math.sin(h))), t.x = e, t.y = n, t);
                }
                if (Math.abs(this.coslat0) <= s) {
                  if (l <= s) return n = this.lat0, e = this.long0, t.x = e, t.y = n, t;
                  t.x *= this.con, t.y *= this.con, r = l * this.cons / (2 * this.a * this.k0), n = this.con * T(this.e, r), e = this.con * L(this.con * this.long0 + Math.atan2(t.x, -1 * t.y));
                } else a = 2 * Math.atan(l * this.cosX0 / (2 * this.a * this.k0 * this.ms1)), e = this.long0, l <= s ? i = this.X0 : (i = Math.asin(Math.cos(a) * this.sinX0 + t.y * Math.sin(a) * this.cosX0 / l), e = L(this.long0 + Math.atan2(t.x * Math.sin(a), l * this.cosX0 * Math.cos(a) - t.y * this.sinX0 * Math.sin(a)))), n = -1 * T(this.e, Math.tan(.5 * (o + i)));
                return t.x = e, t.y = n, t;
              },
              names: ["stere", "Stereographic_South_Pole", "Polar Stereographic (variant B)"],
              ssfn_: function ssfn_(t, e, n) {
                return e *= n, Math.tan(.5 * (o + t)) * Math.pow((1 - e) / (1 + e), .5 * n);
              }
            },
            Kt = {
              init: function init() {
                var t = this.lat0;
                this.lambda0 = this.long0;
                var e = Math.sin(t),
                  n = this.a,
                  r = 1 / this.rf,
                  a = 2 * r - Math.pow(r, 2),
                  i = this.e = Math.sqrt(a);
                this.R = this.k0 * n * Math.sqrt(1 - a) / (1 - a * Math.pow(e, 2)), this.alpha = Math.sqrt(1 + a / (1 - a) * Math.pow(Math.cos(t), 4)), this.b0 = Math.asin(e / this.alpha);
                var o = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2)),
                  s = Math.log(Math.tan(Math.PI / 4 + t / 2)),
                  l = Math.log((1 + i * e) / (1 - i * e));
                this.K = o - this.alpha * s + this.alpha * i / 2 * l;
              },
              forward: function forward(t) {
                var e = Math.log(Math.tan(Math.PI / 4 - t.y / 2)),
                  n = this.e / 2 * Math.log((1 + this.e * Math.sin(t.y)) / (1 - this.e * Math.sin(t.y))),
                  r = -this.alpha * (e + n) + this.K,
                  a = 2 * (Math.atan(Math.exp(r)) - Math.PI / 4),
                  i = this.alpha * (t.x - this.lambda0),
                  o = Math.atan(Math.sin(i) / (Math.sin(this.b0) * Math.tan(a) + Math.cos(this.b0) * Math.cos(i))),
                  s = Math.asin(Math.cos(this.b0) * Math.sin(a) - Math.sin(this.b0) * Math.cos(a) * Math.cos(i));
                return t.y = this.R / 2 * Math.log((1 + Math.sin(s)) / (1 - Math.sin(s))) + this.y0, t.x = this.R * o + this.x0, t;
              },
              inverse: function inverse(t) {
                for (var e = t.x - this.x0, n = t.y - this.y0, r = e / this.R, a = 2 * (Math.atan(Math.exp(n / this.R)) - Math.PI / 4), i = Math.asin(Math.cos(this.b0) * Math.sin(a) + Math.sin(this.b0) * Math.cos(a) * Math.cos(r)), o = Math.atan(Math.sin(r) / (Math.cos(this.b0) * Math.cos(r) - Math.sin(this.b0) * Math.tan(a))), s = this.lambda0 + o / this.alpha, l = 0, h = i, u = -1e3, c = 0; Math.abs(h - u) > 1e-7;) {
                  if (++c > 20) return;
                  l = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + i / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(h)) / 2)), u = h, h = 2 * Math.atan(Math.exp(l)) - Math.PI / 2;
                }
                return t.x = s, t.y = h, t;
              },
              names: ["somerc"]
            };
          function $t(t) {
            return $t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, $t(t);
          }
          var te = 1e-7;
          var ee = {
              init: function init() {
                var t,
                  e,
                  n,
                  r,
                  a,
                  i,
                  h,
                  f,
                  d,
                  _,
                  p,
                  y,
                  g,
                  m = 0,
                  v = 0,
                  x = 0,
                  b = 0,
                  k = 0,
                  M = 0,
                  w = 0;
                this.no_off = (g = "object" === $t((y = this).PROJECTION) ? Object.keys(y.PROJECTION)[0] : y.PROJECTION, "no_uoff" in y || "no_off" in y || -1 !== ["Hotine_Oblique_Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin"].indexOf(g)), this.no_rot = "no_rot" in this;
                var C = !1;
                "alpha" in this && (C = !0);
                var E = !1;
                if ("rectified_grid_angle" in this && (E = !0), C && (w = this.alpha), E && (m = this.rectified_grid_angle * l), C || E) v = this.longc;else if (x = this.long1, k = this.lat1, b = this.long2, M = this.lat2, Math.abs(k - M) <= te || (t = Math.abs(k)) <= te || Math.abs(t - o) <= te || Math.abs(Math.abs(this.lat0) - o) <= te || Math.abs(Math.abs(M) - o) <= te) throw new Error();
                var S = 1 - this.es;
                e = Math.sqrt(S), Math.abs(this.lat0) > s ? (f = Math.sin(this.lat0), n = Math.cos(this.lat0), t = 1 - this.es * f * f, this.B = n * n, this.B = Math.sqrt(1 + this.es * this.B * this.B / S), this.A = this.B * this.k0 * e / t, (a = (r = this.B * e / (n * Math.sqrt(t))) * r - 1) <= 0 ? a = 0 : (a = Math.sqrt(a), this.lat0 < 0 && (a = -a)), this.E = a += r, this.E *= Math.pow(P(this.e, this.lat0, f), this.B)) : (this.B = 1 / e, this.A = this.k0, this.E = r = a = 1), C || E ? (C ? (p = Math.asin(Math.sin(w) / r), E || (m = w)) : (p = m, w = Math.asin(r * Math.sin(p))), this.lam0 = v - Math.asin(.5 * (a - 1 / a) * Math.tan(p)) / this.B) : (i = Math.pow(P(this.e, k, Math.sin(k)), this.B), h = Math.pow(P(this.e, M, Math.sin(M)), this.B), a = this.E / i, d = (h - i) / (h + i), _ = ((_ = this.E * this.E) - h * i) / (_ + h * i), (t = x - b) < -Math.pi ? b -= c : t > Math.pi && (b += c), this.lam0 = L(.5 * (x + b) - Math.atan(_ * Math.tan(.5 * this.B * (x - b)) / d) / this.B), p = Math.atan(2 * Math.sin(this.B * L(x - this.lam0)) / (a - 1 / a)), m = w = Math.asin(r * Math.sin(p))), this.singam = Math.sin(p), this.cosgam = Math.cos(p), this.sinrot = Math.sin(m), this.cosrot = Math.cos(m), this.rB = 1 / this.B, this.ArB = this.A * this.rB, this.BrA = 1 / this.ArB, this.A, this.B, this.no_off ? this.u_0 = 0 : (this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(r * r - 1) / Math.cos(w))), this.lat0 < 0 && (this.u_0 = -this.u_0)), a = .5 * p, this.v_pole_n = this.ArB * Math.log(Math.tan(u - a)), this.v_pole_s = this.ArB * Math.log(Math.tan(u + a));
              },
              forward: function forward(t) {
                var e,
                  n,
                  r,
                  a,
                  i,
                  l,
                  h,
                  u,
                  c = {};
                if (t.x = t.x - this.lam0, Math.abs(Math.abs(t.y) - o) > s) {
                  if (e = .5 * ((i = this.E / Math.pow(P(this.e, t.y, Math.sin(t.y)), this.B)) - (l = 1 / i)), n = .5 * (i + l), a = Math.sin(this.B * t.x), r = (e * this.singam - a * this.cosgam) / n, Math.abs(Math.abs(r) - 1) < s) throw new Error();
                  u = .5 * this.ArB * Math.log((1 - r) / (1 + r)), l = Math.cos(this.B * t.x), h = Math.abs(l) < te ? this.A * t.x : this.ArB * Math.atan2(e * this.cosgam + a * this.singam, l);
                } else u = t.y > 0 ? this.v_pole_n : this.v_pole_s, h = this.ArB * t.y;
                return this.no_rot ? (c.x = h, c.y = u) : (h -= this.u_0, c.x = u * this.cosrot + h * this.sinrot, c.y = h * this.cosrot - u * this.sinrot), c.x = this.a * c.x + this.x0, c.y = this.a * c.y + this.y0, c;
              },
              inverse: function inverse(t) {
                var e,
                  n,
                  r,
                  a,
                  i,
                  l,
                  h,
                  u = {};
                if (t.x = (t.x - this.x0) * (1 / this.a), t.y = (t.y - this.y0) * (1 / this.a), this.no_rot ? (n = t.y, e = t.x) : (n = t.x * this.cosrot - t.y * this.sinrot, e = t.y * this.cosrot + t.x * this.sinrot + this.u_0), a = .5 * ((r = Math.exp(-this.BrA * n)) - 1 / r), i = .5 * (r + 1 / r), h = ((l = Math.sin(this.BrA * e)) * this.cosgam + a * this.singam) / i, Math.abs(Math.abs(h) - 1) < s) u.x = 0, u.y = h < 0 ? -o : o;else {
                  if (u.y = this.E / Math.sqrt((1 + h) / (1 - h)), u.y = T(this.e, Math.pow(u.y, 1 / this.B)), u.y === 1 / 0) throw new Error();
                  u.x = -this.rB * Math.atan2(a * this.cosgam - l * this.singam, Math.cos(this.BrA * e));
                }
                return u.x += this.lam0, u;
              },
              names: ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Two_Point_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "Oblique_Mercator", "omerc"]
            },
            ne = {
              init: function init() {
                if (this.lat2 || (this.lat2 = this.lat1), this.k0 || (this.k0 = 1), this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, !(Math.abs(this.lat1 + this.lat2) < s)) {
                  var t = this.b / this.a;
                  this.e = Math.sqrt(1 - t * t);
                  var e = Math.sin(this.lat1),
                    n = Math.cos(this.lat1),
                    r = D(this.e, e, n),
                    a = P(this.e, this.lat1, e),
                    i = Math.sin(this.lat2),
                    o = Math.cos(this.lat2),
                    l = D(this.e, i, o),
                    h = P(this.e, this.lat2, i),
                    u = P(this.e, this.lat0, Math.sin(this.lat0));
                  Math.abs(this.lat1 - this.lat2) > s ? this.ns = Math.log(r / l) / Math.log(a / h) : this.ns = e, isNaN(this.ns) && (this.ns = e), this.f0 = r / (this.ns * Math.pow(a, this.ns)), this.rh = this.a * this.f0 * Math.pow(u, this.ns), this.title || (this.title = "Lambert Conformal Conic");
                }
              },
              forward: function forward(t) {
                var e = t.x,
                  n = t.y;
                Math.abs(2 * Math.abs(n) - Math.PI) <= s && (n = R(n) * (o - 2e-10));
                var r,
                  a,
                  i = Math.abs(Math.abs(n) - o);
                if (i > s) r = P(this.e, n, Math.sin(n)), a = this.a * this.f0 * Math.pow(r, this.ns);else {
                  if ((i = n * this.ns) <= 0) return null;
                  a = 0;
                }
                var l = this.ns * L(e - this.long0);
                return t.x = this.k0 * (a * Math.sin(l)) + this.x0, t.y = this.k0 * (this.rh - a * Math.cos(l)) + this.y0, t;
              },
              inverse: function inverse(t) {
                var e,
                  n,
                  r,
                  a,
                  i,
                  s = (t.x - this.x0) / this.k0,
                  l = this.rh - (t.y - this.y0) / this.k0;
                this.ns > 0 ? (e = Math.sqrt(s * s + l * l), n = 1) : (e = -Math.sqrt(s * s + l * l), n = -1);
                var h = 0;
                if (0 !== e && (h = Math.atan2(n * s, n * l)), 0 !== e || this.ns > 0) {
                  if (n = 1 / this.ns, r = Math.pow(e / (this.a * this.f0), n), -9999 === (a = T(this.e, r))) return null;
                } else a = -o;
                return i = L(h / this.ns + this.long0), t.x = i, t.y = a, t;
              },
              names: ["Lambert Tangential Conformal Conic Projection", "Lambert_Conformal_Conic", "Lambert_Conformal_Conic_1SP", "Lambert_Conformal_Conic_2SP", "lcc", "Lambert Conic Conformal (1SP)", "Lambert Conic Conformal (2SP)"]
            },
            re = {
              init: function init() {
                this.a = 6377397.155, this.es = .006674372230614, this.e = Math.sqrt(this.es), this.lat0 || (this.lat0 = .863937979737193), this.long0 || (this.long0 = .4334234309119251), this.k0 || (this.k0 = .9999), this.s45 = .785398163397448, this.s90 = 2 * this.s45, this.fi0 = this.lat0, this.e2 = this.es, this.e = Math.sqrt(this.e2), this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2)), this.uq = 1.04216856380474, this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa), this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2), this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g, this.k1 = this.k0, this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2)), this.s0 = 1.37008346281555, this.n = Math.sin(this.s0), this.ro0 = this.k1 * this.n0 / Math.tan(this.s0), this.ad = this.s90 - this.uq;
              },
              forward: function forward(t) {
                var e,
                  n,
                  r,
                  a,
                  i,
                  o,
                  s,
                  l = t.x,
                  h = t.y,
                  u = L(l - this.long0);
                return e = Math.pow((1 + this.e * Math.sin(h)) / (1 - this.e * Math.sin(h)), this.alfa * this.e / 2), n = 2 * (Math.atan(this.k * Math.pow(Math.tan(h / 2 + this.s45), this.alfa) / e) - this.s45), r = -u * this.alfa, a = Math.asin(Math.cos(this.ad) * Math.sin(n) + Math.sin(this.ad) * Math.cos(n) * Math.cos(r)), i = Math.asin(Math.cos(n) * Math.sin(r) / Math.cos(a)), o = this.n * i, s = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(a / 2 + this.s45), this.n), t.y = s * Math.cos(o) / 1, t.x = s * Math.sin(o) / 1, this.czech || (t.y *= -1, t.x *= -1), t;
              },
              inverse: function inverse(t) {
                var e,
                  n,
                  r,
                  a,
                  i,
                  o,
                  s,
                  l = t.x;
                t.x = t.y, t.y = l, this.czech || (t.y *= -1, t.x *= -1), i = Math.sqrt(t.x * t.x + t.y * t.y), a = Math.atan2(t.y, t.x) / Math.sin(this.s0), r = 2 * (Math.atan(Math.pow(this.ro0 / i, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45), e = Math.asin(Math.cos(this.ad) * Math.sin(r) - Math.sin(this.ad) * Math.cos(r) * Math.cos(a)), n = Math.asin(Math.cos(r) * Math.sin(a) / Math.cos(e)), t.x = this.long0 - n / this.alfa, o = e, s = 0;
                var h = 0;
                do {
                  t.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(e / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(o)) / (1 - this.e * Math.sin(o)), this.e / 2)) - this.s45), Math.abs(o - t.y) < 1e-10 && (s = 1), o = t.y, h += 1;
                } while (0 === s && h < 15);
                return h >= 15 ? null : t;
              },
              names: ["Krovak", "krovak"]
            };
          function ae(t, e, n, r, a) {
            return t * a - e * Math.sin(2 * a) + n * Math.sin(4 * a) - r * Math.sin(6 * a);
          }
          function ie(t) {
            return 1 - .25 * t * (1 + t / 16 * (3 + 1.25 * t));
          }
          function oe(t) {
            return .375 * t * (1 + .25 * t * (1 + .46875 * t));
          }
          function se(t) {
            return .05859375 * t * t * (1 + .75 * t);
          }
          function le(t) {
            return t * t * t * (35 / 3072);
          }
          function he(t, e, n) {
            var r = e * n;
            return t / Math.sqrt(1 - r * r);
          }
          function ue(t) {
            return Math.abs(t) < o ? t : t - R(t) * Math.PI;
          }
          function ce(t, e, n, r, a) {
            var i, o;
            i = t / e;
            for (var s = 0; s < 15; s++) {
              if (i += o = (t - (e * i - n * Math.sin(2 * i) + r * Math.sin(4 * i) - a * Math.sin(6 * i))) / (e - 2 * n * Math.cos(2 * i) + 4 * r * Math.cos(4 * i) - 6 * a * Math.cos(6 * i)), Math.abs(o) <= 1e-10) return i;
            }
            return NaN;
          }
          var fe = {
            init: function init() {
              this.sphere || (this.e0 = ie(this.es), this.e1 = oe(this.es), this.e2 = se(this.es), this.e3 = le(this.es), this.ml0 = this.a * ae(this.e0, this.e1, this.e2, this.e3, this.lat0));
            },
            forward: function forward(t) {
              var e,
                n,
                r = t.x,
                a = t.y;
              if (r = L(r - this.long0), this.sphere) e = this.a * Math.asin(Math.cos(a) * Math.sin(r)), n = this.a * (Math.atan2(Math.tan(a), Math.cos(r)) - this.lat0);else {
                var i = Math.sin(a),
                  o = Math.cos(a),
                  s = he(this.a, this.e, i),
                  l = Math.tan(a) * Math.tan(a),
                  h = r * Math.cos(a),
                  u = h * h,
                  c = this.es * o * o / (1 - this.es);
                e = s * h * (1 - u * l * (1 / 6 - (8 - l + 8 * c) * u / 120)), n = this.a * ae(this.e0, this.e1, this.e2, this.e3, a) - this.ml0 + s * i / o * u * (.5 + (5 - l + 6 * c) * u / 24);
              }
              return t.x = e + this.x0, t.y = n + this.y0, t;
            },
            inverse: function inverse(t) {
              t.x -= this.x0, t.y -= this.y0;
              var e,
                n,
                r = t.x / this.a,
                a = t.y / this.a;
              if (this.sphere) {
                var i = a + this.lat0;
                e = Math.asin(Math.sin(i) * Math.cos(r)), n = Math.atan2(Math.tan(r), Math.cos(i));
              } else {
                var l = ce(this.ml0 / this.a + a, this.e0, this.e1, this.e2, this.e3);
                if (Math.abs(Math.abs(l) - o) <= s) return t.x = this.long0, t.y = o, a < 0 && (t.y *= -1), t;
                var h = he(this.a, this.e, Math.sin(l)),
                  u = h * h * h / this.a / this.a * (1 - this.es),
                  c = Math.pow(Math.tan(l), 2),
                  f = r * this.a / h,
                  d = f * f;
                e = l - h * Math.tan(l) / u * f * f * (.5 - (1 + 3 * c) * f * f / 24), n = f * (1 - d * (c / 3 + (1 + 3 * c) * c * d / 15)) / Math.cos(l);
              }
              return t.x = L(n + this.long0), t.y = ue(e), t;
            },
            names: ["Cassini", "Cassini_Soldner", "cass"]
          };
          function de(t, e) {
            var n;
            return t > 1e-7 ? (1 - t * t) * (e / (1 - (n = t * e) * n) - .5 / t * Math.log((1 - n) / (1 + n))) : 2 * e;
          }
          var _e = {
            init: function init() {
              var t,
                e = Math.abs(this.lat0);
              if (Math.abs(e - o) < s ? this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE : Math.abs(e) < s ? this.mode = this.EQUIT : this.mode = this.OBLIQ, this.es > 0) switch (this.qp = de(this.e, 1), this.mmf = .5 / (1 - this.es), this.apa = function (t) {
                var e,
                  n = [];
                return n[0] = .3333333333333333 * t, e = t * t, n[0] += .17222222222222222 * e, n[1] = .06388888888888888 * e, e *= t, n[0] += .10257936507936508 * e, n[1] += .0664021164021164 * e, n[2] = .016415012942191543 * e, n;
              }(this.es), this.mode) {
                case this.N_POLE:
                case this.S_POLE:
                  this.dd = 1;
                  break;
                case this.EQUIT:
                  this.rq = Math.sqrt(.5 * this.qp), this.dd = 1 / this.rq, this.xmf = 1, this.ymf = .5 * this.qp;
                  break;
                case this.OBLIQ:
                  this.rq = Math.sqrt(.5 * this.qp), t = Math.sin(this.lat0), this.sinb1 = de(this.e, t) / this.qp, this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1), this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * t * t) * this.rq * this.cosb1), this.ymf = (this.xmf = this.rq) / this.dd, this.xmf *= this.dd;
              } else this.mode === this.OBLIQ && (this.sinph0 = Math.sin(this.lat0), this.cosph0 = Math.cos(this.lat0));
            },
            forward: function forward(t) {
              var e,
                n,
                r,
                a,
                i,
                l,
                h,
                c,
                f,
                d,
                _ = t.x,
                p = t.y;
              if (_ = L(_ - this.long0), this.sphere) {
                if (i = Math.sin(p), d = Math.cos(p), r = Math.cos(_), this.mode === this.OBLIQ || this.mode === this.EQUIT) {
                  if ((n = this.mode === this.EQUIT ? 1 + d * r : 1 + this.sinph0 * i + this.cosph0 * d * r) <= s) return null;
                  e = (n = Math.sqrt(2 / n)) * d * Math.sin(_), n *= this.mode === this.EQUIT ? i : this.cosph0 * i - this.sinph0 * d * r;
                } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
                  if (this.mode === this.N_POLE && (r = -r), Math.abs(p + this.lat0) < s) return null;
                  n = u - .5 * p, e = (n = 2 * (this.mode === this.S_POLE ? Math.cos(n) : Math.sin(n))) * Math.sin(_), n *= r;
                }
              } else {
                switch (h = 0, c = 0, f = 0, r = Math.cos(_), a = Math.sin(_), i = Math.sin(p), l = de(this.e, i), this.mode !== this.OBLIQ && this.mode !== this.EQUIT || (h = l / this.qp, c = Math.sqrt(1 - h * h)), this.mode) {
                  case this.OBLIQ:
                    f = 1 + this.sinb1 * h + this.cosb1 * c * r;
                    break;
                  case this.EQUIT:
                    f = 1 + c * r;
                    break;
                  case this.N_POLE:
                    f = o + p, l = this.qp - l;
                    break;
                  case this.S_POLE:
                    f = p - o, l = this.qp + l;
                }
                if (Math.abs(f) < s) return null;
                switch (this.mode) {
                  case this.OBLIQ:
                  case this.EQUIT:
                    f = Math.sqrt(2 / f), n = this.mode === this.OBLIQ ? this.ymf * f * (this.cosb1 * h - this.sinb1 * c * r) : (f = Math.sqrt(2 / (1 + c * r))) * h * this.ymf, e = this.xmf * f * c * a;
                    break;
                  case this.N_POLE:
                  case this.S_POLE:
                    l >= 0 ? (e = (f = Math.sqrt(l)) * a, n = r * (this.mode === this.S_POLE ? f : -f)) : e = n = 0;
                }
              }
              return t.x = this.a * e + this.x0, t.y = this.a * n + this.y0, t;
            },
            inverse: function inverse(t) {
              t.x -= this.x0, t.y -= this.y0;
              var e,
                n,
                r,
                a,
                i,
                l,
                h,
                u,
                c,
                f,
                d = t.x / this.a,
                _ = t.y / this.a;
              if (this.sphere) {
                var p,
                  y = 0,
                  g = 0;
                if ((n = .5 * (p = Math.sqrt(d * d + _ * _))) > 1) return null;
                switch (n = 2 * Math.asin(n), this.mode !== this.OBLIQ && this.mode !== this.EQUIT || (g = Math.sin(n), y = Math.cos(n)), this.mode) {
                  case this.EQUIT:
                    n = Math.abs(p) <= s ? 0 : Math.asin(_ * g / p), d *= g, _ = y * p;
                    break;
                  case this.OBLIQ:
                    n = Math.abs(p) <= s ? this.lat0 : Math.asin(y * this.sinph0 + _ * g * this.cosph0 / p), d *= g * this.cosph0, _ = (y - Math.sin(n) * this.sinph0) * p;
                    break;
                  case this.N_POLE:
                    _ = -_, n = o - n;
                    break;
                  case this.S_POLE:
                    n -= o;
                }
                e = 0 !== _ || this.mode !== this.EQUIT && this.mode !== this.OBLIQ ? Math.atan2(d, _) : 0;
              } else {
                if (h = 0, this.mode === this.OBLIQ || this.mode === this.EQUIT) {
                  if (d /= this.dd, _ *= this.dd, (l = Math.sqrt(d * d + _ * _)) < s) return t.x = this.long0, t.y = this.lat0, t;
                  a = 2 * Math.asin(.5 * l / this.rq), r = Math.cos(a), d *= a = Math.sin(a), this.mode === this.OBLIQ ? (h = r * this.sinb1 + _ * a * this.cosb1 / l, i = this.qp * h, _ = l * this.cosb1 * r - _ * this.sinb1 * a) : (h = _ * a / l, i = this.qp * h, _ = l * r);
                } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
                  if (this.mode === this.N_POLE && (_ = -_), !(i = d * d + _ * _)) return t.x = this.long0, t.y = this.lat0, t;
                  h = 1 - i / this.qp, this.mode === this.S_POLE && (h = -h);
                }
                e = Math.atan2(d, _), f = (u = Math.asin(h)) + u, n = u + (c = this.apa)[0] * Math.sin(f) + c[1] * Math.sin(f + f) + c[2] * Math.sin(f + f + f);
              }
              return t.x = L(this.long0 + e), t.y = n, t;
            },
            names: ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"],
            S_POLE: 1,
            N_POLE: 2,
            EQUIT: 3,
            OBLIQ: 4
          };
          function pe(t) {
            return Math.abs(t) > 1 && (t = t > 1 ? 1 : -1), Math.asin(t);
          }
          var ye = {
              init: function init() {
                Math.abs(this.lat1 + this.lat2) < s || (this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e3 = Math.sqrt(this.es), this.sin_po = Math.sin(this.lat1), this.cos_po = Math.cos(this.lat1), this.t1 = this.sin_po, this.con = this.sin_po, this.ms1 = D(this.e3, this.sin_po, this.cos_po), this.qs1 = de(this.e3, this.sin_po, this.cos_po), this.sin_po = Math.sin(this.lat2), this.cos_po = Math.cos(this.lat2), this.t2 = this.sin_po, this.ms2 = D(this.e3, this.sin_po, this.cos_po), this.qs2 = de(this.e3, this.sin_po, this.cos_po), this.sin_po = Math.sin(this.lat0), this.cos_po = Math.cos(this.lat0), this.t3 = this.sin_po, this.qs0 = de(this.e3, this.sin_po, this.cos_po), Math.abs(this.lat1 - this.lat2) > s ? this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1) : this.ns0 = this.con, this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1, this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0);
              },
              forward: function forward(t) {
                var e = t.x,
                  n = t.y;
                this.sin_phi = Math.sin(n), this.cos_phi = Math.cos(n);
                var r = de(this.e3, this.sin_phi, this.cos_phi),
                  a = this.a * Math.sqrt(this.c - this.ns0 * r) / this.ns0,
                  i = this.ns0 * L(e - this.long0),
                  o = a * Math.sin(i) + this.x0,
                  s = this.rh - a * Math.cos(i) + this.y0;
                return t.x = o, t.y = s, t;
              },
              inverse: function inverse(t) {
                var e, n, r, a, i, o;
                return t.x -= this.x0, t.y = this.rh - t.y + this.y0, this.ns0 >= 0 ? (e = Math.sqrt(t.x * t.x + t.y * t.y), r = 1) : (e = -Math.sqrt(t.x * t.x + t.y * t.y), r = -1), a = 0, 0 !== e && (a = Math.atan2(r * t.x, r * t.y)), r = e * this.ns0 / this.a, this.sphere ? o = Math.asin((this.c - r * r) / (2 * this.ns0)) : (n = (this.c - r * r) / this.ns0, o = this.phi1z(this.e3, n)), i = L(a / this.ns0 + this.long0), t.x = i, t.y = o, t;
              },
              names: ["Albers_Conic_Equal_Area", "Albers", "aea"],
              phi1z: function phi1z(t, e) {
                var n,
                  r,
                  a,
                  i,
                  o = pe(.5 * e);
                if (t < s) return o;
                for (var l = t * t, h = 1; h <= 25; h++) {
                  if (o += i = .5 * (a = 1 - (r = t * (n = Math.sin(o))) * r) * a / Math.cos(o) * (e / (1 - l) - n / a + .5 / t * Math.log((1 - r) / (1 + r))), Math.abs(i) <= 1e-7) return o;
                }
                return null;
              }
            },
            ge = {
              init: function init() {
                this.sin_p14 = Math.sin(this.lat0), this.cos_p14 = Math.cos(this.lat0), this.infinity_dist = 1e3 * this.a, this.rc = 1;
              },
              forward: function forward(t) {
                var e,
                  n,
                  r,
                  a,
                  i,
                  o,
                  l,
                  h = t.x,
                  u = t.y;
                return r = L(h - this.long0), e = Math.sin(u), n = Math.cos(u), a = Math.cos(r), (i = this.sin_p14 * e + this.cos_p14 * n * a) > 0 || Math.abs(i) <= s ? (o = this.x0 + 1 * this.a * n * Math.sin(r) / i, l = this.y0 + 1 * this.a * (this.cos_p14 * e - this.sin_p14 * n * a) / i) : (o = this.x0 + this.infinity_dist * n * Math.sin(r), l = this.y0 + this.infinity_dist * (this.cos_p14 * e - this.sin_p14 * n * a)), t.x = o, t.y = l, t;
              },
              inverse: function inverse(t) {
                var e, n, r, a, i, o;
                return t.x = (t.x - this.x0) / this.a, t.y = (t.y - this.y0) / this.a, t.x /= this.k0, t.y /= this.k0, (e = Math.sqrt(t.x * t.x + t.y * t.y)) ? (a = Math.atan2(e, this.rc), n = Math.sin(a), o = pe((r = Math.cos(a)) * this.sin_p14 + t.y * n * this.cos_p14 / e), i = Math.atan2(t.x * n, e * this.cos_p14 * r - t.y * this.sin_p14 * n), i = L(this.long0 + i)) : (o = this.phic0, i = 0), t.x = i, t.y = o, t;
              },
              names: ["gnom"]
            },
            me = {
              init: function init() {
                this.sphere || (this.k0 = D(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)));
              },
              forward: function forward(t) {
                var e,
                  n,
                  r = t.x,
                  a = t.y,
                  i = L(r - this.long0);
                if (this.sphere) e = this.x0 + this.a * i * Math.cos(this.lat_ts), n = this.y0 + this.a * Math.sin(a) / Math.cos(this.lat_ts);else {
                  var o = de(this.e, Math.sin(a));
                  e = this.x0 + this.a * this.k0 * i, n = this.y0 + this.a * o * .5 / this.k0;
                }
                return t.x = e, t.y = n, t;
              },
              inverse: function inverse(t) {
                var e, n;
                return t.x -= this.x0, t.y -= this.y0, this.sphere ? (e = L(this.long0 + t.x / this.a / Math.cos(this.lat_ts)), n = Math.asin(t.y / this.a * Math.cos(this.lat_ts))) : (n = function (t, e) {
                  var n = 1 - (1 - t * t) / (2 * t) * Math.log((1 - t) / (1 + t));
                  if (Math.abs(Math.abs(e) - n) < 1e-6) return e < 0 ? -1 * o : o;
                  for (var r, a, i, s, l = Math.asin(.5 * e), h = 0; h < 30; h++) {
                    if (a = Math.sin(l), i = Math.cos(l), s = t * a, l += r = Math.pow(1 - s * s, 2) / (2 * i) * (e / (1 - t * t) - a / (1 - s * s) + .5 / t * Math.log((1 - s) / (1 + s))), Math.abs(r) <= 1e-10) return l;
                  }
                  return NaN;
                }(this.e, 2 * t.y * this.k0 / this.a), e = L(this.long0 + t.x / (this.a * this.k0))), t.x = e, t.y = n, t;
              },
              names: ["cea"]
            },
            ve = {
              init: function init() {
                this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.lat_ts = this.lat_ts || 0, this.title = this.title || "Equidistant Cylindrical (Plate Carre)", this.rc = Math.cos(this.lat_ts);
              },
              forward: function forward(t) {
                var e = t.x,
                  n = t.y,
                  r = L(e - this.long0),
                  a = ue(n - this.lat0);
                return t.x = this.x0 + this.a * r * this.rc, t.y = this.y0 + this.a * a, t;
              },
              inverse: function inverse(t) {
                var e = t.x,
                  n = t.y;
                return t.x = L(this.long0 + (e - this.x0) / (this.a * this.rc)), t.y = ue(this.lat0 + (n - this.y0) / this.a), t;
              },
              names: ["Equirectangular", "Equidistant_Cylindrical", "eqc"]
            },
            xe = {
              init: function init() {
                this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e = Math.sqrt(this.es), this.e0 = ie(this.es), this.e1 = oe(this.es), this.e2 = se(this.es), this.e3 = le(this.es), this.ml0 = this.a * ae(this.e0, this.e1, this.e2, this.e3, this.lat0);
              },
              forward: function forward(t) {
                var e,
                  n,
                  r,
                  a = t.x,
                  i = t.y,
                  o = L(a - this.long0);
                if (r = o * Math.sin(i), this.sphere) Math.abs(i) <= s ? (e = this.a * o, n = -1 * this.a * this.lat0) : (e = this.a * Math.sin(r) / Math.tan(i), n = this.a * (ue(i - this.lat0) + (1 - Math.cos(r)) / Math.tan(i)));else if (Math.abs(i) <= s) e = this.a * o, n = -1 * this.ml0;else {
                  var l = he(this.a, this.e, Math.sin(i)) / Math.tan(i);
                  e = l * Math.sin(r), n = this.a * ae(this.e0, this.e1, this.e2, this.e3, i) - this.ml0 + l * (1 - Math.cos(r));
                }
                return t.x = e + this.x0, t.y = n + this.y0, t;
              },
              inverse: function inverse(t) {
                var e, n, r, a, i, o, l, h, u;
                if (r = t.x - this.x0, a = t.y - this.y0, this.sphere) {
                  if (Math.abs(a + this.a * this.lat0) <= s) e = L(r / this.a + this.long0), n = 0;else {
                    var c;
                    for (o = this.lat0 + a / this.a, l = r * r / this.a / this.a + o * o, h = o, i = 20; i; --i) {
                      if (h += u = -1 * (o * (h * (c = Math.tan(h)) + 1) - h - .5 * (h * h + l) * c) / ((h - o) / c - 1), Math.abs(u) <= s) {
                        n = h;
                        break;
                      }
                    }
                    e = L(this.long0 + Math.asin(r * Math.tan(h) / this.a) / Math.sin(n));
                  }
                } else if (Math.abs(a + this.ml0) <= s) n = 0, e = L(this.long0 + r / this.a);else {
                  var f, d, _, p, y;
                  for (o = (this.ml0 + a) / this.a, l = r * r / this.a / this.a + o * o, h = o, i = 20; i; --i) {
                    if (y = this.e * Math.sin(h), f = Math.sqrt(1 - y * y) * Math.tan(h), d = this.a * ae(this.e0, this.e1, this.e2, this.e3, h), _ = this.e0 - 2 * this.e1 * Math.cos(2 * h) + 4 * this.e2 * Math.cos(4 * h) - 6 * this.e3 * Math.cos(6 * h), h -= u = (o * (f * (p = d / this.a) + 1) - p - .5 * f * (p * p + l)) / (this.es * Math.sin(2 * h) * (p * p + l - 2 * o * p) / (4 * f) + (o - p) * (f * _ - 2 / Math.sin(2 * h)) - _), Math.abs(u) <= s) {
                      n = h;
                      break;
                    }
                  }
                  f = Math.sqrt(1 - this.es * Math.pow(Math.sin(n), 2)) * Math.tan(n), e = L(this.long0 + Math.asin(r * f / this.a) / Math.sin(n));
                }
                return t.x = e, t.y = n, t;
              },
              names: ["Polyconic", "poly"]
            },
            be = {
              init: function init() {
                this.A = [], this.A[1] = .6399175073, this.A[2] = -.1358797613, this.A[3] = .063294409, this.A[4] = -.02526853, this.A[5] = .0117879, this.A[6] = -.0055161, this.A[7] = .0026906, this.A[8] = -.001333, this.A[9] = 67e-5, this.A[10] = -34e-5, this.B_re = [], this.B_im = [], this.B_re[1] = .7557853228, this.B_im[1] = 0, this.B_re[2] = .249204646, this.B_im[2] = .003371507, this.B_re[3] = -.001541739, this.B_im[3] = .04105856, this.B_re[4] = -.10162907, this.B_im[4] = .01727609, this.B_re[5] = -.26623489, this.B_im[5] = -.36249218, this.B_re[6] = -.6870983, this.B_im[6] = -1.1651967, this.C_re = [], this.C_im = [], this.C_re[1] = 1.3231270439, this.C_im[1] = 0, this.C_re[2] = -.577245789, this.C_im[2] = -.007809598, this.C_re[3] = .508307513, this.C_im[3] = -.112208952, this.C_re[4] = -.15094762, this.C_im[4] = .18200602, this.C_re[5] = 1.01418179, this.C_im[5] = 1.64497696, this.C_re[6] = 1.9660549, this.C_im[6] = 2.5127645, this.D = [], this.D[1] = 1.5627014243, this.D[2] = .5185406398, this.D[3] = -.03333098, this.D[4] = -.1052906, this.D[5] = -.0368594, this.D[6] = .007317, this.D[7] = .0122, this.D[8] = .00394, this.D[9] = -.0013;
              },
              forward: function forward(t) {
                var e,
                  n = t.x,
                  r = t.y - this.lat0,
                  a = n - this.long0,
                  o = r / i * 1e-5,
                  s = a,
                  l = 1,
                  h = 0;
                for (e = 1; e <= 10; e++) {
                  l *= o, h += this.A[e] * l;
                }
                var u,
                  c = h,
                  f = s,
                  d = 1,
                  _ = 0,
                  p = 0,
                  y = 0;
                for (e = 1; e <= 6; e++) {
                  u = _ * c + d * f, d = d * c - _ * f, _ = u, p = p + this.B_re[e] * d - this.B_im[e] * _, y = y + this.B_im[e] * d + this.B_re[e] * _;
                }
                return t.x = y * this.a + this.x0, t.y = p * this.a + this.y0, t;
              },
              inverse: function inverse(t) {
                var e,
                  n,
                  r = t.x,
                  a = t.y,
                  o = r - this.x0,
                  s = (a - this.y0) / this.a,
                  l = o / this.a,
                  h = 1,
                  u = 0,
                  c = 0,
                  f = 0;
                for (e = 1; e <= 6; e++) {
                  n = u * s + h * l, h = h * s - u * l, u = n, c = c + this.C_re[e] * h - this.C_im[e] * u, f = f + this.C_im[e] * h + this.C_re[e] * u;
                }
                for (var d = 0; d < this.iterations; d++) {
                  var _,
                    p = c,
                    y = f,
                    g = s,
                    m = l;
                  for (e = 2; e <= 6; e++) {
                    _ = y * c + p * f, p = p * c - y * f, y = _, g += (e - 1) * (this.B_re[e] * p - this.B_im[e] * y), m += (e - 1) * (this.B_im[e] * p + this.B_re[e] * y);
                  }
                  p = 1, y = 0;
                  var v = this.B_re[1],
                    x = this.B_im[1];
                  for (e = 2; e <= 6; e++) {
                    _ = y * c + p * f, p = p * c - y * f, y = _, v += e * (this.B_re[e] * p - this.B_im[e] * y), x += e * (this.B_im[e] * p + this.B_re[e] * y);
                  }
                  var b = v * v + x * x;
                  c = (g * v + m * x) / b, f = (m * v - g * x) / b;
                }
                var k = c,
                  M = f,
                  w = 1,
                  C = 0;
                for (e = 1; e <= 9; e++) {
                  w *= k, C += this.D[e] * w;
                }
                var E = this.lat0 + C * i * 1e5,
                  S = this.long0 + M;
                return t.x = S, t.y = E, t;
              },
              names: ["New_Zealand_Map_Grid", "nzmg"]
            },
            ke = {
              init: function init() {},
              forward: function forward(t) {
                var e = t.x,
                  n = t.y,
                  r = L(e - this.long0),
                  a = this.x0 + this.a * r,
                  i = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + n / 2.5)) * 1.25;
                return t.x = a, t.y = i, t;
              },
              inverse: function inverse(t) {
                t.x -= this.x0, t.y -= this.y0;
                var e = L(this.long0 + t.x / this.a),
                  n = 2.5 * (Math.atan(Math.exp(.8 * t.y / this.a)) - Math.PI / 4);
                return t.x = e, t.y = n, t;
              },
              names: ["Miller_Cylindrical", "mill"]
            },
            Me = {
              init: function init() {
                this.sphere ? (this.n = 1, this.m = 0, this.es = 0, this.C_y = Math.sqrt((this.m + 1) / this.n), this.C_x = this.C_y / (this.m + 1)) : this.en = Tt(this.es);
              },
              forward: function forward(t) {
                var e,
                  n,
                  r = t.x,
                  a = t.y;
                if (r = L(r - this.long0), this.sphere) {
                  if (this.m) for (var i = this.n * Math.sin(a), o = 20; o; --o) {
                    var l = (this.m * a + Math.sin(a) - i) / (this.m + Math.cos(a));
                    if (a -= l, Math.abs(l) < s) break;
                  } else a = 1 !== this.n ? Math.asin(this.n * Math.sin(a)) : a;
                  e = this.a * this.C_x * r * (this.m + Math.cos(a)), n = this.a * this.C_y * a;
                } else {
                  var h = Math.sin(a),
                    u = Math.cos(a);
                  n = this.a * Bt(a, h, u, this.en), e = this.a * r * u / Math.sqrt(1 - this.es * h * h);
                }
                return t.x = e, t.y = n, t;
              },
              inverse: function inverse(t) {
                var e, n, r;
                return t.x -= this.x0, n = t.x / this.a, t.y -= this.y0, e = t.y / this.a, this.sphere ? (e /= this.C_y, n /= this.C_x * (this.m + Math.cos(e)), this.m ? e = pe((this.m * e + Math.sin(e)) / this.n) : 1 !== this.n && (e = pe(Math.sin(e) / this.n)), n = L(n + this.long0), e = ue(e)) : (e = Qt(t.y / this.a, this.es, this.en), (r = Math.abs(e)) < o ? (r = Math.sin(e), n = L(this.long0 + t.x * Math.sqrt(1 - this.es * r * r) / (this.a * Math.cos(e)))) : r - s < o && (n = this.long0)), t.x = n, t.y = e, t;
              },
              names: ["Sinusoidal", "sinu"]
            },
            we = {
              init: function init() {},
              forward: function forward(t) {
                for (var e = t.x, n = t.y, r = L(e - this.long0), a = n, i = Math.PI * Math.sin(n);;) {
                  var o = -(a + Math.sin(a) - i) / (1 + Math.cos(a));
                  if (a += o, Math.abs(o) < s) break;
                }
                a /= 2, Math.PI / 2 - Math.abs(n) < s && (r = 0);
                var l = .900316316158 * this.a * r * Math.cos(a) + this.x0,
                  h = 1.4142135623731 * this.a * Math.sin(a) + this.y0;
                return t.x = l, t.y = h, t;
              },
              inverse: function inverse(t) {
                var e, n;
                t.x -= this.x0, t.y -= this.y0, n = t.y / (1.4142135623731 * this.a), Math.abs(n) > .999999999999 && (n = .999999999999), e = Math.asin(n);
                var r = L(this.long0 + t.x / (.900316316158 * this.a * Math.cos(e)));
                r < -Math.PI && (r = -Math.PI), r > Math.PI && (r = Math.PI), n = (2 * e + Math.sin(2 * e)) / Math.PI, Math.abs(n) > 1 && (n = 1);
                var a = Math.asin(n);
                return t.x = r, t.y = a, t;
              },
              names: ["Mollweide", "moll"]
            },
            Ce = {
              init: function init() {
                Math.abs(this.lat1 + this.lat2) < s || (this.lat2 = this.lat2 || this.lat1, this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e = Math.sqrt(this.es), this.e0 = ie(this.es), this.e1 = oe(this.es), this.e2 = se(this.es), this.e3 = le(this.es), this.sinphi = Math.sin(this.lat1), this.cosphi = Math.cos(this.lat1), this.ms1 = D(this.e, this.sinphi, this.cosphi), this.ml1 = ae(this.e0, this.e1, this.e2, this.e3, this.lat1), Math.abs(this.lat1 - this.lat2) < s ? this.ns = this.sinphi : (this.sinphi = Math.sin(this.lat2), this.cosphi = Math.cos(this.lat2), this.ms2 = D(this.e, this.sinphi, this.cosphi), this.ml2 = ae(this.e0, this.e1, this.e2, this.e3, this.lat2), this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1)), this.g = this.ml1 + this.ms1 / this.ns, this.ml0 = ae(this.e0, this.e1, this.e2, this.e3, this.lat0), this.rh = this.a * (this.g - this.ml0));
              },
              forward: function forward(t) {
                var e,
                  n = t.x,
                  r = t.y;
                if (this.sphere) e = this.a * (this.g - r);else {
                  var a = ae(this.e0, this.e1, this.e2, this.e3, r);
                  e = this.a * (this.g - a);
                }
                var i = this.ns * L(n - this.long0),
                  o = this.x0 + e * Math.sin(i),
                  s = this.y0 + this.rh - e * Math.cos(i);
                return t.x = o, t.y = s, t;
              },
              inverse: function inverse(t) {
                var e, n, r, a;
                t.x -= this.x0, t.y = this.rh - t.y + this.y0, this.ns >= 0 ? (n = Math.sqrt(t.x * t.x + t.y * t.y), e = 1) : (n = -Math.sqrt(t.x * t.x + t.y * t.y), e = -1);
                var i = 0;
                return 0 !== n && (i = Math.atan2(e * t.x, e * t.y)), this.sphere ? (a = L(this.long0 + i / this.ns), r = ue(this.g - n / this.a), t.x = a, t.y = r, t) : (r = ce(this.g - n / this.a, this.e0, this.e1, this.e2, this.e3), a = L(this.long0 + i / this.ns), t.x = a, t.y = r, t);
              },
              names: ["Equidistant_Conic", "eqdc"]
            },
            Ee = {
              init: function init() {
                this.R = this.a;
              },
              forward: function forward(t) {
                var e,
                  n,
                  r = t.x,
                  a = t.y,
                  i = L(r - this.long0);
                Math.abs(a) <= s && (e = this.x0 + this.R * i, n = this.y0);
                var l = pe(2 * Math.abs(a / Math.PI));
                (Math.abs(i) <= s || Math.abs(Math.abs(a) - o) <= s) && (e = this.x0, n = a >= 0 ? this.y0 + Math.PI * this.R * Math.tan(.5 * l) : this.y0 + Math.PI * this.R * -Math.tan(.5 * l));
                var h = .5 * Math.abs(Math.PI / i - i / Math.PI),
                  u = h * h,
                  c = Math.sin(l),
                  f = Math.cos(l),
                  d = f / (c + f - 1),
                  _ = d * d,
                  p = d * (2 / c - 1),
                  y = p * p,
                  g = Math.PI * this.R * (h * (d - y) + Math.sqrt(u * (d - y) * (d - y) - (y + u) * (_ - y))) / (y + u);
                i < 0 && (g = -g), e = this.x0 + g;
                var m = u + d;
                return g = Math.PI * this.R * (p * m - h * Math.sqrt((y + u) * (u + 1) - m * m)) / (y + u), n = a >= 0 ? this.y0 + g : this.y0 - g, t.x = e, t.y = n, t;
              },
              inverse: function inverse(t) {
                var e, n, r, a, i, o, l, h, u, c, f, d;
                return t.x -= this.x0, t.y -= this.y0, f = Math.PI * this.R, i = (r = t.x / f) * r + (a = t.y / f) * a, f = 3 * (a * a / (h = -2 * (o = -Math.abs(a) * (1 + i)) + 1 + 2 * a * a + i * i) + (2 * (l = o - 2 * a * a + r * r) * l * l / h / h / h - 9 * o * l / h / h) / 27) / (u = (o - l * l / 3 / h) / h) / (c = 2 * Math.sqrt(-u / 3)), Math.abs(f) > 1 && (f = f >= 0 ? 1 : -1), d = Math.acos(f) / 3, n = t.y >= 0 ? (-c * Math.cos(d + Math.PI / 3) - l / 3 / h) * Math.PI : -(-c * Math.cos(d + Math.PI / 3) - l / 3 / h) * Math.PI, e = Math.abs(r) < s ? this.long0 : L(this.long0 + Math.PI * (i - 1 + Math.sqrt(1 + 2 * (r * r - a * a) + i * i)) / 2 / r), t.x = e, t.y = n, t;
              },
              names: ["Van_der_Grinten_I", "VanDerGrinten", "vandg"]
            },
            Se = {
              init: function init() {
                this.sin_p12 = Math.sin(this.lat0), this.cos_p12 = Math.cos(this.lat0);
              },
              forward: function forward(t) {
                var e,
                  n,
                  r,
                  a,
                  i,
                  l,
                  h,
                  u,
                  c,
                  f,
                  d,
                  _,
                  p,
                  y,
                  g,
                  m,
                  v,
                  x,
                  b,
                  k,
                  M,
                  w,
                  C = t.x,
                  E = t.y,
                  S = Math.sin(t.y),
                  A = Math.cos(t.y),
                  I = L(C - this.long0);
                return this.sphere ? Math.abs(this.sin_p12 - 1) <= s ? (t.x = this.x0 + this.a * (o - E) * Math.sin(I), t.y = this.y0 - this.a * (o - E) * Math.cos(I), t) : Math.abs(this.sin_p12 + 1) <= s ? (t.x = this.x0 + this.a * (o + E) * Math.sin(I), t.y = this.y0 + this.a * (o + E) * Math.cos(I), t) : (x = this.sin_p12 * S + this.cos_p12 * A * Math.cos(I), v = (m = Math.acos(x)) ? m / Math.sin(m) : 1, t.x = this.x0 + this.a * v * A * Math.sin(I), t.y = this.y0 + this.a * v * (this.cos_p12 * S - this.sin_p12 * A * Math.cos(I)), t) : (e = ie(this.es), n = oe(this.es), r = se(this.es), a = le(this.es), Math.abs(this.sin_p12 - 1) <= s ? (i = this.a * ae(e, n, r, a, o), l = this.a * ae(e, n, r, a, E), t.x = this.x0 + (i - l) * Math.sin(I), t.y = this.y0 - (i - l) * Math.cos(I), t) : Math.abs(this.sin_p12 + 1) <= s ? (i = this.a * ae(e, n, r, a, o), l = this.a * ae(e, n, r, a, E), t.x = this.x0 + (i + l) * Math.sin(I), t.y = this.y0 + (i + l) * Math.cos(I), t) : (h = S / A, u = he(this.a, this.e, this.sin_p12), c = he(this.a, this.e, S), f = Math.atan((1 - this.es) * h + this.es * u * this.sin_p12 / (c * A)), b = 0 === (d = Math.atan2(Math.sin(I), this.cos_p12 * Math.tan(f) - this.sin_p12 * Math.cos(I))) ? Math.asin(this.cos_p12 * Math.sin(f) - this.sin_p12 * Math.cos(f)) : Math.abs(Math.abs(d) - Math.PI) <= s ? -Math.asin(this.cos_p12 * Math.sin(f) - this.sin_p12 * Math.cos(f)) : Math.asin(Math.sin(I) * Math.cos(f) / Math.sin(d)), _ = this.e * this.sin_p12 / Math.sqrt(1 - this.es), m = u * b * (1 - (k = b * b) * (g = (p = this.e * this.cos_p12 * Math.cos(d) / Math.sqrt(1 - this.es)) * p) * (1 - g) / 6 + (M = k * b) / 8 * (y = _ * p) * (1 - 2 * g) + (w = M * b) / 120 * (g * (4 - 7 * g) - 3 * _ * _ * (1 - 7 * g)) - w * b / 48 * y), t.x = this.x0 + m * Math.sin(d), t.y = this.y0 + m * Math.cos(d), t));
              },
              inverse: function inverse(t) {
                var e, n, r, a, i, l, h, u, c, f, d, _, p, y, g, m, v, x, b, k, M, w, C;
                if (t.x -= this.x0, t.y -= this.y0, this.sphere) {
                  if ((e = Math.sqrt(t.x * t.x + t.y * t.y)) > 2 * o * this.a) return;
                  return n = e / this.a, r = Math.sin(n), a = Math.cos(n), i = this.long0, Math.abs(e) <= s ? l = this.lat0 : (l = pe(a * this.sin_p12 + t.y * r * this.cos_p12 / e), h = Math.abs(this.lat0) - o, i = Math.abs(h) <= s ? this.lat0 >= 0 ? L(this.long0 + Math.atan2(t.x, -t.y)) : L(this.long0 - Math.atan2(-t.x, t.y)) : L(this.long0 + Math.atan2(t.x * r, e * this.cos_p12 * a - t.y * this.sin_p12 * r))), t.x = i, t.y = l, t;
                }
                return u = ie(this.es), c = oe(this.es), f = se(this.es), d = le(this.es), Math.abs(this.sin_p12 - 1) <= s ? (l = ce(((_ = this.a * ae(u, c, f, d, o)) - (e = Math.sqrt(t.x * t.x + t.y * t.y))) / this.a, u, c, f, d), i = L(this.long0 + Math.atan2(t.x, -1 * t.y)), t.x = i, t.y = l, t) : Math.abs(this.sin_p12 + 1) <= s ? (_ = this.a * ae(u, c, f, d, o), l = ce(((e = Math.sqrt(t.x * t.x + t.y * t.y)) - _) / this.a, u, c, f, d), i = L(this.long0 + Math.atan2(t.x, t.y)), t.x = i, t.y = l, t) : (e = Math.sqrt(t.x * t.x + t.y * t.y), g = Math.atan2(t.x, t.y), p = he(this.a, this.e, this.sin_p12), m = Math.cos(g), x = -(v = this.e * this.cos_p12 * m) * v / (1 - this.es), b = 3 * this.es * (1 - x) * this.sin_p12 * this.cos_p12 * m / (1 - this.es), w = 1 - x * (M = (k = e / p) - x * (1 + x) * Math.pow(k, 3) / 6 - b * (1 + 3 * x) * Math.pow(k, 4) / 24) * M / 2 - k * M * M * M / 6, y = Math.asin(this.sin_p12 * Math.cos(M) + this.cos_p12 * Math.sin(M) * m), i = L(this.long0 + Math.asin(Math.sin(g) * Math.sin(M) / Math.cos(y))), C = Math.sin(y), l = Math.atan2((C - this.es * w * this.sin_p12) * Math.tan(y), C * (1 - this.es)), t.x = i, t.y = l, t);
              },
              names: ["Azimuthal_Equidistant", "aeqd"]
            },
            Ae = {
              init: function init() {
                this.sin_p14 = Math.sin(this.lat0), this.cos_p14 = Math.cos(this.lat0);
              },
              forward: function forward(t) {
                var e,
                  n,
                  r,
                  a,
                  i,
                  o,
                  l,
                  h = t.x,
                  u = t.y;
                return r = L(h - this.long0), e = Math.sin(u), n = Math.cos(u), a = Math.cos(r), ((i = this.sin_p14 * e + this.cos_p14 * n * a) > 0 || Math.abs(i) <= s) && (o = 1 * this.a * n * Math.sin(r), l = this.y0 + 1 * this.a * (this.cos_p14 * e - this.sin_p14 * n * a)), t.x = o, t.y = l, t;
              },
              inverse: function inverse(t) {
                var e, n, r, a, i, l, h;
                return t.x -= this.x0, t.y -= this.y0, n = pe((e = Math.sqrt(t.x * t.x + t.y * t.y)) / this.a), r = Math.sin(n), a = Math.cos(n), l = this.long0, Math.abs(e) <= s ? (h = this.lat0, t.x = l, t.y = h, t) : (h = pe(a * this.sin_p14 + t.y * r * this.cos_p14 / e), i = Math.abs(this.lat0) - o, Math.abs(i) <= s ? (l = this.lat0 >= 0 ? L(this.long0 + Math.atan2(t.x, -t.y)) : L(this.long0 - Math.atan2(-t.x, t.y)), t.x = l, t.y = h, t) : (l = L(this.long0 + Math.atan2(t.x * r, e * this.cos_p14 * a - t.y * this.sin_p14 * r)), t.x = l, t.y = h, t));
              },
              names: ["ortho"]
            };
          function Ie(t, e, n, r) {
            var a;
            return t < s ? (r.value = 1, a = 0) : (a = Math.atan2(e, n), Math.abs(a) <= u ? r.value = 1 : a > u && a <= o + u ? (r.value = 2, a -= o) : a > o + u || a <= -(o + u) ? (r.value = 3, a = a >= 0 ? a - f : a + f) : (r.value = 4, a += o)), a;
          }
          function Oe(t, e) {
            var n = t + e;
            return n < -f ? n += c : n > +f && (n -= c), n;
          }
          var je = {
            init: function init() {
              this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.lat_ts = this.lat_ts || 0, this.title = this.title || "Quadrilateralized Spherical Cube", this.lat0 >= o - u / 2 ? this.face = 5 : this.lat0 <= -(o - u / 2) ? this.face = 6 : Math.abs(this.long0) <= u ? this.face = 1 : Math.abs(this.long0) <= o + u ? this.face = this.long0 > 0 ? 2 : 4 : this.face = 3, 0 !== this.es && (this.one_minus_f = 1 - (this.a - this.b) / this.a, this.one_minus_f_squared = this.one_minus_f * this.one_minus_f);
            },
            forward: function forward(t) {
              var e,
                n,
                r,
                a,
                i,
                s,
                l = {
                  x: 0,
                  y: 0
                },
                h = {
                  value: 0
                };
              if (t.x -= this.long0, e = 0 !== this.es ? Math.atan(this.one_minus_f_squared * Math.tan(t.y)) : t.y, n = t.x, 5 === this.face) a = o - e, n >= u && n <= o + u ? (h.value = 1, r = n - o) : n > o + u || n <= -(o + u) ? (h.value = 2, r = n > 0 ? n - f : n + f) : n > -(o + u) && n <= -u ? (h.value = 3, r = n + o) : (h.value = 4, r = n);else if (6 === this.face) a = o + e, n >= u && n <= o + u ? (h.value = 1, r = -n + o) : n < u && n >= -u ? (h.value = 2, r = -n) : n < -u && n >= -(o + u) ? (h.value = 3, r = -n - o) : (h.value = 4, r = n > 0 ? -n + f : -n - f);else {
                var c, d, _, p, y, g;
                2 === this.face ? n = Oe(n, +o) : 3 === this.face ? n = Oe(n, +f) : 4 === this.face && (n = Oe(n, -o)), p = Math.sin(e), y = Math.cos(e), g = Math.sin(n), c = y * Math.cos(n), d = y * g, _ = p, 1 === this.face ? r = Ie(a = Math.acos(c), _, d, h) : 2 === this.face ? r = Ie(a = Math.acos(d), _, -c, h) : 3 === this.face ? r = Ie(a = Math.acos(-c), _, -d, h) : 4 === this.face ? r = Ie(a = Math.acos(-d), _, c, h) : (a = r = 0, h.value = 1);
              }
              return s = Math.atan(12 / f * (r + Math.acos(Math.sin(r) * Math.cos(u)) - o)), i = Math.sqrt((1 - Math.cos(a)) / (Math.cos(s) * Math.cos(s)) / (1 - Math.cos(Math.atan(1 / Math.cos(r))))), 2 === h.value ? s += o : 3 === h.value ? s += f : 4 === h.value && (s += 1.5 * f), l.x = i * Math.cos(s), l.y = i * Math.sin(s), l.x = l.x * this.a + this.x0, l.y = l.y * this.a + this.y0, t.x = l.x, t.y = l.y, t;
            },
            inverse: function inverse(t) {
              var e,
                n,
                r,
                a,
                i,
                s,
                l,
                h,
                u,
                c,
                d,
                _,
                p = {
                  lam: 0,
                  phi: 0
                },
                y = {
                  value: 0
                };
              if (t.x = (t.x - this.x0) / this.a, t.y = (t.y - this.y0) / this.a, n = Math.atan(Math.sqrt(t.x * t.x + t.y * t.y)), e = Math.atan2(t.y, t.x), t.x >= 0 && t.x >= Math.abs(t.y) ? y.value = 1 : t.y >= 0 && t.y >= Math.abs(t.x) ? (y.value = 2, e -= o) : t.x < 0 && -t.x >= Math.abs(t.y) ? (y.value = 3, e = e < 0 ? e + f : e - f) : (y.value = 4, e += o), u = f / 12 * Math.tan(e), i = Math.sin(u) / (Math.cos(u) - 1 / Math.sqrt(2)), s = Math.atan(i), (l = 1 - (r = Math.cos(e)) * r * (a = Math.tan(n)) * a * (1 - Math.cos(Math.atan(1 / Math.cos(s))))) < -1 ? l = -1 : l > 1 && (l = 1), 5 === this.face) h = Math.acos(l), p.phi = o - h, 1 === y.value ? p.lam = s + o : 2 === y.value ? p.lam = s < 0 ? s + f : s - f : 3 === y.value ? p.lam = s - o : p.lam = s;else if (6 === this.face) h = Math.acos(l), p.phi = h - o, 1 === y.value ? p.lam = -s + o : 2 === y.value ? p.lam = -s : 3 === y.value ? p.lam = -s - o : p.lam = s < 0 ? -s - f : -s + f;else {
                var g, m, v;
                u = (g = l) * g, m = (u += (v = u >= 1 ? 0 : Math.sqrt(1 - u) * Math.sin(s)) * v) >= 1 ? 0 : Math.sqrt(1 - u), 2 === y.value ? (u = m, m = -v, v = u) : 3 === y.value ? (m = -m, v = -v) : 4 === y.value && (u = m, m = v, v = -u), 2 === this.face ? (u = g, g = -m, m = u) : 3 === this.face ? (g = -g, m = -m) : 4 === this.face && (u = g, g = m, m = -u), p.phi = Math.acos(-v) - o, p.lam = Math.atan2(m, g), 2 === this.face ? p.lam = Oe(p.lam, -o) : 3 === this.face ? p.lam = Oe(p.lam, -f) : 4 === this.face && (p.lam = Oe(p.lam, +o));
              }
              return 0 !== this.es && (c = p.phi < 0 ? 1 : 0, d = Math.tan(p.phi), _ = this.b / Math.sqrt(d * d + this.one_minus_f_squared), p.phi = Math.atan(Math.sqrt(this.a * this.a - _ * _) / (this.one_minus_f * _)), c && (p.phi = -p.phi)), p.lam += this.long0, t.x = p.lam, t.y = p.phi, t;
            },
            names: ["Quadrilateralized Spherical Cube", "Quadrilateralized_Spherical_Cube", "qsc"]
          };
          var Ne = [[1, 22199e-21, -715515e-10, 31103e-10], [.9986, -482243e-9, -24897e-9, -13309e-10], [.9954, -83103e-8, -448605e-10, -9.86701e-7], [.99, -.00135364, -59661e-9, 36777e-10], [.9822, -.00167442, -449547e-11, -572411e-11], [.973, -.00214868, -903571e-10, 1.8736e-8], [.96, -.00305085, -900761e-10, 164917e-11], [.9427, -.00382792, -653386e-10, -26154e-10], [.9216, -.00467746, -10457e-8, 481243e-11], [.8962, -.00536223, -323831e-10, -543432e-11], [.8679, -.00609363, -113898e-9, 332484e-11], [.835, -.00698325, -640253e-10, 9.34959e-7], [.7986, -.00755338, -500009e-10, 9.35324e-7], [.7597, -.00798324, -35971e-9, -227626e-11], [.7186, -.00851367, -701149e-10, -86303e-10], [.6732, -.00986209, -199569e-9, 191974e-10], [.6213, -.010418, 883923e-10, 624051e-11], [.5722, -.00906601, 182e-6, 624051e-11], [.5322, -.00677797, 275608e-9, 624051e-11]],
            Ge = [[-520417e-23, .0124, 121431e-23, -845284e-16], [.062, .0124, -1.26793e-9, 4.22642e-10], [.124, .0124, 5.07171e-9, -1.60604e-9], [.186, .0123999, -1.90189e-8, 6.00152e-9], [.248, .0124002, 7.10039e-8, -2.24e-8], [.31, .0123992, -2.64997e-7, 8.35986e-8], [.372, .0124029, 9.88983e-7, -3.11994e-7], [.434, .0123893, -369093e-11, -4.35621e-7], [.4958, .0123198, -102252e-10, -3.45523e-7], [.5571, .0121916, -154081e-10, -5.82288e-7], [.6176, .0119938, -241424e-10, -5.25327e-7], [.6769, .011713, -320223e-10, -5.16405e-7], [.7346, .0113541, -397684e-10, -6.09052e-7], [.7903, .0109107, -489042e-10, -104739e-11], [.8435, .0103431, -64615e-9, -1.40374e-9], [.8936, .00969686, -64636e-9, -8547e-9], [.9394, .00840947, -192841e-9, -42106e-10], [.9761, .00616527, -256e-6, -42106e-10], [1, .00328947, -319159e-9, -42106e-10]],
            De = .8487,
            Re = 1.3523,
            Le = function Le(t, e) {
              return t[0] + e * (t[1] + e * (t[2] + e * t[3]));
            };
          var Pe = {
              init: function init() {
                this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.long0 = this.long0 || 0, this.es = 0, this.title = this.title || "Robinson";
              },
              forward: function forward(t) {
                var e = L(t.x - this.long0),
                  n = Math.abs(t.y),
                  r = Math.floor(11.459155902616464 * n);
                r < 0 ? r = 0 : r >= 18 && (r = 17);
                var a = {
                  x: Le(Ne[r], n = h * (n - .08726646259971647 * r)) * e,
                  y: Le(Ge[r], n)
                };
                return t.y < 0 && (a.y = -a.y), a.x = a.x * this.a * De + this.x0, a.y = a.y * this.a * Re + this.y0, a;
              },
              inverse: function inverse(t) {
                var e = {
                  x: (t.x - this.x0) / (this.a * De),
                  y: Math.abs(t.y - this.y0) / (this.a * Re)
                };
                if (e.y >= 1) e.x /= Ne[18][0], e.y = t.y < 0 ? -o : o;else {
                  var n = Math.floor(18 * e.y);
                  for (n < 0 ? n = 0 : n >= 18 && (n = 17);;) {
                    if (Ge[n][0] > e.y) --n;else {
                      if (!(Ge[n + 1][0] <= e.y)) break;
                      ++n;
                    }
                  }
                  var r = Ge[n],
                    a = 5 * (e.y - r[0]) / (Ge[n + 1][0] - r[0]);
                  a = function (t, e, n, r) {
                    for (var a = e; r; --r) {
                      var i = t(a);
                      if (a -= i, Math.abs(i) < 1e-10) break;
                    }
                    return a;
                  }(function (t) {
                    return (Le(r, t) - e.y) / function (t, e) {
                      return t[1] + e * (2 * t[2] + 3 * e * t[3]);
                    }(r, t);
                  }, a, 0, 100), e.x /= Le(Ne[n], a), e.y = (5 * n + a) * l, t.y < 0 && (e.y = -e.y);
                }
                return e.x = L(e.x + this.long0), e;
              },
              names: ["Robinson", "robin"]
            },
            Te = {
              init: function init() {
                this.name = "geocent";
              },
              forward: function forward(t) {
                return at(t, this.es, this.a);
              },
              inverse: function inverse(t) {
                return it(t, this.es, this.a, this.b);
              },
              names: ["Geocentric", "geocentric", "geocent", "Geocent"]
            };
          var Be = {
            h: {
              def: 1e5,
              num: !0
            },
            azi: {
              def: 0,
              num: !0,
              degrees: !0
            },
            tilt: {
              def: 0,
              num: !0,
              degrees: !0
            },
            long0: {
              def: 0,
              num: !0
            },
            lat0: {
              def: 0,
              num: !0
            }
          };
          var Qe = {
              init: function init() {
                if (Object.keys(Be).forEach(function (t) {
                  if (void 0 === this[t]) this[t] = Be[t].def;else {
                    if (Be[t].num && isNaN(this[t])) throw new Error("Invalid parameter value, must be numeric " + t + " = " + this[t]);
                    Be[t].num && (this[t] = parseFloat(this[t]));
                  }
                  Be[t].degrees && (this[t] = this[t] * l);
                }.bind(this)), Math.abs(Math.abs(this.lat0) - o) < s ? this.mode = this.lat0 < 0 ? 1 : 0 : Math.abs(this.lat0) < s ? this.mode = 2 : (this.mode = 3, this.sinph0 = Math.sin(this.lat0), this.cosph0 = Math.cos(this.lat0)), this.pn1 = this.h / this.a, this.pn1 <= 0 || this.pn1 > 1e10) throw new Error("Invalid height");
                this.p = 1 + this.pn1, this.rp = 1 / this.p, this.h1 = 1 / this.pn1, this.pfact = (this.p + 1) * this.h1, this.es = 0;
                var t = this.tilt,
                  e = this.azi;
                this.cg = Math.cos(e), this.sg = Math.sin(e), this.cw = Math.cos(t), this.sw = Math.sin(t);
              },
              forward: function forward(t) {
                t.x -= this.long0;
                var e,
                  n,
                  r,
                  a,
                  i = Math.sin(t.y),
                  o = Math.cos(t.y),
                  s = Math.cos(t.x);
                switch (this.mode) {
                  case 3:
                    n = this.sinph0 * i + this.cosph0 * o * s;
                    break;
                  case 2:
                    n = o * s;
                    break;
                  case 1:
                    n = -i;
                    break;
                  case 0:
                    n = i;
                }
                switch (e = (n = this.pn1 / (this.p - n)) * o * Math.sin(t.x), this.mode) {
                  case 3:
                    n *= this.cosph0 * i - this.sinph0 * o * s;
                    break;
                  case 2:
                    n *= i;
                    break;
                  case 0:
                    n *= -o * s;
                    break;
                  case 1:
                    n *= o * s;
                }
                return a = 1 / ((r = n * this.cg + e * this.sg) * this.sw * this.h1 + this.cw), e = (e * this.cg - n * this.sg) * this.cw * a, n = r * a, t.x = e * this.a, t.y = n * this.a, t;
              },
              inverse: function inverse(t) {
                t.x /= this.a, t.y /= this.a;
                var e,
                  n,
                  r,
                  a = {
                    x: t.x,
                    y: t.y
                  };
                r = 1 / (this.pn1 - t.y * this.sw), e = this.pn1 * t.x * r, n = this.pn1 * t.y * this.cw * r, t.x = e * this.cg + n * this.sg, t.y = n * this.cg - e * this.sg;
                var i = Ut(t.x, t.y);
                if (Math.abs(i) < s) a.x = 0, a.y = t.y;else {
                  var o, l;
                  switch (l = 1 - i * i * this.pfact, l = (this.p - Math.sqrt(l)) / (this.pn1 / i + i / this.pn1), o = Math.sqrt(1 - l * l), this.mode) {
                    case 3:
                      a.y = Math.asin(o * this.sinph0 + t.y * l * this.cosph0 / i), t.y = (o - this.sinph0 * Math.sin(a.y)) * i, t.x *= l * this.cosph0;
                      break;
                    case 2:
                      a.y = Math.asin(t.y * l / i), t.y = o * i, t.x *= l;
                      break;
                    case 0:
                      a.y = Math.asin(o), t.y = -t.y;
                      break;
                    case 1:
                      a.y = -Math.asin(o);
                  }
                  a.x = Math.atan2(t.x, t.y);
                }
                return t.x = a.x + this.long0, t.y = a.y, t;
              },
              names: ["Tilted_Perspective", "tpers"]
            },
            Fe = {
              init: function init() {
                if (this.flip_axis = "x" === this.sweep ? 1 : 0, this.h = Number(this.h), this.radius_g_1 = this.h / this.a, this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) throw new Error();
                if (this.radius_g = 1 + this.radius_g_1, this.C = this.radius_g * this.radius_g - 1, 0 !== this.es) {
                  var t = 1 - this.es,
                    e = 1 / t;
                  this.radius_p = Math.sqrt(t), this.radius_p2 = t, this.radius_p_inv2 = e, this.shape = "ellipse";
                } else this.radius_p = 1, this.radius_p2 = 1, this.radius_p_inv2 = 1, this.shape = "sphere";
                this.title || (this.title = "Geostationary Satellite View");
              },
              forward: function forward(t) {
                var e,
                  n,
                  r,
                  a,
                  i = t.x,
                  o = t.y;
                if (i -= this.long0, "ellipse" === this.shape) {
                  o = Math.atan(this.radius_p2 * Math.tan(o));
                  var s = this.radius_p / Ut(this.radius_p * Math.cos(o), Math.sin(o));
                  if (n = s * Math.cos(i) * Math.cos(o), r = s * Math.sin(i) * Math.cos(o), a = s * Math.sin(o), (this.radius_g - n) * n - r * r - a * a * this.radius_p_inv2 < 0) return t.x = Number.NaN, t.y = Number.NaN, t;
                  e = this.radius_g - n, this.flip_axis ? (t.x = this.radius_g_1 * Math.atan(r / Ut(a, e)), t.y = this.radius_g_1 * Math.atan(a / e)) : (t.x = this.radius_g_1 * Math.atan(r / e), t.y = this.radius_g_1 * Math.atan(a / Ut(r, e)));
                } else "sphere" === this.shape && (e = Math.cos(o), n = Math.cos(i) * e, r = Math.sin(i) * e, a = Math.sin(o), e = this.radius_g - n, this.flip_axis ? (t.x = this.radius_g_1 * Math.atan(r / Ut(a, e)), t.y = this.radius_g_1 * Math.atan(a / e)) : (t.x = this.radius_g_1 * Math.atan(r / e), t.y = this.radius_g_1 * Math.atan(a / Ut(r, e))));
                return t.x = t.x * this.a, t.y = t.y * this.a, t;
              },
              inverse: function inverse(t) {
                var e,
                  n,
                  r,
                  a,
                  i = -1,
                  o = 0,
                  s = 0;
                if (t.x = t.x / this.a, t.y = t.y / this.a, "ellipse" === this.shape) {
                  this.flip_axis ? (s = Math.tan(t.y / this.radius_g_1), o = Math.tan(t.x / this.radius_g_1) * Ut(1, s)) : (o = Math.tan(t.x / this.radius_g_1), s = Math.tan(t.y / this.radius_g_1) * Ut(1, o));
                  var l = s / this.radius_p;
                  if (e = o * o + l * l + i * i, (r = (n = 2 * this.radius_g * i) * n - 4 * e * this.C) < 0) return t.x = Number.NaN, t.y = Number.NaN, t;
                  a = (-n - Math.sqrt(r)) / (2 * e), i = this.radius_g + a * i, o *= a, s *= a, t.x = Math.atan2(o, i), t.y = Math.atan(s * Math.cos(t.x) / i), t.y = Math.atan(this.radius_p_inv2 * Math.tan(t.y));
                } else if ("sphere" === this.shape) {
                  if (this.flip_axis ? (s = Math.tan(t.y / this.radius_g_1), o = Math.tan(t.x / this.radius_g_1) * Math.sqrt(1 + s * s)) : (o = Math.tan(t.x / this.radius_g_1), s = Math.tan(t.y / this.radius_g_1) * Math.sqrt(1 + o * o)), e = o * o + s * s + i * i, (r = (n = 2 * this.radius_g * i) * n - 4 * e * this.C) < 0) return t.x = Number.NaN, t.y = Number.NaN, t;
                  a = (-n - Math.sqrt(r)) / (2 * e), i = this.radius_g + a * i, o *= a, s *= a, t.x = Math.atan2(o, i), t.y = Math.atan(s * Math.cos(t.x) / i);
                }
                return t.x = t.x + this.long0, t;
              },
              names: ["Geostationary Satellite View", "Geostationary_Satellite", "geos"]
            };
          gt.defaultDatum = "WGS84", gt.Proj = rt, gt.WGS84 = new gt.Proj("WGS84"), gt.Point = Dt, gt.toPoint = ct, gt.defs = O, gt.nadgrid = function (t, e) {
            var n = new DataView(e),
              r = function (t) {
                var e = t.getInt32(8, !1);
                return 11 !== e && (11 !== (e = t.getInt32(8, !0)) && console.warn("Failed to detect nadgrid endian-ness, defaulting to little-endian"), !0);
              }(n),
              a = function (t, e) {
                return {
                  nFields: t.getInt32(8, e),
                  nSubgridFields: t.getInt32(24, e),
                  nSubgrids: t.getInt32(40, e),
                  shiftType: Y(t, 56, 64).trim(),
                  fromSemiMajorAxis: t.getFloat64(120, e),
                  fromSemiMinorAxis: t.getFloat64(136, e),
                  toSemiMajorAxis: t.getFloat64(152, e),
                  toSemiMinorAxis: t.getFloat64(168, e)
                };
              }(n, r);
            a.nSubgrids > 1 && console.log("Only single NTv2 subgrids are currently supported, subsequent sub grids are ignored");
            var i = function (t, e, n) {
                for (var r = [], a = 0; a < e.nSubgrids; a++) {
                  var i = $(t, 176, n),
                    o = tt(t, 176, i, n),
                    s = Math.round(1 + (i.upperLongitude - i.lowerLongitude) / i.longitudeInterval),
                    l = Math.round(1 + (i.upperLatitude - i.lowerLatitude) / i.latitudeInterval);
                  r.push({
                    ll: [V(i.lowerLongitude), V(i.lowerLatitude)],
                    del: [V(i.longitudeInterval), V(i.latitudeInterval)],
                    lim: [s, l],
                    count: i.gridNodeCount,
                    cvs: K(o)
                  });
                }
                return r;
              }(n, a, r),
              o = {
                header: a,
                subgrids: i
              };
            return J[t] = o, o;
          }, gt.transform = dt, gt.mgrs = Mt, gt.version = "__VERSION__", function (t) {
            t.Proj.projections.add(Ft), t.Proj.projections.add(Zt), t.Proj.projections.add(Xt), t.Proj.projections.add(Vt), t.Proj.projections.add(Yt), t.Proj.projections.add(Kt), t.Proj.projections.add(ee), t.Proj.projections.add(ne), t.Proj.projections.add(re), t.Proj.projections.add(fe), t.Proj.projections.add(_e), t.Proj.projections.add(ye), t.Proj.projections.add(ge), t.Proj.projections.add(me), t.Proj.projections.add(ve), t.Proj.projections.add(xe), t.Proj.projections.add(be), t.Proj.projections.add(ke), t.Proj.projections.add(Me), t.Proj.projections.add(we), t.Proj.projections.add(Ce), t.Proj.projections.add(Ee), t.Proj.projections.add(Se), t.Proj.projections.add(Ae), t.Proj.projections.add(je), t.Proj.projections.add(Pe), t.Proj.projections.add(Te), t.Proj.projections.add(Qe), t.Proj.projections.add(Fe);
          }(gt);
          var qe = gt;
        },
        9613: function _(t) {
          var e = " +no_defs",
            n = " +towgs84=0,0,0,0,0,0,0",
            r = " +ellps=GRS80",
            a = "+proj=tmerc",
            i = " +units=m",
            o = " +towgs84=23.92,-141.27,-80.9,-0,0.35,0.82,-0.12",
            s = " +towgs84=24.47,-130.89,-81.56,-0,-0,0.13,-0.22",
            l = "+proj=lcc",
            h = "+proj=utm",
            u = " +units=us-ft",
            c = "+proj=longlat",
            f = " +lat_0=0",
            d = " +ellps=krass",
            _ = " +y_0=0",
            p = " +x_0=500000",
            y = " +towgs84=0,0,4.5,0,0,0.554,0.2263",
            g = " +towgs84=0,0,1.9,0,0,0.814,-0.38",
            m = " +ellps=intl",
            v = " +datum=WGS84",
            x = " +ellps=WGS72",
            b = " +towgs84=15.8,-154.4,-82.3,0,0,0,0",
            k = " +k=0.9999",
            M = " +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
            w = " +datum=NAD27",
            C = " +ellps=bessel",
            E = " +x_0=609601.2192024384",
            S = " +x_0=600000",
            A = " +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84",
            I = " +ellps=clrk80",
            O = " +b=6356755.288157528",
            j = " +x_0=152400.3048006096",
            N = " +lat_0=36.66666666666666",
            G = " +towgs84=-146.414,507.337,680.507,0,0,0,0",
            D = " +x_0=200000",
            R = " +ellps=clrk66",
            L = " +ellps=WGS84",
            P = " +x_0=500000.001016002",
            T = " +x_0=240000",
            B = " +lat_0=-90",
            Q = " +towgs84=-87,-98,-121,0,0,0,0",
            F = " +south",
            q = " +lat_0=41.66666666666666",
            U = " +y_0=36000",
            z = " +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29",
            H = " +x_0=0",
            Z = " +units=ft",
            X = " +x_0=400000",
            J = " +towgs84=-115.854,-99.0583,-152.462,0,0,0,0",
            W = " +towgs84=-208.406,-109.878,-2.5764,0,0,0,0",
            V = " +ellps=aust_SA",
            Y = " +lat_0=39.33333333333334",
            K = " +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
            $ = " +lat_0=37.66666666666666",
            tt = " +lat_0=36.33333333333334",
            et = " +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
            nt = " +y_0=500000.0001016001",
            rt = " +x_0=200000.0001016002",
            at = " +x_0=500000.0001016001",
            it = " +x_0=500000.00001016",
            ot = " +y_0=1000000",
            st = " +x_0=300000",
            lt = " +lon_0=-120.5",
            ht = " +lat_0=43.66666666666666",
            ut = " +lat_0=43.83333333333334",
            ct = " +lat_1=-68.66666666666667",
            ft = " +lat_2=-71.33333333333333",
            dt = " +k=0.999966667",
            _t = " +k=0.9996",
            pt = " +lat_0=38.33333333333334",
            yt = " +lat_1=73.66666666666667",
            gt = " +lat_2=70.33333333333333",
            mt = " +lat_0=72.02500919444445",
            vt = " +a=6378249.2",
            xt = " +x_0=1500000",
            bt = " +lat_ts=-80.23861111111111",
            kt = " +towgs84=-288,175,-376,0,0,0,0",
            Mt = " +lat_1=41.78333333333333",
            wt = " +lat_2=-75.33333333333333",
            Ct = " +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21",
            Et = " +x_0=304800",
            St = " +x_0=2000000.0001016",
            At = " +k=0.9999375",
            It = " +y_0=500000",
            Ot = " +towgs84=-209.362,-87.8162,404.62,0.0046,3.4784,0.5805,-1.4547",
            jt = " +lon_0=-100.3333333333333",
            Nt = " +lat_1=-72.66666666666667",
            Gt = " +lat_1=-76.66666666666667",
            Dt = " +lat_2=-79.33333333333333",
            Rt = " +y_0=10000000",
            Lt = " +towgs84=-57,1,-41,0,0,0,0",
            Pt = " +k=0.999941177",
            Tt = " +x_0=800000.0000101599",
            Bt = " +y_0=99999.99998983997",
            Qt = " +lat_1=38.43333333333333",
            Ft = " +lat_0=24.33333333333333",
            qt = " +towgs84=26,-121,-78,0,0,0,0",
            Ut = " +a=6378140",
            zt = " +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496",
            Ht = " +x_0=399999.99998984",
            Zt = " +towgs84=-24,-15,5,0,0,0,0",
            Xt = " +towgs84=682,-203,480,0,0,0,0",
            Jt = " +towgs84=-136,-108,-292,0,0,0,0",
            Wt = " +b=6356075.41314024",
            Vt = " +lat_1=37.96666666666667",
            Yt = " +lat_0=38.83333333333334",
            Kt = " +lat_0=40.16666666666666",
            $t = " +lat_0=34.33333333333334",
            te = " +lat_0=42.83333333333334",
            ee = " +lon_0=-84.36666666666666",
            ne = " +x_0=300000.0000000001",
            re = " +k=0.999933333",
            ae = " +lat_1=48.73333333333333",
            ie = " +lon_0=-111.5",
            oe = " +k=0.9999473679999999",
            se = " +towgs84=-67.35,3.88,-38.22,0,0,0,0",
            le = " +lat_2=73.66666666666667",
            he = " +lat_0=75.36440330555556",
            ue = " +b=6356515",
            ce = " +towgs84=25,-141,-78.5,-0,0.35,0.736,0",
            fe = "+proj=stere",
            de = " +lat_1=-64.66666666666667",
            _e = " +lat_2=-67.33333333333333",
            pe = " +b=6356514.966398753",
            ye = " +towgs84=295,736,257,0,0,0,0",
            ge = " +x_0=100000",
            me = " +towgs84=-11,851,5,0,0,0,0",
            ve = " +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0",
            xe = " +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06",
            be = " +lat_0=39.66666666666666",
            ke = " +x_0=1000000",
            Me = " +lon_0=-105.5",
            we = " +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15",
            Ce = " +a=6378249.145",
            Ee = " +x_0=2000000",
            Se = " +lat_0=45.66666666666666",
            Ae = " +lat_1=80.33333333333333",
            Ie = " +lat_0=78.70733752777778",
            Oe = " +b=6356774.50408554",
            je = " +lon_0=-91.33333333333333",
            Ne = " +lon_0=-123.3333333333333",
            Ge = " +towgs84=-168,-60,320,0,0,0,0",
            De = " +lat_0=31",
            Re = " +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093",
            Le = " +x_0=150000",
            Pe = " +x_0=3500000",
            Te = " +towgs84=213.11,9.37,-74.95,0,0,0,0",
            Be = " +lat_1=43.66666666666666",
            Qe = " +lat_0=40.33333333333334",
            Fe = " +towgs84=-148,136,90,0,0,0,0",
            qe = " +towgs84=616,97,-251,0,0,0,0",
            Ue = " +lon_0=-90",
            ze = " +x_0=250000",
            He = " +x_0=914401.8288036576",
            Ze = " +lon_0=-90.33333333333333",
            Xe = " +a=6377276.345",
            Je = " +b=6356103.038993155",
            We = " +lat_0=40.5",
            Ve = " +towgs84=-134,-48,149,0,0,0,0",
            Ye = " +towgs84=25,-141,-78.5,0,0.35,0.736,0",
            Ke = " +lat_1=27.83333333333333",
            $e = " +lat_2=26.16666666666667",
            tn = " +lat_2=40.71666666666667",
            en = " +lat_2=39.01666666666667",
            nn = " +lat_2=37.21666666666667",
            rn = " +lat_1=70.33333333333333",
            an = " +lat_0=68.68747555555557",
            on = " +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68",
            sn = " +y_0=304800.6096012192",
            ln = " +x_0=699999.9998983998",
            hn = " +y_0=999999.9998983998",
            un = " +y_0=800000",
            cn = " +k=0.99995",
            fn = " +lat_0=34.75",
            dn = " +lon_0=-81",
            _n = " +lon_0=-100",
            pn = " +b=6356098.145120132",
            yn = "+proj=omerc",
            gn = " +lon_0=-98.5",
            mn = " +towgs84=-103.746,-9.614,-255.95,0,0,0,0",
            vn = " +x_0=800000",
            xn = " +lat_0=37.83333333333334",
            bn = " +lat_2=44.33333333333334",
            kn = " +lat_2=42.33333333333334",
            Mn = " +lat_0=29.66666666666667",
            wn = " +lat_0=25.66666666666667",
            Cn = " +lat_0=35.83333333333334",
            En = " +lat_1=83.66666666666667",
            Sn = " +lat_2=80.33333333333333",
            An = " +lat_0=82.05842488888888",
            In = " +lat_0=38",
            On = " +x_0=2500000",
            jn = " +towgs84=-377,681,-50,0,0,0,0",
            Nn = "+proj=cass",
            Gn = " +y_0=2000000",
            Dn = " +towgs84=-143,-236,7,0,0,0,0",
            Rn = " +lon_0=-110.1666666666667",
            Ln = " +lon_0=-111.9166666666667",
            Pn = " +lon_0=-75.41666666666667",
            Tn = " +lon_0=-82.16666666666667",
            Bn = " +lon_0=-84.16666666666667",
            Qn = " +lon_0=-112.1666666666667",
            Fn = " +lon_0=-88.83333333333333",
            qn = " +lon_0=-104.3333333333333",
            Un = " +lon_0=-107.8333333333333",
            zn = " +lon_0=-76.58333333333333",
            Hn = " +lon_0=-78.58333333333333",
            Zn = " +lon_0=-120.8333333333333",
            Xn = " +lon_0=-88.33333333333333",
            Jn = " +lon_0=-90.16666666666667",
            Wn = " +lon_0=-85.66666666666667",
            Vn = " +lon_0=-87.08333333333333",
            Yn = " +lon_0=-70.16666666666667",
            Kn = " +lon_0=-93.09999999999999",
            $n = " +lon_0=-115.5833333333333",
            tr = " +lon_0=-116.6666666666667",
            er = " +lon_0=-118.5833333333333",
            nr = " +lon_0=-71.66666666666667",
            rr = " +lon_0=-105.1666666666667",
            ar = " +lon_0=-107.3333333333333",
            ir = " +lon_0=-110.0833333333333",
            or = " +lat_0=37.5",
            sr = " +y_0=700000",
            lr = " +towgs84=-242.2,-144.9,370.3,0,0,0,0",
            hr = " +x_0=4500000",
            ur = " +y_0=1500000",
            cr = " +x_0=599999.9999976",
            fr = " +towgs84=-275.722,94.7824,340.894,-8.001,-4.42,-11.821,1",
            dr = "+proj=aea",
            _r = " +y_0=-2500000",
            pr = " +lat_2=38.96666666666667",
            yr = " +lat_1=41.66666666666666",
            gr = " +lat_1=39.83333333333334",
            mr = " +lat_2=38.33333333333334",
            vr = " +lat_2=37.06666666666667",
            xr = " +lat_0=35.33333333333334",
            br = " +lat_1=35.46666666666667",
            kr = " +lat_2=34.03333333333333",
            Mr = " +lat_1=33.88333333333333",
            wr = " +lat_2=32.78333333333333",
            Cr = " +lat_0=32.16666666666666",
            Er = " +lat_2=37.23333333333333",
            Sr = " +lat_1=41.86666666666667",
            Ar = " +lat_0=40.83333333333334",
            Ir = " +lat_2=29.58333333333333",
            Or = " +lat_2=41.71666666666667",
            jr = " +lat_1=41.03333333333333",
            Nr = " +lat_2=40.66666666666666",
            Gr = " +lat_1=36.76666666666667",
            Dr = " +lat_0=33.33333333333334",
            Rr = " +lat_1=40.96666666666667",
            Lr = " +lat_2=39.93333333333333",
            Pr = " +lat_0=31.83333333333333",
            Tr = " +lat_0=31.66666666666667",
            Br = " +lat_0=27.83333333333333",
            Qr = " +lat_2=36.76666666666667",
            Fr = " +lat_0=45.33333333333334",
            qr = " +lat_0=45.16666666666666",
            Ur = " +lat_1=36.23333333333333",
            zr = " +lat_2=34.93333333333333",
            Hr = " +lat_1=34.76666666666667",
            Zr = " +lat_0=32.66666666666666",
            Xr = " +lat_1=43.26666666666667",
            Jr = " +lat_2=42.06666666666667",
            Wr = " +lat_2=40.61666666666667",
            Vr = " +lat_1=39.78333333333333",
            Yr = " +lat_2=38.71666666666667",
            Kr = " +lat_1=38.56666666666667",
            $r = " +lat_2=37.26666666666667",
            ta = " +lat_0=41.08333333333334",
            ea = " +lat_0=42.33333333333334",
            na = " +y_0=100000",
            ra = " +b=6356173.508712696",
            aa = " +y_0=5500000",
            ia = " +lon_0=105",
            oa = " +y_0=-5000000",
            sa = " +k=0.9995000000000001",
            la = " +k=0.9999749999999999",
            ha = " +towgs84=-160,-6,-302,0,0,0,0",
            ua = " +towgs84=307,304,-318,0,0,0,0",
            ca = " +lon_0=-82.5",
            fa = " +towgs84=70.995,-335.916,262.898,0,0,0,0",
            da = " +towgs84=-304.046,-60.576,103.64,0,0,0,0",
            _a = " +x_0=700000",
            pa = " +x_0=213360",
            ya = " +lon_0=-85.75",
            ga = " +lon_0=-100.5",
            ma = " +lon_0=-77.75",
            va = " +x_0=999999.9999898402",
            xa = " +towgs84=-151.99,287.04,-147.45,0,0,0,0",
            ba = " +lon_0=129",
            ka = " +a=6378293.645208759",
            Ma = " +b=6356617.987679838",
            wa = " +x_0=5500000",
            Ca = " +lat_1=40.78333333333333",
            Ea = " +lat_2=39.71666666666667",
            Sa = " +lat_1=37.93333333333333",
            Aa = " +lat_2=36.73333333333333",
            Ia = " +lat_1=42.68333333333333",
            Oa = " +lat_1=41.48333333333333",
            ja = " +lat_2=41.28333333333333",
            Na = " +lat_1=47.08333333333334",
            Ga = " +lat_2=45.48333333333333",
            Da = " +lat_0=44.78333333333333",
            Ra = " +lat_2=44.18333333333333",
            La = " +lat_0=43.31666666666667",
            Pa = " +lat_1=36.16666666666666",
            Ta = " +lat_2=34.33333333333334",
            Ba = " +lat_2=47.43333333333333",
            Qa = " +lat_1=47.48333333333333",
            Fa = " +lat_2=46.18333333333333",
            qa = " +lat_2=35.56666666666667",
            Ua = " +lat_1=35.23333333333333",
            za = " +lat_2=33.93333333333333",
            Ha = " +lat_2=40.88333333333333",
            Za = " +lat_1=34.83333333333334",
            Xa = " +lat_1=36.41666666666666",
            Ja = " +lat_1=36.18333333333333",
            Wa = " +lat_1=33.96666666666667",
            Va = " +lat_2=32.13333333333333",
            Ya = " +lat_1=31.88333333333333",
            Ka = " +lat_2=30.11666666666667",
            $a = " +lat_1=30.28333333333333",
            ti = " +lat_2=28.38333333333333",
            ei = " +lat_2=38.03333333333333",
            ni = " +lat_1=47.33333333333334",
            ri = " +lat_2=45.83333333333334",
            ai = " +lat_1=46.76666666666667",
            ii = " +lat_2=45.56666666666667",
            oi = " +lat_1=44.06666666666667",
            si = " +lat_2=42.73333333333333",
            li = " +lat_1=32.66666666666666",
            hi = " +lat_2=31.16666666666667",
            ui = " +lat_1=48.63333333333333",
            ci = " +lat_2=47.03333333333333",
            fi = " +lat_2=45.61666666666667",
            di = " +lat_1=45.21666666666667",
            _i = " +lat_2=43.78333333333333",
            pi = " +lat_0=39.83333333333334",
            yi = " +lat_2=40.43333333333333",
            gi = " +lat_1=40.03333333333333",
            mi = " +lat_2=38.73333333333333",
            vi = " +lat_1=45.68333333333333",
            xi = " +lat_2=44.41666666666666",
            bi = " +lat_2=42.83333333333334",
            ki = " +lat_1=38.88333333333333",
            Mi = " +lat_2=37.48333333333333",
            wi = " +lat_1=37.08333333333334",
            Ci = " +lat_2=38.66666666666666",
            Ei = " +lat_0=58",
            Si = " +lon_0=-98",
            Ai = " +lon_0=117",
            Ii = " +lon_0=135",
            Oi = " +lat_0=41.5",
            ji = " +lat_0=42.5",
            Ni = " +y_0=3000000",
            Gi = " +lon_0=123",
            Di = " +lat_0=40",
            Ri = " +lat_0=54",
            Li = " +towgs84=-192.873,-39.382,-111.202,-0.00205,-0.0005,0.00335,0.0188",
            Pi = " +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725",
            Ti = " +x_0=914401.8289",
            Bi = " +y_0=304800.6096",
            Qi = " +lon_0=111",
            Fi = " +k_0=0.99878641",
            qi = " +lon_0=-66.43333333333334",
            Ui = " +towgs84=61,-285,-181,0,0,0,0",
            zi = " +towgs84=-133,-77,-51,0,0,0,0",
            Hi = " +towgs84=-679,669,-48,0,0,0,0",
            Zi = " +lon_0=-71.5",
            Xi = " +lon_0=-78.5",
            Ji = " +lon_0=-93.5",
            Wi = " +lat_0=41.75",
            Vi = " +y_0=249999.9998983998",
            Yi = " +y_0=999999.9999898402",
            Ki = " +to_meter=1.0000135965",
            $i = " +a=6377304.063",
            to = " +lat_0=36",
            eo = " +towgs84=-79.9,-158,-168.9,0,0,0,0",
            no = " +towgs84=-50.9,-347.6,-231,0,0,0,0",
            ro = " +towgs84=-106.869,52.2978,-103.724,0.3366,-0.457,1.8422,-1.2747",
            ao = " +towgs84=283,682,231,0,0,0,0",
            io = " +towgs84=-206,172,-6,0,0,0,0",
            oo = " +towgs84=-92,-93,122,0,0,0,0",
            so = " +to_meter=0.9143985307444408",
            lo = "+proj=sterea",
            ho = " +lat_0=21.16666666666667",
            uo = " +lat_1=18.43333333333333",
            co = " +lat_2=18.03333333333333",
            fo = " +lat_0=17.83333333333333",
            _o = " +gamma=323.1301023611111",
            po = " +lon_0=-79.5",
            yo = " +y_0=4500000",
            go = " +x_0=31500000",
            mo = " +x_0=500000.0001504",
            vo = " +b=6356514.96582849",
            xo = " +towgs84=674.4,15.1,405.3,0,0,0,0",
            bo = " +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.7101",
            ko = " +towgs84=589,76,480,0,0,0,0",
            Mo = " +towgs84=-263,6,431,0,0,0,0",
            wo = " +lon_0=15",
            Co = " +axis=wsu",
            Eo = " +lon_0=21",
            So = " +lat_0=30",
            Ao = " +ellps=helmert",
            Io = " +a=6377299.151",
            Oo = " +lon_0=-74.5",
            jo = " +b=6356750.304921594",
            No = " +y_0=2000000.0001016",
            Go = " +x_0=3500000.0001016",
            Do = " +y_0=399999.99998984",
            Ro = " +x_0=200000.00001016",
            Lo = " +b=6356098.359005156",
            Po = " +x_0=14500000",
            To = " +x_0=29500000",
            Bo = " +towgs84=-117,-132,-164,0,0,0,0",
            Qo = " +zone=20",
            Fo = " +lon_0=-122",
            qo = " +ellps=bess_nam",
            Uo = " +lon_0=-86.15000000000001",
            zo = " +towgs84=-189,-242,-91,0,0,0,0",
            Ho = " +towgs84=-265,120,-358,0,0,0,0",
            Zo = " +towgs84=-73.472,-51.66,-112.482,0.953,4.6,-2.368,0.586",
            Xo = " +towgs84=-17.51,-108.32,-62.39,0,0,0,0",
            Jo = " +towgs84=-10.18,-350.43,291.37,0,0,0,0",
            Wo = " +towgs84=-190.421,8.532,238.69,0,0,0,0",
            Vo = " +lon_0=-68.5",
            Yo = " +a=6377299.36559538",
            Ko = " +x_0=79999.99999968",
            $o = " +x_0=50000.00001504",
            ts = " +lon_0=0",
            es = " +lon_0=27",
            ns = " +lon_0=75",
            rs = " +lon_0=81",
            as = " +lon_0=93",
            is = " +lon_0=99",
            os = " +x_0=900000",
            ss = " +x_0=13500000",
            ls = " +x_0=20500000",
            hs = " +x_0=22500000",
            us = " +towgs84=-166,-15,204,0,0,0,0",
            cs = " +towgs84=-130,110,-13,0,0,0,0",
            fs = " +towgs84=-587.8,519.75,145.76,0,0,0,0",
            ds = " +lat_2=83.66666666666667",
            _s = " +lat_0=85.43711833333333",
            ps = " +towgs84=-273.5,110.6,-357.9,0,0,0,0",
            ys = " +lon_0=87",
            gs = "+proj=laea",
            ms = " +towgs84=-403,684,41,0,0,0,0",
            vs = " +lon_0=-92.5",
            xs = " +y_0=6000000",
            bs = " +zone=19",
            ks = " +lat_0=29.5",
            Ms = " +y_0=300000",
            ws = " +lat_2=45.5",
            Cs = " +k=0.999909091",
            Es = " +a=6377492.018",
            Ss = " +b=6356751.689189189",
            As = " +b=6356100.230165384",
            Is = " +lon_0=90",
            Os = " +lat_0=90",
            js = " +x_0=18500000",
            Ns = " +x_0=19500000",
            Gs = " +x_0=15500000",
            Ds = " +x_0=16500000",
            Rs = " +x_0=21500000",
            Ls = " +x_0=23500000",
            Ps = " +x_0=25500000",
            Ts = " +x_0=26500000",
            Bs = " +x_0=27500000",
            Qs = " +x_0=28500000",
            Fs = " +zone=18",
            qs = " +zone=21",
            Us = " +towgs84=-124.76,53,466.79,0,0,0,0",
            zs = " +lon_0=-92",
            Hs = " +lon_0=33",
            Zs = " +lon_0=12",
            Xs = " +lon_0=24",
            Js = " +lat_2=77",
            Ws = " +y_0=200000",
            Vs = " +lon_0=-70.5",
            Ys = " +x_0=7500000",
            Ks = " +y_0=3500000",
            $s = " +towgs84=31,146,47,0,0,0,0",
            tl = " +lat_0=45",
            el = " +lat_0=26",
            nl = " +a=6378160",
            rl = " +lon_0=-109.5",
            al = " +x_0=30500000",
            il = " +x_0=32500000",
            ol = " +lon_0=-85.83333333333333",
            sl = " +lon_0=-118.3333333333333",
            ll = " +y_0=0.003048006096012192",
            hl = " +lat_0=30.5",
            ul = " +lat_0=44",
            cl = " +lon_0=30",
            fl = " +lat_0=47",
            dl = " +lat_1=77",
            _l = " +lat_0=36.16666666666666",
            pl = " +lat_0=4.596200416666666",
            yl = " +gamma=53.13010236111111",
            gl = " +lon_0=13.33333333333333",
            ml = " +lat_0=81.31722600000001",
            vl = " +lat_0=73.15574086111111",
            xl = " +lat_0=65.10127088888888",
            bl = " +zone=17",
            kl = " +lon_0=132",
            Ml = " +lon_0=114",
            wl = " +towgs84=-143,-90,-294,0,0,0,0",
            Cl = " +zone=22",
            El = " +lat_0=41",
            Sl = " +lat_0=46.5",
            Al = " +lon_0=-118",
            Il = " +y_0=400000",
            Ol = " +x_0=17500000",
            jl = " +x_0=33500000",
            Nl = " +lon_0=-113.75",
            Gl = " +lon_0=-116.25",
            Dl = " +lon_0=-115.75",
            Rl = " +lon_0=-106.25",
            Ll = " +k=0.999916667",
            Pl = " +k=0.999964286",
            Tl = " +lon_0=-108.75",
            Bl = " +towgs84=-73,-247,227,0,0,0,0",
            Ql = " +towgs84=265.025,384.929,-194.046,0,0,0,0",
            Fl = " +k=0.99998",
            ql = " +lat_1=40.65",
            Ul = " +lat_1=38.35",
            zl = " +y_0=2500000",
            Hl = " +y_0=6500000",
            Zl = " +x_0=39999.99999984",
            Xl = " +towgs84=-61.702,284.488,472.052,0,0,0,0",
            Jl = " +towgs84=-223.237,110.193,36.649,0,0,0,0",
            Wl = " +zone=39",
            Vl = " +zone=32",
            Yl = " +towgs84=-125,53,467,0,0,0,0",
            Kl = " +towgs84=198,881,317,0,0,0,0",
            $l = " +towgs84=214,804,268,0,0,0,0",
            th = " +towgs84=217,823,299,0,0,0,0",
            eh = " +lon_0=45",
            nh = " +lat_1=43",
            rh = "+proj=merc",
            ah = " +x_0=99999.99998983997",
            ih = " +x_0=99999.99999960001",
            oh = " +x_0=2743195.592233322",
            sh = " +y_0=914398.5307444407",
            lh = " +zone=38",
            hh = " +zone=28",
            uh = " +lon_0=-114",
            ch = " +lat_1=45.5",
            fh = " +towgs84=-73,46,-86,0,0,0,0",
            dh = " +towgs84=11,72,-101,0,0,0,0",
            _h = " +towgs84=287.58,177.78,-135.41,0,0,0,0",
            ph = " +towgs84=-162.619,-276.959,-161.764,0.067753,-2.24365,-1.15883,-1.09425",
            yh = " +lon_0=-87",
            gh = " +lon_0=-99",
            mh = " +lon_0=102",
            vh = " +lon_0=126",
            xh = " +k=0.99999",
            bh = " +x_0=50000",
            kh = " +lat_2=40",
            Mh = " +lon_0=-84.25",
            wh = " +x_0=11500000",
            Ch = " +lon_0=-72.75",
            Eh = " +lon_0=-101.5",
            Sh = " +lon_0=-94.25",
            Ah = " +x_0=6500000",
            Ih = " +y_0=5000000",
            Oh = " +x_0=1700000",
            jh = " +towgs84=31.95,300.99,419.19,0,0,0,0",
            Nh = " +towgs84=-189.681,18.3463,-42.7695,-0.33746,-3.09264,2.53861,0.4598",
            Gh = " +towgs84=-119.425,-303.659,-11.0006,1.1643,0.174458,1.09626,3.65706",
            Dh = " +towgs84=982.609,552.753,-540.873,6.68163,-31.6115,-19.8482,16.805",
            Rh = " +zone=29",
            Lh = " +lon_0=9",
            Ph = " +zone=33",
            Th = " +zone=37",
            Bh = " +no_uoff",
            Qh = " +lon_0=120",
            Fh = " +lon_0=177",
            qh = " +lon_0=-177",
            Uh = " +lon_0=-158",
            zh = " +y_0=250000",
            Hh = " +lon_0=-111",
            Zh = " +x_0=2500000.0001424",
            Xh = " +x_0=1500000.0001464",
            Jh = " +lon_0=-71.60561777777777",
            Wh = " +lon_0=-156.6666666666667",
            Vh = " +lon_0=-160.1666666666667",
            Yh = " +lat_0=0.1166666666666667",
            Kh = " +towgs84=0,0,0,-0,-0,-0,0",
            $h = " +lon_0=-117.8333333333333",
            tu = " +lon_0=-123.1666666666667",
            eu = " +lon_0=-122.3333333333333",
            nu = " +lon_0=-119.1666666666667",
            ru = " +lon_0=-123.0833333333333",
            au = " +lon_0=-85.84999999999999",
            iu = " +lon_0=-87.09999999999999",
            ou = " +lon_0=-86.90000000000001",
            su = " +lon_0=-89.24166666666667",
            lu = " +lon_0=-92.63333333333334",
            hu = " +towgs84=347.103,1078.12,2623.92,-33.8875,70.6773,-9.3943,186.074",
            uu = " +towgs84=8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926",
            cu = " +towgs84=-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7",
            fu = " +towgs84=-0.293,766.95,87.713,0.195704,1.69507,3.47302,-0.039338",
            du = " +towgs84=221.525,152.948,176.768,-2.3847,-1.3896,-0.877,11.4741",
            _u = " +towgs84=215.525,149.593,176.229,-3.2624,-1.692,-1.1571,10.4773",
            pu = " +zone=35",
            yu = " +lat_0=46.95240555555556",
            gu = " +alpha=30.28813972222222",
            mu = " +lat_1=10.16666666666667",
            vu = " +lat_0=10.16666666666667",
            xu = " +lat_0=18.83333333333333",
            bu = " +lat_0=20.33333333333333",
            ku = " +lat_0=21.83333333333333",
            Mu = " +lat_0=21.66666666666667",
            wu = " +lat_0=45.30916666666666",
            Cu = " +lat_1=49.83333333333334",
            Eu = " +lat_2=51.16666666666666",
            Su = " +lonc=-133.6666666666667",
            Au = " +alpha=323.1301023611111",
            Iu = " +lat_1=53.83333333333334",
            Ou = " +lat_2=51.83333333333334",
            ju = " +lat_1=44.66666666666666",
            Nu = " +lat_0=44.66666666666666",
            Gu = " +lat_1=45.66666666666666",
            Du = " +lat_0=45.91666666666666",
            Ru = " +lat_0=45.08333333333334",
            Lu = " +lat_0=44.33333333333334",
            Pu = " +lat_0=44.08333333333334",
            Tu = " +lat_1=48.33333333333334",
            Bu = " +lat_0=48.33333333333334",
            Qu = " +lat_0=31.73409694444445",
            Fu = " +lon_0=35.21208055555556",
            qu = " +lat_0=44.03611111111111",
            Uu = " +lat_0=4.599047222222222",
            zu = " +lat_0=40.66666666666666",
            Hu = " +lat_1=49",
            Zu = " +lon_0=39",
            Xu = " +lat_1=37.25",
            Ju = " +lat_1=39.75",
            Wu = " +lat_2=38.45",
            Vu = " +lat_1=30.75",
            Yu = " +lon_0=-84.5",
            Ku = " +lat_0=33.75",
            $u = " +x_0=4000000",
            tc = " +y_0=4000000",
            ec = " +lon_0=-72.5",
            nc = " +x_0=5000000",
            rc = " +x_0=10500000",
            ac = " +x_0=12500000",
            ic = " +x_0=24500000",
            oc = " +k=0.99999375",
            sc = " +x_0=399999.9999984",
            lc = " +lon_0=-77",
            hc = " +lon_0=108",
            uc = " +lon_0=171",
            cc = " +towgs84=-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925",
            fc = " +lon_0=-171",
            dc = " +lat_0=32.5",
            _c = " +lon_0=-117",
            pc = " +k=1.000015",
            yc = " +k=1.000034",
            gc = " +k=1.000031",
            mc = " +k=1.000026",
            vc = " +ellps=evrstSS",
            xc = " +a=6377301.243",
            bc = " +towgs84=410.721,55.049,80.746,2.5779,2.3514,0.6664,17.3311",
            kc = " +towgs84=72.438,345.918,79.486,1.6045,0.8823,0.5565,1.3746",
            Mc = " +pm=ferro",
            wc = " +lon_0=78",
            Cc = " +lon_0=10",
            Ec = " +pm=paris",
            Sc = " +towgs84=0.055,-0.541,-0.185,0.0183,-0.0003,-0.007,-0.014",
            Ac = " +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489",
            Ic = " +towgs84=8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081",
            Oc = " +towgs84=572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378",
            jc = " +zone=58",
            Nc = " +zone=23",
            Gc = " +x_0=304800.6096012192",
            Dc = " +y_0=152400.3048006096",
            Rc = " +x_0=800000.0001016001",
            Lc = " +x_0=399999.9998983998",
            Pc = " +x_0=7999999.999968001",
            Tc = " +x_0=5999999.999976001",
            Bc = " +x_0=830000.0001016001",
            Qc = " +x_0=249999.9998983998",
            Fc = " +x_0=350000.0001016001",
            qc = " +to_meter=0.3047972654",
            Uc = " +x_0=99999.99989839978",
            zc = " +y_0=8000000.000010163",
            Hc = " +x_0=699999.9999898402",
            Zc = " +lon_0=-69",
            Xc = " +lon_0=-86",
            Jc = " +towgs84=-3.2,-5.7,2.8,0,0,0,0",
            Wc = " +x_0=8500000",
            Vc = " +x_0=9500000",
            Yc = " +lat_1=39.45",
            Kc = " +lat_0=44.25",
            $c = " +lat_1=41.95",
            tf = " +lat_2=35.25",
            ef = " +lat_2=34.65",
            nf = " +lat_2=44.25",
            rf = " +lat_1=47.05",
            af = " +lat_1=40.25",
            of = " +k_0=1.00012",
            sf = " +lat_0=40.25",
            lf = " +zone=40",
            hf = " +zone=36",
            uf = " +zone=51",
            cf = " +zone=48",
            ff = " +zone=49",
            df = " +lon_0=96",
            _f = " +y_0=750000",
            pf = " +lat_0=36.5",
            yf = " +lon_0=-119",
            gf = " +lat_0=33.5",
            mf = " +lat_2=41.2",
            vf = " +k=0.999995",
            xf = " +lat_2=33.3",
            bf = " +lat_0=38.5",
            kf = " +lon_0=-154",
            Mf = " +lon_0=-120",
            wf = " +x_0=34500000",
            Cf = " +x_0=35500000",
            Ef = " +x_0=36500000",
            Sf = " +x_0=37500000",
            Af = " +x_0=38500000",
            If = " +x_0=39500000",
            Of = " +x_0=40500000",
            jf = " +x_0=41500000",
            Nf = " +x_0=43500000",
            Gf = " +x_0=45500000",
            Df = " +y_0=3999999.99998984",
            Rf = " +y_0=2000000.00001016",
            Lf = " +towgs84=164,138,-189,0,0,0,0",
            Pf = " +towgs84=-186,230,110,0,0,0,0",
            Tf = " +towgs84=-199,32,322,0,0,0,0",
            Bf = " +to_meter=0.3047997101815088",
            Qf = " +towgs84=-76,-138,67,0,0,0,0",
            Ff = " +towgs84=-43,-163,45,0,0,0,0",
            qf = " +towgs84=-346,-1,224,0,0,0,0",
            Uf = " +towgs84=210,814,289,0,0,0,0",
            zf = " +towgs84=-74,-130,42,0,0,0,0",
            Hf = " +zone=15",
            Zf = " +zone=16",
            Xf = " +zone=34",
            Jf = " +zone=50",
            Wf = " +zone=52",
            Vf = " +lon_0=-62",
            Yf = " +lon_0=-84",
            Kf = " +lon_0=-79",
            $f = " +lon_0=131",
            td = " +lon_0=153",
            ed = " +lon_0=165",
            nd = " +lon_0=-94",
            rd = " +lon_0=-54",
            ad = " +a=6378300.789",
            id = " +b=6356566.435",
            od = " +y_0=3999999.9998984",
            sd = " +y_0=5000000.0001016",
            ld = " +x_0=150000.00001464",
            hd = " +lat_2=46",
            ud = " +lon_0=84",
            cd = " +lat_0=43",
            fd = " +k_0=0.999625769",
            dd = " +towgs84=51,391,-36,0,0,0,0",
            _d = " +towgs84=-83,37,124,0,0,0,0",
            pd = " +towgs84=-355,21,72,0,0,0,0",
            yd = " +towgs84=-23,259,-9,0,0,0,0",
            gd = " +towgs84=174.05,-25.49,112.57,-0,-0,0.554,0.2263",
            md = " +zone=59",
            vd = " +zone=25",
            xd = " +zone=11",
            bd = " +zone=12",
            kd = " +zone=13",
            Md = " +zone=54",
            wd = " +zone=14",
            Cd = " +zone=24",
            Ed = " +zone=47",
            Sd = " +lat_2=38.3",
            Ad = " +lat_1=45.7",
            Id = " +lat_2=42.1",
            Od = " +x_0=165000",
            jd = " +lat_2=32.5",
            Nd = " +x_0=609600",
            Gd = " +lat_1=39.2",
            Dd = " +lat_2=47.5",
            Rd = " +lat_1=30.7",
            Ld = " +lat_2=29.3",
            Pd = " +lat_0=28.5",
            Td = " +lat_1=41.7",
            Bd = " +lat_1=44.4",
            Qd = " +lat_1=27.5",
            Fd = " +lon_0=-150",
            qd = " +lat_0=44.5",
            Ud = " +k=1.000027",
            zd = " +k=1.000038",
            Hd = " +k=1.000036",
            Zd = " +lon_0=-87.5",
            Xd = " +x_0=3999999.999984",
            Jd = " +x_0=199999.9999992",
            Wd = " +towgs84=16,196,93,0,0,0,0",
            Vd = " +towgs84=-88,4,101,0,0,0,0",
            Yd = " +lat_0=18",
            Kd = " +lat_2=67",
            $d = " +lon_0=-96",
            t_ = " +x_0=80000",
            e_ = " +lon_0=-82",
            n_ = " +lon_0=-74",
            r_ = " +lon_0=147",
            a_ = " +lon_0=150",
            i_ = " +x_0=40000",
            o_ = " +k=1.00002",
            s_ = " +x_0=42500000",
            l_ = " +x_0=44500000",
            h_ = " +lon_0=-85.05",
            u_ = " +ellps=mod_airy",
            c_ = " +lat_0=0.1333333333333333",
            f_ = " +lat_1=-60.66666666666666",
            d_ = " +lat_2=-63.33333333333334",
            __ = " +lon_0=-91.91666666666667",
            p_ = " +y_0=0.003352806705613411",
            y_ = " +zone=30",
            g_ = " +lon_0=3",
            m_ = " +zone=26",
            v_ = " +zone=53",
            x_ = " +lat_0=31.73439361111111",
            b_ = " +lon_0=35.20451694444445",
            k_ = " +lon_0=7.439583333333333",
            M_ = " +lon_0=132.1666666666667",
            w_ = " +lon_0=134.3333333333333",
            C_ = " +lon_0=137.1666666666667",
            E_ = " +lon_0=139.8333333333333",
            S_ = " +lon_0=140.8333333333333",
            A_ = " +lon_0=3.192280555555556",
            I_ = " +lat_1=49.50000000000001",
            O_ = " +lat_0=49.50000000000001",
            j_ = " +alpha=53.31582047222222",
            N_ = " +lon_0=10.33333333333333",
            G_ = " +lon_0=16.33333333333333",
            D_ = " +towgs84=-502.862,-247.438,312.724,0,0,0,0",
            R_ = " +towgs84=-381.788,-57.501,-256.673,0,0,0,0",
            L_ = " +towgs84=-43.685,-179.785,-267.721,0,0,0,0",
            P_ = " +zone=60",
            T_ = " +zone=55",
            B_ = " +lon_0=36",
            Q_ = " +lon_0=42",
            F_ = " +lat_1=46",
            q_ = " +lat_1=44",
            U_ = " +lat_0=42",
            z_ = " +lon_0=51",
            H_ = " +lat_0=33",
            Z_ = " +lat_0=52",
            X_ = " +ellps=airy",
            J_ = " +pm=jakarta",
            W_ = " +x_0=2743195.5",
            V_ = " +y_0=-4354009.816",
            Y_ = " +k_0=0.9987864078000001",
            K_ = " +towgs84=-106.226,166.366,-37.893,0,0,0,0",
            $_ = " +towgs84=508.088,-191.042,565.223,0,0,0,0",
            tp = " +k=0.99996",
            ep = " +a=6378135",
            np = " +lon_0=-66",
            rp = " +lon_0=141",
            ap = " +lon_0=159",
            ip = " +k=0.99984",
            op = " +lat_0=-22",
            sp = " +lon_0=127.5",
            lp = " +x_0=6000000",
            hp = " +x_0=3900000",
            up = " +y_0=1300000",
            cp = " +lat_0=44.75",
            fp = " +lat_0=37.75",
            dp = " +lat_0=40.55",
            _p = " +lon_0=-87.3",
            pp = " +lon_0=-86.5",
            yp = " +towgs84=195.671,332.517,274.607,0,0,0,0",
            gp = " +towgs84=-204.619,140.176,55.226,0,0,0,0",
            mp = "+proj=somerc",
            vp = " +y_0=30480.06096012192",
            xp = " +y_0=999999.9999960001",
            bp = " +x_0=182880.3657607315",
            kp = " +towgs84=674.374,15.056,405.346,0,0,0,0",
            Mp = " +towgs84=-133.63,-157.5,-158.62,0,0,0,0",
            wp = " +towgs84=-0.465,372.095,171.736,0,0,0,0",
            Cp = " +towgs84=-56.263,16.136,-22.856,0,0,0,0",
            Ep = " +towgs84=-241.54,-163.64,396.06,0,0,0,0",
            Sp = " +zone=31",
            Ap = " +zone=10",
            Ip = " +zone=46",
            Op = " +x_0=304800.6096",
            jp = " +y_0=152400.3048",
            Np = " +alpha=337.25556",
            Gp = " +x_0=2546731.496",
            Dp = " +gamma=337.25556",
            Rp = " +k_0=0.999625544",
            Lp = " +towgs84=335.47,222.58,-230.94,0,0,0,0",
            Pp = " +towgs84=217.037,86.959,23.956,0,0,0,0",
            Tp = " +towgs84=-128.16,-282.42,21.93,0,0,0,0",
            Bp = " +towgs84=103.25,-100.4,-307.19,0,0,0,0",
            Qp = " +lon_0=31",
            Fp = " +lon_0=18",
            qp = " +lat_2=36",
            Up = " +lat_0=29",
            zp = " +lat_0=35",
            Hp = " +lat_0=34",
            Zp = " +lon_0=63",
            Xp = " +lat_0=37",
            Jp = " +lat_2=65",
            Wp = " +y_0=-4000000",
            Vp = " +y_0=914398.5",
            Yp = " +towgs84=-199.87,74.79,246.62,0,0,0,0",
            Kp = " +towgs84=-11.64,-348.6,291.98,0,0,0,0",
            $p = " +towgs84=-254.1,-5.36,-100.29,0,0,0,0",
            ty = " +towgs84=-206.1,-174.7,-87.7,0,0,0,0",
            ey = " +towgs84=-770.1,158.4,-498.2,0,0,0,0",
            ny = " +towgs84=-146.21,112.63,4.05,0,0,0,0",
            ry = " +towgs84=-294.7,-200.1,525.5,0,0,0,0",
            ay = " +lat_0=4",
            iy = " +a=6378300",
            oy = " +lon_0=-63",
            sy = " +lon_0=162",
            ly = " +lat_ts=90",
            hy = " +y_0=600000",
            uy = " +x_0=350000",
            cy = " +y_0=900000",
            fy = " +lat_1=32.5",
            dy = " +lon_0=-147",
            _y = " +k=1.000043",
            py = " +lat_0=48.5",
            yy = " +lat_0=40.9",
            gy = " +k=1.000028",
            my = " +k=1.000025",
            vy = " +x_0=170251.555",
            xy = " +b=6356657.142669561",
            by = " +b=6356094.667915204",
            ky = " +b=6355862.933255573",
            My = " +a=6378249.144808011",
            wy = " +b=6356514.966204134",
            Cy = " +towgs84=-70.9,-151.8,-41.4,0,0,0,0",
            Ey = " +towgs84=52.17,-71.82,-14.9,0,0,0,0",
            Sy = " +towgs84=283.7,735.9,261.1,0,0,0,0",
            Ay = " +zone=5",
            Iy = " +zone=7",
            Oy = " +lon_0=19",
            jy = " +lon_0=25",
            Ny = " +lat_2=45",
            Gy = " +lon_0=57",
            Dy = " +lon_0=69",
            Ry = " +lat_2=39",
            Ly = " +lat_2=35",
            Py = " +lon_0=28",
            Ty = " +lon_0=-61.5",
            By = " +lon_0=-64.5",
            Qy = " +lon_0=-90.5",
            Fy = " +lon_0=-94.5",
            qy = " +y_0=2800000",
            Uy = " +x_0=4321000",
            zy = " +y_0=3210000",
            Hy = " +y_0=14743.5",
            Zy = " +y_0=1999999.999992",
            Xy = " +y_0=2999999.999988",
            Jy = " +y_0=50000.00001504",
            Wy = " +zone=41",
            Vy = " +zone=42",
            Yy = " +k=0.994",
            Ky = " +zone=56",
            $y = " +lon_0=-67.875",
            tg = " +lon_0=-70.375",
            eg = " +x_0=609601.22",
            ng = " +b=6356889.449",
            rg = " +lon_0=-69.125",
            ag = " +lon_0=-121.75",
            ig = " +lon_0=-121.25",
            og = " +lon_0=-119.75",
            sg = " +lon_0=-122.75",
            lg = " +zone=6",
            hg = "+proj=krovak",
            ug = " +towgs84=-637,-549,-203,0,0,0,0",
            cg = " +towgs84=-20.8,11.3,2.4,0,0,0,0",
            fg = " +lon_0=-93",
            dg = " +lon_0=127",
            _g = " +lon_0=125",
            pg = " +k=0.99975",
            yg = " +lon_0=136",
            gg = " +lon_0=138",
            mg = " +lon_0=180",
            vg = " +y_0=50000",
            xg = " +lon_0=-85",
            bg = " +k=1.00016",
            kg = " +lon_0=2.7",
            Mg = " +towgs84=27.5,14,186.4,0,0,0,0",
            wg = " +towgs84=-499,-249,314,0,0,0,0",
            Cg = " +towgs84=-467,-16,-300,0,0,0,0",
            Eg = " +towgs84=-382,-59,-262,0,0,0,0",
            Sg = " +towgs84=253,-132,-127,0,0,0,0",
            Ag = " +towgs84=-963,510,-359,0,0,0,0",
            Ig = " +towgs84=94,-948,-1262,0,0,0,0",
            Og = " +zone=1",
            jg = " +zone=27",
            Ng = " +zone=57",
            Gg = " +pm=oslo",
            Dg = " +zone=43",
            Rg = " +lon_0=23",
            Lg = " +lon_0=48",
            Pg = " +lon_0=54",
            Tg = " +lat_0=49.5",
            Bg = " +k=0.999912",
            Qg = " +lon_0=-174",
            Fg = " +lon_0=-168",
            qg = " +lon_0=-170",
            Ug = " +lon_0=-165",
            zg = " +lat_2=40.5",
            Hg = " +lon_0=-115",
            Zg = " +lat_1=29.5",
            Xg = " +k=1.000045",
            Jg = " +lat_1=39.5",
            Wg = " +lat_1=33.3",
            Vg = " +lat_0=33.3",
            Yg = " +lon_0=-155.5",
            Kg = " +lon_0=-159.5",
            $g = " +y_0=-4480000",
            tm = " +lon_0=-176.5",
            em = " +lon_0=-89.75",
            nm = " +k_0=1.000008",
            rm = " +lonc=-124.05",
            am = " +k_0=1.000002",
            im = " +lon_0=-122.5",
            om = " +lon_0=-98.25",
            sm = " +lon_0=-112.5",
            lm = " +lon_0=-84.95",
            hm = " +lon_0=-86.95",
            um = " +lon_0=-85.45",
            cm = " +lon_0=-87.45",
            fm = " +lon_0=-87.55",
            dm = " +towgs84=-149,128,296,0,0,0,0",
            _m = " +towgs84=-425,-169,81,0,0,0,0",
            pm = " +towgs84=-104,167,-38,0,0,0,0",
            ym = " +towgs84=-106,-87,188,0,0,0,0",
            gm = " +towgs84=-289,-124,60,0,0,0,0",
            mm = " +towgs84=137,248,-430,0,0,0,0",
            vm = " +towgs84=-13,-348,292,0,0,0,0",
            xm = " +towgs84=-115,118,426,0,0,0,0",
            bm = " +towgs84=0,-0.15,0.68,0,0,0,0",
            km = " +towgs84=145,-187,103,0,0,0,0",
            Mm = " +towgs84=-134,229,-29,0,0,0,0",
            wm = " +towgs84=70,207,389.5,0,0,0,0",
            Cm = " +towgs84=-148,51,-291,0,0,0,0",
            Em = " +towgs84=-255,-15,71,0,0,0,0",
            Sm = " +towgs84=725,685,536,0,0,0,0",
            Am = " +towgs84=72,213.7,93,0,0,0,0",
            Im = " +towgs84=174,359,365,0,0,0,0",
            Om = " +towgs84=-173,253,27,0,0,0,0",
            jm = " +towgs84=-203,141,53,0,0,0,0",
            Nm = " +towgs84=186,482,151,0,0,0,0",
            Gm = " +towgs84=162,117,154,0,0,0,0",
            Dm = " +towgs84=-73,213,296,0,0,0,0",
            Rm = " +towgs84=-130,29,364,0,0,0,0",
            Lm = " +towgs84=-10,375,165,0,0,0,0",
            Pm = " +towgs84=175,-38,113,0,0,0,0",
            Tm = " +to_meter=0.9143984146160287",
            Bm = " +zone=2",
            Qm = " +zone=8",
            Fm = " +zone=9",
            qm = " +zone=4",
            Um = " +towgs84=30,430,368,0,0,0,0",
            zm = " +towgs84=185,165,42,0,0,0,0",
            Hm = " +towgs84=-97,787,86,0,0,0,0",
            Zm = " +towgs84=639,405,60,0,0,0,0",
            Xm = " +zone=44",
            Jm = " +zone=45",
            Wm = " +lon_0=-58.5",
            Vm = " +lon_0=-67.5",
            Ym = " +lon_0=-73.5",
            Km = " +lon_0=-76.5",
            $m = " +y_0=1200000",
            tv = " +lon_0=133.5",
            ev = " +x_0=8000000",
            nv = " +y_0=8000000",
            rv = " +k=0.9998335",
            av = " +lon_0=-85.5",
            iv = " +x_0=7000000",
            ov = " +lat_0=43.75",
            sv = " +lat_0=43.25",
            lv = " +lat_0=45.25",
            hv = " +lon_0=-86.3",
            uv = " +lat_0=38.15",
            cv = " +lat_0=39.15",
            fv = " +lat_0=41.25",
            dv = " +lat_0=40.65",
            _v = " +lat_0=39.25",
            pv = " +lat_0=40.35",
            yv = " +lon_0=-85.8",
            gv = " +towgs84=9,183,236,0,0,0,0",
            mv = " +towgs84=-48,55,52,0,0,0,0",
            vv = " +towgs84=84,274,65,0,0,0,0",
            xv = " +lon_0=17",
            bv = " +lat_1=60",
            kv = " +k=0.9998",
            Mv = " +lon_0=66",
            wv = " +lon_0=20",
            Cv = " +lon_0=26",
            Ev = " +lat_0=51",
            Sv = " +lat_1=87",
            Av = " +lat_1=26",
            Iv = " +lon_0=144",
            Ov = " +lon_0=168",
            jv = " +lon_0=174",
            Nv = " +lon_0=-72",
            Gv = " +lon_0=-75",
            Dv = " +lon_0=-60",
            Rv = " +lon_0=-39",
            Lv = "+proj=poly",
            Pv = " +x_0=219529.584",
            Tv = " +a=6378306.3696",
            Bv = " +lon_0=-61.33333333333334",
            Qv = " +lon_0=-91.86666666666666",
            Fv = " +lon_0=-8.131906111111112",
            qv = " +lon_0=-83.66666666666667",
            Uv = " +lon_0=-108.4166666666667",
            zv = " +lon_0=-108.3333333333333",
            Hv = " +lon_0=-85.40000000000001",
            Zv = " +lon_0=-86.65000000000001",
            Xv = " +lon_0=-86.40000000000001",
            Jv = " +lon_0=-85.59999999999999",
            Wv = " +lon_0=-87.15000000000001",
            Vv = " +lon_0=-86.59999999999999",
            Yv = " +lon_0=-84.90000000000001",
            Kv = " +lon_0=-85.65000000000001",
            $v = " +lon_0=-87.65000000000001",
            tx = " +lon_0=-85.34999999999999",
            ex = " +lon_0=-87.40000000000001",
            nx = " +lon_0=-87.34999999999999",
            rx = " +lon_0=-85.90000000000001",
            ax = " +lon_0=-90.62222222222222",
            ix = " +lon_0=-91.84999999999999",
            ox = " +lon_0=-91.15277777777779",
            sx = " +lon_0=-91.79722222222222",
            lx = " +lon_0=-92.45777777777778",
            hx = " +lon_0=-91.29444444444444",
            ux = " +lon_0=-90.70833333333334",
            cx = " +lon_0=-89.39444444444445",
            fx = " +lon_0=-89.42222222222223",
            dx = " +lon_0=-88.77500000000001",
            _x = " +lon_0=-87.27222222222223",
            px = " +lon_0=-91.89444444444445",
            yx = " +lon_0=-91.28888888888889",
            gx = " +lon_0=-88.14166666666668",
            mx = " +lon_0=-88.63333333333334",
            vx = " +lon_0=-89.83888888888889",
            xx = " +lon_0=-90.16111111111111",
            bx = " +lon_0=-90.25555555555556",
            kx = " +lon_0=-90.84429651944444",
            Mx = " +lon_0=-87.89444444444445",
            wx = " +lon_0=-91.31666666666666",
            Cx = " +lon_0=-89.03333333333333",
            Ex = " +lon_0=-89.73333333333333",
            Sx = " +lon_0=-87.71111111111111",
            Ax = " +lon_0=-88.41666666666667",
            Ix = " +lon_0=-90.64166666666668",
            Ox = " +lon_0=-87.90833333333335",
            jx = " +lon_0=-89.54444444444444",
            Nx = " +lon_0=-92.22777777777777",
            Gx = " +lon_0=-90.48888888888889",
            Dx = " +lon_0=-90.43055555555556",
            Rx = " +lon_0=-89.07222222222222",
            Lx = " +lon_0=-91.06666666666666",
            Px = " +lon_0=-89.90000000000001",
            Tx = " +lon_0=-91.11666666666666",
            Bx = " +lon_0=-88.60555555555555",
            Qx = " +lon_0=-90.48333333333333",
            Fx = " +lon_0=-91.36666666666666",
            qx = " +lon_0=-90.78333333333333",
            Ux = " +lon_0=-89.48888888888889",
            zx = " +lon_0=-88.54166666666667",
            Hx = " +lon_0=-91.78333333333333",
            Zx = " +lon_0=-88.06388888888888",
            Xx = " +lon_0=-88.22499999999999",
            Jx = " +lon_0=-88.81666666666666",
            Wx = " +y_0=0.004876809753619507",
            Vx = " +y_0=0.008534417068834137",
            Yx = " +y_0=0.003962407924815849",
            Kx = " +y_0=0.005791211582423164",
            $x = " +lon_0=-55.68333333333333",
            tb = " +to_meter=0.201166195164",
            eb = " +lat_0=4.666666666666667",
            nb = " +lat_0=6.666666666666667",
            rb = " +lon_0=6.166666666666667",
            ab = " +lat_0=10.44166666666667",
            ib = " +lat_0=22.31213333333334",
            ob = " +lon_0=114.1785555555556",
            sb = " +lon_0=51.21666666666667",
            lb = " +lon_0=11.30827777777778",
            hb = " +lon_0=13.55827777777778",
            ub = " +lon_0=15.80827777777778",
            cb = " +lon_0=18.05827777777778",
            fb = " +lon_0=20.30827777777778",
            db = " +lon_0=22.55827777777778",
            _b = " +lat_1=27.41666666666667",
            pb = " +lat_2=34.91666666666666",
            yb = " +lat_0=31.16666666666667",
            gb = " +lat_1=59.33333333333334",
            mb = " +lat_0=57.51755393055556",
            vb = " +lon_0=4.359215833333333",
            xb = " +lat_1=61.66666666666666",
            bb = " +lat_0=29.02626833333333",
            kb = " +lat_1=48.66666666666666",
            Mb = " +lat_2=53.66666666666666",
            wb = " +lon_0=127.0028902777778",
            Cb = " +lon_0=89.84999999999999",
            Eb = " +lon_0=91.56666666666666",
            Sb = " +lon_0=24.83333333333333",
            Ab = " +lat_2=63.66666666666666",
            Ib = " +lat_0=65.35103930555555",
            Ob = " +lat_1=63.66666666666666",
            jb = " +lat_2=60.33333333333334",
            Nb = " +lat_0=62.01530688888889",
            Gb = " +lat_1=45.78333333333333",
            Db = " +lat_0=45.78333333333333",
            Rb = " +lat_0=42.66666666666666",
            Lb = " +lat_0=43.36666666666667",
            Pb = " +lat_0=45.70611111111111",
            Tb = " +lat_0=45.13333333333333",
            Bb = " +lat_1=46.66964837722222",
            Qb = " +lat_0=46.66964837722222",
            Fb = " +lat_0=43.48138888888889",
            qb = " +lat_1=45.89871486583333",
            Ub = " +lat_0=45.89871486583333",
            zb = " +lat_0=42.71944444444445",
            Hb = " +lat_1=44.97785689861112",
            Zb = " +lat_0=44.97785689861112",
            Xb = " +lat_1=43.46254664583333",
            Jb = " +lat_0=43.46254664583333",
            Wb = " +lon_0=-90.9388888888889",
            Vb = " +lat_0=41.47222222222222",
            Yb = " +lat_0=45.88333333333333",
            Kb = " +lat_0=44.40833333333333",
            $b = " +lat_1=44.87228112638889",
            tk = " +lat_0=44.87228112638889",
            ek = " +lat_0=45.43888888888888",
            nk = " +lat_0=44.00555555555555",
            rk = " +lat_0=41.41111111111111",
            ak = " +lat_1=42.63756227694444",
            ik = " +lat_0=42.63756227694444",
            ok = " +lat_1=43.80700011777778",
            sk = " +lat_0=43.80700011777778",
            lk = " +lat_0=42.53888888888888",
            hk = " +lat_0=45.43333333333333",
            uk = " +lat_0=44.25333512777778",
            ck = " +lat_0=42.21666666666667",
            fk = " +lat_0=43.26666666666667",
            dk = " +lat_0=43.45111111111111",
            _k = " +lat_1=45.15423710527778",
            pk = " +lat_0=45.15423710527778",
            yk = " +lat_0=44.84444444444445",
            gk = " +lat_1=44.90090442361111",
            mk = " +lat_0=44.90090442361111",
            vk = " +lat_0=44.69166666666666",
            xk = " +lat_0=44.71666666666667",
            bk = " +lat_1=44.00007392861111",
            kk = " +lat_0=44.00007392861111",
            Mk = " +lat_0=44.39722222222222",
            wk = " +lat_1=45.70422377027778",
            Ck = " +lat_0=45.70422377027778",
            Ek = " +lat_1=44.63614887194444",
            Sk = " +lat_0=44.63614887194444",
            Ak = " +lat_0=44.66111111111111",
            Ik = " +lat_1=44.41682397527777",
            Ok = " +lat_0=44.41682397527777",
            jk = " +lat_0=44.55555555555555",
            Nk = " +lat_0=41.94444444444444",
            Gk = " +lat_0=43.91944444444444",
            Dk = " +lat_0=42.81944444444445",
            Rk = " +lat_1=45.90009913138888",
            Lk = " +lat_0=45.90009913138888",
            Pk = " +lat_1=45.17782208583333",
            Tk = " +lat_0=45.17782208583333",
            Bk = " +lat_0=43.16111111111111",
            Qk = " +lat_1=43.57503293972223",
            Fk = " +lat_0=43.57503293972223",
            qk = " +lat_1=46.07784409055556",
            Uk = " +lat_0=46.07784409055556",
            zk = " +lat_1=42.66946209694444",
            Hk = " +lat_0=42.66946209694444",
            Zk = " +lat_1=45.96121983333334",
            Xk = " +lat_0=45.96121983333334",
            Jk = " +lat_0=42.91805555555555",
            Wk = " +lat_0=42.56944444444445",
            Vk = " +lat_0=43.42027777777778",
            Yk = " +lat_1=44.11394404583334",
            Kk = " +lat_0=44.11394404583334",
            $k = " +lat_1=44.36259546944444",
            tM = " +lat_0=44.36259546944444",
            eM = " +lat_1=44.10000000000001",
            nM = " +lat_0=44.10000000000001",
            rM = " +lat_1=42.16500000000001",
            aM = " +lat_0=42.16500000000001",
            iM = " +lat_0=52.15616055555555",
            oM = " +lat_2=48.73333333333333",
            sM = " +zone=3",
            lM = " +lat_0=53.5",
            hM = " +k=0.999923",
            uM = " +x_0=850000",
            cM = " +x_0=830000",
            fM = " +lon_0=16.5",
            dM = " +x_0=520000",
            _M = " +lat_2=31.5",
            pM = " +lon_0=10.5",
            yM = " +lat_1=44.5",
            gM = " +lon_0=-153",
            mM = " +lon_0=-135",
            vM = " +x_0=750000",
            xM = " +lat_0=43.5",
            bM = " +lon_0=-142",
            kM = " +lon_0=-146",
            MM = " +lon_0=-162",
            wM = " +lon_0=-166",
            CM = " +lon_0=-176",
            EM = " +lat_2=39.5",
            SM = " +lon_0=-129",
            AM = " +k_0=1.0002",
            IM = " +k=1.000023",
            OM = " +lon_0=-121",
            jM = " +k=1.000175",
            NM = " +lat_0=45.5",
            GM = " +k=1.000155",
            DM = " +lat_2=37.5",
            RM = " +lat_1=48.5",
            LM = " +k=1.000029",
            PM = " +lat_0=39.6",
            TM = " +k=1.000013",
            BM = " +k=1.000022",
            QM = " +lat_0=40.7",
            FM = " +lat_0=39.3",
            qM = " +lat_0=37.8",
            UM = " +lat_0=38.9",
            zM = " +lon_0=-5.4",
            HM = " +y_0=626907.39",
            ZM = " +b=6356571.996",
            XM = " +a=6377295.664",
            JM = " +lon_0=5.38763888888889",
            WM = " +y_0=-4600000.00001208",
            VM = " +y_0=1889763.779527559",
            YM = " +y_0=99999.99999960001",
            KM = " +x_0=120091.4401828804",
            $M = " +lon_0=72",
            tw = " +lat_0=50",
            ew = " +lat_1=50",
            nw = " +lat_1=35",
            rw = " +lon_0=22",
            aw = " +lat_1=34",
            iw = " +lonc=115",
            ow = " +lat_0=-9",
            sw = " +lat_0=23",
            lw = " +lat_1=85",
            hw = " +lat_2=69",
            uw = " +lat_1=69",
            cw = " +lat_2=61",
            fw = " +lon_0=34",
            dw = " +lon_0=140.25",
            _w = " +lon_0=142.25",
            pw = " +lon_0=144.25",
            yw = " +x_0=47500000",
            gw = " +y_0=-3000000",
            mw = " +pm=2.337208333333333",
            vw = " +x_0=7000000.00000248",
            xw = " +lon_0=6",
            bw = " +k=0.997",
            kw = " +lon_0=106",
            Mw = " +lon_0=154",
            ww = " +lon_0=156",
            Cw = " +lat_2=-36",
            Ew = " +lon_0=119",
            Sw = " +lon_0=121",
            Aw = " +lon_0=166",
            Iw = " +a=6371228",
            Ow = " +b=6371228",
            jw = " +a=6378273",
            Nw = " +lat_0=-44",
            Gw = " +pm=lisbon",
            Dw = " +lon_0=-57",
            Rw = " +lon_0=-56",
            Lw = " +k=1.00007",
            Pw = " +lonc=-123",
            Tw = " +alpha=295",
            Bw = " +gamma=295",
            Qw = " +k=1.00011",
            Fw = " +k=1.00005",
            qw = " +k=1.00013",
            Uw = " +x_0=30000",
            zw = " +k=1.00001",
            Hw = " +k=1.00003",
            Zw = " +y_0=130000.00001472",
            Xw = " +x_0=119999.99999952",
            Jw = " +y_0=-2999999.999988",
            Ww = " +x_0=-299999.9999988",
            Vw = " +lat_1=43.0695160375",
            Yw = " +lat_0=43.0695160375",
            Kw = " +lat_1=43.3223129275",
            $w = " +lat_0=43.3223129275",
            tC = " +k=1.0000067",
            eC = " +a=6378298.3",
            nC = " +lon_0=-66.5",
            rC = " +lon_0=129.5",
            aC = " +lon_0=138.5",
            iC = " +x_0=2300000",
            oC = " +x_0=3300000",
            sC = " +x_0=4300000",
            lC = " +y_0=7500000",
            hC = " +lonc=102.25",
            uC = " +y_0=1166200",
            cC = " +x_0=3000000",
            fC = " +lat_1=46.25",
            dC = " +ellps=WGS66",
            _C = " +ellps=GRS67",
            pC = " +lat_1=34.65",
            yC = " +y_0=59999.99999976",
            gC = " +y_0=30000.00001512",
            mC = " +x_0=59999.99999976",
            vC = " +x_0=30000.00001512",
            xC = " +lat_1=43.200055605",
            bC = " +lat_0=43.200055605",
            kC = " +y_0=65379.0134283",
            MC = " +alpha=323.0257905",
            wC = " +alpha=53.31580995",
            CC = " +x_0=10000.0000152";
          t.exports = [2e3, a + f + Vf + sa + X + _ + I + i + e, 1, a + f + Vf + sa + X + _ + I + Em + i + e, 1, a + f + Vf + sa + X + _ + I + Sm + i + e, 1, a + f + Vf + sa + X + _ + I + Am + i + e, 1, a + f + Vf + sa + X + _ + I + Im + i + e, 1, a + f + Vf + sa + X + _ + I + gv + i + e, 1, a + f + Vf + sa + X + _ + I + dm + i + e, 1, a + f + Vf + sa + X + _ + I + yp + i + e, 2, a + f + Wm + k + Et + _ + R + i + e, 1, a + f + Ty + k + Et + _ + R + i + e, 1, a + f + By + k + Et + _ + R + i + e, 1, a + f + Vm + k + Et + _ + R + i + e, 1, a + f + Vs + k + Et + _ + R + i + e, 1, a + f + Ym + k + Et + _ + R + i + e, 1, a + f + Km + k + Et + _ + R + i + e, 1, a + f + po + k + Et + _ + R + i + e, 1, a + f + Ym + k + Et + _ + R + i + e, 1, a + f + Km + k + Et + _ + R + i + e, 1, a + f + po + k + Et + _ + R + i + e, 1, a + f + ca + k + Et + _ + R + i + e, 1, a + f + dn + k + Et + _ + R + i + e, 1, a + f + Yf + k + Et + _ + R + i + e, 1, a + f + yh + k + Et + _ + R + i + e, 1, a + f + Ue + k + Et + _ + R + i + e, 1, a + f + fg + k + Et + _ + R + i + e, 1, a + f + $d + k + Et + _ + R + i + e, 1, h + Hf + R + i + e, 1, h + Zf + R + i + e, 1, h + bl + R + i + e, 1, h + Fs + R + i + e, 1, h + bl + R + i + e, 1, h + Fs + R + i + e, 1, h + bs + R + i + e, 1, h + Qo + R + i + e, 1, h + qs + R + i + e, 4, a + x_ + b_ + tC + Pv + HM + r + mv + i + e, 1, h + y_ + I + Yl + i + e, 1, h + y_ + I + Us + i + e, 1, h + Rh + I + Yl + i + e, 1, h + Rh + I + Us + i + e, 1, a + f + ia + " +k=1" + js + _ + d + Xo + i + e, 1, a + f + Qi + " +k=1" + Ns + _ + d + Xo + i + e, 1, a + f + wo + " +k=1" + H + _ + Co + L + n + i + e, 1, a + f + xv + " +k=1" + H + _ + Co + L + n + i + e, 1, a + f + Oy + " +k=1" + H + _ + Co + L + n + i + e, 1, a + f + Eo + " +k=1" + H + _ + Co + L + n + i + e, 1, a + f + Rg + " +k=1" + H + _ + Co + L + n + i + e, 1, a + f + jy + " +k=1" + H + _ + Co + L + n + i + e, 1, a + f + es + " +k=1" + H + _ + Co + L + n + i + e, 1, a + f + " +lon_0=29 +k=1" + H + _ + Co + L + n + i + e, 1, a + f + Qp + " +k=1" + H + _ + Co + L + n + i + e, 1, a + f + Hs + " +k=1" + H + _ + Co + L + n + i + e, 1, mp + yu + k_ + " +k_0=1 +x_0=2600000" + $m + C + kp + i + e, 1, yn + " +lat_0=27.51882880555555 +lonc=52.60353916666667 +alpha=0.5716611944444444 +k=0.999895934 +x_0=658377.437 +y_0=3044969.194 +gamma=0.5716611944444444" + m + Mp + i + e, 1, h + lh + m + Bo + i + e, 1, h + Wl + m + Bo + i + e, 1, h + lf + m + Bo + i + e, 1, h + Wy + m + Bo + i + e, 1, l + " +lat_1=40" + Di + ts + " +k_0=0.9988085293" + S + hy + eC + xy + " +pm=madrid" + i + e, 3, hg + Tg + " +lon_0=42.5" + gu + k + H + _ + C + ko + Mc + i + e, 1, Nn + " +lat_0=11.25217861111111 +lon_0=-60.68600888888889 +x_0=37718.66159325 +y_0=36209.91512952" + ka + Ma + tb + e, 1, h + Qo + m + wp + i + e, 1, a + f + Lh + k + D + _ + m + J + i + e, 1, a + f + " +lon_0=11" + k + D + _ + m + J + i + e, 1, a + f + " +lon_0=13" + k + D + _ + m + J + i + e, 1, a + f + wo + k + D + _ + m + J + i + e, 1, a + f + xv + k + D + _ + m + J + i + e, 1, a + f + Oy + k + D + _ + m + J + i + e, 1, a + f + Eo + k + D + _ + m + J + i + e, 1, a + f + Rg + k + D + _ + m + J + i + e, 1, a + f + jy + k + D + _ + m + J + i + e, 1, h + Vl + m + J + i + e, 1, h + Ph + m + J + i + e, 1, h + Xf + m + J + i + e, 1, h + pu + m + J + i + e, 1, a + B + Zc + " +k=1" + On + _ + m + i + e, 1, a + B + Zc + " +k=1" + On + _ + m + Mg + i + e, 1, a + B + Zc + " +k=1" + On + _ + m + Wd + i + e, 1, h + bs + F + m + Wd + i + e, 3, a + f + Zs + _t + p + _ + m + J + i + e, 1, a + f + " +lon_0=11" + _t + p + _ + vt + ue + Mo + i + e, 1, h + lh + L + n + i + e, 1, h + Wl + L + n + i + e, 3, a + f + kw + " +k=1" + p + _ + d + Xo + i + e, 1, a + f + kw + _t + p + _ + x + g + i + e, 1, h + hh + m + Om + i + e, 1, a + In + ba + " +k=1" + D + It + C + i + e, 1, a + In + dg + " +k=1" + D + It + C + i + e, 1, a + In + _g + " +k=1" + D + It + C + i + e, 1, Nn + " +lat_0=25.38236111111111 +lon_0=50.76138888888889" + ge + na + Ao + i + e, 1, a + f + Xs + _t + p + _ + r + Yp + i + e, 1, l + mu + vu + Jh + " +k_0=1" + H + " +y_0=-52684.972" + m + i + e, 1, l + mu + vu + Jh + " +k_0=1" + D + " +y_0=147315.028" + m + i + e, 1, l + mu + vu + Jh + " +k_0=1" + p + " +y_0=447315.028" + m + i + e, 1, l + mu + vu + Jh + " +k_0=1 +x_0=-17044 +y_0=-23139.97" + m + i + e, 1, a + " +lat_0=-36.87972222222222 +lon_0=174.7641666666667" + k + X + un + r + n + i + e, 1, a + " +lat_0=-37.76111111111111 +lon_0=176.4661111111111 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-38.62444444444444 +lon_0=177.8855555555556 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-39.65083333333333 +lon_0=176.6736111111111 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-39.13555555555556 +lon_0=174.2277777777778 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-39.51222222222222 +lon_0=175.64 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-40.24194444444444 +lon_0=175.4880555555555 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-40.92527777777777 +lon_0=175.6472222222222 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-41.3011111111111 +lon_0=174.7763888888889 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-40.71472222222223 +lon_0=172.6719444444444 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-41.27444444444444 +lon_0=173.2991666666667 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-41.28972222222222 +lon_0=172.1088888888889 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-41.81055555555555 +lon_0=171.5811111111111 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-42.33361111111111 +lon_0=171.5497222222222 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-42.68888888888888 +lon_0=173.01 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-41.54444444444444 +lon_0=173.8019444444444 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-42.88611111111111 +lon_0=170.9797222222222 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-43.11 +lon_0=170.2608333333333 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-43.97777777777778 +lon_0=168.6061111111111 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-43.59055555555556 +lon_0=172.7269444444445 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-43.74861111111111 +lon_0=171.3605555555555 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-44.40194444444445 +lon_0=171.0572222222222 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-44.735 +lon_0=169.4675 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-45.13277777777778 +lon_0=168.3986111111111 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-45.56361111111111 +lon_0=167.7386111111111 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-45.81611111111111 +lon_0=170.6283333333333 +k=1" + X + un + r + n + i + e, 1, a + " +lat_0=-45.86138888888889 +lon_0=170.2825" + tp + X + un + r + n + i + e, 1, a + " +lat_0=-46.6 +lon_0=168.3427777777778 +k=1" + X + un + r + n + i + e, 1, h + jc + F + r + n + i + e, 1, h + md + F + r + n + i + e, 1, h + P_ + F + r + n + i + e, 1, a + eb + " +lon_0=-1" + pg + " +x_0=274319.7391633579" + _ + iy + Ss + Tf + Bf + e, 1, a + f + " +lon_0=-1" + _t + p + _ + iy + Ss + Tf + i + e, 1, l + bv + hd + ul + Vo + H + _ + R + i + e, 16, l + Hu + " +lat_2=44" + Sl + g_ + _a + " +y_0=6600000" + r + n + i + e, 3, a + lM + " +lon_0=-8 +k=0.99982" + S + _f + r + n + i + e, 1, h + Rh + r + n + i + e, 1, a + nb + " +lon_0=-12 +k=1 +x_0=152399.8550907544" + _ + iy + Ss + Bf + e, 1, a + nb + " +lon_0=-12 +k=1 +x_0=243839.7681452071 +y_0=182879.8261089053" + iy + Ss + Bf + e, 1, h + hh + I + Vd + i + e, 1, h + Rh + I + Vd + i + e, 1, gs + tl + _n + H + _ + " +a=6370997 +b=6370997" + i + e, 1, a + f + " +lon_0=-5" + _t + p + _ + I + Yl + i + e, 1, a + f + " +lon_0=-5" + _t + p + _ + I + Us + i + e, 4, a + " +lat_0=49.83333333333334" + rb + " +k=1" + t_ + na + m + Nh + i + e, 3, lo + " +lat_0=53.00194444444445 +lon_0=21.50277777777778" + kv + " +x_0=4603000 +y_0=5806000" + d + A + i + e, 1, lo + " +lat_0=53.58333333333334 +lon_0=17.00833333333333" + kv + " +x_0=3501000 +y_0=5999000" + d + A + i + e, 1, lo + " +lat_0=51.67083333333333 +lon_0=16.67222222222222" + kv + " +x_0=3703000 +y_0=5627000" + d + A + i + e, 1, a + f + " +lon_0=18.95833333333333 +k=0.999983 +x_0=237000 +y_0=-4700000" + d + A + i + e, 1, a + f + wo + hM + wa + _ + r + n + i + e, 1, a + f + Fp + hM + Ah + _ + r + n + i + e, 1, a + f + Eo + hM + Ys + _ + r + n + i + e, 1, a + f + Xs + hM + Wc + _ + r + n + i + e, 1, a + f + Oy + " +k=0.9993" + p + " +y_0=-5300000" + r + n + i + e, 8, h + vd + m + _m + i + e, 1, h + m_ + m + pm + i + e, 1, h + m_ + m + jm + i + e, 3, a + f + " +lon_0=173" + _t + " +x_0=1600000" + Rt + r + n + i + e, 2, h + Bm + F + r + n + i + e, 1, a + f + " +lon_0=9.5" + cn + D + _ + r + n + i + e, 1, a + f + Zs + cn + p + _ + r + n + i + e, 1, a + f + wo + " +k=1" + os + _ + r + n + i + e, 2, lo + Sl + nC + Bg + st + un + ep + jo + i + e, 1, h + Fs + r + n + i + e, 1, h + bs + r + n + i + e, 1, h + Qo + r + n + i + e, 1, l + " +lat_1=35.25 +lat_2=36.41666666666666 +lat_0=34.66666666666666" + Xc + E + vp + w + u + e, 1, l + Vt + pr + or + Mh + p + _ + r + n + i + e, 1, a + f + es + " +k=1" + Vc + _ + m + Q + i + e, 1, a + f + cl + " +k=1" + rc + _ + m + Q + i + e, 1, a + f + Hs + " +k=1" + wh + _ + m + Q + i + e, 1, a + f + B_ + " +k=1" + ac + _ + m + Q + i + e, 1, a + f + Zu + " +k=1" + ss + _ + m + Q + i + e, 1, a + f + Q_ + " +k=1" + Po + _ + m + Q + i + e, 1, a + f + eh + " +k=1" + Gs + _ + m + Q + i + e, 1, a + f + cl + _t + p + _ + r + n + i + e, 2, h + Vl + vt + ue + Cy + i + e, 1, h + Cl + m + Lf + i + e, 1, h + Nc + m + Lf + i + e, 2, h + bs + ep + jo + i + e, 1, h + Qo + ep + jo + i + e, 2, a + De + Rn + k + pa + _ + r + n + Z + e, 1, a + De + Ln + k + pa + _ + r + n + Z + e, 1, a + De + Nl + re + pa + _ + r + n + Z + e, 1, l + yr + kh + Y + Fo + St + nt + r + n + u + e, 1, l + gr + mr + $ + Fo + St + nt + r + n + u + e, 1, l + Qt + vr + pf + lt + St + nt + r + n + u + e, 1, l + Xu + qp + xr + yf + St + nt + r + n + u + e, 1, l + br + kr + gf + Al + St + nt + r + n + u + e, 1, l + Mr + wr + Cr + Gl + St + nt + r + n + u + e, 1, l + Ca + Ea + Y + Me + He + sn + r + n + u + e, 1, l + Ju + Wu + xn + Me + He + sn + r + n + u + e, 1, l + Qt + Er + N + Me + He + sn + r + n + u + e, 1, l + Sr + mf + Ar + Ch + Gc + Dc + r + n + u + e, 1, a + In + Pn + vf + rt + _ + r + n + u + e, 1, a + Ft + dn + Pt + rt + _ + r + n + u + e, 1, a + Ft + e_ + Pt + rt + _ + r + n + u + e, 1, l + Vu + Ir + Up + Yu + S + _ + r + n + u + e, 1, a + So + Tn + k + rt + _ + r + n + u + e, 1, a + So + Bn + k + ln + _ + r + n + u + e, 1, a + q + Qn + oe + rt + _ + r + n + u + e, 1, a + q + uh + oe + at + _ + r + n + u + e, 1, a + q + Dl + re + Rc + _ + r + n + u + e, 3, l + Vt + pr + or + Mh + at + _ + r + n + u + e, 1, l + Sa + Aa + tt + ya + at + nt + r + n + u + e, 1, l + Yc + Sd + $ + lc + Lc + _ + r + n + u + e, 1, l + Ia + Or + El + Zi + rt + _f + r + n + u + e, 1, l + Oa + ja + El + Vs + at + _ + r + n + u + e, 1, l + Na + Ga + Da + yh + Pc + _ + r + n + Z + e, 1, l + Ad + Ra + La + ee + Tc + _ + r + n + Z + e, 1, l + Be + Id + Oi + ee + Xd + _ + r + n + Z + e, 1, a + ks + Fn + cn + ne + _ + r + n + u + e, 1, a + ks + Ze + cn + ln + _ + r + n + u + e, 1, l + Hu + Ny + Kc + rl + cr + _ + r + n + Z + e, 1, a + De + qn + Cs + Od + _ + r + n + u + e, 1, a + De + Rl + k + at + _ + r + n + u + e, 1, a + De + Un + Ll + Bc + _ + r + n + u + e, 1, a + Yt + Oo + k + Le + _ + r + n + u + e, 1, a + Di + zn + At + Qc + _ + r + n + u + e, 1, a + Di + Hn + At + Fc + _ + r + n + u + e, 1, l + jr + Nr + Kt + n_ + ne + _ + r + n + u + e, 1, l + Pa + Ta + Ku + Kf + E + _ + r + n + u + e, 1, l + ae + Ba + fl + ga + cr + _ + r + n + Z + e, 1, l + Qa + Fa + Se + ga + cr + _ + r + n + Z + e, 1, l + Gr + qa + zp + Si + S + _ + r + n + u + e, 1, l + Ua + za + Dr + Si + S + _ + r + n + u + e, 1, l + F_ + bn + ht + lt + Zh + _ + r + n + Z + e, 1, l + q_ + kn + q + lt + Xh + _ + r + n + Z + e, 1, l + $c + Ha + Kt + ma + S + _ + r + n + u + e, 1, l + Rr + Lr + Y + ma + S + _ + r + n + u + e, 1, l + Za + jd + Pr + dn + Nd + _ + r + n + Z + e, 1, l + Xa + tf + $t + Xc + S + _ + r + n + u + e, 1, l + Ja + ef + Hp + Eh + rt + hn + r + n + u + e, 1, l + Wa + Va + Tr + gn + S + No + r + n + u + e, 1, l + Ya + Ka + Mn + jt + ln + Ni + r + n + u + e, 1, l + $a + ti + Br + gh + S + od + r + n + u + e, 1, l + Ke + $e + wn + gn + ne + sd + r + n + u + e, 1, l + Mt + tn + Qe + ie + mo + xp + r + n + Z + e, 1, l + ql + en + pt + ie + mo + Zy + r + n + Z + e, 1, l + Ul + nn + N + ie + mo + Xy + r + n + Z + e, 1, l + Gd + ei + $ + Xi + Go + No + r + n + u + e, 1, l + Vt + Qr + tt + Xi + Go + hn + r + n + u + e, 1, l + ae + Dd + fl + Zn + at + _ + r + n + u + e, 1, l + ni + ri + Fr + lt + at + _ + r + n + u + e, 1, l + ai + ii + qr + Ue + S + _ + r + n + u + e, 1, l + ch + nf + ut + Ue + S + _ + r + n + u + e, 1, l + oi + si + U_ + Ue + S + _ + r + n + u + e, 1, lo + " +lat_0=47.25" + oy + Bg + _a + Il + ep + jo + i + e, 4, a + f + Ty + k + hr + _ + ep + jo + i + e, 1, a + f + By + k + wa + _ + ep + jo + i + e, 13, a + f + " +lon_0=109" + _t + p + Rt + C + jn + i + e, 1, a + f + " +lon_0=116" + _t + p + Rt + v + i + e, 1, a + f + kl + _t + p + Rt + v + i + e, 1, a + f + xw + _t + p + _ + v + i + e, 1, h + Ph + I + i + e, 1, h + Ph + I + i + e, 1, Nn + ab + Bv + " +x_0=86501.46392052001" + kC + ka + Ma + Xl + qc + e, 1, h + bs + F + m + Fe + i + e, 1, h + Qo + F + m + Fe + i + e, 1, l + " +lat_1=9 +lat_2=3 +lat_0=6" + np + ke + ot + m + kt + i + e, 1, l + " +lat_1=17 +lat_2=33 +lat_0=25.08951" + Lg + H + _ + m + Dn + i + e, 1, a + f + es + " +k=1" + p + _ + m + Q + i + e, 1, a + f + cl + " +k=1" + p + _ + m + Q + i + e, 1, a + f + Hs + " +k=1" + p + _ + m + Q + i + e, 1, a + f + B_ + " +k=1" + p + _ + m + Q + i + e, 1, a + f + Zu + " +k=1" + p + _ + m + Q + i + e, 1, a + f + Q_ + " +k=1" + p + _ + m + Q + i + e, 1, a + f + eh + " +k=1" + p + _ + m + Q + i + e, 1, a + ib + ob + " +k=1 +x_0=836694.05 +y_0=819069.8" + m + ph + i + e, 1, a + f + ns + " +k=1" + ss + _ + Ut + O + i + e, 1, a + f + rs + " +k=1" + Po + _ + Ut + O + i + e, 1, a + f + ys + " +k=1" + Gs + _ + Ut + O + i + e, 1, a + f + as + " +k=1" + Ds + _ + Ut + O + i + e, 1, a + f + is + " +k=1" + Ol + _ + Ut + O + i + e, 1, a + f + ia + " +k=1" + js + _ + Ut + O + i + e, 1, a + f + Qi + " +k=1" + Ns + _ + Ut + O + i + e, 1, a + f + Ai + " +k=1" + ls + _ + Ut + O + i + e, 1, a + f + Gi + " +k=1" + Rs + _ + Ut + O + i + e, 1, a + f + ba + " +k=1" + hs + _ + Ut + O + i + e, 1, a + f + Ii + " +k=1" + Ls + _ + Ut + O + i + e, 1, a + f + ns + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + rs + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + ys + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + as + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + is + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + ia + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + Qi + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + Ai + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + Gi + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + ba + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + Ii + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + ns + " +k=1" + Ps + _ + Ut + O + i + e, 1, a + f + wc + " +k=1" + Ts + _ + Ut + O + i + e, 1, a + f + rs + " +k=1" + Bs + _ + Ut + O + i + e, 1, a + f + ud + " +k=1" + Qs + _ + Ut + O + i + e, 1, a + f + ys + " +k=1" + To + _ + Ut + O + i + e, 1, a + f + Is + " +k=1" + al + _ + Ut + O + i + e, 1, a + f + as + " +k=1" + go + _ + Ut + O + i + e, 1, a + f + df + " +k=1" + il + _ + Ut + O + i + e, 1, a + f + is + " +k=1" + jl + _ + Ut + O + i + e, 1, a + f + mh + " +k=1" + wf + _ + Ut + O + i + e, 1, a + f + ia + " +k=1" + Cf + _ + Ut + O + i + e, 1, a + f + hc + " +k=1" + Ef + _ + Ut + O + i + e, 1, a + f + Qi + " +k=1" + Sf + _ + Ut + O + i + e, 1, a + f + Ml + " +k=1" + Af + _ + Ut + O + i + e, 1, a + f + Ai + " +k=1" + If + _ + Ut + O + i + e, 1, a + f + Qh + " +k=1" + Of + _ + Ut + O + i + e, 1, a + f + Gi + " +k=1" + jf + _ + Ut + O + i + e, 1, a + f + vh + " +k=1" + s_ + _ + Ut + O + i + e, 1, a + f + ba + " +k=1" + Nf + _ + Ut + O + i + e, 1, a + f + kl + " +k=1" + l_ + _ + Ut + O + i + e, 1, a + f + Ii + " +k=1" + Gf + _ + Ut + O + i + e, 1, a + f + ns + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + wc + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + rs + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + ud + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + ys + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + Is + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + as + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + df + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + is + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + mh + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + ia + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + hc + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + Qi + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + Ml + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + Ai + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + Qh + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + Gi + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + vh + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + ba + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + kl + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + Ii + " +k=1" + p + _ + Ut + O + i + e, 1, a + f + Eo + " +k=1" + xt + _ + m + zt + i + e, 1, a + f + Xs + " +k=1" + On + _ + m + zt + i + e, 1, a + f + es + " +k=1" + Pe + _ + m + zt + i + e, 1, a + f + cl + " +k=1" + hr + _ + m + zt + i + e, 1, a + f + eh + " +k=1" + Wc + _ + d + Qf + i + e, 1, a + f + z_ + " +k=1" + Vc + _ + d + Qf + i + e, 1, a + f + Lh + " +k=1" + Pe + _ + d + qt + i + e, 1, a + f + Zs + " +k=1" + hr + _ + d + qt + i + e, 1, a + f + wo + " +k=1" + wa + _ + d + qt + i + e, 2, a + f + ns + " +k=1" + Ps + _ + d + b + i + e, 1, a + f + wc + " +k=1" + Ts + _ + d + b + i + e, 1, a + f + rs + " +k=1" + Bs + _ + d + b + i + e, 1, a + f + ud + " +k=1" + Qs + _ + d + b + i + e, 1, a + f + ys + " +k=1" + To + _ + d + b + i + e, 1, a + f + Is + " +k=1" + al + _ + d + b + i + e, 1, a + f + as + " +k=1" + go + _ + d + b + i + e, 1, a + f + df + " +k=1" + il + _ + d + b + i + e, 1, a + f + is + " +k=1" + jl + _ + d + b + i + e, 1, a + f + mh + " +k=1" + wf + _ + d + b + i + e, 1, a + f + ia + " +k=1" + Cf + _ + d + b + i + e, 1, a + f + hc + " +k=1" + Ef + _ + d + b + i + e, 1, a + f + Qi + " +k=1" + Sf + _ + d + b + i + e, 1, a + f + Ml + " +k=1" + Af + _ + d + b + i + e, 1, a + f + Ai + " +k=1" + If + _ + d + b + i + e, 1, a + f + Qh + " +k=1" + Of + _ + d + b + i + e, 1, a + f + Gi + " +k=1" + jf + _ + d + b + i + e, 1, a + f + vh + " +k=1" + s_ + _ + d + b + i + e, 1, a + f + ba + " +k=1" + Nf + _ + d + b + i + e, 1, a + f + kl + " +k=1" + l_ + _ + d + b + i + e, 1, a + f + Ii + " +k=1" + Gf + _ + d + b + i + e, 1, a + f + ns + " +k=1" + p + _ + d + b + i + e, 1, a + f + wc + " +k=1" + p + _ + d + b + i + e, 1, a + f + rs + " +k=1" + p + _ + d + b + i + e, 1, a + f + ud + " +k=1" + p + _ + d + b + i + e, 1, a + f + ys + " +k=1" + p + _ + d + b + i + e, 1, a + f + Is + " +k=1" + p + _ + d + b + i + e, 1, a + f + as + " +k=1" + p + _ + d + b + i + e, 1, a + f + df + " +k=1" + p + _ + d + b + i + e, 1, a + f + is + " +k=1" + p + _ + d + b + i + e, 1, a + f + mh + " +k=1" + p + _ + d + b + i + e, 1, a + f + ia + " +k=1" + p + _ + d + b + i + e, 1, a + f + hc + " +k=1" + p + _ + d + b + i + e, 1, a + f + Qi + " +k=1" + p + _ + d + b + i + e, 1, a + f + Ml + " +k=1" + p + _ + d + b + i + e, 1, a + f + Ai + " +k=1" + p + _ + d + b + i + e, 1, a + f + Qh + " +k=1" + p + _ + d + b + i + e, 1, a + f + Gi + " +k=1" + p + _ + d + b + i + e, 1, a + f + vh + " +k=1" + p + _ + d + b + i + e, 1, a + f + ba + " +k=1" + p + _ + d + b + i + e, 1, a + f + kl + " +k=1" + p + _ + d + b + i + e, 1, a + f + Ii + " +k=1" + p + _ + d + b + i + e, 1, a + H_ + rC + k + H + _ + r + n + i + e, 1, a + H_ + $f + k + H + _ + r + n + i + e, 1, a + to + M_ + k + H + _ + r + n + i + e, 1, a + H_ + tv + k + H + _ + r + n + i + e, 1, a + to + w_ + k + H + _ + r + n + i + e, 1, a + to + yg + k + H + _ + r + n + i + e, 1, a + to + C_ + k + H + _ + r + n + i + e, 1, a + to + aC + k + H + _ + r + n + i + e, 1, a + to + E_ + k + H + _ + r + n + i + e, 1, a + Di + S_ + k + H + _ + r + n + i + e, 1, a + ul + dw + k + H + _ + r + n + i + e, 1, a + ul + _w + k + H + _ + r + n + i + e, 1, a + ul + pw + k + H + _ + r + n + i + e, 1, a + el + " +lon_0=142" + k + H + _ + r + n + i + e, 1, a + el + sp + k + H + _ + r + n + i + e, 1, a + el + " +lon_0=124" + k + H + _ + r + n + i + e, 1, a + el + $f + k + H + _ + r + n + i + e, 1, a + " +lat_0=20" + yg + k + H + _ + r + n + i + e, 1, a + el + Mw + k + H + _ + r + n + i + e, 1, a + f + Eo + " +k=1" + hr + _ + d + i + e, 1, a + f + Eo + " +k=1" + p + _ + d + s + i + e, 1, a + f + es + " +k=1" + p + _ + d + s + i + e, 1, a + f + Hs + " +k=1" + p + _ + d + s + i + e, 1, a + f + Zu + " +k=1" + p + _ + d + s + i + e, 1, a + f + eh + " +k=1" + p + _ + d + s + i + e, 1, a + f + z_ + " +k=1" + p + _ + d + s + i + e, 1, a + f + Gy + " +k=1" + p + _ + d + s + i + e, 1, a + f + Zp + " +k=1" + p + _ + d + s + i + e, 1, a + f + Dy + " +k=1" + p + _ + d + s + i + e, 1, a + f + ns + " +k=1" + p + _ + d + s + i + e, 1, a + f + rs + " +k=1" + p + _ + d + s + i + e, 1, a + f + ys + " +k=1" + p + _ + d + s + i + e, 1, a + f + as + " +k=1" + p + _ + d + s + i + e, 1, a + f + is + " +k=1" + p + _ + d + s + i + e, 1, a + f + ia + " +k=1" + p + _ + d + s + i + e, 1, a + f + Qi + " +k=1" + p + _ + d + s + i + e, 1, a + f + Ai + " +k=1" + p + _ + d + s + i + e, 1, a + f + Gi + " +k=1" + p + _ + d + s + i + e, 1, a + f + ba + " +k=1" + p + _ + d + s + i + e, 1, a + f + Ii + " +k=1" + p + _ + d + s + i + e, 1, a + f + rp + " +k=1" + p + _ + d + s + i + e, 1, a + f + r_ + " +k=1" + p + _ + d + s + i + e, 1, a + f + td + " +k=1" + p + _ + d + s + i + e, 1, a + f + ap + " +k=1" + p + _ + d + s + i + e, 1, a + f + ed + " +k=1" + p + _ + d + s + i + e, 1, a + f + uc + " +k=1" + p + _ + d + s + i + e, 1, a + f + Fh + " +k=1" + p + _ + d + s + i + e, 1, a + f + qh + " +k=1" + p + _ + d + s + i + e, 1, a + f + fc + " +k=1" + p + _ + d + s + i + e, 3, a + f + Eo + " +k=1" + p + _ + d + o + i + e, 1, a + f + es + " +k=1" + p + _ + d + o + i + e, 1, a + f + Hs + " +k=1" + p + _ + d + o + i + e, 1, a + f + Zu + " +k=1" + p + _ + d + o + i + e, 1, a + f + eh + " +k=1" + p + _ + d + o + i + e, 1, a + f + z_ + " +k=1" + p + _ + d + o + i + e, 1, a + f + Gy + " +k=1" + p + _ + d + o + i + e, 1, a + f + Zp + " +k=1" + p + _ + d + o + i + e, 1, a + f + Dy + " +k=1" + p + _ + d + o + i + e, 1, a + f + ns + " +k=1" + p + _ + d + o + i + e, 1, a + f + rs + " +k=1" + p + _ + d + o + i + e, 1, a + f + ys + " +k=1" + p + _ + d + o + i + e, 1, a + f + as + " +k=1" + p + _ + d + o + i + e, 1, a + f + is + " +k=1" + p + _ + d + o + i + e, 1, a + f + ia + " +k=1" + p + _ + d + o + i + e, 1, a + f + Qi + " +k=1" + p + _ + d + o + i + e, 1, a + f + Ai + " +k=1" + p + _ + d + o + i + e, 1, a + f + Gi + " +k=1" + p + _ + d + o + i + e, 1, a + f + ba + " +k=1" + p + _ + d + o + i + e, 1, a + f + Ii + " +k=1" + p + _ + d + o + i + e, 1, a + f + rp + " +k=1" + p + _ + d + o + i + e, 1, a + f + r_ + " +k=1" + p + _ + d + o + i + e, 1, a + f + td + " +k=1" + p + _ + d + o + i + e, 1, a + f + ap + " +k=1" + p + _ + d + o + i + e, 1, a + f + ed + " +k=1" + p + _ + d + o + i + e, 1, a + f + uc + " +k=1" + p + _ + d + o + i + e, 1, a + f + Fh + " +k=1" + p + _ + d + o + i + e, 1, a + f + qh + " +k=1" + p + _ + d + o + i + e, 1, a + f + fc + " +k=1" + p + _ + d + o + i + e, 1, a + f + Eo + " +k=1" + Ys + _ + d + o + i + e, 1, a + f + Xs + " +k=1" + Wc + _ + d + o + i + e, 1, a + f + es + " +k=1" + Vc + _ + d + o + i + e, 1, a + f + cl + " +k=1" + rc + _ + d + o + i + e, 1, a + f + Hs + " +k=1" + wh + _ + d + o + i + e, 1, a + f + B_ + " +k=1" + ac + _ + d + o + i + e, 1, a + f + Zu + " +k=1" + ss + _ + d + o + i + e, 1, a + f + Q_ + " +k=1" + Po + _ + d + o + i + e, 1, a + f + eh + " +k=1" + Gs + _ + d + o + i + e, 1, a + f + Lg + " +k=1" + Ds + _ + d + o + i + e, 1, a + f + z_ + " +k=1" + Ol + _ + d + o + i + e, 1, a + f + Pg + " +k=1" + js + _ + d + o + i + e, 1, a + f + Gy + " +k=1" + Ns + _ + d + o + i + e, 1, a + f + " +lon_0=60 +k=1" + ls + _ + d + o + i + e, 1, a + f + Zp + " +k=1" + Rs + _ + d + o + i + e, 1, a + f + Mv + " +k=1" + hs + _ + d + o + i + e, 1, a + f + Dy + " +k=1" + Ls + _ + d + o + i + e, 1, a + f + $M + " +k=1" + ic + _ + d + o + i + e, 1, a + f + ns + " +k=1" + Ps + _ + d + o + i + e, 1, a + f + wc + " +k=1" + Ts + _ + d + o + i + e, 1, a + f + rs + " +k=1" + Bs + _ + d + o + i + e, 1, a + f + ud + " +k=1" + Qs + _ + d + o + i + e, 1, a + f + ys + " +k=1" + To + _ + d + o + i + e, 1, a + f + Is + " +k=1" + al + _ + d + o + i + e, 1, a + f + as + " +k=1" + go + _ + d + o + i + e, 1, a + f + df + " +k=1" + il + _ + d + o + i + e, 1, a + f + is + " +k=1" + jl + _ + d + o + i + e, 2, a + f + mh + " +k=1" + wf + _ + d + o + i + e, 1, a + f + ia + " +k=1" + Cf + _ + d + o + i + e, 1, a + f + hc + " +k=1" + Ef + _ + d + o + i + e, 1, a + f + Qi + " +k=1" + Sf + _ + d + o + i + e, 1, a + f + Ml + " +k=1" + Af + _ + d + o + i + e, 1, a + f + Ai + " +k=1" + If + _ + d + o + i + e, 1, a + f + Qh + " +k=1" + Of + _ + d + o + i + e, 1, a + f + Gi + " +k=1" + jf + _ + d + o + i + e, 1, a + f + vh + " +k=1" + s_ + _ + d + o + i + e, 1, a + f + ba + " +k=1" + Nf + _ + d + o + i + e, 1, a + f + kl + " +k=1" + l_ + _ + d + o + i + e, 1, a + f + Ii + " +k=1" + Gf + _ + d + o + i + e, 1, a + f + gg + " +k=1 +x_0=46500000" + _ + d + o + i + e, 1, a + f + rp + " +k=1" + yw + _ + d + o + i + e, 1, a + f + Iv + " +k=1 +x_0=48500000" + _ + d + o + i + e, 1, a + f + r_ + " +k=1 +x_0=49500000" + _ + d + o + i + e, 1, a + f + a_ + " +k=1 +x_0=50500000" + _ + d + o + i + e, 1, a + f + td + " +k=1 +x_0=51500000" + _ + d + o + i + e, 1, a + f + ww + " +k=1 +x_0=52500000" + _ + d + o + i + e, 1, a + f + ap + " +k=1 +x_0=53500000" + _ + d + o + i + e, 1, a + f + sy + " +k=1 +x_0=54500000" + _ + d + o + i + e, 1, a + f + ed + " +k=1 +x_0=55500000" + _ + d + o + i + e, 1, a + f + Ov + " +k=1 +x_0=56500000" + _ + d + o + i + e, 1, a + f + uc + " +k=1 +x_0=57500000" + _ + d + o + i + e, 1, a + f + jv + " +k=1 +x_0=58500000" + _ + d + o + i + e, 1, a + f + Fh + " +k=1 +x_0=59500000" + _ + d + o + i + e, 2, a + f + qh + " +k=1 +x_0=61500000" + _ + d + o + i + e, 1, a + f + Qg + " +k=1 +x_0=62500000" + _ + d + o + i + e, 1, a + f + fc + " +k=1 +x_0=63500000" + _ + d + o + i + e, 1, a + f + Fg + " +k=1 +x_0=64500000" + _ + d + o + i + e, 1, a + f + Eo + " +k=1" + p + _ + d + o + i + e, 1, a + f + Xs + " +k=1" + p + _ + d + o + i + e, 1, a + f + es + " +k=1" + p + _ + d + o + i + e, 1, a + f + cl + " +k=1" + p + _ + d + o + i + e, 1, a + f + Hs + " +k=1" + p + _ + d + o + i + e, 1, a + f + B_ + " +k=1" + p + _ + d + o + i + e, 1, a + f + Zu + " +k=1" + p + _ + d + o + i + e, 1, a + f + Q_ + " +k=1" + p + _ + d + o + i + e, 1, a + f + eh + " +k=1" + p + _ + d + o + i + e, 1, a + f + Lg + " +k=1" + p + _ + d + o + i + e, 1, a + f + z_ + " +k=1" + p + _ + d + o + i + e, 1, a + f + Pg + " +k=1" + p + _ + d + o + i + e, 1, a + f + Gy + " +k=1" + p + _ + d + o + i + e, 1, a + f + " +lon_0=60 +k=1" + p + _ + d + o + i + e, 1, a + f + Zp + " +k=1" + p + _ + d + o + i + e, 1, a + f + Mv + " +k=1" + p + _ + d + o + i + e, 1, a + f + Dy + " +k=1" + p + _ + d + o + i + e, 1, a + f + $M + " +k=1" + p + _ + d + o + i + e, 2, a + f + ns + " +k=1" + p + _ + d + o + i + e, 1, a + f + wc + " +k=1" + p + _ + d + o + i + e, 1, a + f + rs + " +k=1" + p + _ + d + o + i + e, 1, a + f + ud + " +k=1" + p + _ + d + o + i + e, 1, a + f + ys + " +k=1" + p + _ + d + o + i + e, 1, a + f + Is + " +k=1" + p + _ + d + o + i + e, 1, a + f + as + " +k=1" + p + _ + d + o + i + e, 1, a + f + df + " +k=1" + p + _ + d + o + i + e, 1, a + f + is + " +k=1" + p + _ + d + o + i + e, 1, a + f + mh + " +k=1" + p + _ + d + o + i + e, 1, a + f + ia + " +k=1" + p + _ + d + o + i + e, 1, a + f + hc + " +k=1" + p + _ + d + o + i + e, 1, a + f + Qi + " +k=1" + p + _ + d + o + i + e, 1, a + f + Ml + " +k=1" + p + _ + d + o + i + e, 1, a + f + Ai + " +k=1" + p + _ + d + o + i + e, 1, a + f + Qh + " +k=1" + p + _ + d + o + i + e, 1, a + f + Gi + " +k=1" + p + _ + d + o + i + e, 1, a + f + vh + " +k=1" + p + _ + d + o + i + e, 1, a + f + ba + " +k=1" + p + _ + d + o + i + e, 1, a + f + kl + " +k=1" + p + _ + d + o + i + e, 1, a + f + Ii + " +k=1" + p + _ + d + o + i + e, 1, a + f + gg + " +k=1" + p + _ + d + o + i + e, 1, a + f + rp + " +k=1" + p + _ + d + o + i + e, 1, a + f + Iv + " +k=1" + p + _ + d + o + i + e, 1, a + f + r_ + " +k=1" + p + _ + d + o + i + e, 1, a + f + a_ + " +k=1" + p + _ + d + o + i + e, 1, a + f + td + " +k=1" + p + _ + d + o + i + e, 1, a + f + ww + " +k=1" + p + _ + d + o + i + e, 1, a + f + ap + " +k=1" + p + _ + d + o + i + e, 1, a + f + sy + " +k=1" + p + _ + d + o + i + e, 1, a + f + ed + " +k=1" + p + _ + d + o + i + e, 1, a + f + Ov + " +k=1" + p + _ + d + o + i + e, 1, a + f + uc + " +k=1" + p + _ + d + o + i + e, 1, a + f + jv + " +k=1" + p + _ + d + o + i + e, 1, a + f + Fh + " +k=1" + p + _ + d + o + i + e, 1, a + f + mg + " +k=1" + p + _ + d + o + i + e, 1, a + f + qh + " +k=1" + p + _ + d + o + i + e, 1, a + f + Qg + " +k=1" + p + _ + d + o + i + e, 1, a + f + fc + " +k=1" + p + _ + d + o + i + e, 1, a + f + Fg + " +k=1" + p + _ + d + o + i + e, 1, a + f + Eo + " +k=1" + Ys + _ + d + s + i + e, 1, a + f + Xs + " +k=1" + Wc + _ + d + s + i + e, 1, a + f + es + " +k=1" + Vc + _ + d + s + i + e, 1, a + f + cl + " +k=1" + rc + _ + d + s + i + e, 1, a + f + Hs + " +k=1" + wh + _ + d + s + i + e, 1, a + f + B_ + " +k=1" + ac + _ + d + s + i + e, 1, a + f + Zu + " +k=1" + ss + _ + d + s + i + e, 1, a + f + Q_ + " +k=1" + Po + _ + d + s + i + e, 1, a + f + eh + " +k=1" + Gs + _ + d + s + i + e, 1, a + f + Lg + " +k=1" + Ds + _ + d + s + i + e, 1, a + f + z_ + " +k=1" + Ol + _ + d + s + i + e, 1, a + f + Pg + " +k=1" + js + _ + d + s + i + e, 1, a + f + Gy + " +k=1" + Ns + _ + d + s + i + e, 1, a + f + " +lon_0=60 +k=1" + ls + _ + d + s + i + e, 1, a + f + Zp + " +k=1" + Rs + _ + d + s + i + e, 1, a + f + Mv + " +k=1" + hs + _ + d + s + i + e, 1, a + f + Dy + " +k=1" + Ls + _ + d + s + i + e, 1, a + f + $M + " +k=1" + ic + _ + d + s + i + e, 1, a + f + ns + " +k=1" + Ps + _ + d + s + i + e, 1, a + f + wc + " +k=1" + Ts + _ + d + s + i + e, 1, a + f + rs + " +k=1" + Bs + _ + d + s + i + e, 1, a + f + ud + " +k=1" + Qs + _ + d + s + i + e, 1, a + f + ys + " +k=1" + To + _ + d + s + i + e, 1, a + f + Is + " +k=1" + al + _ + d + s + i + e, 1, a + f + as + " +k=1" + go + _ + d + s + i + e, 1, a + f + df + " +k=1" + il + _ + d + s + i + e, 1, a + f + is + " +k=1" + jl + _ + d + s + i + e, 1, a + f + mh + " +k=1" + wf + _ + d + s + i + e, 1, a + f + ia + " +k=1" + Cf + _ + d + s + i + e, 1, a + f + hc + " +k=1" + Ef + _ + d + s + i + e, 1, a + f + Qi + " +k=1" + Sf + _ + d + s + i + e, 1, a + f + Ml + " +k=1" + Af + _ + d + s + i + e, 1, a + f + Ai + " +k=1" + If + _ + d + s + i + e, 1, a + f + Qh + " +k=1" + Of + _ + d + s + i + e, 1, a + f + Gi + " +k=1" + jf + _ + d + s + i + e, 1, a + f + vh + " +k=1" + s_ + _ + d + s + i + e, 1, a + f + ba + " +k=1" + Nf + _ + d + s + i + e, 1, a + f + kl + " +k=1" + l_ + _ + d + s + i + e, 1, a + f + Ii + " +k=1" + Gf + _ + d + s + i + e, 1, a + f + gg + " +k=1 +x_0=46500000" + _ + d + s + i + e, 1, a + f + rp + " +k=1" + yw + _ + d + s + i + e, 1, a + f + Iv + " +k=1 +x_0=48500000" + _ + d + s + i + e, 1, a + f + r_ + " +k=1 +x_0=49500000" + _ + d + s + i + e, 1, a + f + a_ + " +k=1 +x_0=50500000" + _ + d + s + i + e, 1, a + f + td + " +k=1 +x_0=51500000" + _ + d + s + i + e, 1, a + f + ww + " +k=1 +x_0=52500000" + _ + d + s + i + e, 1, a + f + ap + " +k=1 +x_0=53500000" + _ + d + s + i + e, 1, a + f + sy + " +k=1 +x_0=54500000" + _ + d + s + i + e, 1, a + f + ed + " +k=1 +x_0=55500000" + _ + d + s + i + e, 1, a + f + Ov + " +k=1 +x_0=56500000" + _ + d + s + i + e, 1, a + f + uc + " +k=1 +x_0=57500000" + _ + d + s + i + e, 1, a + f + jv + " +k=1 +x_0=58500000" + _ + d + s + i + e, 1, a + f + Fh + " +k=1 +x_0=59500000" + _ + d + s + i + e, 2, a + f + qh + " +k=1 +x_0=61500000" + _ + d + s + i + e, 1, a + f + Qg + " +k=1 +x_0=62500000" + _ + d + s + i + e, 1, a + f + fc + " +k=1 +x_0=63500000" + _ + d + s + i + e, 1, a + f + Fg + " +k=1 +x_0=64500000" + _ + d + s + i + e, 1, a + f + Eo + " +k=1" + p + _ + d + s + i + e, 1, a + f + Xs + " +k=1" + p + _ + d + s + i + e, 1, a + f + es + " +k=1" + p + _ + d + s + i + e, 1, a + f + cl + " +k=1" + p + _ + d + s + i + e, 1, a + f + Hs + " +k=1" + p + _ + d + s + i + e, 1, a + f + B_ + " +k=1" + p + _ + d + s + i + e, 1, a + f + Zu + " +k=1" + p + _ + d + s + i + e, 1, a + f + Q_ + " +k=1" + p + _ + d + s + i + e, 1, a + f + eh + " +k=1" + p + _ + d + s + i + e, 1, a + f + Lg + " +k=1" + p + _ + d + s + i + e, 1, a + f + z_ + " +k=1" + p + _ + d + s + i + e, 1, a + f + Pg + " +k=1" + p + _ + d + s + i + e, 1, a + f + Gy + " +k=1" + p + _ + d + s + i + e, 1, a + f + " +lon_0=60 +k=1" + p + _ + d + s + i + e, 1, a + f + Zp + " +k=1" + p + _ + d + s + i + e, 1, a + f + Mv + " +k=1" + p + _ + d + s + i + e, 1, a + f + Dy + " +k=1" + p + _ + d + s + i + e, 1, a + f + $M + " +k=1" + p + _ + d + s + i + e, 1, a + f + ns + " +k=1" + p + _ + d + s + i + e, 1, a + f + wc + " +k=1" + p + _ + d + s + i + e, 1, a + f + rs + " +k=1" + p + _ + d + s + i + e, 1, a + f + ud + " +k=1" + p + _ + d + s + i + e, 1, a + f + ys + " +k=1" + p + _ + d + s + i + e, 1, a + f + Is + " +k=1" + p + _ + d + s + i + e, 1, a + f + as + " +k=1" + p + _ + d + s + i + e, 1, a + f + df + " +k=1" + p + _ + d + s + i + e, 1, a + f + is + " +k=1" + p + _ + d + s + i + e, 1, a + f + mh + " +k=1" + p + _ + d + s + i + e, 1, a + f + ia + " +k=1" + p + _ + d + s + i + e, 1, a + f + hc + " +k=1" + p + _ + d + s + i + e, 1, a + f + Qi + " +k=1" + p + _ + d + s + i + e, 1, a + f + Ml + " +k=1" + p + _ + d + s + i + e, 1, a + f + Ai + " +k=1" + p + _ + d + s + i + e, 1, a + f + Qh + " +k=1" + p + _ + d + s + i + e, 1, a + f + Gi + " +k=1" + p + _ + d + s + i + e, 1, a + f + vh + " +k=1" + p + _ + d + s + i + e, 1, a + f + ba + " +k=1" + p + _ + d + s + i + e, 1, h + hf + F + R + Zo + i + e, 1, h + Th + F + R + Zo + i + e, 1, a + f + kl + " +k=1" + p + _ + d + s + i + e, 1, a + f + Ii + " +k=1" + p + _ + d + s + i + e, 1, a + f + gg + " +k=1" + p + _ + d + s + i + e, 1, a + f + rp + " +k=1" + p + _ + d + s + i + e, 1, a + f + Iv + " +k=1" + p + _ + d + s + i + e, 1, a + f + r_ + " +k=1" + p + _ + d + s + i + e, 1, a + f + a_ + " +k=1" + p + _ + d + s + i + e, 1, a + f + td + " +k=1" + p + _ + d + s + i + e, 1, a + f + ww + " +k=1" + p + _ + d + s + i + e, 1, a + f + ap + " +k=1" + p + _ + d + s + i + e, 1, a + f + sy + " +k=1" + p + _ + d + s + i + e, 1, a + f + ed + " +k=1" + p + _ + d + s + i + e, 1, a + f + Ov + " +k=1" + p + _ + d + s + i + e, 1, a + f + uc + " +k=1" + p + _ + d + s + i + e, 1, a + f + jv + " +k=1" + p + _ + d + s + i + e, 1, a + f + Fh + " +k=1" + p + _ + d + s + i + e, 1, a + f + mg + " +k=1" + p + _ + d + s + i + e, 1, a + f + qh + " +k=1" + p + _ + d + s + i + e, 1, a + f + Qg + " +k=1" + p + _ + d + s + i + e, 1, a + f + fc + " +k=1" + p + _ + d + s + i + e, 1, a + f + Fg + " +k=1" + p + _ + d + s + i + e, 1, a + hl + ol + tp + D + _ + r + n + i + e, 1, a + So + Zd + re + S + _ + r + n + i + e, 1, a + De + Rn + k + pa + _ + r + n + i + e, 1, a + De + Ln + k + pa + _ + r + n + i + e, 1, a + De + Nl + re + pa + _ + r + n + i + e, 1, l + Ur + zr + $t + zs + X + _ + r + n + i + e, 1, l + Hr + xf + Zr + zs + X + Il + r + n + i + e, 1, l + yr + kh + Y + Fo + Ee + It + r + n + i + e, 1, l + gr + mr + $ + Fo + Ee + It + r + n + i + e, 1, l + Qt + vr + pf + lt + Ee + It + r + n + i + e, 1, l + Xu + qp + xr + yf + Ee + It + r + n + i + e, 1, l + br + kr + gf + Al + Ee + It + r + n + i + e, 1, l + Mr + wr + Cr + Gl + Ee + It + r + n + i + e, 1, l + Ca + Ea + Y + Me + Ti + Bi + r + n + i + e, 1, l + Ju + Wu + xn + Me + Ti + Bi + r + n + i + e, 1, l + Qt + Er + N + Me + Ti + Bi + r + n + i + e, 1, l + Sr + mf + Ar + Ch + Op + jp + r + n + i + e, 1, a + In + Pn + vf + D + _ + r + n + i + e, 1, a + Ft + dn + Pt + D + _ + r + n + i + e, 1, a + Ft + e_ + Pt + D + _ + r + n + i + e, 1, l + Vu + Ir + Up + Yu + S + _ + r + n + i + e, 1, a + So + Tn + k + D + _ + r + n + i + e, 1, a + So + Bn + k + _a + _ + r + n + i + e, 1, a + xu + Yg + dt + p + _ + r + n + i + e, 1, a + bu + Wh + dt + p + _ + r + n + i + e, 1, a + ho + Uh + xh + p + _ + r + n + i + e, 1, a + ku + Kg + xh + p + _ + r + n + i + e, 1, a + Mu + Vh + " +k=1" + p + _ + r + n + i + e, 1, a + q + Qn + oe + D + _ + r + n + i + e, 1, a + q + uh + oe + p + _ + r + n + i + e, 1, a + q + Dl + re + vn + _ + r + n + i + e, 1, a + N + Xn + la + st + _ + r + n + i + e, 1, a + N + Jn + Pt + _a + _ + r + n + i + e, 1, a + or + Wn + dt + ge + zh + r + n + i + e, 1, a + or + Vn + dt + os + zh + r + n + i + e, 1, l + Xr + Jr + Oi + Ji + xt + ot + r + n + i + e, 1, l + Mt + Wr + Di + Ji + p + _ + r + n + i + e, 1, l + Vr + Yr + pt + Si + X + _ + r + n + i + e, 1, l + Kr + $r + N + gn + X + Il + r + n + i + e, 1, l + Vt + pr + or + Mh + p + _ + r + n + i + e, 1, l + Sa + Aa + tt + ya + p + It + r + n + i + e, 1, l + li + hi + hl + vs + ke + _ + r + n + i + e, 1, l + Rd + Ld + Pd + je + ke + _ + r + n + i + e, 1, a + ht + Vo + k + st + _ + r + n + i + e, 1, a + te + Yn + dt + os + _ + r + n + i + e, 1, l + Yc + Sd + $ + lc + X + _ + r + n + i + e, 1, l + Ia + Or + El + Zi + D + _f + r + n + i + e, 1, l + Oa + ja + El + Vs + p + _ + r + n + i + e, 1, l + Na + Ga + Da + yh + ev + _ + r + n + i + e, 1, l + Ad + Ra + La + ee + lp + _ + r + n + i + e, 1, l + Be + Id + Oi + ee + $u + _ + r + n + i + e, 1, l + ui + ci + Sl + Kn + vn + na + r + n + i + e, 1, l + rf + fi + tl + Sh + vn + na + r + n + i + e, 1, l + di + _i + cd + nd + vn + na + r + n + i + e, 1, a + ks + Fn + cn + st + _ + r + n + i + e, 1, a + ks + Ze + cn + _a + _ + r + n + i + e, 1, a + Cn + Qy + re + ze + _ + r + n + i + e, 1, a + Cn + vs + re + p + _ + r + n + i + e, 1, a + _l + Fy + Pt + uM + _ + r + n + i + e, 1, l + Hu + Ny + Kc + rl + S + _ + r + n + i + e, 1, l + nh + kh + pi + _n + p + _ + r + n + i + e, 1, a + fn + $n + k + D + nv + r + n + i + e, 1, a + fn + tr + k + p + xs + r + n + i + e, 1, a + fn + er + k + vn + tc + r + n + i + e, 1, a + ji + nr + dt + st + _ + r + n + i + e, 1, a + Yt + Oo + k + Le + _ + r + n + i + e, 1, a + De + qn + Cs + Od + _ + r + n + i + e, 1, a + De + Rl + k + p + _ + r + n + i + e, 1, a + De + Un + Ll + cM + _ + r + n + i + e, 1, a + Yt + Oo + k + Le + _ + r + n + i + e, 1, a + Di + zn + At + ze + _ + r + n + i + e, 1, a + Di + Hn + At + uy + _ + r + n + i + e, 1, l + jr + Nr + Kt + n_ + st + _ + r + n + i + e, 1, l + ae + Ba + fl + ga + S + _ + r + n + i + e, 1, l + Qa + Fa + Se + ga + S + _ + r + n + i + e, 1, l + Td + yi + be + ca + S + _ + r + n + i + e, 1, l + gi + mi + In + ca + S + _ + r + n + i + e, 1, l + Gr + qa + zp + Si + S + _ + r + n + i + e, 1, l + Ua + za + Dr + Si + S + _ + r + n + i + e, 1, l + F_ + bn + ht + lt + On + _ + r + n + i + e, 1, l + q_ + kn + q + lt + xt + _ + r + n + i + e, 1, a + ta + Zi + oc + ge + _ + r + n + i + e, 1, l + vi + xi + ut + _n + S + _ + r + n + i + e, 1, l + Bd + bi + ea + jt + S + _ + r + n + i + e, 1, l + Xa + tf + $t + Xc + S + _ + r + n + i + e, 1, l + Ja + ef + Hp + Eh + D + ot + r + n + i + e, 1, l + Wa + Va + Tr + gn + S + Gn + r + n + i + e, 1, l + Ya + Ka + Mn + jt + _a + Ni + r + n + i + e, 1, l + $a + ti + Br + gh + S + tc + r + n + i + e, 1, l + Ke + $e + wn + gn + st + Ih + r + n + i + e, 1, l + Mt + tn + Qe + ie + p + ot + r + n + i + e, 1, l + ql + en + pt + ie + p + Gn + r + n + i + e, 1, l + Ul + nn + N + ie + p + Ni + r + n + i + e, 1, a + ji + ec + Pl + p + _ + r + n + i + e, 1, l + Gd + ei + $ + Xi + Pe + Gn + r + n + i + e, 1, l + Vt + Qr + tt + Xi + Pe + ot + r + n + i + e, 1, l + ae + Dd + fl + Zn + p + _ + r + n + i + e, 1, l + ni + ri + Fr + lt + p + _ + r + n + i + e, 1, l + af + Ry + bf + po + S + _ + r + n + i + e, 1, l + ki + Mi + Xp + dn + S + _ + r + n + i + e, 1, l + ai + ii + qr + Ue + S + _ + r + n + i + e, 1, l + ch + nf + ut + Ue + S + _ + r + n + i + e, 1, l + oi + si + U_ + Ue + S + _ + r + n + i + e, 1, a + We + rr + At + D + _ + r + n + i + e, 1, a + We + ar + At + X + na + r + n + i + e, 1, a + We + Tl + At + S + _ + r + n + i + e, 1, a + We + ir + At + vn + na + r + n + i + e, 1, l + uo + co + fo + qi + D + Ws + r + n + i + e, 1, a + De + Rn + k + pa + _ + r + n + Z + e, 1, a + De + Ln + k + pa + _ + r + n + Z + e, 1, a + De + Nl + re + pa + _ + r + n + Z + e, 1, l + yr + kh + Y + Fo + St + nt + r + n + u + e, 1, l + gr + mr + $ + Fo + St + nt + r + n + u + e, 1, l + Qt + vr + pf + lt + St + nt + r + n + u + e, 1, l + Xu + qp + xr + yf + St + nt + r + n + u + e, 1, l + br + kr + gf + Al + St + nt + r + n + u + e, 1, l + Mr + wr + Cr + Gl + St + nt + r + n + u + e, 1, l + Ca + Ea + Y + Me + He + sn + r + n + u + e, 1, l + Ju + Wu + xn + Me + He + sn + r + n + u + e, 1, l + Qt + Er + N + Me + He + sn + r + n + u + e, 1, l + Sr + mf + Ar + Ch + Gc + Dc + r + n + u + e, 1, a + In + Pn + vf + rt + _ + r + n + u + e, 1, a + Ft + dn + Pt + rt + _ + r + n + u + e, 1, a + Ft + e_ + Pt + rt + _ + r + n + u + e, 1, l + Vu + Ir + Up + Yu + S + _ + r + n + u + e, 1, a + So + Tn + k + rt + _ + r + n + u + e, 1, a + So + Bn + k + ln + _ + r + n + u + e, 1, a + q + Qn + oe + rt + _ + r + n + u + e, 1, a + q + uh + oe + at + _ + r + n + u + e, 1, a + q + Dl + re + Rc + _ + r + n + u + e, 3, l + Vt + pr + or + Mh + at + _ + r + n + u + e, 1, l + Sa + Aa + tt + ya + at + nt + r + n + u + e, 1, l + Yc + Sd + $ + lc + Lc + _ + r + n + u + e, 1, l + Ia + Or + El + Zi + rt + _f + r + n + u + e, 1, l + Oa + ja + El + Vs + at + _ + r + n + u + e, 1, l + Na + Ga + Da + yh + Pc + _ + r + n + Z + e, 1, l + Ad + Ra + La + ee + Tc + _ + r + n + Z + e, 1, l + Be + Id + Oi + ee + Xd + _ + r + n + Z + e, 1, a + ks + Fn + cn + ne + _ + r + n + u + e, 1, a + ks + Ze + cn + ln + _ + r + n + u + e, 1, l + Hu + Ny + Kc + rl + cr + _ + r + n + Z + e, 1, a + De + qn + Cs + Od + _ + r + n + u + e, 1, a + De + Rl + k + at + _ + r + n + u + e, 1, a + De + Un + Ll + Bc + _ + r + n + u + e, 1, a + Yt + Oo + k + Le + _ + r + n + u + e, 1, a + Di + zn + At + Qc + _ + r + n + u + e, 1, a + Di + Hn + At + Fc + _ + r + n + u + e, 1, l + jr + Nr + Kt + n_ + ne + _ + r + n + u + e, 1, l + ae + Ba + fl + ga + cr + _ + r + n + Z + e, 1, l + Qa + Fa + Se + ga + cr + _ + r + n + Z + e, 1, l + Gr + qa + zp + Si + S + _ + r + n + u + e, 1, l + Ua + za + Dr + Si + S + _ + r + n + u + e, 1, l + F_ + bn + ht + lt + Zh + _ + r + n + Z + e, 1, l + q_ + kn + q + lt + Xh + _ + r + n + Z + e, 1, l + Xa + tf + $t + Xc + S + _ + r + n + u + e, 1, l + Ja + ef + Hp + Eh + rt + hn + r + n + u + e, 1, l + Wa + Va + Tr + gn + S + No + r + n + u + e, 1, l + Ya + Ka + Mn + jt + ln + Ni + r + n + u + e, 1, l + $a + ti + Br + gh + S + od + r + n + u + e, 1, l + Ke + $e + wn + gn + ne + sd + r + n + u + e, 1, l + Mt + tn + Qe + ie + mo + xp + r + n + Z + e, 1, l + ql + en + pt + ie + mo + Zy + r + n + Z + e, 1, l + Ul + nn + N + ie + mo + Xy + r + n + Z + e, 1, l + Gd + ei + $ + Xi + Go + No + r + n + u + e, 1, l + Vt + Qr + tt + Xi + Go + hn + r + n + u + e, 1, l + ae + Dd + fl + Zn + at + _ + r + n + u + e, 1, l + ni + ri + Fr + lt + at + _ + r + n + u + e, 1, l + ai + ii + qr + Ue + S + _ + r + n + u + e, 1, l + ch + nf + ut + Ue + S + _ + r + n + u + e, 1, l + oi + si + U_ + Ue + S + _ + r + n + u + e, 1, a + f + " +lon_0=13" + _t + p + _ + vt + ue + ym + i + e, 1, a + " +lat_0=24.45" + sb + xh + D + Ms + m + Gh + i + e, 1, h + Jf + F + C + ms + i + e, 2, a + Yh + " +lon_0=41.53333333333333 +k=1 +x_0=1300000" + _ + d + o + i + e, 1, a + Yh + " +lon_0=44.53333333333333 +k=1" + iC + _ + d + o + i + e, 1, a + Yh + " +lon_0=47.53333333333333 +k=1" + oC + _ + d + o + i + e, 1, a + Yh + " +lon_0=50.53333333333333 +k=1" + sC + _ + d + o + i + e, 1, a + c_ + " +lon_0=50.76666666666667 +k=1" + iC + _ + d + o + i + e, 1, a + c_ + " +lon_0=53.76666666666667 +k=1" + oC + _ + d + o + i + e, 1, a + c_ + " +lon_0=56.76666666666667 +k=1" + sC + _ + d + o + i + e, 1, h + hh + m + wg + i + e, 1, h + hh + m + gm + i + e, 2, a + f + Wm + k + Et + _ + r + n + i + e, 1, a + f + Ty + k + Et + _ + r + n + i + e, 1, a + f + By + k + Et + _ + r + n + i + e, 1, a + f + Vm + k + Et + _ + r + n + i + e, 1, a + f + Vs + k + Et + _ + r + n + i + e, 1, a + f + Ym + k + Et + _ + r + n + i + e, 1, a + f + Km + k + Et + _ + r + n + i + e, 1, a + f + po + k + Et + _ + r + n + i + e, 1, lo + Sl + nC + Bg + On + lC + r + n + i + e, 1, lo + " +lat_0=47.25" + oy + Bg + X + un + r + n + i + e, 1, h + xd + r + n + i + e, 1, h + bd + r + n + i + e, 1, h + kd + r + n + i + e, 1, h + bl + r + n + i + e, 1, h + Fs + r + n + i + e, 1, h + bs + r + n + i + e, 1, h + Qo + r + n + i + e, 1, h + qs + r + n + i + e, 2, dr + " +lat_1=55" + Jp + tw + kf + H + _ + w + u + e, 1, a + or + Wn + dt + Uc + Vi + r + n + u + e, 1, a + or + Vn + dt + os + Vi + r + n + u + e, 1, a + or + Wn + dt + Uc + Vi + r + n + u + e, 1, a + or + Vn + dt + os + Vi + r + n + u + e, 1, h + Qo + m + mm + i + e, 1, h + Qo + m + Cg + i + e, 1, h + Cl + m + Pf + i + e, 1, h + Cl + r + n + i + e, 1, h + Qo + m + Nm + i + e, 2, h + lf + F + r + n + i + e, 1, h + lg + F + m + Gm + i + e, 1, h + Ay + F + m + kc + i + e, 1, h + Iy + F + m + vv + i + e, 2, h + lh + F + m + Eg + i + e, 1, h + jc + F + m + Lp + i + e, 6, h + qs + R + Um + i + e, 1, h + Og + F + m + Sg + i + e, 3, l + nh + ws + Wi + lt + X + _ + r + n + i + e, 1, l + nh + ws + Wi + lt + sc + _ + r + n + Z + e, 1, l + nh + ws + Wi + lt + X + _ + r + n + i + e, 1, l + nh + ws + Wi + lt + sc + _ + r + n + Z + e, 1, h + jc + F + m + _h + i + e, 1, h + jc + F + m + vm + i + e, 1, h + jc + F + m + cu + i + e, 1, h + jc + F + m + Jo + i + e, 1, h + lh + F + m + Ag + i + e, 1, rh + " +lon_0=110" + bw + hp + cy + C + ms + i + e, 1, rh + " +lon_0=110" + bw + hp + cy + C + jn + i + e, 1, rh + " +lon_0=110" + bw + hp + cy + C + fs + i + e, 1, a + f + Lh + _t + xt + _ + m + on + i + e, 1, a + f + wo + _t + " +x_0=2520000" + _ + m + on + i + e, 1, dr + ew + " +lat_2=58.5" + tl + " +lon_0=-126" + ke + _ + r + n + i + e, 1, h + Ph + r + n + i + e, 1, a + f + Zs + " +k=1" + Le + _ + r + n + i + e, 1, a + f + " +lon_0=13.5 +k=1" + Le + _ + r + n + i + e, 1, a + f + wo + " +k=1" + Le + _ + r + n + i + e, 1, a + f + fM + " +k=1" + Le + _ + r + n + i + e, 1, a + f + Fp + " +k=1" + Le + _ + r + n + i + e, 1, a + f + " +lon_0=14.25 +k=1" + Le + _ + r + n + i + e, 1, a + f + " +lon_0=15.75 +k=1" + Le + _ + r + n + i + e, 1, a + f + " +lon_0=17.25 +k=1" + Le + _ + r + n + i + e, 1, a + f + " +lon_0=18.75 +k=1" + Le + _ + r + n + i + e, 1, a + f + " +lon_0=20.25 +k=1" + Le + _ + r + n + i + e, 1, a + f + " +lon_0=21.75 +k=1" + Le + _ + r + n + i + e, 1, a + f + " +lon_0=23.25 +k=1" + Le + _ + r + n + i + e, 1, a + f + lb + " +k=1" + xt + _ + C + ve + i + e, 1, a + f + hb + " +k=1" + xt + _ + C + ve + i + e, 1, a + f + ub + " +k=1" + xt + _ + C + ve + i + e, 1, a + f + cb + " +k=1" + xt + _ + C + ve + i + e, 1, a + f + fb + " +k=1" + xt + _ + C + ve + i + e, 1, a + f + db + " +k=1" + xt + _ + C + ve + i + e, 1, a + f + lb + " +k=1" + xt + _ + C + i + e, 1, a + f + hb + " +k=1" + xt + _ + C + i + e, 1, a + f + ub + " +k=1" + xt + _ + C + i + e, 1, a + f + cb + " +k=1" + xt + _ + C + i + e, 1, a + f + fb + " +k=1" + xt + _ + C + i + e, 1, a + f + db + " +k=1" + xt + _ + C + i + e, 1, fe + B + " +lat_ts=-71" + ts + " +k=1" + H + _ + v + i + e, 1, fe + B + " +lat_ts=-71 +lon_0=70 +k=1" + lp + xs + v + i + e, 1, l + " +lat_1=-68.5 +lat_2=-74.5 +lat_0=-50 +lon_0=70" + lp + xs + v + i + e, 1, l + nw + Jp + Z_ + Cc + $u + qy + r + n + i + e, 1, gs + Z_ + Cc + Uy + zy + r + n + i + e, 1, h + hf + F + L + Kh + i + e, 1, h + Th + F + L + Kh + i + e, 3, h + hh + r + n + i + e, 1, h + Rh + r + n + i + e, 1, h + y_ + r + n + i + e, 1, h + Sp + r + n + i + e, 1, h + Vl + r + n + i + e, 1, h + Ph + r + n + i + e, 1, h + Xf + r + n + i + e, 1, h + pu + r + n + i + e, 1, h + hf + r + n + i + e, 1, h + Th + r + n + i + e, 5, h + m_ + m + fh + i + e, 1, h + jg + m + fh + i + e, 1, h + hh + m + fh + i + e, 1, l + " +lat_1=64.25 +lat_2=65.75 +lat_0=65 +lon_0=-19" + p + It + r + n + i + e, 1, a + f + " +lon_0=-8.5 +k=1" + bh + " +y_0=-7800000" + m + Dh + i + e, 1, a + f + Xs + _t + p + " +y_0=-6000000" + r + n + i + e, 1, h + jc + F + m + Kp + i + e, 1, h + hh + m + D_ + i + e, 1, h + m_ + m + gp + i + e, 1, h + m_ + m + K_ + i + e, 1, h + Vl + L + n + i + e, 1, h + Ph + L + n + i + e, 1, a + f + " +lon_0=37" + kv + p + gw + m + Q + i + e, 1, h + pu + r + n + i + e, 1, Nn + " +lat_0=52.41864827777778 +lon_0=13.62720366666667" + i_ + " +y_0=10000" + C + et + i + e, 1, a + f + Ue + _t + p + " +y_0=-4500000" + w + i + e, 1, a + f + Ue + _t + dM + $g + r + n + i + e, 1, a + f + Ue + _t + dM + $g + r + n + i + e, 1, a + ut + $y + Fl + _a + _ + r + n + i + e, 2, a + te + tg + Fl + st + _ + r + n + i + e, 1, a + ut + $y + Fl + _a + _ + r + n + i + e, 2, a + te + tg + Fl + st + _ + r + n + i + e, 1, yn + wu + " +lonc=-86" + Np + _t + Gp + V_ + Bh + Dp + r + n + i + e, 1, yn + wu + " +lonc=-86" + Np + _t + Gp + V_ + Bh + Dp + r + n + i + e, 1, l + _b + pb + yb + _n + " +x_0=914400 +y_0=914400" + w + Z + e, 1, l + _b + pb + yb + _n + ke + ot + r + n + i + e, 1, l + Qd + Ly + Yd + _n + xt + Ih + r + n + i + e, 1, dr + Qd + Ly + Yd + _n + xt + xs + r + n + i + e, 1, l + Qd + Ly + Yd + _n + xt + Ih + r + n + i + e, 1, dr + Qd + Ly + Yd + _n + xt + xs + r + n + i + e, 1, dr + " +lat_1=24" + _M + " +lat_0=24" + Yf + X + _ + r + n + i + e, 1, dr + " +lat_1=24" + _M + " +lat_0=24" + Yf + X + _ + r + n + i + e, 1, l + wi + Ci + tt + ya + xt + ot + r + n + i + e, 1, l + wi + Ci + tt + ya + xt + hn + r + n + u + e, 1, l + wi + Ci + tt + ya + xt + ot + r + n + i + e, 1, l + wi + Ci + tt + ya + xt + hn + r + n + u + e, 1, h + uf + C + G + i + e, 1, h + Wf + C + G + i + e, 1, h + v_ + C + G + i + e, 1, h + Md + C + G + i + e, 1, h + T_ + C + G + i + e, 1, h + uf + r + n + i + e, 1, h + Wf + r + n + i + e, 1, h + v_ + r + n + i + e, 1, h + Md + r + n + i + e, 1, h + T_ + r + n + i + e, 1, l + " +lat_1=-14.26666666666667 +lat_0=-14.26666666666667" + qg + " +k_0=1" + j + " +y_0=95169.31165862332" + R + xm + u + e, 4, a + f + Is + _t + p + _ + Xe + Wt + Sy + i + e, 1, l + " +lat_1=-28" + Cw + " +lat_0=-32" + Ii + ke + Gn + r + n + i + e, 1, a + Tg + " +lon_0=-2.416666666666667 +k=0.999997 +x_0=47000" + vg + r + n + i + e, 1, a + " +lat_0=49.225 +lon_0=-2.135 +k=0.9999999000000001" + i_ + " +y_0=70000" + r + n + i + e, 1, l + " +lat_1=-36 +lat_2=-38 +lat_0=-37 +lon_0=145" + On + yo + V + z + i + e, 1, l + " +lat_1=-36 +lat_2=-38 +lat_0=-37 +lon_0=145" + On + zl + r + n + i + e, 1, l + " +lat_1=-18" + Cw + f + " +lon_0=134" + H + _ + r + n + i + e, 1, a + " +lat_0=-28" + td + xh + bh + na + r + n + i + e, 1, a + pl + " +lon_0=-80.07750791666666 +k=1" + ke + ot + r + n + i + e, 1, a + pl + " +lon_0=-77.07750791666666 +k=1" + ke + ot + r + n + i + e, 1, a + pl + " +lon_0=-74.07750791666666 +k=1" + ke + ot + r + n + i + e, 1, a + pl + " +lon_0=-71.07750791666666 +k=1" + ke + ot + r + n + i + e, 1, a + pl + " +lon_0=-68.07750791666666 +k=1" + ke + ot + r + n + i + e, 1, a + f + pM + " +k=0.999" + ke + ot + m + ty + i + e, 1, lo + " +lat_0=50.625 +lon_0=21.08333333333333" + kv + " +x_0=4637000 +y_0=5467000" + d + A + i + e, 1, a + f + Ai + cn + p + _ + R + xe + i + e, 1, a + f + Ew + cn + p + _ + R + xe + i + e, 1, a + f + Sw + cn + p + _ + R + xe + i + e, 1, a + f + Gi + cn + p + _ + R + xe + i + e, 1, a + f + _g + cn + p + _ + R + xe + i + e, 1, a + f + Oy + " +k=1" + p + _ + r + n + i + e, 1, a + f + wv + " +k=1" + p + _ + r + n + i + e, 1, a + f + Eo + " +k=1" + p + _ + r + n + i + e, 1, a + f + rw + " +k=1" + p + _ + r + n + i + e, 1, a + f + Rg + " +k=1" + p + _ + r + n + i + e, 1, a + f + Xs + " +k=1" + p + _ + r + n + i + e, 1, a + f + jy + " +k=1" + p + _ + r + n + i + e, 1, a + f + Cv + " +k=1" + p + _ + r + n + i + e, 1, a + f + es + " +k=1" + p + _ + r + n + i + e, 1, a + f + Py + " +k=1" + p + _ + r + n + i + e, 1, a + f + " +lon_0=29 +k=1" + p + _ + r + n + i + e, 1, a + f + cl + " +k=1" + p + _ + r + n + i + e, 1, a + f + Qp + " +k=1" + p + _ + r + n + i + e, 2, Nn + " +lat_0=-18 +lon_0=178 +x_0=109435.392 +y_0=141622.272" + Tv + ZM + dd + " +to_meter=0.201168" + e, 1, h + P_ + F + m + Ql + i + e, 1, h + Og + F + m + Ql + i + e, 6, h + cf + Xe + Wt + Kl + i + e, 1, h + ff + Xe + Wt + Kl + i + e, 3, a + f + " +lon_0=18.05779 +k=0.99999425 +x_0=100178.1808 +y_0=-6500614.7836" + r + n + i + e, 1, dr + ew + " +lat_2=58.5" + tl + " +lon_0=-126" + ke + _ + r + n + i + e, 1, h + Iy + r + n + i + e, 1, h + Qm + r + n + i + e, 1, h + Fm + r + n + i + e, 1, h + Ap + r + n + i + e, 1, h + wd + r + n + i + e, 1, h + Hf + r + n + i + e, 1, h + Zf + r + n + i + e, 1, l + yM + " +lat_2=53.5" + f + xg + " +x_0=930000 +y_0=6430000" + r + n + i + e, 1, l + yM + " +lat_2=53.5" + f + xg + " +x_0=930000 +y_0=6430000" + r + n + i + e, 1, l + " +lat_1=-20.66666666666667 +lat_2=-22.33333333333333 +lat_0=-21.5" + Aw + X + Ms + r + n + i + e, 1, h + jc + F + L + Cp + i + e, 1, l + " +lat_1=-22.24469175 +lat_2=-22.29469175 +lat_0=-22.26969175 +lon_0=166.44242575 +x_0=0.66 +y_0=1.02" + m + Jo + i + e, 1, l + " +lat_1=-22.24472222222222 +lat_2=-22.29472222222222 +lat_0=-22.26972222222222 +lon_0=166.4425 +x_0=8.313000000000001 +y_0=-2.354" + m + Jo + i + e, 1, yn + ay + hC + MC + ip + i_ + _ + Bh + _o + XM + by + " +to_meter=20.116756" + e, 1, yn + ay + hC + MC + ip + " +x_0=804670.24" + _ + Bh + _o + XM + by + i + e, 1, h + Ng + F + r + n + i + e, 1, h + jc + F + r + n + i + e, 1, h + md + F + r + n + i + e, 1, h + md + F + m + _h + i + e, 2, dr + " +lat_1=42.122774 +lat_2=49.01518 +lat_0=45.568977 +lon_0=-84.455955" + ke + ot + r + n + i + e, 1, dr + " +lat_1=42.122774 +lat_2=49.01518 +lat_0=45.568977 +lon_0=-83.248627" + ke + ot + r + n + i + e, 1, a + f + kw + _t + p + _ + Xe + Wt + Kl + i + e, 1, a + f + xv + " +k=0.9965000000000001" + ke + _ + m + W + i + e, 1, h + Fs + r + n + i + e, 1, h + bs + r + n + i + e, 1, h + Qo + r + n + i + e, 1, h + qs + r + n + i + e, 1, h + Cl + r + n + i + e, 1, h + Nc + r + n + i + e, 1, h + Cd + r + n + i + e, 1, h + vd + r + n + i + e, 1, h + m_ + r + n + i + e, 1, h + jg + r + n + i + e, 1, h + hh + r + n + i + e, 1, h + Rh + r + n + i + e, 1, a + f + Lh + cn + D + _ + m + W + i + e, 1, a + f + " +lon_0=11" + cn + D + _ + m + W + i + e, 1, a + f + " +lon_0=13" + cn + D + _ + m + W + i + e, 1, a + f + wo + cn + D + _ + m + W + i + e, 1, a + f + xv + cn + D + _ + m + W + i + e, 1, a + f + Oy + cn + D + _ + m + W + i + e, 1, a + f + Eo + cn + D + _ + m + W + i + e, 1, a + f + Rg + cn + D + _ + m + W + i + e, 1, a + f + jy + cn + D + _ + m + W + i + e, 1, h + Vl + m + W + i + e, 1, l + fy + dc + eh + Y_ + xt + uC + I + Ep + i + e, 1, h + Ph + m + W + i + e, 1, h + Xf + m + W + i + e, 1, h + pu + m + W + i + e, 1, l + f_ + d_ + B + np + H + _ + v + i + e, 1, l + f_ + d_ + B + rd + H + _ + v + i + e, 1, l + f_ + d_ + B + " +lon_0=-42" + H + _ + v + i + e, 1, l + de + _e + B + Qg + H + _ + v + i + e, 1, l + de + _e + B + np + H + _ + v + i + e, 1, l + de + _e + B + rd + H + _ + v + i + e, 1, l + de + _e + B + Q_ + H + _ + v + i + e, 1, l + de + _e + B + Pg + H + _ + v + i + e, 1, l + de + _e + B + Mv + H + _ + v + i + e, 1, l + de + _e + B + wc + H + _ + v + i + e, 1, l + de + _e + B + Is + H + _ + v + i + e, 1, l + de + _e + B + mh + H + _ + v + i + e, 1, l + de + _e + B + Ml + H + _ + v + i + e, 1, l + de + _e + B + vh + H + _ + v + i + e, 1, l + de + _e + B + gg + H + _ + v + i + e, 1, l + de + _e + B + a_ + H + _ + v + i + e, 1, l + de + _e + B + sy + H + _ + v + i + e, 1, l + ct + ft + B + " +lon_0=-102" + H + _ + v + i + e, 1, l + ct + ft + B + Ue + H + _ + v + i + e, 1, l + ct + ft + B + " +lon_0=-78" + H + _ + v + i + e, 1, l + ct + ft + B + np + H + _ + v + i + e, 1, l + ct + ft + B + " +lon_0=-18" + H + _ + v + i + e, 1, l + ct + ft + B + " +lon_0=-6" + H + _ + v + i + e, 1, l + ct + ft + B + xw + H + _ + v + i + e, 1, l + ct + ft + B + Fp + H + _ + v + i + e, 1, l + ct + ft + B + cl + H + _ + v + i + e, 1, l + ct + ft + B + Q_ + H + _ + v + i + e, 1, l + ct + ft + B + Pg + H + _ + v + i + e, 1, l + ct + ft + B + Mv + H + _ + v + i + e, 1, l + ct + ft + B + wc + H + _ + v + i + e, 1, l + ct + ft + B + Is + H + _ + v + i + e, 1, l + ct + ft + B + mh + H + _ + v + i + e, 1, l + ct + ft + B + Ml + H + _ + v + i + e, 1, l + ct + ft + B + vh + H + _ + v + i + e, 1, l + ct + ft + B + gg + H + _ + v + i + e, 1, l + ct + ft + B + a_ + H + _ + v + i + e, 1, l + ct + ft + B + sy + H + _ + v + i + e, 1, l + ct + ft + B + jv + H + _ + v + i + e, 1, l + Nt + wt + B + gM + H + _ + v + i + e, 1, l + Nt + wt + B + mM + H + _ + v + i + e, 1, l + Nt + wt + B + _c + H + _ + v + i + e, 1, l + Nt + wt + B + gh + H + _ + v + i + e, 1, l + Nt + wt + B + dn + H + _ + v + i + e, 1, l + Nt + wt + B + oy + H + _ + v + i + e, 1, l + Nt + wt + B + " +lon_0=-27" + H + _ + v + i + e, 1, l + Nt + wt + B + " +lon_0=-9" + H + _ + v + i + e, 1, l + Nt + wt + B + Lh + H + _ + v + i + e, 1, l + Nt + wt + B + es + H + _ + v + i + e, 1, l + Nt + wt + B + eh + H + _ + v + i + e, 1, l + Nt + wt + B + Zp + H + _ + v + i + e, 1, l + Nt + wt + B + rs + H + _ + v + i + e, 1, l + Nt + wt + B + is + H + _ + v + i + e, 1, l + Nt + wt + B + Ai + H + _ + v + i + e, 1, l + Nt + wt + B + Ii + H + _ + v + i + e, 1, l + Nt + wt + B + td + H + _ + v + i + e, 1, l + Nt + wt + B + uc + H + _ + v + i + e, 1, l + Gt + Dt + B + Fg + H + _ + v + i + e, 1, l + Gt + Dt + B + " +lon_0=-144" + H + _ + v + i + e, 1, l + Gt + Dt + B + Mf + H + _ + v + i + e, 1, l + Gt + Dt + B + $d + H + _ + v + i + e, 1, l + Gt + Dt + B + Nv + H + _ + v + i + e, 1, l + Gt + Dt + B + " +lon_0=-48" + H + _ + v + i + e, 1, l + Gt + Dt + B + " +lon_0=-24" + H + _ + v + i + e, 1, l + Gt + Dt + B + ts + H + _ + v + i + e, 1, l + Gt + Dt + B + Xs + H + _ + v + i + e, 1, l + Gt + Dt + B + Lg + H + _ + v + i + e, 1, l + Gt + Dt + B + $M + H + _ + v + i + e, 1, l + Gt + Dt + B + df + H + _ + v + i + e, 1, l + Gt + Dt + B + Qh + H + _ + v + i + e, 1, l + Gt + Dt + B + Iv + H + _ + v + i + e, 1, l + Gt + Dt + B + Ov + H + _ + v + i + e, 1, fe + B + bt + Ug + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + mM + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + " +lon_0=-105 +k=1" + H + _ + v + i + e, 1, fe + B + bt + Gv + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + " +lon_0=-45 +k=1" + H + _ + v + i + e, 1, fe + B + bt + " +lon_0=-15 +k=1" + H + _ + v + i + e, 1, fe + B + bt + wo + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + eh + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + ns + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + ia + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + Ii + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + ed + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + Fd + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + Ue + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + " +lon_0=-30 +k=1" + H + _ + v + i + e, 1, fe + B + bt + cl + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + Is + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + a_ + " +k=1" + H + _ + v + i + e, 1, fe + B + bt + ts + " +k=1" + H + _ + v + i + e, 1, l + Gt + Dt + " +lat_0=-78" + sy + H + _ + v + i + e, 2, h + Ay + F + r + Re + i + e, 1, h + lg + F + r + Re + i + e, 1, h + Iy + F + r + Re + i + e, 1, h + Qm + F + r + Re + i + e, 1, l + gb + " +lat_2=58" + mb + Xs + p + " +y_0=6375000" + r + Sc + i + e, 1, l + gb + " +lat_2=58" + mb + Xs + p + " +y_0=6375000" + r + n + i + e, 1, h + Iy + F + m + bc + i + e, 1, h + Iy + F + m + hu + i + e, 1, h + lg + F + m + du + i + e, 1, h + lg + F + m + _u + i + e, 1, h + Ay + F + m + Pp + i + e, 1, h + Wl + L + bm + i + e, 1, l + " +lat_1=-30.75 +lat_2=-35.75 +lat_0=-33.25" + r_ + " +x_0=9300000" + yo + r + n + i + e, 1, dr + aw + zg + f + Mf + H + Wp + w + i + e, 1, dr + aw + zg + f + Mf + H + Wp + r + n + i + e, 1, dr + aw + zg + f + Mf + H + Wp + r + n + i + e, 1, h + qs + m + Pf + i + e, 1, h + qs + r + n + i + e, 3, a + f + rw + k + p + Rt + I + i + e, 1, a + f + Xs + k + p + Rt + I + i + e, 1, a + f + Zs + k + p + Rt + I + i + e, 1, a + f + " +lon_0=14" + k + p + Rt + I + i + e, 1, a + f + " +lon_0=16" + k + p + Rt + I + i + e, 1, a + f + Fp + k + p + Rt + I + i + e, 1, a + f + wv + k + p + Rt + I + i + e, 1, a + f + rw + k + p + Rt + I + i + e, 1, a + f + Xs + k + p + Rt + I + i + e, 1, a + f + Cv + k + p + Rt + I + i + e, 1, a + f + Py + k + p + Rt + I + i + e, 1, a + f + cl + k + p + Rt + I + i + e, 1, lo + " +lat_0=52.16666666666666 +lon_0=19.16666666666667 +k=0.999714" + p + It + d + A + i + e, 1, a + f + wo + " +k=1" + wa + _ + d + A + i + e, 1, a + f + Fp + " +k=1" + Ah + _ + d + A + i + e, 1, a + f + Eo + " +k=1" + Ys + _ + d + A + i + e, 1, a + f + Xs + " +k=1" + Wc + _ + d + A + i + e, 1, a + f + wo + " +k=1" + Pe + _ + d + A + i + e, 1, a + f + Eo + " +k=1" + hr + _ + d + A + i + e, 1, a + f + es + " +k=1" + wa + _ + d + A + i + e, 1, h + Vy + F + m + km + i + e, 1, l + " +lat_1=-20.19506944444445 +lat_0=-20.19506944444445 +lon_0=57.52182777777778 +k_0=1" + ke + ot + I + ey + i + e, 1, dr + " +lat_1=55" + Jp + tw + kf + H + _ + r + n + i + e, 1, a + f + Zs + k + p + Rt + I + eo + i + e, 1, a + f + " +lon_0=14" + k + p + Rt + I + eo + i + e, 1, a + f + " +lon_0=16" + k + p + Rt + I + eo + i + e, 1, h + Ph + F + I + eo + i + e, 1, h + hh + r + n + i + e, 1, h + Rh + r + n + i + e, 1, h + y_ + r + n + i + e, 1, a + f + Xs + kv + p + _ + r + n + i + e, 1, l + Hu + Js + " +lat_0=63.390675" + Qv + " +x_0=6200000" + Ni + r + n + i + e, 1, l + Hu + Js + " +lat_0=63.390675" + Qv + " +x_0=6200000" + Ni + r + n + i + e, 2, a + " +lat_0=0.1 +lon_0=21.95 +k=1" + ze + _ + d + o + i + e, 1, a + " +lat_0=0.1 +lon_0=24.95 +k=1 +x_0=1250000" + _ + d + o + i + e, 1, a + " +lat_0=0.1 +lon_0=27.95 +k=1 +x_0=2250000" + _ + d + o + i + e, 1, h + Vl + F + m + i + e, 1, h + Vl + F + m + i + e, 1, a + So + Qp + " +k=1 +x_0=615000 +y_0=810000" + Ao + ny + i + e, 3, l + Pa + Ta + Ku + Kf + eg + _ + r + n + i + e, 2, l + Za + jd + Pr + dn + Nd + _ + r + n + i + e, 1, l + Za + jd + Pr + dn + Nd + _ + r + n + Z + e, 1, l + $c + Ha + Kt + ma + S + _ + r + n + i + e, 1, l + $c + Ha + Kt + ma + S + _ + r + n + u + e, 1, l + Rr + Lr + Y + ma + S + _ + r + n + i + e, 1, l + Rr + Lr + Y + ma + S + _ + r + n + u + e, 2, h + hh + I + i + e, 1, h + Rh + I + i + e, 1, h + y_ + I + i + e, 1, h + md + w + i + e, 1, h + P_ + w + i + e, 1, h + md + r + n + i + e, 1, h + P_ + r + n + i + e, 1, h + Rh + m + i + e, 1, yn + ay + hC + " +alpha=323.0257964666666" + ip + " +x_0=804671" + _ + Bh + _o + r + i + e, 1, yn + ay + iw + wC + ip + H + _ + Bh + yl + r + i + e, 1, Nn + " +lat_0=2.121679744444445 +lon_0=103.4279362361111 +x_0=-14810.562 +y_0=8758.32" + r + i + e, 1, Nn + " +lat_0=2.682347636111111 +lon_0=101.9749050416667 +x_0=3673.785 +y_0=-4240.573" + r + i + e, 1, Nn + " +lat_0=3.769388088888889 +lon_0=102.3682989833333 +x_0=-7368.228 +y_0=6485.858" + r + i + e, 1, Nn + " +lat_0=3.68464905 +lon_0=101.3891079138889 +x_0=-34836.161 +y_0=56464.049" + r + i + e, 1, Nn + " +lat_0=4.9762852 +lon_0=103.070275625 +x_0=19594.245 +y_0=3371.895" + r + i + e, 1, Nn + " +lat_0=5.421517541666667 +lon_0=100.3443769638889 +x_0=-23.414 +y_0=62.283" + r + i + e, 1, Nn + " +lat_0=5.964672713888889 +lon_0=100.6363711111111" + H + _ + r + i + e, 1, Nn + " +lat_0=4.859063022222222 +lon_0=100.8154105861111 +x_0=-1.769 +y_0=133454.779" + r + i + e, 1, Nn + " +lat_0=5.972543658333334 +lon_0=102.2952416694444 +x_0=13227.851 +y_0=8739.894" + r + i + e, 1, a + f + Fp + " +k=1" + p + _ + m + zt + i + e, 1, a + f + Hs + " +k=1" + wa + _ + m + zt + i + e, 1, rh + z_ + " +lat_ts=42" + H + _ + d + o + i + e, 1, a + f + mg + " +k=1 +x_0=60500000" + _ + d + o + i + e, 1, a + f + mg + " +k=1 +x_0=60500000" + _ + d + s + i + e, 1, h + Th + I + fa + i + e, 1, h + lh + I + fa + i + e, 1, h + Wl + I + fa + i + e, 1, l + fy + dc + eh + Y_ + xt + uC + I + i + e, 1, rh + ts + " +k=1" + H + _ + v + i + e, 1, a + f + Lh + " +k=1" + Pe + _ + C + i + e, 1, a + f + Zs + " +k=1" + hr + _ + C + i + e, 1, a + f + Zs + " +k=1" + hr + _ + C + i + e, 1, a + f + wo + " +k=1" + wa + _ + C + i + e, 1, a + f + Hg + " +k=0.9992" + p + _ + r + n + i + e, 1, a + f + Hg + " +k=0.9992" + H + _ + r + n + i + e, 1, a + f + Hg + " +k=0.9992" + p + _ + r + n + i + e, 1, a + f + Hg + " +k=0.9992" + H + _ + r + n + i + e, 1, l + Pa + Ta + Ku + Kf + E + _ + r + n + u + e, 1, h + cf + L + Li + i + e, 1, h + ff + L + Li + i + e, 1, Nn + ib + ob + " +x_0=40243.57775604237 +y_0=19069.93351512578" + ka + Ma + qc + e, 1, gs + Os + ts + H + _ + Iw + Ow + i + e, 1, gs + B + ts + H + _ + Iw + Ow + i + e, 1, "+proj=cea" + ts + " +lat_ts=30" + H + _ + Iw + Ow + i + e, 1, fe + Os + " +lat_ts=70 +lon_0=-45 +k=1" + H + _ + jw + ng + i + e, 1, fe + B + " +lat_ts=-70" + ts + " +k=1" + H + _ + jw + ng + i + e, 1, fe + Os + " +lat_ts=70 +lon_0=-45 +k=1" + H + _ + v + i + e, 1, a + " +lat_0=1.366666666666667 +lon_0=103.8333333333333 +k=1 +x_0=28001.642 +y_0=38744.572" + L + i + e, 1, l + " +lat_1=18 +lat_2=24 +lat_0=21" + Ml + p + It + x + g + i + e, 1, l + Hu + hd + " +lat_0=47.5" + gl + X + Il + r + n + i + e, 1, l + Xr + Jr + Oi + Ji + xt + Yi + r + n + u + e, 1, l + Mt + Wr + Di + Ji + it + _ + r + n + u + e, 1, l + Vr + Yr + pt + Si + Ht + _ + r + n + u + e, 1, l + Kr + $r + N + gn + Ht + Do + r + n + u + e, 1, a + fn + $n + k + Ro + zc + r + n + u + e, 1, a + fn + tr + k + it + xs + r + n + u + e, 1, a + fn + er + k + Tt + Df + r + n + u + e, 1, a + Yt + Oo + k + Le + _ + r + n + u + e, 1, l + Xr + Jr + Oi + Ji + xt + Yi + r + n + u + e, 1, l + Mt + Wr + Di + Ji + it + _ + r + n + u + e, 1, l + Vr + Yr + pt + Si + Ht + _ + r + n + u + e, 1, l + Kr + $r + N + gn + Ht + Do + r + n + u + e, 1, a + fn + $n + k + Ro + zc + r + n + u + e, 1, a + fn + tr + k + it + xs + r + n + u + e, 1, a + fn + er + k + Tt + Df + r + n + u + e, 1, a + Yt + Oo + k + Le + _ + r + n + u + e, 1, l + Ur + zr + $t + zs + Ht + _ + r + n + u + e, 1, l + Hr + xf + Zr + zs + Ht + Do + r + n + u + e, 1, a + N + Xn + la + ne + _ + r + n + u + e, 1, a + N + Jn + Pt + Hc + _ + r + n + u + e, 1, a + ji + nr + dt + ne + _ + r + n + u + e, 1, a + ta + Zi + oc + ah + _ + r + n + u + e, 1, h + Wl + I + bo + i + e, 1, h + lf + I + bo + i + e, 1, l + Ur + zr + $t + zs + Ht + _ + r + n + u + e, 1, l + Hr + xf + Zr + zs + Ht + Do + r + n + u + e, 1, a + N + Xn + la + ne + _ + r + n + u + e, 1, a + N + Jn + Pt + Hc + _ + r + n + u + e, 1, a + ji + nr + dt + ne + _ + r + n + u + e, 1, a + ta + Zi + oc + ah + _ + r + n + u + e, 1, l + Cu + Eu + " +lat_0=50.797815" + vb + " +x_0=150328 +y_0=166262" + r + n + i + e, 1, l + " +lat_1=18" + Yd + lc + " +k_0=1" + vM + " +y_0=650000" + L + n + i + e, 1, h + bl + L + n + i + e, 1, h + Fs + L + n + i + e, 1, l + li + hi + hl + vs + va + _ + r + n + u + e, 1, l + Rd + Ld + Pd + je + va + _ + r + n + u + e, 1, l + Ke + $e + " +lat_0=25.5" + je + va + _ + r + n + u + e, 2, l + Bd + bi + ea + jt + S + _ + r + n + u + e, 1, l + li + hi + hl + vs + va + _ + r + n + u + e, 1, l + Rd + Ld + Pd + je + va + _ + r + n + u + e, 1, l + vi + xi + ut + _n + S + _ + r + n + u + e, 1, l + Bd + bi + ea + jt + S + _ + r + n + u + e, 1, a + " +lat_0=-17 +lon_0=178.75 +k=0.99985" + Ee + tc + x + y + i + e, 1, h + hh + vt + ue + _d + i + e, 1, h + Rh + vt + ue + _d + i + e, 1, a + xM + rg + Fl + p + _ + r + n + i + e, 1, a + xM + rg + Fl + p + _ + r + n + i + e, 1, a + hl + ol + tp + D + _ + r + n + i + e, 1, a + So + Zd + re + S + _ + r + n + i + e, 1, dr + " +lat_1=55" + Jp + tw + kf + H + _ + r + n + i + e, 1, yn + " +lat_0=57" + Su + Au + k + nc + oa + Bh + _o + r + n + i + e, 1, a + Ri + bM + k + p + _ + r + n + i + e, 1, a + Ri + kM + k + p + _ + r + n + i + e, 1, a + Ri + Fd + k + p + _ + r + n + i + e, 1, a + Ri + kf + k + p + _ + r + n + i + e, 1, a + Ri + Uh + k + p + _ + r + n + i + e, 1, a + Ri + MM + k + p + _ + r + n + i + e, 1, a + Ri + wM + k + p + _ + r + n + i + e, 1, a + Ri + qg + k + p + _ + r + n + i + e, 1, l + Iu + Ou + Ev + CM + ke + _ + r + n + i + e, 1, a + De + Ln + k + pa + _ + r + n + i + e, 1, a + De + Ln + k + pa + _ + r + n + Z + e, 1, a + De + Rn + k + pa + _ + r + n + i + e, 1, a + De + Rn + k + pa + _ + r + n + Z + e, 1, a + De + Nl + re + pa + _ + r + n + i + e, 1, a + De + Nl + re + pa + _ + r + n + Z + e, 1, l + Ur + zr + $t + zs + X + _ + r + n + i + e, 1, l + Ur + zr + $t + zs + Ht + _ + r + n + u + e, 1, l + Hr + xf + Zr + zs + X + Il + r + n + i + e, 1, l + Hr + xf + Zr + zs + Ht + Do + r + n + u + e, 1, dr + aw + zg + f + Mf + H + Wp + r + n + i + e, 1, l + yr + kh + Y + Fo + Ee + It + r + n + i + e, 1, l + yr + kh + Y + Fo + St + nt + r + n + u + e, 1, l + gr + mr + $ + Fo + Ee + It + r + n + i + e, 1, l + gr + mr + $ + Fo + St + nt + r + n + u + e, 1, l + Qt + vr + pf + lt + Ee + It + r + n + i + e, 1, l + Qt + vr + pf + lt + St + nt + r + n + u + e, 1, l + Xu + qp + xr + yf + Ee + It + r + n + i + e, 1, l + Xu + qp + xr + yf + St + nt + r + n + u + e, 1, l + br + kr + gf + Al + Ee + It + r + n + i + e, 1, l + br + kr + gf + Al + St + nt + r + n + u + e, 1, l + Mr + wr + Cr + Gl + Ee + It + r + n + i + e, 1, l + Mr + wr + Cr + Gl + St + nt + r + n + u + e, 1, l + Ju + Wu + xn + Me + Ti + Bi + r + n + i + e, 1, l + Ju + Wu + xn + Me + He + sn + r + n + u + e, 1, l + Ca + Ea + Y + Me + Ti + Bi + r + n + i + e, 1, l + Ca + Ea + Y + Me + He + sn + r + n + u + e, 1, l + Qt + Er + N + Me + Ti + Bi + r + n + i + e, 1, l + Qt + Er + N + Me + He + sn + r + n + u + e, 1, l + Sr + mf + Ar + Ch + Op + jp + r + n + i + e, 1, l + Sr + mf + Ar + Ch + Gc + Dc + r + n + u + e, 1, a + In + Pn + vf + D + _ + r + n + i + e, 1, a + In + Pn + vf + rt + _ + r + n + u + e, 1, a + Ft + dn + Pt + D + _ + r + n + i + e, 1, a + Ft + dn + Pt + rt + _ + r + n + u + e, 1, dr + " +lat_1=24" + _M + " +lat_0=24" + Yf + X + _ + r + n + i + e, 1, l + Vu + Ir + Up + Yu + S + _ + r + n + i + e, 1, l + Vu + Ir + Up + Yu + S + _ + r + n + u + e, 1, a + Ft + e_ + Pt + D + _ + r + n + i + e, 1, a + Ft + e_ + Pt + rt + _ + r + n + u + e, 1, a + So + Tn + k + D + _ + r + n + i + e, 1, a + So + Tn + k + rt + _ + r + n + u + e, 1, a + So + Bn + k + _a + _ + r + n + i + e, 1, a + So + Bn + k + ln + _ + r + n + u + e, 1, a + q + uh + oe + p + _ + r + n + i + e, 1, a + q + uh + oe + at + _ + r + n + u + e, 1, a + q + Qn + oe + D + _ + r + n + i + e, 1, a + q + Qn + oe + rt + _ + r + n + u + e, 1, a + q + Dl + re + vn + _ + r + n + i + e, 1, a + q + Dl + re + Rc + _ + r + n + u + e, 1, a + N + Xn + la + st + _ + r + n + i + e, 1, a + N + Xn + la + ne + _ + r + n + u + e, 1, a + N + Jn + Pt + _a + _ + r + n + i + e, 1, a + N + Jn + Pt + Hc + _ + r + n + u + e, 1, a + or + Wn + dt + ge + zh + r + n + i + e, 1, a + or + Wn + dt + Uc + Vi + r + n + u + e, 1, a + or + Vn + dt + os + zh + r + n + i + e, 1, a + or + Vn + dt + os + Vi + r + n + u + e, 1, l + Xr + Jr + Oi + Ji + xt + ot + r + n + i + e, 1, l + Xr + Jr + Oi + Ji + xt + Yi + r + n + u + e, 1, l + Mt + Wr + Di + Ji + p + _ + r + n + i + e, 1, l + Mt + Wr + Di + Ji + it + _ + r + n + u + e, 1, l + Vr + Yr + pt + Si + X + _ + r + n + i + e, 1, l + Vr + Yr + pt + Si + Ht + _ + r + n + u + e, 1, l + Kr + $r + N + gn + X + Il + r + n + i + e, 1, l + Kr + $r + N + gn + Ht + Do + r + n + u + e, 1, l + Vt + pr + or + Mh + p + _ + r + n + i + e, 1, l + Vt + pr + or + Mh + at + _ + r + n + u + e, 1, l + wi + Ci + tt + ya + xt + ot + r + n + i + e, 1, l + wi + Ci + tt + ya + xt + hn + r + n + u + e, 1, l + Sa + Aa + tt + ya + p + It + r + n + i + e, 1, l + Sa + Aa + tt + ya + at + nt + r + n + u + e, 1, l + li + hi + hl + vs + ke + _ + r + n + i + e, 1, l + li + hi + hl + vs + va + _ + r + n + u + e, 1, l + Rd + Ld + Pd + je + ke + _ + r + n + i + e, 1, l + Rd + Ld + Pd + je + va + _ + r + n + u + e, 1, a + xM + rg + Fl + p + _ + r + n + i + e, 1, a + ut + $y + Fl + _a + _ + r + n + i + e, 1, a + te + tg + Fl + st + _ + r + n + i + e, 1, a + ht + Vo + k + st + _ + r + n + i + e, 1, a + te + Yn + dt + os + _ + r + n + i + e, 1, l + Yc + Sd + $ + lc + X + _ + r + n + i + e, 1, l + Mt + tn + Qe + ie + it + Yi + r + n + u + e, 1, a + xu + Yg + dt + j + _ + R + Ui + u + e, 1, a + bu + Wh + dt + j + _ + R + Ui + u + e, 1, a + ho + Uh + xh + j + _ + R + Ui + u + e, 1, a + ku + Kg + xh + j + _ + R + Ui + u + e, 1, a + Mu + Vh + " +k=1" + j + _ + R + Ui + u + e, 1, l + ql + en + pt + ie + it + Rf + r + n + u + e, 1, l + Ul + nn + N + ie + it + Ni + r + n + u + e, 1, l + Mt + tn + Qe + ie + it + Yi + r + n + u + e, 1, l + ql + en + pt + ie + it + Rf + r + n + u + e, 1, l + Ul + nn + N + ie + it + Ni + r + n + u + e, 1, gs + Os + mg + H + _ + v + i + e, 1, gs + Os + Fd + H + _ + v + i + e, 1, gs + Os + _n + H + _ + v + i + e, 1, gs + Os + " +lon_0=-40" + H + _ + v + i + e, 1, gs + Os + Cc + H + _ + v + i + e, 1, gs + Os + Is + H + _ + v + i + e, 1, dr + " +lat_1=-18" + Cw + f + kl + H + _ + r + n + i + e, 1, dr + xb + " +lat_2=68 +lat_0=59 +lon_0=-132.5" + p + It + r + n + i + e, 1, dr + xb + " +lat_2=68 +lat_0=59 +lon_0=-132.5" + p + It + r + n + i + e, 1, l + " +lat_1=62 +lat_2=70" + f + " +lon_0=-112" + H + _ + r + n + i + e, 1, l + " +lat_1=62 +lat_2=70" + f + " +lon_0=-112" + H + _ + r + n + i + e, 1, l + Yc + Sd + $ + lc + Lc + _ + r + n + u + e, 1, l + Oa + ja + El + Vs + p + _ + r + n + i + e, 1, l + Oa + ja + El + Vs + at + _ + r + n + u + e, 1, l + Ia + Or + El + Zi + D + _f + r + n + i + e, 1, l + Ia + Or + El + Zi + rt + _f + r + n + u + e, 1, l + Ad + Ra + La + ee + lp + _ + r + n + i + e, 1, l + Ad + Ra + La + ee + Tc + _ + r + n + Z + e, 1, l + Na + Ga + Da + yh + ev + _ + r + n + i + e, 1, l + Na + Ga + Da + yh + Pc + _ + r + n + Z + e, 1, yn + wu + " +lonc=-86" + Np + _t + Gp + V_ + Bh + Dp + r + n + i + e, 1, l + Be + Id + Oi + ee + $u + _ + r + n + i + e, 1, l + Be + Id + Oi + ee + Xd + _ + r + n + Z + e, 1, l + rf + fi + tl + Sh + vn + na + r + n + i + e, 1, l + ui + ci + Sl + Kn + vn + na + r + n + i + e, 1, l + di + _i + cd + nd + vn + na + r + n + i + e, 1, a + ks + Fn + cn + st + _ + r + n + i + e, 1, a + ks + Fn + cn + ne + _ + r + n + u + e, 1, a + ks + Ze + cn + _a + _ + r + n + i + e, 1, a + ks + Ze + cn + ln + _ + r + n + u + e, 1, a + Cn + vs + re + p + _ + r + n + i + e, 1, a + Cn + Qy + re + ze + _ + r + n + i + e, 1, a + _l + Fy + Pt + uM + _ + r + n + i + e, 1, l + Hu + Ny + Kc + rl + S + _ + r + n + i + e, 1, l + Hu + Ny + Kc + rl + cr + _ + r + n + Z + e, 1, l + nh + kh + pi + _n + p + _ + r + n + i + e, 1, a + fn + tr + k + p + xs + r + n + i + e, 1, a + fn + tr + k + it + xs + r + n + u + e, 1, a + fn + $n + k + D + nv + r + n + i + e, 1, a + fn + $n + k + Ro + zc + r + n + u + e, 1, a + fn + er + k + vn + tc + r + n + i + e, 1, a + fn + er + k + Tt + Df + r + n + u + e, 1, a + ji + nr + dt + st + _ + r + n + i + e, 1, a + ji + nr + dt + ne + _ + r + n + u + e, 1, a + Yt + Oo + k + Le + _ + r + n + i + e, 1, a + Yt + Oo + k + Le + _ + r + n + u + e, 1, a + De + Rl + k + p + _ + r + n + i + e, 1, a + De + Rl + k + at + _ + r + n + u + e, 1, a + De + qn + Cs + Od + _ + r + n + i + e, 1, a + De + qn + Cs + Od + _ + r + n + u + e, 1, a + De + Un + Ll + cM + _ + r + n + i + e, 1, a + De + Un + Ll + Bc + _ + r + n + u + e, 1, a + Di + zn + At + ze + _ + r + n + i + e, 1, a + Di + zn + At + Qc + _ + r + n + u + e, 1, a + Yt + Oo + k + Le + _ + r + n + i + e, 1, a + Yt + Oo + k + Le + _ + r + n + u + e, 1, l + jr + Nr + Kt + n_ + st + _ + r + n + i + e, 1, l + jr + Nr + Kt + n_ + ne + _ + r + n + u + e, 1, a + Di + Hn + At + uy + _ + r + n + i + e, 1, a + Di + Hn + At + Fc + _ + r + n + u + e, 1, l + Pa + Ta + Ku + Kf + eg + _ + r + n + i + e, 1, l + Pa + Ta + Ku + Kf + E + _ + r + n + u + e, 1, l + ae + Ba + fl + ga + S + _ + r + n + i + e, 1, l + ae + Ba + fl + ga + cr + _ + r + n + Z + e, 1, l + Qa + Fa + Se + ga + S + _ + r + n + i + e, 1, l + Qa + Fa + Se + ga + cr + _ + r + n + Z + e, 1, l + Td + yi + be + ca + S + _ + r + n + i + e, 1, l + gi + mi + In + ca + S + _ + r + n + i + e, 1, l + Gr + qa + zp + Si + S + _ + r + n + i + e, 1, l + Gr + qa + zp + Si + S + _ + r + n + u + e, 1, l + Ua + za + Dr + Si + S + _ + r + n + i + e, 1, l + Ua + za + Dr + Si + S + _ + r + n + u + e, 1, l + nh + ws + Wi + lt + X + _ + r + n + i + e, 1, l + nh + ws + Wi + lt + sc + _ + r + n + Z + e, 1, l + F_ + bn + ht + lt + On + _ + r + n + i + e, 1, l + F_ + bn + ht + lt + Zh + _ + r + n + Z + e, 1, l + q_ + kn + q + lt + xt + _ + r + n + i + e, 1, l + q_ + kn + q + lt + Xh + _ + r + n + Z + e, 1, l + $c + Ha + Kt + ma + S + _ + r + n + i + e, 1, l + $c + Ha + Kt + ma + S + _ + r + n + u + e, 1, l + Rr + Lr + Y + ma + S + _ + r + n + i + e, 1, l + Rr + Lr + Y + ma + S + _ + r + n + u + e, 1, a + ta + Zi + oc + ge + _ + r + n + i + e, 1, a + ta + Zi + oc + ah + _ + r + n + u + e, 1, l + Za + jd + Pr + dn + Nd + _ + r + n + i + e, 1, l + Za + jd + Pr + dn + Nd + _ + r + n + Z + e, 1, l + vi + xi + ut + _n + S + _ + r + n + i + e, 1, l + vi + xi + ut + _n + S + _ + r + n + u + e, 1, l + Bd + bi + ea + jt + S + _ + r + n + i + e, 1, l + Bd + bi + ea + jt + S + _ + r + n + u + e, 1, l + Xa + tf + $t + Xc + S + _ + r + n + i + e, 1, l + Xa + tf + $t + Xc + S + _ + r + n + u + e, 1, l + Ya + Ka + Mn + jt + _a + Ni + r + n + i + e, 1, l + Ya + Ka + Mn + jt + ln + Ni + r + n + u + e, 1, dr + Qd + Ly + Yd + _n + xt + xs + r + n + i + e, 1, l + Qd + Ly + Yd + _n + xt + Ih + r + n + i + e, 1, l + Ja + ef + Hp + Eh + D + ot + r + n + i + e, 1, l + Ja + ef + Hp + Eh + rt + hn + r + n + u + e, 1, l + Wa + Va + Tr + gn + S + Gn + r + n + i + e, 1, l + Wa + Va + Tr + gn + S + No + r + n + u + e, 1, l + Ke + $e + wn + gn + st + Ih + r + n + i + e, 1, l + Ke + $e + wn + gn + ne + sd + r + n + u + e, 1, l + $a + ti + Br + gh + S + tc + r + n + i + e, 1, l + $a + ti + Br + gh + S + od + r + n + u + e, 1, l + ql + en + pt + ie + p + Gn + r + n + i + e, 1, l + ql + en + pt + ie + mo + Zy + r + n + Z + e, 1, l + ql + en + pt + ie + it + Rf + r + n + u + e, 1, l + Mt + tn + Qe + ie + p + ot + r + n + i + e, 1, l + Mt + tn + Qe + ie + mo + xp + r + n + Z + e, 1, l + Mt + tn + Qe + ie + it + Yi + r + n + u + e, 1, l + Ul + nn + N + ie + p + Ni + r + n + i + e, 1, l + Ul + nn + N + ie + mo + Xy + r + n + Z + e, 1, l + Ul + nn + N + ie + it + Ni + r + n + u + e, 1, a + ji + ec + Pl + p + _ + r + n + i + e, 1, l + Gd + ei + $ + Xi + Pe + Gn + r + n + i + e, 1, l + Gd + ei + $ + Xi + Go + No + r + n + u + e, 1, l + Vt + Qr + tt + Xi + Pe + ot + r + n + i + e, 1, l + Vt + Qr + tt + Xi + Go + hn + r + n + u + e, 1, l + ae + Dd + fl + Zn + p + _ + r + n + i + e, 1, l + ae + Dd + fl + Zn + at + _ + r + n + u + e, 1, l + ni + ri + Fr + lt + p + _ + r + n + i + e, 1, l + ni + ri + Fr + lt + at + _ + r + n + u + e, 1, l + af + Ry + bf + po + S + _ + r + n + i + e, 1, l + ki + Mi + Xp + dn + S + _ + r + n + i + e, 1, l + ch + nf + ut + Ue + S + _ + r + n + i + e, 1, l + ch + nf + ut + Ue + S + _ + r + n + u + e, 1, l + ai + ii + qr + Ue + S + _ + r + n + i + e, 1, l + ai + ii + qr + Ue + S + _ + r + n + u + e, 1, l + oi + si + U_ + Ue + S + _ + r + n + i + e, 1, l + oi + si + U_ + Ue + S + _ + r + n + u + e, 1, a + f + Ue + _t + dM + $g + r + n + i + e, 1, a + We + rr + At + D + _ + r + n + i + e, 1, a + We + ar + At + X + na + r + n + i + e, 1, a + We + Tl + At + S + _ + r + n + i + e, 1, a + We + ir + At + vn + na + r + n + i + e, 1, h + md + r + n + i + e, 1, h + P_ + r + n + i + e, 1, h + Og + r + n + i + e, 1, h + Bm + r + n + i + e, 1, h + sM + r + n + i + e, 1, h + qm + r + n + i + e, 1, h + Ay + r + n + i + e, 1, h + lg + r + n + i + e, 1, h + Iy + r + n + i + e, 1, h + Qm + r + n + i + e, 1, h + Fm + r + n + i + e, 1, h + Ap + r + n + i + e, 1, h + xd + r + n + i + e, 1, h + bd + r + n + i + e, 1, h + kd + r + n + i + e, 1, h + wd + r + n + i + e, 1, h + Hf + r + n + i + e, 1, h + Zf + r + n + i + e, 1, h + bl + r + n + i + e, 1, h + Fs + r + n + i + e, 1, h + bs + r + n + i + e, 1, a + " +lat_0=-21.11666666666667 +lon_0=55.53333333333333 +k=1 +x_0=160000" + vg + m + Ig + i + e, 1, l + Td + yi + be + ca + S + _ + r + n + u + e, 1, l + gi + mi + In + ca + S + _ + r + n + u + e, 1, a + We + rr + At + Ro + _ + r + n + u + e, 1, a + We + ar + At + Ht + Bt + r + n + u + e, 1, a + We + Tl + At + S + _ + r + n + u + e, 1, a + We + ir + At + Tt + Bt + r + n + u + e, 1, l + Td + yi + be + ca + S + _ + r + n + u + e, 1, l + gi + mi + In + ca + S + _ + r + n + u + e, 1, a + We + rr + At + Ro + _ + r + n + u + e, 1, a + We + ar + At + Ht + Bt + r + n + u + e, 1, a + We + Tl + At + S + _ + r + n + u + e, 1, a + We + ir + At + Tt + Bt + r + n + u + e, 1, h + Ap + r + n + i + e, 1, h + xd + r + n + i + e, 1, h + bd + r + n + i + e, 1, h + kd + r + n + i + e, 1, h + wd + r + n + i + e, 1, h + Hf + r + n + i + e, 1, h + Zf + r + n + i + e, 1, h + bl + r + n + i + e, 1, h + Fs + r + n + i + e, 1, h + bs + r + n + i + e, 1, h + qm + r + n + i + e, 1, h + Ay + r + n + i + e, 2, l + Td + yi + be + ca + S + _ + r + n + u + e, 1, l + gi + mi + In + ca + S + _ + r + n + u + e, 1, a + We + rr + At + Ro + _ + r + n + u + e, 1, a + We + ar + At + Ht + Bt + r + n + u + e, 1, a + We + Tl + At + S + _ + r + n + u + e, 1, a + We + ir + At + Tt + Bt + r + n + u + e, 1, a + ho + Uh + xh + it + _ + r + n + u + e, 1, a + ho + Uh + xh + it + _ + r + n + u + e, 1, h + Cl + r + n + i + e, 1, l + " +lat_1=-54 +lat_2=-54.75 +lat_0=-55 +lon_0=-37" + H + _ + v + i + e, 1, a + " +lat_0=39.66825833333333 +lon_0=-8.133108333333334 +k=1" + H + _ + r + n + i + e, 1, a + Nw + tm + " +k=1" + X + un + r + n + i + e, 1, a + f + fM + k + p + _ + r + n + i + e, 1, l + " +lat_1=45.91666666666666 +lat_2=43.08333333333334" + f + fM + H + _ + r + n + i + e, 1, h + Ph + r + n + i + e, 1, h + Xf + r + n + i + e, 1, h + Qo + R + Dm + i + e, 1, a + " +lat_0=32 +lon_0=-64.75 +k=1 +x_0=550000" + na + L + n + i + e, 1, a + f + Hh + k + H + _ + w + i + e, 1, a + f + uh + k + H + _ + w + i + e, 1, a + f + _c + k + H + _ + w + i + e, 2, a + f + Hh + k + H + _ + r + n + i + e, 1, a + f + uh + k + H + _ + r + n + i + e, 1, a + f + _c + k + H + _ + r + n + i + e, 2, a + f + Hh + k + H + _ + r + n + i + e, 1, a + f + uh + k + H + _ + r + n + i + e, 1, a + f + _c + k + H + _ + r + n + i + e, 2, a + " +lat_0=-25.06855261111111 +lon_0=-130.1129671111111 +k=1 +x_0=14200 +y_0=15500" + L + n + i + e, 1, h + Fm + F + m + zm + i + e, 4, a + f + Aw + " +k=1" + Pe + Rt + r + n + i + e, 1, a + f + " +lon_0=169 +k=1" + Pe + Rt + r + n + i + e, 1, a + f + " +lon_0=179 +k=1" + Pe + Rt + r + n + i + e, 1, a + f + " +lon_0=-178 +k=1" + Pe + Rt + r + n + i + e, 2, a + f + tm + " +k=1" + Pe + Rt + r + n + i + e, 1, a + f + wo + k + p + oa + r + n + i + e, 1, l + " +lat_1=23 +lat_2=21.7 +lat_0=22.35" + dn + p + " +y_0=280296.016" + w + i + e, 1, l + " +lat_1=21.3 +lat_2=20.13333333333333 +lat_0=20.71666666666667 +lon_0=-76.83333333333333" + p + " +y_0=229126.939" + w + i + e, 1, l + ew + hd + ul + " +lon_0=-70" + vn + _ + w + i + e, 1, l + ew + hd + ul + " +lon_0=-70" + vn + _ + r + n + i + e, 1, l + ew + hd + ul + " +lon_0=-70" + vn + _ + r + n + i + e, 1, a + f + Mf + k + H + _ + w + i + e, 1, a + f + Mf + k + H + _ + r + n + i + e, 1, a + f + Mf + k + H + _ + r + n + i + e, 10, l + Cu + Eu + " +lat_0=50.797815" + vb + " +x_0=649328 +y_0=665262" + r + n + i + e, 2, a + dc + em + rv + p + up + r + n + i + e, 1, a + dc + em + rv + p + up + r + n + i + e, 1, a + dc + em + rv + p + up + r + n + i + e, 3, c + C + " +towgs84=595.48,121.69,515.35,4.115,-2.9383,0.853,-3.408" + e, 2, c + V + e, 3, c + r + n + e, 1, a + f + Ew + k + ze + _ + r + n + i + e, 1, a + f + Sw + k + ze + _ + r + n + i + e, 1, a + f + Ew + k + ze + _ + V + i + e, 1, a + f + Sw + k + ze + _ + V + i + e, 1, h + uf + m + ug + i + e, 3, rh + a_ + " +k=1" + H + _ + v + i + e, 1, a + f + Lh + " +k=1" + On + _ + d + A + i + e, 1, a + f + Lh + " +k=1" + On + _ + d + qt + i + e, 1, a + f + wo + " +k=1" + Pe + _ + d + qt + i + e, 1, a + f + Eo + " +k=1" + hr + _ + d + qt + i + e, 1, a + f + Lh + " +k=1" + Pe + _ + d + A + i + e, 1, a + f + Zs + " +k=1" + hr + _ + d + A + i + e, 1, a + f + es + " +k=1" + Vc + _ + d + A + i + e, 1, a + f + cl + " +k=1" + rc + _ + d + A + i + e, 1, a + f + Fp + " +k=1" + Ah + _ + d + qt + i + e, 3, lo + " +lat_0=46" + jy + pg + p + It + d + A + i + e, 1, a + f + " +lon_0=11.30625 +k=1.000006 +x_0=1500025.141 +y_0=-667.282" + r + n + i + e, 1, a + f + " +lon_0=13.55626666666667 +k=1.0000058 +x_0=1500044.695 +y_0=-667.13" + r + n + i + e, 1, a + f + " +lon_0=15.80628452944445 +k=1.00000561024 +x_0=1500064.274 +y_0=-667.711" + r + n + i + e, 1, a + f + " +lon_0=18.0563 +k=1.0000054 +x_0=1500083.521 +y_0=-668.8440000000001" + r + n + i + e, 1, a + f + " +lon_0=20.30631666666667 +k=1.0000052 +x_0=1500102.765 +y_0=-670.706" + r + n + i + e, 1, a + f + " +lon_0=22.55633333333333 +k=1.0000049 +x_0=1500121.846 +y_0=-672.557" + r + n + i + e, 1, l + " +lat_1=-37.5 +lat_2=-44.5 +lat_0=-41 +lon_0=173" + cC + " +y_0=7000000" + r + n + i + e, 1, l + Gt + Dt + B + " +lon_0=157" + p + _ + r + n + i + e, 2, a + f + " +lon_0=18.05787 +k=0.99999506 +x_0=100182.7406 +y_0=-6500620.1207" + r + n + i + e, 3, rh + " +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0" + _ + " +k=1.0" + i + " +nadgrids=@null +wktext " + e, 16, a + f + Oy + " +k=1" + Ns + _ + r + n + i + e, 1, a + f + wv + " +k=1" + ls + _ + r + n + i + e, 1, a + f + Eo + " +k=1" + Rs + _ + r + n + i + e, 1, a + f + rw + " +k=1" + hs + _ + r + n + i + e, 1, a + f + Rg + " +k=1" + Ls + _ + r + n + i + e, 1, a + f + Xs + " +k=1" + ic + _ + r + n + i + e, 1, a + f + jy + " +k=1" + Ps + _ + r + n + i + e, 1, a + f + Cv + " +k=1" + Ts + _ + r + n + i + e, 1, a + f + es + " +k=1" + Bs + _ + r + n + i + e, 1, a + f + Py + " +k=1" + Qs + _ + r + n + i + e, 1, a + f + " +lon_0=29 +k=1" + To + _ + r + n + i + e, 1, a + f + cl + " +k=1" + al + _ + r + n + i + e, 1, a + f + Qp + " +k=1" + go + _ + r + n + i + e, 4, c + r + n + e, 1, h + Th + r + n + i + e, 1, h + lh + r + n + i + e, 1, h + Wl + r + n + i + e, 1, a + bb + " +lon_0=46.5 +k=0.9994" + vn + _ + m + Q + i + e, 13, c + C + Xt + e, 6, a + f + wo + k + p + oa + C + Xt + i + e, 8, h + Qo + R + dh + i + e, 22, l + " +lat_1=41.25 +lat_2=42.75" + U_ + g_ + Oh + $m + r + n + i + e, 1, l + " +lat_1=42.25 +lat_2=43.75" + cd + g_ + Oh + " +y_0=2200000" + r + n + i + e, 1, l + " +lat_1=43.25 +lat_2=44.75" + ul + g_ + Oh + " +y_0=3200000" + r + n + i + e, 1, l + " +lat_1=44.25 +lat_2=45.75" + tl + g_ + Oh + " +y_0=4200000" + r + n + i + e, 1, l + " +lat_1=45.25 +lat_2=46.75 +lat_0=46" + g_ + Oh + " +y_0=5200000" + r + n + i + e, 1, l + fC + " +lat_2=47.75" + fl + g_ + Oh + " +y_0=6200000" + r + n + i + e, 1, l + " +lat_1=47.25 +lat_2=48.75 +lat_0=48" + g_ + Oh + " +y_0=7200000" + r + n + i + e, 1, l + " +lat_1=48.25 +lat_2=49.75 +lat_0=49" + g_ + Oh + " +y_0=8200000" + r + n + i + e, 1, l + " +lat_1=49.25 +lat_2=50.75" + tw + g_ + Oh + " +y_0=9200000" + r + n + i + e, 18, l + " +lat_1=37" + EM + to + po + H + _ + r + n + i + e, 1, l + " +lat_1=37" + EM + to + po + H + _ + r + n + i + e, 1, l + " +lat_1=37" + EM + to + po + H + _ + r + n + i + e, 6, fe + B + " +lat_ts=-70" + ts + " +k=1" + H + _ + v + i + e, 2, l + Hu + Js + " +lat_0=49 +lon_0=-95" + H + _ + r + n + i + e, 1, l + Hu + Js + " +lat_0=49 +lon_0=-95" + H + _ + r + n + i + e, 7, a + ow + cl + " +k=1" + D + It + R + mn + i + e, 1, a + ow + Py + " +k=1" + D + It + R + mn + i + e, 1, a + ow + Cv + " +k=1" + D + It + R + mn + i + e, 1, a + ow + Xs + " +k=1" + D + It + R + mn + i + e, 2, l + uo + co + fo + qi + j + _ + R + dh + u + e, 1, l + uo + co + fo + qi + j + vp + R + dh + u + e, 2, rh + " +lon_0=100 +lat_ts=-41" + H + _ + v + i + e, 1, fe + Os + " +lat_ts=71" + ts + " +k=1" + H + _ + v + i + e, 1, fe + Os + " +lat_ts=75" + ts + " +k=1" + H + _ + v + i + e, 1, a + f + " +lon_0=55.33333333333334 +k=1" + p + _ + v + i + e, 4, c + X_ + e, 1, c + u_ + e, 1, c + V + e, 1, c + C + e, 1, c + Es + ra + e, 1, c + qo + e, 1, c + ka + Ma + e, 1, c + R + e, 2, c + ad + id + e, 1, c + vt + ue + e, 1, c + I + e, 1, c + Ce + pe + e, 1, c + vt + " +b=6356514.996941779" + e, 1, c + Xe + Wt + e, 1, c + vc + e, 2, c + $i + Je + e, 1, c + r + e, 1, c + Ao + e, 1, c + nl + Oe + e, 1, c + m + e, 1, c + r + n + e, 0, c + r + n + e, 1, c + d + e, 1, c + dC + e, 1, a + f + " +lon_0=28.4 +k=0.9999400000000001" + D + oa + r + n + i + e, 1, c + " +a=6376523" + ky + e, 1, c + eC + xy + e, 1, c + iy + Ss + e, 1, c + L + e, 1, c + L + e, 1, c + " +a=6378136.2 +b=6356751.516927429" + e, 1, c + " +a=6378136.3 +b=6356751.616592146" + e, 1, c + My + wy + e, 2, c + _C + e, 1, h + pu + v + i + e, 1, h + hf + v + i + e, 3, c + ep + jo + e, 1, c + Yo + Lo + e, 1, c + x + e, 1, c + xc + As + e, 1, c + Io + pn + e, 1, c + r + n + e, 1, c + " +a=6371007 +b=6371007" + e, 1, a + f + Zs + k + p + Rt + r + n + i + e, 1, a + f + " +lon_0=14" + k + p + Rt + r + n + i + e, 1, a + f + " +lon_0=16" + k + p + Rt + r + n + i + e, 1, a + f + Fp + k + p + Rt + r + n + i + e, 1, c + " +a=6370997 +b=6370997" + e, 1, c + Iw + Ow + e, 1, c + jw + ng + e, 2, a + f + wv + k + p + Rt + r + n + i + e, 1, a + f + rw + k + p + Rt + r + n + i + e, 1, a + f + Xs + k + p + Rt + r + n + i + e, 1, a + f + Cv + k + p + Rt + r + n + i + e, 1, a + f + Py + k + p + Rt + r + n + i + e, 1, h + Ph + F + r + n + i + e, 1, h + Xf + F + r + n + i + e, 1, h + pu + F + r + n + i + e, 8, h + Nc + F + m + Mm + i + e, 4, c + r + n + e, 6, c + r + n + e, 1, h + jg + r + n + i + e, 1, h + hh + r + n + i + e, 4, "+proj=eqc +lat_ts=0" + f + ts + H + _ + v + i + e, 1, "+proj=eqc +lat_ts=0" + f + ts + H + _ + " +a=6371007 +b=6371007" + i + e, 5, a + f + Lh + Fl + D + oa + r + n + i + e, 1, a + f + Cc + Fl + X + oa + r + n + i + e, 1, a + f + " +lon_0=11.75" + Fl + S + oa + r + n + i + e, 1, a + f + wo + " +k=1" + vn + oa + r + n + i + e, 24, c + C + e, 1, c + r + Yp + e, 1, c + ep + jo + e, 1, c + m + zt + e, 1, c + C + ve + e, 3, c + R + Zo + e, 1, c + R + e, 1, c + R + e, 1, c + L + Kh + e, 1, c + Xe + Wt + Kl + e, 1, c + I + Ep + e, 1, c + r + Sc + e, 1, c + I + bo + e, 1, c + R + Ui + e, 1, c + R + e, 1, c + R + e, 1, c + R + e, 1, c + R + dh + e, 2, c + r + mv + e, 1, c + I + Yl + e, 1, c + I + Us + e, 1, c + Xe + Wt + $l + e, 1, c + xc + As + ao + e, 1, c + Io + pn + ye + e, 1, c + d + Xo + e, 1, c + L + n + e, 1, c + C + xo + e, 1, c + C + kp + e, 1, c + r + n + e, 1, c + r + n + e, 1, c + m + Mp + e, 1, c + m + Bo + e, 1, c + vt + ue + _d + e, 1, c + C + ko + e, 1, c + ka + Ma + e, 1, c + m + wp + e, 1, c + m + J + e, 1, c + m + e, 1, c + m + Mg + e, 1, c + C + e, 1, c + L + n + e, 1, c + d + Qf + e, 1, c + m + Om + e, 1, c + L + n + e, 1, c + r + n + e, 1, c + iy + Ss + Tf + e, 1, c + R + xm + e, 1, c + r + n + e, 1, c + r + n + e, 2, c + r + n + e, 1, c + iy + Ss + e, 1, c + I + Vd + e, 1, c + r + n + e, 2, c + d + qt + e, 1, c + d + A + e, 1, c + r + n + e, 1, c + m + Nh + e, 1, c + m + _m + e, 1, c + m + pm + e, 1, c + m + jm + e, 4, c + X_ + we + e, 1, c + r + n + e, 1, c + r + n + e, 1, c + d + e, 1, c + m + ty + e, 1, c + vt + ue + Cy + e, 1, c + m + Lf + e, 1, c + m + " +towgs84=105,326,-102.5,0,0,0.814,-0.6" + e, 1, c + m + " +towgs84=-45,417,-3.5,0,0,0.814,-0.6" + e, 1, c + I + e, 1, c + I + e, 1, c + m + e, 1, c + d + s + e, 1, c + I + us + e, 1, c + V + z + e, 1, c + V + Ve + e, 1, c + m + Dn + e, 1, c + d + Ff + e, 1, c + vt + ue + e, 1, c + m + da + e, 1, c + m + xa + e, 1, c + Ce + pe + wl + e, 1, c + I + ha + e, 1, c + C + jn + e, 1, c + I + jh + e, 1, c + vt + ue + ym + e, 1, c + d + b + e, 1, c + m + e, 1, c + R + Dm + e, 1, a + f + uc + _t + P + _ + r + n + u + e, 0, a + f + uc + _t + P + _ + r + n + u + e, 1, c + m + ua + e, 1, c + C + " +towgs84=-384,664,-48,0,0,0,0" + e, 1, c + I + no + e, 1, c + m + Fe + e, 1, c + Ce + pe + Jt + e, 1, c + vt + ue + Mo + e, 1, c + m + Mm + e, 1, c + m + io + e, 2, c + vt + ue + Wo + e, 2, c + Ao + cs + e, 1, c + m + Q + e, 1, c + m + " +towgs84=-83.11,-97.38,-117.22,0.00569291,-0.0446976,0.0442851,0.1218" + e, 1, c + I + qf + e, 4, c + m + ug + e, 1, c + _C + Ey + e, 1, c + nl + Oe + Zt + e, 1, c + Xe + Wt + th + e, 1, c + Xe + Wt + Uf + e, 1, c + My + wy + e, 1, c + R + wm + e, 1, c + Yo + Lo + e, 1, c + Xe + Wt + Hm + e, 1, c + $i + Je + me + e, 1, c + I + ry + e, 1, c + m + ps + e, 1, c + m + kt + e, 1, c + m + e, 1, c + I + Rm + e, 1, c + I + " +towgs84=-90,40,88,0,0,0,0" + e, 1, c + vt + ue + e, 1, c + R + zi + e, 1, c + m + Wd + e, 1, c + m + " +towgs84=-333,-222,114,0,0,0,0" + e, 1, c + I + " +towgs84=41,-220,-134,0,0,0,0" + e, 1, c + C + fs + e, 1, c + r + n + e, 1, c + m + $p + e, 2, c + vt + ue + $s + e, 1, c + C + Zm + e, 1, c + I + oo + e, 2, c + m + on + e, 1, c + vt + ue + zf + e, 1, c + w + e, 2, c + r + n + e, 1, c + I + lr + e, 1, c + m + Lm + e, 1, c + m + M + e, 1, c + Es + ra + Ct + e, 1, c + m + Jl + e, 1, c + vt + ue + Ge + e, 1, c + dC + e, 1, c + X_ + Ac + e, 1, c + X_ + e, 1, c + X_ + e, 1, c + C + e, 1, c + ad + id + fr + e, 1, c + vt + ue + Cm + e, 1, c + r + n + e, 1, c + d + o + e, 1, c + m + Tp + e, 1, c + Ao + e, 2, c + m + e, 1, c + C + Pi + e, 3, c + m + pd + e, 1, c + qo + qe + e, 2, c + C + e, 2, c + m + zo + e, 1, c + vc + Hi + e, 1, c + u_ + we + e, 1, c + u_ + we + e, 1, c + C + G + e, 1, c + ka + Ma + Xl + e, 1, c + Ao + e, 1, c + vt + ue + Bl + e, 2, c + C + e, 1, c + I + Ot + e, 1, c + C + e, 1, c + m + " +towgs84=-155,171,37,0,0,0,0" + e, 1, c + vt + ue + e, 1, c + m + Ho + e, 1, c + C + K + e, 1, c + m + ro + e, 1, c + C + et + e, 1, c + vt + ue + yd + e, 1, c + m + Bp + e, 2, c + L + Jc + e, 1, c + r + cg + e, 3, c + x + y + e, 2, c + x + g + e, 2, c + v + e, 64, Nn + " +lat_0=2.042583333333333 +lon_0=103.5627583333333" + H + _ + $i + Je + me + i + e, 1, Nn + " +lat_0=2.712283333333334 +lon_0=101.9411666666667 +x_0=-242.005 +y_0=-948.547" + $i + Je + me + i + e, 1, Nn + " +lat_0=3.710972222222222 +lon_0=102.4361777777778" + H + _ + $i + Je + me + i + e, 1, Nn + " +lat_0=3.680344444444444 +lon_0=101.5082444444444 +x_0=-21759.438 +y_0=55960.906" + $i + Je + me + i + e, 1, Nn + " +lat_0=4.946141666666667 +lon_0=102.8952083333333" + H + _ + $i + Je + me + i + e, 1, Nn + " +lat_0=5.421325 +lon_0=100.3458694444444" + H + _ + $i + Je + me + i + e, 1, Nn + " +lat_0=5.965147222222223 +lon_0=100.6375944444444" + H + _ + $i + Je + me + i + e, 1, Nn + " +lat_0=4.859380555555555 +lon_0=100.8167666666667" + H + " +y_0=133453.669" + $i + Je + me + i + e, 1, Nn + " +lat_0=5.893922222222222 +lon_0=102.1772916666667" + H + _ + $i + Je + me + i + e, 1, a + f + uc + _t + P + _ + w + u + e, 1, a + f + Fh + _t + P + _ + w + u + e, 1, a + f + qh + _t + P + _ + w + u + e, 1, a + f + fc + _t + P + _ + w + u + e, 1, a + f + Ug + _t + P + _ + w + u + e, 1, a + f + " +lon_0=-159" + _t + P + _ + w + u + e, 0, a + f + " +lon_0=-159" + _t + P + _ + w + u + e, 1, a + f + gM + _t + P + _ + w + u + e, 1, a + f + dy + _t + P + _ + w + u + e, 1, a + f + " +lon_0=-141" + _t + P + _ + w + u + e, 1, a + f + mM + _t + P + _ + w + u + e, 1, a + f + SM + _t + P + _ + w + u + e, 1, a + f + " +lon_0=-123" + _t + P + _ + w + u + e, 1, a + f + _c + _t + P + _ + w + u + e, 1, a + f + Hh + _t + P + _ + w + u + e, 1, a + f + " +lon_0=-105" + _t + P + _ + w + u + e, 1, a + " +lat_0=13.5 +lon_0=144.75 +k=1" + ge + Ws + r + n + i + e, 1, l + " +lat_1=-6.5 +lat_2=-11.5" + ow + Cv + p + It + R + mn + i + e, 2, a + f + Eo + " +k=1" + Ys + _ + d + qt + i + e, 1, a + f + Gv + _t + P + _ + w + u + e, 1, a + f + Zc + _t + P + _ + w + u + e, 1, a + f + Fh + _t + P + _ + r + n + u + e, 1, a + f + qh + _t + P + _ + r + n + u + e, 1, a + f + fc + _t + P + _ + r + n + u + e, 1, a + f + Ug + _t + P + _ + r + n + u + e, 1, a + f + " +lon_0=-159" + _t + P + _ + r + n + u + e, 1, a + f + gM + _t + P + _ + r + n + u + e, 1, a + f + dy + _t + P + _ + r + n + u + e, 1, a + f + " +lon_0=-141" + _t + P + _ + r + n + u + e, 1, a + f + mM + _t + P + _ + r + n + u + e, 1, a + f + SM + _t + P + _ + r + n + u + e, 1, a + f + " +lon_0=-123" + _t + P + _ + r + n + u + e, 1, a + f + _c + _t + P + _ + r + n + u + e, 1, a + f + Hh + _t + P + _ + r + n + u + e, 1, a + f + " +lon_0=-105" + _t + P + _ + r + n + u + e, 1, a + f + Xs + " +k=1" + Wc + _ + d + qt + i + e, 3, l + uo + co + fo + qi + D + Ws + r + n + i + e, 1, a + f + Gv + _t + P + _ + r + n + u + e, 1, a + f + Zc + _t + P + _ + r + n + u + e, 16, l + Rr + Lr + Y + ma + E + _ + w + u + e, 1, l + jr + Nr + We + n_ + E + vp + w + u + e, 1, l + vi + xi + ut + _n + S + _ + r + n + u + e, 5, l + " +lat_1=-18" + Cw + " +lat_0=-27" + kl + H + _ + v + i + e, 1, c + r + n + e, 4, h + qs + r + n + i + e, 3, c + r + n + e, 1, h + lh + F + r + n + i + e, 4, c + m + R_ + e, 8, c + r + n + e, 1, h + xd + r + n + i + e, 1, h + bd + r + n + i + e, 1, h + kd + r + n + i + e, 1, h + wd + r + n + i + e, 1, h + Hf + r + n + i + e, 1, h + Zf + r + n + i + e, 1, c + r + e, 1, a + f + ns + " +k=1" + ss + _ + r + i + e, 1, a + f + rs + " +k=1" + Po + _ + r + i + e, 1, a + f + ys + " +k=1" + Gs + _ + r + i + e, 1, a + f + as + " +k=1" + Ds + _ + r + i + e, 1, a + f + is + " +k=1" + Ol + _ + r + i + e, 1, a + f + ia + " +k=1" + js + _ + r + i + e, 1, a + f + Qi + " +k=1" + Ns + _ + r + i + e, 1, a + f + Ai + " +k=1" + ls + _ + r + i + e, 1, a + f + Gi + " +k=1" + Rs + _ + r + i + e, 1, a + f + ba + " +k=1" + hs + _ + r + i + e, 1, a + f + Ii + " +k=1" + Ls + _ + r + i + e, 1, a + f + ns + " +k=1" + p + _ + r + i + e, 1, a + f + rs + " +k=1" + p + _ + r + i + e, 1, a + f + ys + " +k=1" + p + _ + r + i + e, 1, a + f + as + " +k=1" + p + _ + r + i + e, 1, a + f + is + " +k=1" + p + _ + r + i + e, 1, a + f + ia + " +k=1" + p + _ + r + i + e, 1, a + f + Qi + " +k=1" + p + _ + r + i + e, 1, a + f + Ai + " +k=1" + p + _ + r + i + e, 1, a + f + Gi + " +k=1" + p + _ + r + i + e, 1, a + f + ba + " +k=1" + p + _ + r + i + e, 1, a + f + Ii + " +k=1" + p + _ + r + i + e, 1, a + f + ns + " +k=1" + Ps + _ + r + i + e, 1, a + f + wc + " +k=1" + Ts + _ + r + i + e, 1, a + f + rs + " +k=1" + Bs + _ + r + i + e, 1, a + f + ud + " +k=1" + Qs + _ + r + i + e, 1, a + f + ys + " +k=1" + To + _ + r + i + e, 1, a + f + Is + " +k=1" + al + _ + r + i + e, 1, a + f + as + " +k=1" + go + _ + r + i + e, 1, a + f + df + " +k=1" + il + _ + r + i + e, 1, a + f + is + " +k=1" + jl + _ + r + i + e, 1, a + f + mh + " +k=1" + wf + _ + r + i + e, 1, a + f + ia + " +k=1" + Cf + _ + r + i + e, 1, a + f + hc + " +k=1" + Ef + _ + r + i + e, 1, a + f + Qi + " +k=1" + Sf + _ + r + i + e, 1, a + f + Ml + " +k=1" + Af + _ + r + i + e, 1, a + f + Ai + " +k=1" + If + _ + r + i + e, 1, a + f + Qh + " +k=1" + Of + _ + r + i + e, 1, a + f + Gi + " +k=1" + jf + _ + r + i + e, 1, a + f + vh + " +k=1" + s_ + _ + r + i + e, 1, a + f + ba + " +k=1" + Nf + _ + r + i + e, 1, a + f + kl + " +k=1" + l_ + _ + r + i + e, 1, a + f + Ii + " +k=1" + Gf + _ + r + i + e, 1, a + f + ns + " +k=1" + p + _ + r + i + e, 1, a + f + wc + " +k=1" + p + _ + r + i + e, 1, a + f + rs + " +k=1" + p + _ + r + i + e, 1, a + f + ud + " +k=1" + p + _ + r + i + e, 1, a + f + ys + " +k=1" + p + _ + r + i + e, 1, a + f + Is + " +k=1" + p + _ + r + i + e, 1, a + f + as + " +k=1" + p + _ + r + i + e, 1, a + f + df + " +k=1" + p + _ + r + i + e, 1, a + f + is + " +k=1" + p + _ + r + i + e, 1, a + f + mh + " +k=1" + p + _ + r + i + e, 1, a + f + ia + " +k=1" + p + _ + r + i + e, 1, a + f + hc + " +k=1" + p + _ + r + i + e, 1, a + f + Qi + " +k=1" + p + _ + r + i + e, 1, a + f + Ml + " +k=1" + p + _ + r + i + e, 1, a + f + Ai + " +k=1" + p + _ + r + i + e, 1, a + f + Qh + " +k=1" + p + _ + r + i + e, 1, a + f + Gi + " +k=1" + p + _ + r + i + e, 1, a + f + vh + " +k=1" + p + _ + r + i + e, 1, a + f + ba + " +k=1" + p + _ + r + i + e, 1, a + f + kl + " +k=1" + p + _ + r + i + e, 1, a + f + Ii + " +k=1" + p + _ + r + i + e, 1, c + d + e, 3, c + r + n + e, 1, h + Qo + r + n + i + e, 9, a + f + ns + " +k=1" + ss + _ + d + i + e, 1, a + f + rs + " +k=1" + Po + _ + d + i + e, 1, a + f + ys + " +k=1" + Gs + _ + d + i + e, 1, a + f + as + " +k=1" + Ds + _ + d + i + e, 1, a + f + is + " +k=1" + Ol + _ + d + i + e, 1, a + f + ia + " +k=1" + js + _ + d + i + e, 1, a + f + Qi + " +k=1" + Ns + _ + d + i + e, 1, a + f + Ai + " +k=1" + ls + _ + d + i + e, 1, a + f + Gi + " +k=1" + Rs + _ + d + i + e, 1, a + f + ba + " +k=1" + hs + _ + d + i + e, 1, a + f + Ii + " +k=1" + Ls + _ + d + i + e, 1, a + f + ns + " +k=1" + p + _ + d + i + e, 1, a + f + rs + " +k=1" + p + _ + d + i + e, 1, a + f + ys + " +k=1" + p + _ + d + i + e, 1, a + f + as + " +k=1" + p + _ + d + i + e, 1, a + f + is + " +k=1" + p + _ + d + i + e, 1, a + f + ia + " +k=1" + p + _ + d + i + e, 1, a + f + Qi + " +k=1" + p + _ + d + i + e, 1, a + f + Ai + " +k=1" + p + _ + d + i + e, 1, a + f + Gi + " +k=1" + p + _ + d + i + e, 1, a + f + ba + " +k=1" + p + _ + d + i + e, 1, a + f + Ii + " +k=1" + p + _ + d + i + e, 11, c + I + e, 1, c + I + Em + e, 1, c + I + Sm + e, 1, c + I + Am + e, 1, c + I + Im + e, 1, c + I + gv + e, 1, c + I + dm + e, 1, c + I + yp + e, 1, c + R + e, 1, c + R + e, 1, c + Ut + O + e, 1, c + m + ph + e, 1, c + r + n + e, 1, c + C + ms + e, 1, c + m + Gh + e, 1, c + m + wg + e, 1, c + m + gm + e, 1, c + r + n + e, 1, c + V + Lt + e, 1, c + r + n + e, 1, c + I + " +towgs84=-106,-129,165,0,0,0,0" + e, 1, c + m + mm + e, 1, c + m + Cg + e, 1, c + m + Pf + e, 1, c + r + n + e, 1, c + m + Nm + e, 1, c + m + Ig + e, 1, c + r + n + e, 1, c + m + Gm + e, 1, c + m + kc + e, 1, c + m + vv + e, 2, c + m + Eg + e, 1, c + m + Lp + e, 3, c + m + " +towgs84=365,194,166,0,0,0,0" + e, 1, c + m + " +towgs84=325,154,172,0,0,0,0" + e, 1, c + R + Um + e, 1, c + m + Sg + e, 2, c + m + _h + e, 1, c + m + vm + e, 1, c + m + cu + e, 1, c + m + Jo + e, 2, c + m + Ag + e, 1, a + f + Lh + _t + il + _ + r + n + i + e, 5, a + f + ns + " +k=1" + Ps + _ + d + i + e, 1, a + f + wc + " +k=1" + Ts + _ + d + i + e, 1, a + f + rs + " +k=1" + Bs + _ + d + i + e, 1, a + f + ud + " +k=1" + Qs + _ + d + i + e, 1, a + f + ys + " +k=1" + To + _ + d + i + e, 1, c + " +a=6377019.27 +b=6355762.5391 +towgs84=-28,199,5,0,0,0,0" + e, 1, c + m + fh + e, 1, c + r + n + e, 1, c + m + Dh + e, 1, c + r + n + e, 1, c + m + Kp + e, 1, c + m + D_ + e, 1, c + m + gp + e, 1, c + m + K_ + e, 1, c + C + $_ + e, 1, c + L + n + e, 1, c + m + " +towgs84=-86,-98,-119,0,0,0,0" + e, 1, c + r + n + e, 1, c + L + n + e, 1, c + vt + ue + e, 1, c + m + Pm + e, 1, c + m + gd + e, 1, c + r + n + e, 1, c + R + " +towgs84=-100,-248,259,0,0,0,0" + e, 1, c + d + e, 1, c + d + e, 1, c + d + " +towgs84=44.585,-131.212,-39.544,0,0,0,0" + e, 1, c + I + " +towgs84=-80.01,253.26,291.19,0,0,0,0" + e, 1, c + I + " +towgs84=124.5,-63.5,-281,0,0,0,0" + e, 2, c + Xe + Wt + Sy + e, 1, c + R + xe + e, 1, c + m + " +towgs84=-133,-321,50,0,0,0,0" + e, 2, c + r + n + e, 1, c + r + Re + e, 1, c + m + hu + e, 1, c + m + bc + e, 1, c + m + du + e, 1, c + m + _u + e, 1, c + m + Pp + e, 1, c + L + bm + e, 1, c + L + n + e, 1, c + R + mn + e, 1, c + I + e, 1, c + I + e, 1, c + m + km + e, 1, c + I + ey + e, 1, c + I + e, 1, c + I + eo + e, 1, c + r + n + e, 1, c + I + e, 1, c + m + e, 1, c + m + e, 1, c + Ao + ny + e, 1, c + m + " +towgs84=114,-116,-333,0,0,0,0" + e, 1, c + V + " +towgs84=-491,-22,435,0,0,0,0" + e, 1, c + m + " +towgs84=145,75,-272,0,0,0,0" + e, 1, c + m + " +towgs84=-320,550,-494,0,0,0,0" + e, 1, c + m + " +towgs84=124,-234,-25,0,0,0,0" + e, 1, c + m + " +towgs84=-205,107,53,0,0,0,0" + e, 1, c + I + " +towgs84=-79,-129,145,0,0,0,0" + e, 1, c + m + " +towgs84=-127,-769,472,0,0,0,0" + e, 1, c + m + " +towgs84=-104,-129,239,0,0,0,0" + e, 1, c + m + " +towgs84=298,-304,-375,0,0,0,0" + e, 1, c + R + " +towgs84=-2,151,181,0,0,0,0" + e, 1, c + m + " +towgs84=230,-199,-752,0,0,0,0" + e, 1, c + m + " +towgs84=211,147,111,0,0,0,0" + e, 1, c + x + y + e, 1, c + m + Ql + e, 1, c + m + " +towgs84=-794,119,-298,0,0,0,0" + e, 1, c + R + cc + e, 1, c + m + " +towgs84=208,-435,-229,0,0,0,0" + e, 1, c + m + " +towgs84=189,-79,-202,0,0,0,0" + e, 1, c + R + Ic + e, 1, c + m + " +towgs84=403,-81,277,0,0,0,0" + e, 1, c + m + " +towgs84=-307,-92,127,0,0,0,0" + e, 1, c + m + zm + e, 1, c + m + " +towgs84=170,42,84,0,0,0,0" + e, 2, c + " +a=6378270 +b=6356794.343434343 +towgs84=102,52,-38,0,0,0,0" + e, 1, c + m + " +towgs84=276,-57,149,0,0,0,0" + e, 1, c + m + " +towgs84=-632,438,-609,0,0,0,0" + e, 1, c + m + " +towgs84=647,1777,-1124,0,0,0,0" + e, 1, c + I + " +towgs84=260,12,-147,0,0,0,0" + e, 1, c + r + n + e, 1, c + ka + Ma + e, 1, c + m + " +towgs84=-156,-271,-189,0,0,0,0" + e, 1, c + " +a=6378136 +b=6356751.361745712 +towgs84=0,0,1.5,-0,-0,0.076,0" + e, 1, c + m + e, 1, c + r + e, 1, c + I + fa + e, 1, c + I + e, 1, c + C + e, 1, c + C + e, 1, c + r + n + e, 1, c + Tv + ZM + dd + e, 1, c + r + n + e, 1, c + L + Cp + e, 1, c + XM + by + e, 1, c + Tv + ZM + dd + e, 1, c + m + e, 1, c + m + W + e, 1, c + L + n + e, 1, c + L + Li + e, 1, c + L + e, 1, c + L + n + e, 1, c + r + n + e, 1, c + dC + e, 1, c + r + n + e, 1, c + L + n + e, 1, c + L + n + e, 1, c + r + n + e, 1, c + r + n + e, 1, a + f + Is + " +k=1" + al + _ + d + i + e, 1, a + f + as + " +k=1" + go + _ + d + i + e, 1, a + f + df + " +k=1" + il + _ + d + i + e, 1, a + f + is + " +k=1" + jl + _ + d + i + e, 1, a + f + mh + " +k=1" + wf + _ + d + i + e, 1, a + f + ia + " +k=1" + Cf + _ + d + i + e, 1, a + f + hc + " +k=1" + Ef + _ + d + i + e, 1, a + f + Qi + " +k=1" + Sf + _ + d + i + e, 1, a + f + Ml + " +k=1" + Af + _ + d + i + e, 1, a + f + Ai + " +k=1" + If + _ + d + i + e, 1, a + f + Qh + " +k=1" + Of + _ + d + i + e, 1, a + f + Gi + " +k=1" + jf + _ + d + i + e, 1, a + f + vh + " +k=1" + s_ + _ + d + i + e, 1, a + f + ba + " +k=1" + Nf + _ + d + i + e, 1, a + f + kl + " +k=1" + l_ + _ + d + i + e, 1, a + f + Ii + " +k=1" + Gf + _ + d + i + e, 1, a + f + ns + " +k=1" + p + _ + d + i + e, 1, a + f + wc + " +k=1" + p + _ + d + i + e, 1, a + f + rs + " +k=1" + p + _ + d + i + e, 1, a + f + ud + " +k=1" + p + _ + d + i + e, 1, a + f + ys + " +k=1" + p + _ + d + i + e, 1, a + f + Is + " +k=1" + p + _ + d + i + e, 1, a + f + as + " +k=1" + p + _ + d + i + e, 1, a + f + df + " +k=1" + p + _ + d + i + e, 1, a + f + is + " +k=1" + p + _ + d + i + e, 1, a + f + mh + " +k=1" + p + _ + d + i + e, 1, a + f + ia + " +k=1" + p + _ + d + i + e, 1, a + f + hc + " +k=1" + p + _ + d + i + e, 1, a + f + Qi + " +k=1" + p + _ + d + i + e, 1, a + f + Ml + " +k=1" + p + _ + d + i + e, 1, a + f + Ai + " +k=1" + p + _ + d + i + e, 1, a + f + Qh + " +k=1" + p + _ + d + i + e, 1, a + f + Gi + " +k=1" + p + _ + d + i + e, 1, a + f + vh + " +k=1" + p + _ + d + i + e, 1, a + f + ba + " +k=1" + p + _ + d + i + e, 1, c + C + xo + " +pm=bern" + e, 1, c + m + ua + " +pm=bogota" + e, 1, c + m + da + Gw + e, 1, c + C + fs + J_ + e, 1, c + C + Xt + Mc + e, 1, c + m + on + " +pm=rome" + e, 1, c + vt + ue + Ge + Ec + e, 1, c + C + J_ + e, 1, c + m + " +pm=brussels" + e, 1, c + m + zo + Ec + e, 1, c + vt + ue + Bl + Ec + e, 1, a + f + kl + " +k=1" + p + _ + d + i + e, 0, a + f + kl + " +k=1" + p + _ + d + i + e, 1, c + C + jn + J_ + e, 1, c + C + " +pm=stockholm" + e, 1, c + C + " +pm=athens" + e, 1, c + vt + ue + Mo + Ec + e, 1, c + Es + ra + Ct + Gg + e, 1, c + C + ko + Mc + e, 2, c + C + ms + J_ + e, 1, c + vt + ue + Ec + e, 1, a + f + Ii + " +k=1" + p + _ + d + i + e, 1, c + m + e, 1, c + m + e, 2, l + " +lat_1=15 +lat_2=16.66666666666667 +lat_0=15.83333333333333 +lon_0=-24 +x_0=161587.83 +y_0=128511.202" + v + i + e, 13, l + kb + Mb + Ev + pM + H + _ + r + n + i + e, 62, c + " +a=6376523" + ky + mw + e, 2, c + eC + xy + " +pm=madrid" + e, 1, c + C + $_ + Gw + e, 109, c + r + n + e, 1, h + vd + r + n + i + e, 1, h + m_ + r + n + i + e, 1, h + hh + r + n + i + e, 2, a + be + Fv + " +k=1" + H + _ + m + da + i + e, 23, fe + Os + ly + ts + Yy + Ee + Gn + v + i + e, 1, fe + B + " +lat_ts=-90" + ts + Yy + Ee + Gn + v + i + e, 6, h + pu + r + n + i + e, 21, dr + Zg + ws + sw + $d + H + _ + w + i + e, 1, dr + Zg + ws + sw + $d + H + _ + r + n + i + e, 1, dr + Zg + ws + sw + $d + H + _ + r + n + i + e, 1, dr + Zg + ws + sw + $d + H + _ + r + n + i + e, 33, a + Ei + " +lon_0=5.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=6.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=7.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=8.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=9.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + pM + " +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=11.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=12.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=13.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=14.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=15.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + fM + " +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=17.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=18.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=19.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=20.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=21.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=22.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=23.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=24.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=25.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=26.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=27.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=28.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=29.5 +k=1" + ge + ot + r + n + i + e, 1, a + Ei + " +lon_0=30.5 +k=1" + ge + ot + r + n + i + e, 2, c + C + e, 35, a + In + $f + " +k=1" + D + It + C + i + e, 1, a + In + dg + " +k=1" + D + " +y_0=550000" + C + i + e, 1, a + In + _g + " +k=1" + D + It + C + i + e, 1, a + In + dg + " +k=1" + D + It + C + i + e, 1, a + In + ba + " +k=1" + D + It + C + i + e, 1, a + In + $f + " +k=1" + D + It + C + i + e, 1, a + In + " +lon_0=125.0028902777778 +k=1" + D + It + C + i + e, 1, a + In + wb + " +k=1" + D + It + C + i + e, 1, a + In + wb + " +k=1" + D + " +y_0=550000" + C + i + e, 1, a + In + " +lon_0=129.0028902777778 +k=1" + D + It + C + i + e, 1, a + In + " +lon_0=131.0028902777778 +k=1" + D + It + C + i + e, 1, a + In + sp + _t + ke + Gn + C + i + e, 1, a + In + sp + _t + ke + Gn + r + n + i + e, 1, a + In + _g + " +k=1" + D + It + r + n + i + e, 1, a + In + dg + " +k=1" + D + It + r + n + i + e, 1, a + In + dg + " +k=1" + D + " +y_0=550000" + r + n + i + e, 1, a + In + ba + " +k=1" + D + It + r + n + i + e, 1, a + In + $f + " +k=1" + D + It + r + n + i + e, 1, a + In + _g + " +k=1" + D + hy + r + n + i + e, 1, a + In + dg + " +k=1" + D + hy + r + n + i + e, 1, a + In + ba + " +k=1" + D + hy + r + n + i + e, 1, a + In + $f + " +k=1" + D + hy + r + n + i + e, 33, hg + Tg + " +lon_0=42.5" + gu + k + H + _ + C + ko + Mc + i + e, 2, a + f + Zs + _t + p + It + v + i + e, 5, c + C + Oc + e, 1, c + C + Oc + Mc + e, 4, c + Xe + Wt + fu + e, 1, a + " +lat_0=7.000480277777778 +lon_0=80.77171111111112 +k=0.9999238418" + D + Ws + Xe + Wt + Hm + i + e, 1, a + " +lat_0=7.000471527777778 +lon_0=80.77171308333334 +k=0.9999238418" + p + It + Xe + Wt + fu + i + e, 8, l + kb + Mb + Ev + pM + H + _ + r + n + i + e, 3, c + r + e, 1, yn + ay + iw + wC + ip + H + _ + Bh + yl + r + i + e, 5, c + r + n + e, 1, a + f + es + " +k=1" + p + _ + r + n + i + e, 1, a + f + cl + " +k=1" + p + _ + r + n + i + e, 1, a + f + Hs + " +k=1" + p + _ + r + n + i + e, 1, a + f + B_ + " +k=1" + p + _ + r + n + i + e, 1, a + f + Zu + " +k=1" + p + _ + r + n + i + e, 1, a + f + Q_ + " +k=1" + p + _ + r + n + i + e, 1, a + f + eh + " +k=1" + p + _ + r + n + i + e, 5, c + r + n + e, 2, a + f + Is + " +k=1" + ze + _ + r + n + i + e, 3, a + f + es + " +k=1" + Vc + _ + r + n + i + e, 1, a + f + cl + " +k=1" + rc + _ + r + n + i + e, 1, a + f + Hs + " +k=1" + wh + _ + r + n + i + e, 1, a + f + B_ + " +k=1" + ac + _ + r + n + i + e, 1, a + f + Zu + " +k=1" + ss + _ + r + n + i + e, 1, a + f + Q_ + " +k=1" + Po + _ + r + n + i + e, 1, a + f + eh + " +k=1" + Gs + _ + r + n + i + e, 17, a + f + " +lon_0=90.73333333333333 +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=89.55 +k=1" + ze + _r + r + n + i + e, 1, a + f + Cb + " +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=90.03333333333333 +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=90.15000000000001 +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=91.13333333333334 +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=91.23333333333333 +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=89.34999999999999 +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=91.34999999999999 +k=1" + ze + _r + r + n + i + e, 1, a + f + Cb + " +k=1" + ze + _r + r + n + i + e, 1, a + f + Eb + " +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=89.06666666666666 +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=90.26666666666667 +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=89.55 +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=91.75 +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=90.5 +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=90.16666666666667 +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=90.11666666666666 +k=1" + ze + _r + r + n + i + e, 1, a + f + Eb + " +k=1" + ze + _r + r + n + i + e, 1, a + f + " +lon_0=90.86666666666666 +k=1" + ze + _r + r + n + i + e, 5, a + f + " +lon_0=-7 +k=0.999997" + D + " +y_0=-6000000" + r + n + i + e, 4, l + yM + " +lat_2=54.5" + f + Yf + ke + _ + r + n + i + e, 1, l + yM + " +lat_2=54.5" + f + Yf + ke + _ + r + n + i + e, 3, c + r + n + e, 1, l + " +lat_1=64.25 +lat_2=65.75 +lat_0=65 +lon_0=-19" + Oh + Ms + r + n + i + e, 4, rh + A_ + bw + hp + cy + C + ms + J_ + i + e, 1, rh + A_ + bw + hp + cy + C + jn + J_ + i + e, 1, rh + A_ + bw + hp + cy + C + fs + J_ + i + e, 6, h + vd + F + m + xa + i + e, 3, c + r + n + e, 3, a + B + Nv + " +k=1" + xt + _ + r + n + i + e, 1, a + B + Zc + " +k=1" + On + _ + r + n + i + e, 1, a + B + np + " +k=1" + Pe + _ + r + n + i + e, 1, a + B + oy + " +k=1" + hr + _ + r + n + i + e, 1, a + B + Dv + " +k=1" + wa + _ + r + n + i + e, 1, a + B + Dw + " +k=1" + Ah + _ + r + n + i + e, 1, a + B + rd + " +k=1" + Ys + _ + r + n + i + e, 5, c + r + n + e, 1, h + Qo + F + r + n + i + e, 1, h + bs + F + r + n + i + e, 1, h + qs + F + r + n + i + e, 3, c + r + n + e, 1, h + bs + F + r + n + i + e, 1, h + Fs + F + r + n + i + e, 3, c + L + n + e, 2, a + f + Yf + k + p + _ + L + n + i + e, 4, c + r + n + e, 2, c + r + n + e, 8, c + L + n + e, 1, h + qs + F + L + n + i + e, 1, h + Cl + F + L + n + i + e, 4, h + Fs + F + r + n + i + e, 2, h + bs + F + r + n + i + e, 4, c + r + n + e, 3, h + m_ + F + r + n + i + e, 55, c + R + Te + e, 5, l + " +lat_1=10.46666666666667 +lat_0=10.46666666666667 +lon_0=-84.33333333333333 +k_0=0.99995696" + p + " +y_0=271820.522" + R + Te + i + e, 1, l + " +lat_1=9 +lat_0=9" + qv + " +k_0=0.99995696" + p + " +y_0=327987.436" + R + Te + i + e, 2, l + " +lat_1=14.9 +lat_0=14.9" + Ze + " +k_0=0.99989906" + p + " +y_0=325992.681" + R + Te + i + e, 1, l + " +lat_1=13.78333333333333 +lat_0=13.78333333333333 +lon_0=-89 +k_0=0.99996704" + p + " +y_0=295809.184" + R + Te + i + e, 1, l + " +lat_1=13.86666666666667 +lat_0=13.86666666666667" + av + " +k_0=0.99990314" + p + " +y_0=359891.816" + R + Te + i + e, 1, l + " +lat_1=11.73333333333333 +lat_0=11.73333333333333" + av + " +k_0=0.9999222800000001" + p + " +y_0=288876.327" + R + Te + i + e, 1, h + bl + V + Lt + i + e, 1, c + ka + Ma + e, 3, c + R + e, 2, l + " +lat_1=8.416666666666666 +lat_0=8.416666666666666 +lon_0=-80 +k_0=0.99989909" + p + " +y_0=294865.303" + R + i + e, 3, Lv + " +lat_0=8.25" + dn + " +x_0=914391.7962 +y_0=999404.7217154861" + R + " +to_meter=0.9143917962" + e, 7, l + Gt + Dt + " +lat_0=-78 +lon_0=163" + iv + Ih + r + n + i + e, 1, l + " +lat_1=-73.66666666666667" + wt + " +lat_0=-74.5" + ed + nc + Ni + r + n + i + e, 1, l + " +lat_1=-70.66666666666667 +lat_2=-72.33333333333333 +lat_0=-71.5" + Aw + cC + ot + r + n + i + e, 1, fe + B + " +lat_ts=-90" + mg + Yy + nc + ot + r + n + i + e, 7, c + r + n + e, 1, h + Qo + r + n + i + e, 23, hg + Tg + Sb + gu + k + H + _ + C + ko + i + e, 1, hg + Tg + Sb + gu + k + H + _ + C + ko + i + e, 4, a + Nw + tm + " +k=1" + uy + " +y_0=650000" + m + Pm + i + e, 1, a + Nw + tm + " +k=1" + uy + " +y_0=650000" + m + gd + i + e, 1, a + f + g_ + " +k=1" + xt + _ + C + et + i + e, 3, a + f + " +lon_0=11.5" + _t + xt + aa + v + i + e, 1, c + m + e, 3, c + V + se + e, 3, Lv + f + rd + nc + Rt + V + se + i + e, 1, h + qs + F + V + se + i + e, 2, h + Nc + F + V + se + i + e, 1, h + Cd + F + V + se + i + e, 1, h + vd + F + V + se + i + e, 1, h + qs + F + m + i + e, 1, h + Cl + F + m + i + e, 1, h + Nc + F + m + i + e, 1, h + Cd + F + m + i + e, 7, c + r + n + e, 4, h + Md + F + r + n + i + e, 1, h + T_ + F + r + n + i + e, 1, h + Ky + F + r + n + i + e, 7, l + " +lat_1=16.81666666666667 +lat_0=16.81666666666667" + Ze + " +k_0=0.99992226" + p + " +y_0=292209.579" + R + Te + i + e, 2, c + d + ce + e, 1, a + f + Eo + " +k=1" + hr + _ + d + ce + i + e, 1, a + f + es + " +k=1" + wa + _ + d + ce + i + e, 1, a + f + Hs + " +k=1" + Ah + _ + d + ce + i + e, 1, a + f + Zu + " +k=1" + Ys + _ + d + ce + i + e, 1, a + f + Eo + " +k=1" + p + _ + d + ce + i + e, 1, a + f + es + " +k=1" + p + _ + d + ce + i + e, 1, a + f + Hs + " +k=1" + p + _ + d + ce + i + e, 1, a + f + Zu + " +k=1" + p + _ + d + ce + i + e, 19, lo + Sl + nC + Bg + Et + " +y_0=304800" + w + Z + e, 1, a + " +lat_0=17.06124194444444 +lon_0=-88.6318575 +k=1 +x_0=66220.02833082761 +y_0=135779.5099885299" + ka + Ma + qc + e, 4, c + r + n + e, 3, a + f + " +lon_0=11.33333333333333 +k=1" + ke + _ + r + n + i + e, 27, a + Oi + qv + " +k=0.999942857" + j + _ + w + u + e, 1, a + Oi + ya + Cs + j + _ + w + u + e, 1, a + Oi + " +lon_0=-88.75" + Cs + j + _ + w + u + e, 2, a + f + xw + _t + p + _ + m + Q + i + e, 2, h + lh + F + L + Kh + i + e, 2, a + f + Lh + " +k=1" + On + _ + d + A + i + e, 1, l + nw + Jp + Z_ + Cc + $u + qy + r + n + i + e, 1, gs + Z_ + Cc + Uy + zy + r + n + i + e, 1, l + nw + Jp + Z_ + Cc + $u + qy + r + n + i + e, 1, gs + Z_ + Cc + Uy + zy + r + n + i + e, 1, gs + Z_ + Cc + Uy + zy + r + n + i + e, 1, l + nw + Jp + Z_ + Cc + $u + qy + r + n + i + e, 1, gs + Z_ + Cc + Uy + zy + r + n + i + e, 1, l + nw + Jp + Z_ + Cc + $u + qy + r + n + i + e, 2, rh + " +lon_0=-43 +lat_ts=-2" + nc + Rt + r + n + i + e, 2, l + " +lat_1=52.66666666666666 +lat_2=54.33333333333334 +lat_0=48" + Cc + " +x_0=815000" + _ + m + Q + i + e, 1, h + Wl + F + r + n + i + e, 2, a + ji + ec + Pl + it + _ + r + n + u + e, 3, a + f + g_ + _t + go + _ + r + n + i + e, 1, a + f + wo + _t + jl + _ + r + n + i + e, 1, a + f + g_ + _t + go + _ + r + n + i + e, 1, a + f + Lh + _t + il + _ + r + n + i + e, 1, a + f + wo + _t + jl + _ + r + n + i + e, 1, a + ji + ec + Pl + it + _ + r + n + u + e, 1, a + ji + ec + Pl + it + _ + r + n + u + e, 4, a + f + Lh + _t + " +x_0=500053 +y_0=-3999820" + m + on + i + e, 4, a + f + wo + " +k=1" + Pe + _ + d + A + i + e, 1, a + f + Lh + " +k=1" + On + _ + d + qt + i + e, 1, a + f + wo + " +k=1" + Pe + _ + d + qt + i + e, 1, a + f + Lh + " +k=1" + Pe + _ + C + i + e, 1, a + f + Zs + " +k=1" + hr + _ + C + i + e, 1, a + f + Zs + " +k=1" + hr + _ + C + i + e, 1, a + f + wo + " +k=1" + wa + _ + C + i + e, 1, a + f + Lh + " +k=1" + Pe + _ + d + A + i + e, 1, a + f + Zs + " +k=1" + hr + _ + d + A + i + e, 1, a + f + wo + " +k=1" + wa + _ + d + A + i + e, 1, a + f + Lh + " +k=1" + Pe + _ + d + qt + i + e, 1, a + f + Zs + " +k=1" + hr + _ + d + qt + i + e, 1, a + f + wo + " +k=1" + wa + _ + d + qt + i + e, 1, a + f + xw + " +k=1" + On + _ + C + et + i + e, 1, a + f + Lh + " +k=1" + Pe + _ + C + et + i + e, 1, a + f + Zs + " +k=1" + hr + _ + C + et + i + e, 1, a + f + wo + " +k=1" + wa + _ + C + et + i + e, 1, a + f + g_ + " +k=1" + xt + _ + C + et + i + e, 1, c + C + e, 1, a + f + xw + " +k=1" + On + _ + C + i + e, 1, a + f + Lh + " +k=1" + Pe + _ + C + i + e, 1, a + f + Zs + " +k=1" + hr + _ + C + i + e, 1, a + f + wo + " +k=1" + wa + _ + C + i + e, 15, h + Og + F + r + n + i + e, 125, a + " +lat_0=-35.31773627777778 +lon_0=149.0092948305555 +k=1.000086" + D + hy + V + z + i + e, 11, h + Th + L + n + i + e, 1, h + lf + L + n + i + e, 2, h + bl + F + r + n + i + e, 3, a + f + Zs + _t + p + Rt + v + i + e, 2, a + f + cl + k + p + Rt + r + n + i + e, 14, h + Cl + F + V + se + i + e, 17, h + Fs + F + V + se + i + e, 1, h + bs + F + V + se + i + e, 1, h + Qo + F + V + se + i + e, 2, h + lh + F + m + R_ + i + e, 1, Lv + f + rd + nc + Rt + r + n + i + e, 6, c + r + e, 1, a + f + qh + _t + xt + Ih + r + i + e, 3, fe + Os + " +lat_ts=70" + Is + " +k=1" + H + _ + jw + ng + i + e, 31, l + lw + Js + ml + Hh + H + _ + v + i + e, 1, l + lw + Js + ml + Rv + H + _ + v + i + e, 1, l + lw + Js + ml + Hs + H + _ + v + i + e, 1, l + lw + Js + ml + ia + H + _ + v + i + e, 1, l + lw + Js + ml + Fh + H + _ + v + i + e, 1, l + dl + hw + vl + Hh + H + _ + v + i + e, 1, l + dl + hw + vl + Rv + H + _ + v + i + e, 1, l + dl + hw + vl + Hs + H + _ + v + i + e, 1, l + dl + hw + vl + ia + H + _ + v + i + e, 1, l + dl + hw + vl + Fh + H + _ + v + i + e, 1, l + uw + cw + xl + Hh + H + _ + v + i + e, 1, l + uw + cw + xl + Rv + H + _ + v + i + e, 1, l + uw + cw + xl + Hs + H + _ + v + i + e, 1, l + uw + cw + xl + ia + H + _ + v + i + e, 1, l + uw + cw + xl + Fh + H + _ + v + i + e, 1, fe + Os + ly + Fd + Yy + Ee + Gn + v + i + e, 1, fe + Os + ly + _n + Yy + Ee + Gn + v + i + e, 1, fe + Os + ly + " +lon_0=-33" + Yy + Ee + Gn + v + i + e, 1, fe + Os + ly + Fp + Yy + Ee + Gn + v + i + e, 1, fe + Os + ly + ia + Yy + Ee + Gn + v + i + e, 110, l + Sv + ds + _s + " +lon_0=-30" + Ps + ur + r + n + i + e, 1, l + En + Sn + An + " +lon_0=-52" + js + zl + r + n + i + e, 1, l + En + Sn + An + " +lon_0=-12" + ls + zl + r + n + i + e, 1, l + Ae + Js + Ie + Zc + To + Ks + r + n + i + e, 1, l + Ae + Js + Ie + Rv + go + Ks + r + n + i + e, 1, l + Ae + Js + Ie + " +lon_0=-10" + jl + Ks + r + n + i + e, 1, l + dl + le + he + " +lon_0=-64" + ls + yo + r + n + i + e, 1, l + dl + le + he + Rv + hs + yo + r + n + i + e, 1, l + dl + le + he + " +lon_0=-14" + ic + yo + r + n + i + e, 1, l + yt + gt + mt + Vf + jf + aa + r + n + i + e, 1, l + yt + gt + mt + " +lon_0=-42" + Nf + aa + r + n + i + e, 1, l + yt + gt + mt + " +lon_0=-22" + Gf + aa + r + n + i + e, 1, l + rn + Kd + an + Rw + Ts + Hl + r + n + i + e, 1, l + rn + Kd + an + " +lon_0=-38" + Qs + Hl + r + n + i + e, 1, l + rn + Kd + an + " +lon_0=-20" + al + Hl + r + n + i + e, 1, l + " +lat_1=67" + Ab + Ib + " +lon_0=-51" + wh + lC + r + n + i + e, 1, l + " +lat_1=67" + Ab + Ib + " +lon_0=-34" + ss + lC + r + n + i + e, 1, l + Ob + jb + Nb + " +lon_0=-52" + ls + " +y_0=8500000" + r + n + i + e, 1, l + Ob + jb + Nb + " +lon_0=-37" + hs + " +y_0=8500000" + r + n + i + e, 1, l + En + Sn + An + " +lon_0=16" + hs + zl + r + n + i + e, 1, l + Ae + Js + Ie + Eo + wh + Ks + r + n + i + e, 1, l + dl + le + he + Cc + Ts + yo + r + n + i + e, 1, l + dl + le + he + fw + Qs + yo + r + n + i + e, 1, l + yt + gt + mt + " +lon_0=14" + wh + aa + r + n + i + e, 1, l + yt + gt + mt + fw + ss + aa + r + n + i + e, 1, l + En + Sn + An + " +lon_0=53" + ic + zl + v + i + e, 1, l + En + Sn + An + as + Ts + zl + v + i + e, 1, l + Ae + Js + Ie + " +lon_0=52" + ss + Ks + v + i + e, 1, l + Ae + Js + Ie + " +lon_0=83" + Gs + Ks + v + i + e, 1, l + Ae + Js + Ie + Ml + Ol + Ks + v + i + e, 1, l + Ae + Js + Ie + " +lon_0=145" + Ns + Ks + v + i + e, 1, l + dl + le + he + " +lon_0=58" + al + yo + v + i + e, 1, l + dl + le + he + " +lon_0=82" + il + yo + v + i + e, 1, l + dl + le + he + kw + wf + yo + v + i + e, 1, l + dl + le + he + " +lon_0=130" + Ef + yo + v + i + e, 1, l + dl + le + he + Mw + Af + yo + v + i + e, 1, l + dl + le + he + " +lon_0=179" + Of + yo + v + i + e, 1, l + yt + gt + mt + Pg + Gs + aa + v + i + e, 1, l + yt + gt + mt + " +lon_0=74" + Ol + aa + v + i + e, 1, l + yt + gt + mt + " +lon_0=95" + Ns + aa + v + i + e, 1, l + yt + gt + mt + " +lon_0=116" + Rs + aa + v + i + e, 1, l + yt + gt + mt + " +lon_0=137" + Ls + aa + v + i + e, 1, l + yt + gt + mt + " +lon_0=158" + Ps + aa + v + i + e, 1, l + yt + gt + mt + " +lon_0=179" + Bs + aa + v + i + e, 1, l + yt + gt + mt + " +lon_0=-163" + To + aa + r + n + i + e, 1, l + yt + gt + mt + dy + go + aa + r + n + i + e, 1, l + rn + Kd + an + Ug + Po + Hl + r + n + i + e, 1, l + rn + Kd + an + dy + Ds + Hl + r + n + i + e, 1, l + Sv + ds + _s + Ue + Ls + ur + r + n + i + e, 1, l + En + Sn + An + Hg + Po + zl + r + n + i + e, 1, l + En + Sn + An + Gv + Ds + zl + r + n + i + e, 1, l + Ae + Js + Ie + SM + Ps + Ks + r + n + i + e, 1, l + Ae + Js + Ie + gh + Bs + Ks + r + n + i + e, 1, l + Ae + Js + Ie + Zc + To + Ks + r + n + i + e, 1, l + dl + le + he + SM + Po + yo + r + n + i + e, 1, l + dl + le + he + " +lon_0=-104" + Ds + yo + r + n + i + e, 1, l + dl + le + he + Kf + js + yo + r + n + i + e, 1, l + yt + gt + mt + " +lon_0=-131" + jl + aa + r + n + i + e, 1, l + yt + gt + mt + Hh + Cf + aa + r + n + i + e, 1, l + yt + gt + mt + " +lon_0=-91" + Sf + aa + r + n + i + e, 1, l + yt + gt + mt + " +lon_0=-71" + If + aa + r + n + i + e, 1, l + rn + Kd + an + " +lon_0=-132" + js + Hl + r + n + i + e, 1, l + rn + Kd + an + " +lon_0=-113" + ls + Hl + r + n + i + e, 1, l + rn + Kd + an + nd + hs + Hl + r + n + i + e, 1, l + rn + Kd + an + Gv + ic + Hl + r + n + i + e, 1, l + Sv + ds + _s + cl + Bs + ur + v + i + e, 1, l + Sv + ds + _s + Is + To + ur + v + i + e, 1, l + Sv + ds + _s + a_ + go + ur + v + i + e, 1, l + Sv + ds + _s + Fd + Rs + ur + v + i + e, 1, l + En + Sn + An + " +lon_0=133" + Qs + zl + v + i + e, 1, l + En + Sn + An + Aw + rc + zl + v + i + e, 1, l + En + Sn + An + kf + ac + zl + v + i + e, 1, l + Ae + Js + Ie + " +lon_0=176" + Rs + Ks + v + i + e, 1, l + Ae + Js + Ie + gM + Ls + Ks + v + i + e, 1, l + dl + le + he + " +lon_0=-155" + ac + yo + v + i + e, 1, l + yt + gt + mt + " +lon_0=-5" + yw + aa + r + n + i + e, 3, h + bl + R + cc + Z + e, 1, h + bl + R + Ic + Z + e, 6, c + r + n + e, 69, a + f + Eo + k + p + _ + C + Xt + i + e, 3, c + Xe + Wt + " +towgs84=293.17,726.18,245.36,0,0,0,0" + e, 3, h + Nc + r + n + i + e, 1, h + Cd + r + n + i + e, 96, l + uo + co + fo + qi + D + Ws + r + i + e, 4, c + L + uu + e, 1, a + f + Hs + cn + D + " +y_0=-3500000" + L + uu + i + e, 4, a + f + Eo + k + Ys + _ + C + Xt + i + e, 2, c + r + e, 4, c + r + e, 3, c + r + e, 3, h + md + r + i + e, 1, h + P_ + r + i + e, 1, h + Og + r + i + e, 1, h + Bm + r + i + e, 1, h + sM + r + i + e, 1, h + qm + r + i + e, 1, h + Ay + r + i + e, 1, h + lg + r + i + e, 1, h + Iy + r + i + e, 1, h + Qm + r + i + e, 1, h + Fm + r + i + e, 1, h + Ap + r + i + e, 1, h + xd + r + i + e, 1, h + bd + r + i + e, 1, h + kd + r + i + e, 1, h + wd + r + i + e, 1, h + Hf + r + i + e, 1, h + Zf + r + i + e, 1, h + bl + r + i + e, 1, h + Fs + r + i + e, 1, h + bs + r + i + e, 2, dr + Zg + ws + sw + $d + H + _ + r + i + e, 1, l + yt + gt + mt + " +lon_0=-163" + To + aa + r + i + e, 1, l + yt + gt + mt + dy + go + aa + r + i + e, 1, l + rn + Kd + an + Ug + Po + Hl + r + i + e, 1, l + rn + Kd + an + dy + Ds + Hl + r + i + e, 1, a + hl + ol + tp + D + _ + r + i + e, 1, a + So + Zd + re + S + _ + r + i + e, 6, l + " +lat_1=17.5 +lat_2=29.5 +lat_0=12 +lon_0=-102" + On + _ + r + n + i + e, 3, c + r + n + e, 1, h + xd + r + n + i + e, 1, h + bd + r + n + i + e, 1, h + kd + r + n + i + e, 1, h + wd + r + n + i + e, 1, h + Hf + r + n + i + e, 1, h + Zf + r + n + i + e, 1, l + " +lat_1=17.5 +lat_2=29.5 +lat_0=12 +lon_0=-102" + On + _ + r + n + i + e, 9, a + f + Eo + " +k=1" + st + _ + d + Ye + i + e, 1, a + f + Xs + " +k=1" + st + _ + d + Ye + i + e, 1, a + f + es + " +k=1" + st + _ + d + Ye + i + e, 1, a + f + cl + " +k=1" + st + _ + d + Ye + i + e, 1, a + f + Hs + " +k=1" + st + _ + d + Ye + i + e, 1, a + f + B_ + " +k=1" + st + _ + d + Ye + i + e, 1, a + f + Zu + " +k=1" + st + _ + d + Ye + i + e, 4, l + " +lat_1=19.33333333333333 +lat_2=19.7 +lat_0=19.33333333333333 +lon_0=-80.56666666666666 +x_0=899160 +y_0=579120" + r + n + Z + e, 2, dr + " +lat_1=55" + Jp + tw + kf + H + _ + r + i + e, 1, yn + " +lat_0=57" + Su + Au + k + nc + oa + Bh + _o + r + i + e, 1, a + Ri + bM + k + p + _ + r + i + e, 1, a + Ri + kM + k + p + _ + r + i + e, 1, a + Ri + Fd + k + p + _ + r + i + e, 1, a + Ri + kf + k + p + _ + r + i + e, 1, a + Ri + Uh + k + p + _ + r + i + e, 1, a + Ri + MM + k + p + _ + r + i + e, 1, a + Ri + wM + k + p + _ + r + i + e, 1, a + Ri + qg + k + p + _ + r + i + e, 1, l + Iu + Ou + Ev + CM + ke + _ + r + i + e, 1, a + De + Ln + k + pa + _ + r + i + e, 1, a + De + Ln + k + pa + _ + r + Z + e, 1, a + De + Rn + k + pa + _ + r + i + e, 1, a + De + Rn + k + pa + _ + r + Z + e, 1, a + De + Nl + re + pa + _ + r + i + e, 1, a + De + Nl + re + pa + _ + r + Z + e, 1, l + Ur + zr + $t + zs + X + _ + r + i + e, 1, l + Ur + zr + $t + zs + Ht + _ + r + u + e, 1, l + Hr + xf + Zr + zs + X + Il + r + i + e, 1, l + Hr + xf + Zr + zs + Ht + Do + r + u + e, 1, dr + aw + zg + f + Mf + H + Wp + r + i + e, 1, l + yr + kh + Y + Fo + Ee + It + r + i + e, 1, l + yr + kh + Y + Fo + St + nt + r + u + e, 1, l + gr + mr + $ + Fo + Ee + It + r + i + e, 1, l + gr + mr + $ + Fo + St + nt + r + u + e, 1, l + Qt + vr + pf + lt + Ee + It + r + i + e, 1, l + Qt + vr + pf + lt + St + nt + r + u + e, 1, l + Xu + qp + xr + yf + Ee + It + r + i + e, 1, l + Xu + qp + xr + yf + St + nt + r + u + e, 1, l + br + kr + gf + Al + Ee + It + r + i + e, 1, l + br + kr + gf + Al + St + nt + r + u + e, 1, l + Mr + wr + Cr + Gl + Ee + It + r + i + e, 1, l + Mr + wr + Cr + Gl + St + nt + r + u + e, 1, l + Ju + Wu + xn + Me + Ti + Bi + r + i + e, 1, l + Ju + Wu + xn + Me + He + sn + r + u + e, 1, l + Ca + Ea + Y + Me + Ti + Bi + r + i + e, 1, l + Ca + Ea + Y + Me + He + sn + r + u + e, 1, l + Qt + Er + N + Me + Ti + Bi + r + i + e, 1, l + Qt + Er + N + Me + He + sn + r + u + e, 1, l + Sr + mf + Ar + Ch + Op + jp + r + i + e, 1, l + Sr + mf + Ar + Ch + Gc + Dc + r + u + e, 1, a + In + Pn + vf + D + _ + r + i + e, 1, a + In + Pn + vf + rt + _ + r + u + e, 1, a + Ft + dn + Pt + D + _ + r + i + e, 1, a + Ft + dn + Pt + rt + _ + r + u + e, 1, dr + " +lat_1=24" + _M + " +lat_0=24" + Yf + X + _ + r + i + e, 1, l + Vu + Ir + Up + Yu + S + _ + r + i + e, 1, l + Vu + Ir + Up + Yu + S + _ + r + u + e, 1, a + Ft + e_ + Pt + D + _ + r + i + e, 1, a + Ft + e_ + Pt + rt + _ + r + u + e, 1, a + So + Tn + k + D + _ + r + i + e, 1, a + So + Tn + k + rt + _ + r + u + e, 1, a + So + Bn + k + _a + _ + r + i + e, 1, a + So + Bn + k + ln + _ + r + u + e, 1, a + q + uh + oe + p + _ + r + i + e, 1, a + q + uh + oe + at + _ + r + u + e, 1, a + q + Qn + oe + D + _ + r + i + e, 1, a + q + Qn + oe + rt + _ + r + u + e, 1, a + q + Dl + re + vn + _ + r + i + e, 1, a + q + Dl + re + Rc + _ + r + u + e, 1, a + N + Xn + la + st + _ + r + i + e, 1, a + N + Xn + la + st + _ + r + u + e, 1, a + N + Jn + Pt + _a + _ + r + i + e, 1, a + N + Jn + Pt + Hc + _ + r + u + e, 1, a + or + Wn + dt + ge + zh + r + i + e, 1, a + or + Wn + dt + Uc + Vi + r + u + e, 1, a + or + Vn + dt + os + zh + r + i + e, 1, a + or + Vn + dt + os + Vi + r + u + e, 1, l + Xr + Jr + Oi + Ji + xt + ot + r + i + e, 1, l + Xr + Jr + Oi + Ji + xt + Yi + r + u + e, 1, l + Mt + Wr + Di + Ji + p + _ + r + i + e, 1, l + Mt + Wr + Di + Ji + it + _ + r + u + e, 1, l + Vr + Yr + pt + Si + X + _ + r + i + e, 1, l + Vr + Yr + pt + Si + Ht + _ + r + u + e, 1, l + Kr + $r + N + gn + X + Il + r + i + e, 1, l + Kr + $r + N + gn + Ht + Do + r + u + e, 1, l + Vt + pr + or + Mh + p + _ + r + i + e, 1, l + Vt + pr + or + Mh + at + _ + r + u + e, 1, l + wi + Ci + tt + ya + xt + ot + r + i + e, 1, l + wi + Ci + tt + ya + xt + hn + r + u + e, 1, l + Sa + Aa + tt + ya + p + It + r + i + e, 1, l + Sa + Aa + tt + ya + at + nt + r + u + e, 1, l + li + hi + hl + vs + ke + _ + r + i + e, 1, l + li + hi + hl + vs + va + _ + r + u + e, 1, l + Rd + Ld + Pd + je + ke + _ + r + i + e, 1, l + Rd + Ld + Pd + je + va + _ + r + u + e, 1, a + xM + rg + Fl + p + _ + r + i + e, 1, a + ut + $y + Fl + _a + _ + r + i + e, 1, a + te + tg + Fl + st + _ + r + i + e, 1, a + ht + Vo + k + st + _ + r + i + e, 1, a + ht + Vo + k + st + _ + r + u + e, 1, a + te + Yn + dt + os + _ + r + i + e, 1, a + te + Yn + dt + os + _ + r + u + e, 1, l + Yc + Sd + $ + lc + X + _ + r + i + e, 1, l + Yc + Sd + $ + lc + Lc + _ + r + u + e, 1, l + Oa + ja + El + Vs + p + _ + r + i + e, 1, l + Oa + ja + El + Vs + at + _ + r + u + e, 1, l + Ia + Or + El + Zi + D + _f + r + i + e, 1, l + Ia + Or + El + Zi + rt + _f + r + u + e, 1, l + Ad + Ra + La + ee + lp + _ + r + i + e, 1, l + Ad + Ra + La + ee + Tc + _ + r + Z + e, 1, l + Na + Ga + Da + yh + ev + _ + r + i + e, 1, l + Na + Ga + Da + yh + Pc + _ + r + Z + e, 1, yn + wu + " +lonc=-86" + Np + _t + Gp + V_ + Bh + Dp + r + i + e, 1, l + Be + Id + Oi + ee + $u + _ + r + i + e, 1, l + Be + Id + Oi + ee + Xd + _ + r + Z + e, 1, l + rf + fi + tl + Sh + vn + na + r + i + e, 1, l + rf + fi + tl + Sh + Tt + Bt + r + u + e, 1, l + ui + ci + Sl + Kn + vn + na + r + i + e, 1, l + ui + ci + Sl + Kn + Tt + Bt + r + u + e, 1, l + di + _i + cd + nd + vn + na + r + i + e, 1, l + di + _i + cd + nd + Tt + Bt + r + u + e, 1, a + ks + Fn + cn + st + _ + r + i + e, 1, a + ks + Fn + cn + st + _ + r + u + e, 1, a + dc + em + rv + p + up + r + i + e, 1, a + ks + Ze + cn + _a + _ + r + i + e, 1, a + ks + Ze + cn + ln + _ + r + u + e, 1, a + Cn + vs + re + p + _ + r + i + e, 1, a + Cn + Qy + re + ze + _ + r + i + e, 1, a + _l + Fy + Pt + uM + _ + r + i + e, 1, l + Hu + Ny + Kc + rl + S + _ + r + i + e, 1, l + Hu + Ny + Kc + rl + cr + _ + r + Z + e, 1, l + nh + kh + pi + _n + p + _ + r + i + e, 2, a + fn + tr + k + p + xs + r + i + e, 1, a + fn + tr + k + it + xs + r + u + e, 1, a + fn + $n + k + D + nv + r + i + e, 1, a + fn + $n + k + Ro + zc + r + u + e, 1, a + fn + er + k + vn + tc + r + i + e, 1, a + fn + er + k + Tt + Df + r + u + e, 1, a + ji + nr + dt + st + _ + r + i + e, 1, a + ji + nr + dt + st + _ + r + u + e, 1, a + Yt + Oo + k + Le + _ + r + i + e, 1, a + Yt + Oo + k + Le + _ + r + u + e, 1, a + De + Rl + k + p + _ + r + i + e, 1, a + De + Rl + k + at + _ + r + u + e, 1, a + De + qn + Cs + Od + _ + r + i + e, 1, a + De + qn + Cs + Od + _ + r + u + e, 1, a + De + Un + Ll + cM + _ + r + i + e, 1, a + De + Un + Ll + Bc + _ + r + u + e, 1, a + Di + zn + At + ze + _ + r + i + e, 1, a + Di + zn + At + Qc + _ + r + u + e, 1, a + Yt + Oo + k + Le + _ + r + i + e, 1, a + Yt + Oo + k + Le + _ + r + u + e, 1, l + jr + Nr + Kt + n_ + st + _ + r + i + e, 1, l + jr + Nr + Kt + n_ + st + _ + r + u + e, 1, a + Di + Hn + At + uy + _ + r + i + e, 1, a + Di + Hn + At + Fc + _ + r + u + e, 1, l + Pa + Ta + Ku + Kf + eg + _ + r + i + e, 1, l + Pa + Ta + Ku + Kf + E + _ + r + u + e, 1, l + ae + Ba + fl + ga + S + _ + r + i + e, 1, l + ae + Ba + fl + ga + cr + _ + r + Z + e, 1, l + Qa + Fa + Se + ga + S + _ + r + i + e, 1, l + Qa + Fa + Se + ga + cr + _ + r + Z + e, 1, l + Td + yi + be + ca + S + _ + r + i + e, 1, l + Td + yi + be + ca + S + _ + r + u + e, 1, l + gi + mi + In + ca + S + _ + r + i + e, 1, l + gi + mi + In + ca + S + _ + r + u + e, 1, l + Gr + qa + zp + Si + S + _ + r + i + e, 1, l + Gr + qa + zp + Si + S + _ + r + u + e, 1, l + Ua + za + Dr + Si + S + _ + r + i + e, 1, l + Ua + za + Dr + Si + S + _ + r + u + e, 1, l + nh + ws + Wi + lt + X + _ + r + i + e, 1, l + nh + ws + Wi + lt + sc + _ + r + Z + e, 1, l + F_ + bn + ht + lt + On + _ + r + i + e, 1, l + F_ + bn + ht + lt + Zh + _ + r + Z + e, 1, l + q_ + kn + q + lt + xt + _ + r + i + e, 1, l + q_ + kn + q + lt + Xh + _ + r + Z + e, 1, l + $c + Ha + Kt + ma + S + _ + r + i + e, 1, l + $c + Ha + Kt + ma + S + _ + r + u + e, 1, l + Rr + Lr + Y + ma + S + _ + r + i + e, 1, l + Rr + Lr + Y + ma + S + _ + r + u + e, 1, l + uo + co + fo + qi + D + Ws + r + i + e, 1, a + ta + Zi + oc + ge + _ + r + i + e, 1, a + ta + Zi + oc + ah + _ + r + u + e, 1, l + Za + jd + Pr + dn + Nd + _ + r + i + e, 1, l + Za + jd + Pr + dn + Nd + _ + r + Z + e, 1, l + vi + xi + ut + _n + S + _ + r + i + e, 1, l + vi + xi + ut + _n + S + _ + r + u + e, 1, l + Bd + bi + ea + jt + S + _ + r + i + e, 1, l + Bd + bi + ea + jt + S + _ + r + u + e, 1, l + Xa + tf + $t + Xc + S + _ + r + i + e, 1, l + Xa + tf + $t + Xc + S + _ + r + u + e, 1, l + Ya + Ka + Mn + jt + _a + Ni + r + i + e, 1, l + Ya + Ka + Mn + jt + ln + Ni + r + u + e, 1, dr + Qd + Ly + Yd + _n + xt + xs + r + i + e, 1, l + Qd + Ly + Yd + _n + xt + Ih + r + i + e, 1, l + Ja + ef + Hp + Eh + D + ot + r + i + e, 1, l + Ja + ef + Hp + Eh + rt + hn + r + u + e, 1, l + Wa + Va + Tr + gn + S + Gn + r + i + e, 1, l + Wa + Va + Tr + gn + S + No + r + u + e, 1, l + Ke + $e + wn + gn + st + Ih + r + i + e, 1, l + Ke + $e + wn + gn + st + sd + r + u + e, 1, l + $a + ti + Br + gh + S + tc + r + i + e, 1, l + $a + ti + Br + gh + S + od + r + u + e, 1, a + ji + ec + Pl + p + _ + r + i + e, 1, a + ji + ec + Pl + it + _ + r + u + e, 1, l + " +lat_1=37" + EM + to + po + H + _ + r + i + e, 1, l + Gd + ei + $ + Xi + Pe + Gn + r + i + e, 1, l + Gd + ei + $ + Xi + Go + No + r + u + e, 1, l + Vt + Qr + tt + Xi + Pe + ot + r + i + e, 1, l + Vt + Qr + tt + Xi + Go + hn + r + u + e, 1, l + ae + Dd + fl + Zn + p + _ + r + i + e, 1, l + ae + Dd + fl + Zn + at + _ + r + u + e, 1, l + ni + ri + Fr + lt + p + _ + r + i + e, 1, l + ni + ri + Fr + lt + at + _ + r + u + e, 1, l + af + Ry + bf + po + S + _ + r + i + e, 1, l + af + Ry + bf + po + S + _ + r + u + e, 1, l + ki + Mi + Xp + dn + S + _ + r + i + e, 1, l + ki + Mi + Xp + dn + S + _ + r + u + e, 2, l + ch + nf + ut + Ue + S + _ + r + u + e, 1, l + ai + ii + qr + Ue + S + _ + r + i + e, 1, l + ai + ii + qr + Ue + S + _ + r + u + e, 1, l + oi + si + U_ + Ue + S + _ + r + i + e, 1, l + oi + si + U_ + Ue + S + _ + r + u + e, 1, a + f + Ue + _t + dM + $g + r + i + e, 1, a + We + rr + At + D + _ + r + i + e, 1, a + We + rr + At + Ro + _ + r + u + e, 1, a + We + ar + At + X + na + r + i + e, 1, a + We + ar + At + Ht + Bt + r + u + e, 1, a + We + ir + At + vn + na + r + i + e, 1, a + We + ir + At + Tt + Bt + r + u + e, 1, a + We + Tl + At + S + _ + r + i + e, 1, a + We + Tl + At + S + _ + r + u + e, 1, l + ql + en + pt + ie + p + Gn + r + i + e, 1, l + Mt + tn + Qe + ie + p + ot + r + i + e, 1, l + Ul + nn + N + ie + p + Ni + r + i + e, 1, l + bv + hd + ul + Vo + H + _ + r + n + i + e, 1, dr + bv + hd + ul + Vo + H + _ + r + n + i + e, 1, dr + bv + hd + ul + Vo + H + _ + r + n + i + e, 1, l + ql + en + pt + ie + it + Rf + r + u + e, 1, l + Mt + tn + Qe + ie + it + Yi + r + u + e, 1, l + Ul + nn + N + ie + it + Ni + r + u + e, 1, a + xu + Yg + dt + p + _ + r + i + e, 1, a + bu + Wh + dt + p + _ + r + i + e, 1, a + ho + Uh + xh + p + _ + r + i + e, 1, a + ku + Kg + xh + p + _ + r + i + e, 1, a + Mu + Vh + " +k=1" + p + _ + r + i + e, 1, a + ho + Uh + xh + it + _ + r + u + e, 1, h + qm + r + i + e, 1, h + Ay + r + i + e, 1, h + Bm + F + r + i + e, 1, a + " +lat_0=13.5 +lon_0=144.75 +k=1" + ge + Ws + r + i + e, 9, a + bb + " +lon_0=46.5 +k=0.9994" + vn + _ + Ce + vo + fa + i + e, 22, c + r + e, 1, a + H_ + rC + k + H + _ + r + i + e, 1, a + H_ + $f + k + H + _ + r + i + e, 1, a + to + M_ + k + H + _ + r + i + e, 1, a + H_ + tv + k + H + _ + r + i + e, 1, a + to + w_ + k + H + _ + r + i + e, 1, a + to + yg + k + H + _ + r + i + e, 1, a + to + C_ + k + H + _ + r + i + e, 1, a + to + aC + k + H + _ + r + i + e, 1, a + to + E_ + k + H + _ + r + i + e, 1, a + Di + S_ + k + H + _ + r + i + e, 1, a + ul + dw + k + H + _ + r + i + e, 1, a + ul + _w + k + H + _ + r + i + e, 1, a + ul + pw + k + H + _ + r + i + e, 1, a + el + " +lon_0=142" + k + H + _ + r + i + e, 1, a + el + sp + k + H + _ + r + i + e, 1, a + el + " +lon_0=124" + k + H + _ + r + i + e, 1, a + el + $f + k + H + _ + r + i + e, 1, a + " +lat_0=20" + yg + k + H + _ + r + i + e, 1, a + el + Mw + k + H + _ + r + i + e, 1, h + uf + r + i + e, 1, h + Wf + r + i + e, 1, h + v_ + r + i + e, 1, h + Md + r + i + e, 1, h + T_ + r + i + e, 11, a + f + Dv + _t + p + Rt + L + n + i + e, 3, c + r + n + e, 1, h + Vl + r + n + i + e, 1, h + Ph + r + n + i + e, 1, h + Xf + r + n + i + e, 11, a + f + " +lon_0=105.625 +k=1.000024" + bh + up + L + n + i + e, 1, a + f + " +lon_0=105.625 +k=1.00002514" + bh + up + r + n + i + e, 1, a + f + " +lon_0=96.875 +k=1" + bh + " +y_0=1400000" + L + n + i + e, 1, a + f + " +lon_0=96.875 +k=0.99999387" + bh + ur + r + n + i + e, 13, h + Ip + F + r + n + i + e, 1, h + Ed + F + r + n + i + e, 1, h + md + F + r + n + i + e, 45, c + r + e, 1, a + qd + $h + bg + i_ + _ + r + i + e, 1, a + qd + $h + bg + Zl + _ + r + Z + e, 1, a + qd + $h + bg + i_ + _ + r + i + e, 1, a + qd + $h + bg + Zl + _ + r + Z + e, 1, a + Wi + ag + " +k=1.0002" + t_ + _ + r + i + e, 1, a + Wi + ag + " +k=1.0002" + Ko + _ + r + Z + e, 1, a + Wi + ag + " +k=1.0002" + t_ + _ + r + i + e, 1, a + Wi + ag + " +k=1.0002" + Ko + _ + r + Z + e, 1, l + ju + Nu + ig + of + t_ + " +y_0=130000" + r + i + e, 1, l + ju + Nu + ig + of + Ko + Zw + r + Z + e, 1, l + ju + Nu + ig + of + t_ + " +y_0=130000" + r + i + e, 1, l + ju + Nu + ig + of + Ko + Zw + r + Z + e, 1, l + Be + ht + og + AM + " +x_0=120000 +y_0=60000" + r + i + e, 1, l + Be + ht + og + AM + Xw + yC + r + Z + e, 1, l + Be + ht + og + AM + " +x_0=120000 +y_0=60000" + r + i + e, 1, l + Be + ht + og + AM + Xw + yC + r + Z + e, 1, a + ji + Ne + Lw + i_ + _ + r + i + e, 1, a + ji + Ne + Lw + Zl + _ + r + Z + e, 1, a + ji + Ne + Lw + i_ + _ + r + i + e, 1, a + ji + Ne + Lw + Zl + _ + r + Z + e, 1, l + Gu + Se + lt + nm + Le + " +y_0=30000" + r + i + e, 1, l + Gu + Se + lt + nm + ld + gC + r + Z + e, 1, l + Gu + Se + lt + nm + Le + " +y_0=30000" + r + i + e, 1, l + Gu + Se + lt + nm + ld + gC + r + Z + e, 1, yn + Du + Pw + Tw + " +k=1" + iv + gw + Bh + Bw + r + i + e, 1, yn + Du + Pw + Tw + " +k=1" + vw + Jw + Bh + Bw + r + Z + e, 1, yn + Du + Pw + Tw + " +k=1" + iv + gw + Bh + Bw + r + i + e, 1, yn + Du + Pw + Tw + " +k=1" + vw + Jw + Bh + Bw + r + Z + e, 1, a + te + Ne + IM + bh + _ + r + i + e, 1, a + te + Ne + IM + $o + _ + r + Z + e, 1, a + te + Ne + IM + bh + _ + r + i + e, 1, a + te + Ne + IM + $o + _ + r + Z + e, 1, a + qd + OM + Qw + t_ + _ + r + i + e, 1, a + qd + OM + Qw + Ko + _ + r + Z + e, 1, a + qd + OM + Qw + t_ + _ + r + i + e, 1, a + qd + OM + Qw + Ko + _ + r + Z + e, 1, a + ov + tu + pc + bh + _ + r + i + e, 1, a + ov + tu + pc + $o + _ + r + Z + e, 1, a + ov + tu + pc + bh + _ + r + i + e, 1, a + ov + tu + pc + $o + _ + r + Z + e, 1, a + Wi + Ne + _y + bh + _ + r + i + e, 1, a + Wi + Ne + _y + $o + _ + r + Z + e, 1, a + Wi + Ne + _y + bh + _ + r + i + e, 1, a + Wi + Ne + _y + $o + _ + r + Z + e, 1, a + tl + eu + Fw + " +x_0=10000" + _ + r + i + e, 1, a + tl + eu + Fw + CC + _ + r + Z + e, 1, a + tl + eu + Fw + " +x_0=10000" + _ + r + i + e, 1, a + tl + eu + Fw + CC + _ + r + Z + e, 1, a + tl + Al + qw + i_ + _ + r + i + e, 1, a + tl + Al + qw + Zl + _ + r + Z + e, 1, a + tl + Al + qw + i_ + _ + r + i + e, 1, a + tl + Al + qw + Zl + _ + r + Z + e, 1, a + sv + _c + " +k=1.0001" + t_ + _ + r + i + e, 1, a + sv + _c + " +k=1.0001" + Ko + _ + r + Z + e, 1, a + sv + _c + " +k=1.0001" + t_ + _ + r + i + e, 1, a + sv + _c + " +k=1.0001" + Ko + _ + r + Z + e, 1, yn + cp + rm + " +alpha=5 +k=1 +x_0=-300000 +y_0=-4600000" + Bh + " +gamma=5" + r + i + e, 1, yn + cp + rm + " +alpha=5 +k=1" + Ww + WM + Bh + " +gamma=5" + r + Z + e, 1, yn + cp + rm + " +alpha=5 +k=1 +x_0=-300000 +y_0=-4600000" + Bh + " +gamma=5" + r + i + e, 1, yn + cp + rm + " +alpha=5 +k=1" + Ww + WM + Bh + " +gamma=5" + r + Z + e, 1, a + lv + nu + Xg + " +x_0=60000" + _ + r + i + e, 1, a + lv + nu + Xg + mC + _ + r + Z + e, 1, a + lv + nu + Xg + " +x_0=60000" + _ + r + i + e, 1, a + lv + nu + Xg + mC + _ + r + Z + e, 1, a + Ru + sl + jM + Uw + _ + r + i + e, 1, a + Ru + sl + jM + vC + _ + r + Z + e, 1, a + Ru + sl + jM + Uw + _ + r + i + e, 1, a + Ru + sl + jM + vC + _ + r + Z + e, 1, l + ch + NM + sg + am + ge + vg + r + i + e, 1, l + ch + NM + sg + am + ih + Jy + r + Z + e, 1, l + ch + NM + sg + am + ge + vg + r + i + e, 1, l + ch + NM + sg + am + ih + Jy + r + Z + e, 1, a + Lu + ru + zw + bh + _ + r + i + e, 1, a + Lu + ru + zw + $o + _ + r + Z + e, 1, a + Lu + ru + zw + bh + _ + r + i + e, 1, a + Lu + ru + zw + $o + _ + r + Z + e, 1, a + Pu + im + GM + H + _ + r + i + e, 1, a + Pu + im + GM + H + _ + r + Z + e, 1, a + Pu + im + GM + H + _ + r + i + e, 1, a + Pu + im + GM + H + _ + r + Z + e, 4, l + nh + ws + Wi + lt + X + _ + r + i + e, 1, l + nh + ws + Wi + lt + sc + _ + r + Z + e, 2, a + f + wv + " +k=1" + p + _ + r + n + i + e, 5, a + f + Zs + " +k=0.9985000000000001" + iv + _ + r + n + i + e, 1, a + f + Zs + " +k=1" + cC + _ + r + n + i + e, 3, l + ch + nf + ut + Ue + S + _ + r + i + e, 1, l + nh + kh + pi + _n + it + _ + r + u + e, 1, c + Ce + vo + " +towgs84=-24,-203,268,0,0,0,0" + e, 1, c + Ce + vo + " +towgs84=-183,-15,273,0,0,0,0" + e, 1, c + m + " +towgs84=-235,-110,393,0,0,0,0" + e, 1, l + F_ + bn + ht + lt + On + _ + r + i + e, 1, l + F_ + bn + ht + lt + Zh + _ + r + Z + e, 1, l + q_ + kn + q + lt + xt + _ + r + i + e, 1, l + q_ + kn + q + lt + Xh + _ + r + Z + e, 5, c + Ce + vo + L_ + e, 2, c + Ce + vo + " +towgs84=-63,176,185,0,0,0,0" + e, 21, h + lf + Ce + vo + L_ + i + e, 7, l + Jg + DM + to + om + X + _ + r + n + i + e, 1, l + Jg + DM + to + om + Ht + _ + r + n + u + e, 1, l + Jg + DM + to + om + X + _ + r + i + e, 1, l + Jg + DM + to + om + Ht + _ + r + u + e, 6, gs + Os + ts + H + _ + L + n + i + e, 1, gs + B + ts + H + _ + L + n + i + e, 1, "+proj=cea" + ts + " +lat_ts=30" + H + _ + L + n + i + e, 29, l + " +lat_1=39 +lat_2=43" + El + wv + H + _ + r + n + i + e, 21, c + r + e, 1, a + x_ + b_ + tC + Pv + HM + r + i + e, 6, c + r + e, 1, a + x_ + b_ + tC + Pv + HM + r + i + e, 14, h + Th + Ce + vo + lr + i + e, 1, h + lh + Ce + vo + lr + i + e, 1, h + Wl + Ce + vo + lr + i + e, 28, c + r + e, 2, c + r + e, 2, c + r + e, 2, c + r + e, 16, l + " +lat_1=43.2 +lat_0=43.2 +lon_0=-95.25 +k_0=1.000052 +x_0=3505207.010414021 +y_0=2926085.852171705" + r + u + e, 1, l + " +lat_1=43.16666666666666 +lat_0=43.16666666666666 +lon_0=-92.75 +k_0=1.000043 +x_0=3810007.62001524 +y_0=2987045.974091948" + r + u + e, 1, a + sf + " +lon_0=-91.2 +k=1.000035 +x_0=4114808.229616459 +y_0=2529845.05969012" + r + u + e, 1, l + " +lat_1=42.53333333333333 +lat_0=42.53333333333333 +lon_0=-94.83333333333333 +k_0=1.000045 +x_0=4419608.839217679 +y_0=2621285.242570485" + r + u + e, 1, l + " +lat_1=42.65 +lat_0=42.65 +lon_0=-92.25 +k_0=1.000032 +x_0=4724409.448818898 +y_0=2712725.425450851" + r + u + e, 1, a + sf + " +lon_0=-95.73333333333333 +k=1.000039 +x_0=5029210.058420117 +y_0=2011684.023368047" + r + u + e, 1, a + sf + " +lon_0=-94.63333333333334" + Xg + " +x_0=5334010.668021336 +y_0=2072644.145288291" + r + u + e, 1, a + sf + " +lon_0=-93.71666666666667 +k=1.000033 +x_0=5638811.277622555 +y_0=2133604.267208535" + r + u + e, 1, a + sf + " +lon_0=-92.81666666666666" + Ud + " +x_0=5943611.887223775 +y_0=2194564.389128779" + r + u + e, 1, l + " +lat_1=41.83333333333334 +lat_0=41.83333333333334 +lon_0=-91.66666666666667 +k_0=1.00002 +x_0=6248412.496824994 +y_0=2438404.876809754" + r + u + e, 1, a + sf + " +lon_0=-90.53333333333333" + Ud + " +x_0=6553213.106426213 +y_0=2316484.632969266" + r + u + e, 1, l + " +lat_1=40.91666666666666 +lat_0=40.91666666666666 +lon_0=-93.75 +k_0=1.000037 +x_0=6858013.716027432" + VM + r + u + e, 1, a + sf + __ + o_ + " +x_0=7162814.325628651 +y_0=1950723.901447803" + r + u + e, 1, a + sf + " +lon_0=-91.25 +k=1.000018 +x_0=7467614.93522987" + VM + r + u + e, 3, c + r + e, 1, h + Th + F + r + i + e, 1, h + lh + F + r + i + e, 1, h + Wl + F + r + i + e, 1, h + lf + F + r + i + e, 1, h + Wy + F + r + i + e, 1, h + Vy + F + r + i + e, 1, h + Dg + F + r + i + e, 1, h + Xm + F + r + i + e, 3, c + r + e, 2, c + r + e, 23, a + py + sm + bg + Le + _ + r + i + e, 1, a + " +lat_0=48" + sm + " +k=1.00019" + ge + _ + r + i + e, 1, l + RM + py + Hh + " +k_0=1.000145" + Le + Ws + r + i + e, 1, l + RM + py + " +lon_0=-108.5" + of + D + " +y_0=150000" + r + i + e, 1, l + Tu + Bu + Me + of + D + na + r + i + e, 1, l + Tu + Bu + Me + " +k_0=1.00009" + ge + vg + r + i + e, 1, a + cp + " +lon_0=-107.75 +k=1.000148" + D + _ + r + i + e, 1, l + fC + " +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185" + ge + na + r + i + e, 1, l + Gb + Db + Uv + " +k_0=1.0001515" + D + vg + r + i + e, 1, a + Rb + zv + " +k=1.00024" + ge + _ + r + i + e, 1, a + py + sm + bg + ld + _ + r + Z + e, 1, a + " +lat_0=48" + sm + " +k=1.00019" + ih + _ + r + Z + e, 1, l + RM + py + Hh + " +k_0=1.000145" + ld + " +y_0=199999.9999992" + r + Z + e, 1, l + RM + py + " +lon_0=-108.5" + of + Jd + " +y_0=150000.00001464" + r + Z + e, 1, l + Tu + Bu + Me + of + Jd + YM + r + Z + e, 1, l + Tu + Bu + Me + " +k_0=1.00009" + ih + " +y_0=49999.99971024" + r + Z + e, 1, a + cp + " +lon_0=-107.75 +k=1.000148" + Jd + _ + r + Z + e, 1, l + fC + " +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185" + ih + YM + r + Z + e, 1, l + Gb + Db + Uv + " +k_0=1.0001515" + Jd + Jy + r + Z + e, 1, a + Rb + zv + " +k=1.00024" + ah + _ + r + u + e, 3, a + fp + " +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000" + r + i + e, 1, a + fp + " +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000" + r + u + e, 1, c + r + e, 3, c + L + e, 3, c + L + e, 3, a + Qu + Fu + " +k=1" + vy + " +y_0=126867.909" + ad + id + " +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1" + i + e, 115, a + dp + lm + yc + T + U + r + i + e, 1, a + dp + lm + yc + T + U + r + u + e, 1, a + yy + h_ + gc + T + U + r + i + e, 1, a + yy + h_ + gc + T + U + r + u + e, 1, a + " +lat_0=39" + au + mc + T + U + r + i + e, 1, a + " +lat_0=39" + au + mc + T + U + r + u + e, 1, a + " +lat_0=40.45" + _p + LM + T + U + r + i + e, 1, a + " +lat_0=40.45" + _p + LM + T + U + r + u + e, 1, a + " +lat_0=40.05" + Hv + zd + T + U + r + i + e, 1, a + " +lat_0=40.05" + Hv + zd + T + U + r + u + e, 1, a + PM + pp + Hd + T + U + r + i + e, 1, a + PM + pp + Hd + T + U + r + u + e, 1, a + " +lat_0=39" + hv + Hw + T + U + r + i + e, 1, a + " +lat_0=39" + hv + Hw + T + U + r + u + e, 1, a + " +lat_0=40.4" + Zv + mc + T + U + r + i + e, 1, a + " +lat_0=40.4" + Zv + mc + T + U + r + u + e, 1, a + dp + Xv + gy + T + U + r + i + e, 1, a + dp + Xv + gy + T + U + r + u + e, 1, a + uv + Jv + " +k=1.000021" + T + U + r + i + e, 1, a + uv + Jv + " +k=1.000021" + T + U + r + u + e, 1, a + cv + Wv + " +k=1.000024" + T + U + r + i + e, 1, a + cv + Wv + " +k=1.000024" + T + U + r + u + e, 1, a + " +lat_0=40.15" + Vv + " +k=1.000032" + T + U + r + i + e, 1, a + " +lat_0=40.15" + Vv + " +k=1.000032" + T + U + r + u + e, 1, a + " +lat_0=38.1" + pp + my + T + U + r + i + e, 1, a + " +lat_0=38.1" + pp + my + T + U + r + u + e, 1, a + " +lat_0=38.45" + iu + " +k=1.000018" + T + U + r + i + e, 1, a + " +lat_0=38.45" + iu + " +k=1.000018" + T + U + r + u + e, 1, a + " +lat_0=38.65" + Yv + LM + T + U + r + i + e, 1, a + " +lat_0=38.65" + Yv + LM + T + U + r + u + e, 1, a + " +lat_0=39.1" + Kv + Hd + T + U + r + i + e, 1, a + " +lat_0=39.1" + Kv + Hd + T + U + r + u + e, 1, a + fv + lm + Hd + T + U + r + i + e, 1, a + fv + lm + Hd + T + U + r + u + e, 1, a + " +lat_0=38.2" + hm + o_ + T + U + r + i + e, 1, a + " +lat_0=38.2" + hm + o_ + T + U + r + u + e, 1, a + dv + au + " +k=1.000033" + T + U + r + i + e, 1, a + dv + au + " +k=1.000033" + T + U + r + u + e, 1, a + _v + h_ + zd + T + U + r + i + e, 1, a + _v + h_ + zd + T + U + r + u + e, 1, a + " +lat_0=39.95" + _p + my + T + U + r + i + e, 1, a + " +lat_0=39.95" + _p + my + T + U + r + u + e, 1, a + yy + hv + gc + T + U + r + i + e, 1, a + yy + hv + gc + T + U + r + u + e, 1, a + uv + $v + TM + T + U + r + i + e, 1, a + uv + $v + TM + T + U + r + u + e, 1, a + pv + " +lon_0=-85.7" + yc + T + U + r + i + e, 1, a + pv + " +lon_0=-85.7" + yc + T + U + r + u + e, 1, a + " +lat_0=39.9" + Xc + yc + T + U + r + i + e, 1, a + " +lat_0=39.9" + Xc + yc + T + U + r + u + e, 1, a + " +lat_0=39.65" + yv + Hd + T + U + r + i + e, 1, a + " +lat_0=39.65" + yv + Hd + T + U + r + u + e, 1, a + " +lat_0=37.95" + Uo + Ud + T + U + r + i + e, 1, a + " +lat_0=37.95" + Uo + Ud + T + U + r + u + e, 1, a + " +lat_0=39.75" + um + _y + T + U + r + i + e, 1, a + " +lat_0=39.75" + um + _y + T + U + r + u + e, 1, a + pv + Uo + gc + T + U + r + i + e, 1, a + pv + Uo + gc + T + U + r + u + e, 1, a + dv + av + yc + T + U + r + i + e, 1, a + dv + av + yc + T + U + r + u + e, 1, a + " +lat_0=38.7 +lon_0=-85.95" + BM + T + U + r + i + e, 1, a + " +lat_0=38.7 +lon_0=-85.95" + BM + T + U + r + u + e, 1, a + QM + iu + Ud + T + U + r + i + e, 1, a + QM + iu + Ud + T + U + r + u + e, 1, a + " +lat_0=40.3" + xg + zd + T + U + r + i + e, 1, a + " +lat_0=40.3" + xg + zd + T + U + r + u + e, 1, a + " +lat_0=38.55" + tx + gy + T + U + r + i + e, 1, a + " +lat_0=38.55" + tx + gy + T + U + r + u + e, 1, a + " +lat_0=38.8" + yv + my + T + U + r + i + e, 1, a + " +lat_0=38.8" + yv + my + T + U + r + u + e, 1, a + FM + Uo + gc + T + U + r + i + e, 1, a + FM + Uo + gc + T + U + r + u + e, 1, a + " +lat_0=38.4" + cm + pc + T + U + r + i + e, 1, a + " +lat_0=38.4" + cm + pc + T + U + r + u + e, 1, a + fv + um + " +k=1.000037" + T + U + r + i + e, 1, a + fv + um + " +k=1.000037" + T + U + r + u + e, 1, a + QM + ex + mc + T + U + r + i + e, 1, a + QM + ex + mc + T + U + r + u + e, 1, a + yy + " +lon_0=-86.75" + Ud + T + U + r + i + e, 1, a + yy + " +lon_0=-86.75" + Ud + T + U + r + u + e, 1, a + " +lat_0=38.95" + pp + gy + T + U + r + i + e, 1, a + " +lat_0=38.95" + pp + gy + T + U + r + u + e, 1, a + " +lat_0=39.45" + hm + gc + T + U + r + i + e, 1, a + " +lat_0=39.45" + hm + gc + T + U + r + u + e, 1, a + cv + ou + mc + T + U + r + i + e, 1, a + cv + ou + mc + T + U + r + u + e, 1, a + PM + nx + BM + T + U + r + i + e, 1, a + PM + nx + BM + T + U + r + u + e, 1, a + qM + " +lon_0=-86.7" + o_ + T + U + r + i + e, 1, a + qM + " +lon_0=-86.7" + o_ + T + U + r + u + e, 1, a + " +lat_0=37.85" + _p + pc + T + U + r + i + e, 1, a + " +lat_0=37.85" + _p + pc + T + U + r + u + e, 1, a + fp + " +lon_0=-87.95" + TM + T + U + r + i + e, 1, a + fp + " +lon_0=-87.95" + TM + T + U + r + u + e, 1, a + " +lat_0=39.7" + h_ + " +k=1.000044" + T + U + r + i + e, 1, a + " +lat_0=39.7" + h_ + " +k=1.000044" + T + U + r + u + e, 1, a + UM + " +lon_0=-85.3" + zd + T + U + r + i + e, 1, a + UM + " +lon_0=-85.3" + zd + T + U + r + u + e, 1, a + FM + rx + Hw + T + U + r + i + e, 1, a + FM + rx + Hw + T + U + r + u + e, 1, a + fp + " +lon_0=-87.05 +k=1.000014" + T + U + r + i + e, 1, a + fp + " +lon_0=-87.05 +k=1.000014" + T + U + r + u + e, 1, a + Oi + xg + " +k=1.000041" + T + U + r + i + e, 1, a + Oi + xg + " +k=1.000041" + T + U + r + u + e, 1, a + UM + Zd + " +k=1.000017" + T + U + r + i + e, 1, a + UM + Zd + " +k=1.000017" + T + U + r + u + e, 1, a + " +lat_0=40.2" + ou + mc + T + U + r + i + e, 1, a + " +lat_0=40.2" + ou + mc + T + U + r + u + e, 1, a + qM + fm + pc + T + U + r + i + e, 1, a + qM + fm + pc + T + U + r + u + e, 1, a + _v + cm + o_ + T + U + r + i + e, 1, a + _v + cm + o_ + T + U + r + u + e, 1, a + dp + " +lon_0=-85.25" + yc + T + U + r + i + e, 1, a + dp + " +lon_0=-85.25" + yc + T + U + r + u + e, 3, c + r + n + e, 1, h + Wl + r + n + i + e, 1, h + lf + r + n + i + e, 1, h + Wy + r + n + i + e, 152, a + Lb + Ue + " +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037" + r + i + e, 1, a + Pb + ax + " +k=1.0000495683 +x_0=172821.9461 +y_0=0.0017" + r + i + e, 1, a + Tb + ix + " +k=1.0000486665 +x_0=93150 +y_0=0.0029" + r + i + e, 1, l + Bb + Qb + ox + " +k_0=1.0000331195 +x_0=228600.4575 +y_0=148551.4837" + r + i + e, 1, a + cd + " +lon_0=-88" + o_ + " +x_0=31600 +y_0=4600" + r + i + e, 1, a + Fb + sx + " +k=1.0000382778 +x_0=175260.3502 +y_0=0.0048" + r + i + e, 1, l + qb + Ub + lx + " +k_0=1.0000383841 +x_0=64008.1276 +y_0=59445.9043" + r + i + e, 1, a + zb + " +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049" + r + i + e, 1, l + Hb + Zb + hx + " +k_0=1.0000391127 +x_0=60045.72 +y_0=44091.4346" + r + i + e, 1, a + " +lat_0=43.6" + ux + " +k=1.0000463003 +x_0=199949.1989 +y_0=0.0086" + r + i + e, 1, l + Xb + Jb + cx + " +k_0=1.00003498 +x_0=169164.3381 +y_0=111569.6134" + r + i + e, 1, l + xC + bC + Wb + " +k_0=1.0000349151 +x_0=113690.6274 +y_0=53703.1201" + r + i + e, 1, l + Vw + Yw + fx + " +k_0=1.0000384786 +x_0=247193.2944 +y_0=146591.9896" + r + i + e, 1, a + Vb + dx + " +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076" + r + i + e, 1, a + " +lat_0=44.4" + _x + " +k=1.0000187521 +x_0=158801.1176 +y_0=0.0023" + r + i + e, 1, a + Yb + __ + " +k=1.0000385418 +x_0=59131.3183 +y_0=0.0041" + r + i + e, 1, a + Kb + px + " +k=1.0000410324 +x_0=51816.104 +y_0=0.003" + r + i + e, 1, l + $b + tk + yx + " +k_0=1.000035079 +x_0=120091.4402 +y_0=91687.92389999999" + r + i + e, 1, a + ek + gx + " +k=1.0000552095 +x_0=133502.6683 +y_0=0.0063" + r + i + e, 1, a + nk + mx + " +k=1.0000673004 +x_0=275844.5533 +y_0=0.0157" + r + i + e, 1, a + rk + " +lon_0=-90.8 +k=1.0000349452 +x_0=242316.4841 +y_0=0.01" + r + i + e, 1, l + ak + ik + vx + " +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947" + r + i + e, 1, l + ok + sk + su + " +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795" + r + i + e, 1, a + lk + xx + " +k=1.0000394961 +x_0=113081.0261 +y_0=0.0045" + r + i + e, 1, a + hk + bx + " +k=1.0000677153 +x_0=220980.4419 +y_0=0.008500000000000001" + r + i + e, 1, a + uk + kx + " +k=1.0000353 +x_0=27000 +y_0=25000" + r + i + e, 1, a + ck + Mx + " +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009" + r + i + e, 1, a + fk + fm + " +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012" + r + i + e, 1, a + dk + wx + " +k=1.0000319985 +x_0=130454.6598 +y_0=0.0033" + r + i + e, 1, l + _k + pk + Cx + " +k_0=1.0000627024 +x_0=198425.197 +y_0=105279.7829" + r + i + e, 1, a + yk + Ex + " +k=1.0000599003 +x_0=116129.0323 +y_0=0.0058" + r + i + e, 1, l + gk + mk + " +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493 +y_0=55049.2669" + r + i + e, 1, a + vk + Sx + " +k=1.0000234982 +x_0=238658.8794 +y_0=0.0032" + r + i + e, 1, a + xk + Ax + " +k=1.0000362499 +x_0=105461.0121 +y_0=0.0029" + r + i + e, 1, l + bk + kk + Ix + " +k_0=1.0000434122 +x_0=204521.209 +y_0=121923.9861" + r + i + e, 1, a + Mk + Ox + " +k=1.0000236869 +x_0=182880.3676 +y_0=0.0033" + r + i + e, 1, l + wk + Ck + jx + " +k_0=1.0000686968 +x_0=70104.1401 +y_0=57588.0346" + r + i + e, 1, l + Ek + Sk + Nx + " +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876" + r + i + e, 1, a + Ak + lu + " +k=1.0000433849 +x_0=141732.2823 +y_0=0.0059" + r + i + e, 1, l + Ik + Ok + " +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1128 +y_0=50022.1874" + r + i + e, 1, a + jk + Gx + " +k=1.0000649554 +x_0=227990.8546 +y_0=0.0109" + r + i + e, 1, l + Kw + $w + Dx + " +k_0=1.0000375653 +x_0=202387.6048 +y_0=134255.4253" + r + i + e, 1, a + Nk + Rx + " +k=1.0000337311 +x_0=146304.2926 +y_0=0.0068" + r + i + e, 1, a + Gk + Lx + " +k=1.0000495976 +x_0=250546.1013 +y_0=0.0234" + r + i + e, 1, a + Dk + Px + " +k=1.0000373868 +x_0=185623.5716 +y_0=0.0051" + r + i + e, 1, l + Rk + Lk + Tx + " +k_0=1.0000573461 +x_0=216713.2336 +y_0=120734.1631" + r + i + e, 1, a + qu + Bx + " +k=1.000032144 +x_0=262433.3253 +y_0=0.009599999999999999" + r + i + e, 1, a + qu + lu + " +k=1.0000381803 +x_0=165506.7302 +y_0=0.0103" + r + i + e, 1, l + Pk + Tk + Qx + " +k_0=1.0000597566 +x_0=187147.5744 +y_0=107746.7522" + r + i + e, 1, a + Bk + Fx + " +k=1.0000361538 +x_0=256946.9138 +y_0=0.0041" + r + i + e, 1, l + Qk + Fk + qx + " +k_0=1.0000408158 +x_0=222504.4451 +y_0=47532.0602" + r + i + e, 1, l + qk + Uk + Ux + " +k_0=1.0000730142 +x_0=134417.0689 +y_0=50337.1092" + r + i + e, 1, l + zk + Hk + zx + " +k_0=1.0000367192 +x_0=232562.8651 +y_0=111088.2224" + r + i + e, 1, l + Zk + Xk + Hx + " +k_0=1.0000475376 +x_0=234086.8682 +y_0=188358.6058" + r + i + e, 1, a + Jk + Zx + " +k=1.00003738 +x_0=120091.4415 +y_0=0.003" + r + i + e, 1, a + Wk + Xx + " +k=1.0000346179 +x_0=208788.418 +y_0=0.0034" + r + i + e, 1, a + Vk + Jx + " +k=1.0000333645 +x_0=185013.9709 +y_0=0.007" + r + i + e, 1, l + Yk + Kk + su + " +k_0=1.0000392096 +x_0=120091.4402 +y_0=45069.7587" + r + i + e, 1, l + $k + tM + Ue + " +k_0=1.0000421209 +x_0=208483.6173 +y_0=134589.754" + r + i + e, 1, a + Lb + Ue + " +k=1.0000365285 +x_0=147218.6941325883 +y_0=0.00365760731521463" + r + u + e, 1, a + Pb + ax + " +k=1.0000495683 +x_0=172821.945948692 +y_0=0.001828803657607315" + r + u + e, 1, a + Tb + ix + " +k=1.0000486665 +x_0=93150" + ll + r + u + e, 1, l + Bb + Qb + ox + " +k_0=1.0000331195 +x_0=228600.4575057151 +y_0=148551.4835661671" + r + u + e, 1, a + cd + " +lon_0=-88" + o_ + " +x_0=31599.99989839979 +y_0=4599.999898399797" + r + u + e, 1, a + Fb + sx + " +k=1.0000382778 +x_0=175260.3502159004" + Wx + r + u + e, 1, l + qb + Ub + lx + " +k_0=1.0000383841 +x_0=64008.12771145543 +y_0=59445.90419100838" + r + u + e, 1, a + zb + " +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8892049784" + Wx + r + u + e, 1, l + Hb + Zb + hx + " +k_0=1.0000391127 +x_0=60045.72009144018 +y_0=44091.43449326898" + r + u + e, 1, a + " +lat_0=43.6" + ux + " +k=1.0000463003 +x_0=199949.198983998" + Vx + r + u + e, 1, l + Xb + Jb + cx + " +k_0=1.00003498 +x_0=169164.338023876 +y_0=111569.613512827" + r + u + e, 1, l + xC + bC + Wb + " +k_0=1.0000349151 +x_0=113690.6273812548 +y_0=53703.12024384048" + r + u + e, 1, l + Vw + Yw + fx + " +k_0=1.0000384786 +x_0=247193.2943865888 +y_0=146591.9896367793" + r + u + e, 1, a + Vb + dx + " +k=1.0000346418 +x_0=263347.7263906528 +y_0=0.00762001524003048" + r + u + e, 1, a + " +lat_0=44.4" + _x + " +k=1.0000187521 +x_0=158801.1176022352 +y_0=0.002438404876809754" + r + u + e, 1, a + Yb + __ + " +k=1.0000385418 +x_0=59131.31826263652" + Yx + r + u + e, 1, a + Kb + px + " +k=1.0000410324 +x_0=51816.10393700787" + ll + r + u + e, 1, l + $b + tk + yx + " +k_0=1.000035079" + KM + " +y_0=91687.92390144781" + r + u + e, 1, a + ek + gx + " +k=1.0000552095 +x_0=133502.6682245364 +y_0=0.006400812801625603" + r + u + e, 1, a + nk + mx + " +k=1.0000673004 +x_0=275844.5532131065 +y_0=0.0158496316992634" + r + u + e, 1, a + rk + " +lon_0=-90.8 +k=1.0000349452 +x_0=242316.484023368 +y_0=0.01005842011684023" + r + u + e, 1, l + ak + ik + vx + " +k_0=1.0000390487 +x_0=170078.7401574803 +y_0=45830.29484378968" + r + u + e, 1, l + ok + sk + su + " +k_0=1.0000344057 +x_0=150876.3017526035 +y_0=79170.77937515875" + r + u + e, 1, a + lk + xx + " +k=1.0000394961 +x_0=113081.0261620523 +y_0=0.004572009144018288" + r + u + e, 1, a + hk + bx + " +k=1.0000677153 +x_0=220980.4419608839" + Vx + r + u + e, 1, a + uk + kx + " +k=1.0000353 +x_0=27000 +y_0=24999.99989839979" + r + u + e, 1, a + ck + Mx + " +k=1.0000260649 +x_0=185928.3727711455 +y_0=0.0009144018288036576" + r + u + e, 1, a + fk + fm + " +k=1.0000233704 +x_0=79857.76154432308 +y_0=0.001219202438404877" + r + u + e, 1, a + dk + wx + " +k=1.0000319985 +x_0=130454.6596901194" + p_ + r + u + e, 1, l + _k + pk + Cx + " +k_0=1.0000627024 +x_0=198425.1968503937 +y_0=105279.7828803657" + r + u + e, 1, a + yk + Ex + " +k=1.0000599003 +x_0=116129.0322580645" + Kx + r + u + e, 1, l + gk + mk + " +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493522987 +y_0=55049.26695453391" + r + u + e, 1, a + vk + Sx + " +k=1.0000234982 +x_0=238658.8794513589" + ll + r + u + e, 1, a + xk + Ax + " +k=1.0000362499 +x_0=105461.0121412243" + ll + r + u + e, 1, l + bk + kk + Ix + " +k_0=1.0000434122 +x_0=204521.2090424181 +y_0=121923.9861823724" + r + u + e, 1, a + Mk + Ox + " +k=1.0000236869 +x_0=182880.3675895352" + p_ + r + u + e, 1, l + wk + Ck + jx + " +k_0=1.0000686968 +x_0=70104.14020828041 +y_0=57588.03474726949" + r + u + e, 1, l + Ek + Sk + Nx + " +k_0=1.0000362977 +x_0=167640.3352806706 +y_0=86033.08773177546" + r + u + e, 1, a + Ak + lu + " +k=1.0000433849 +x_0=141732.2822453645" + Kx + r + u + e, 1, l + Ik + Ok + " +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.11277622555 +y_0=50022.1874523749" + r + u + e, 1, a + jk + Gx + " +k=1.0000649554 +x_0=227990.8544577089 +y_0=0.01097282194564389" + r + u + e, 1, l + Kw + $w + Dx + " +k_0=1.0000375653 +x_0=202387.6047752095 +y_0=134255.4254508509" + r + u + e, 1, a + Nk + Rx + " +k=1.0000337311 +x_0=146304.2926085852 +y_0=0.006705613411226822" + r + u + e, 1, a + Gk + Lx + " +k=1.0000495976 +x_0=250546.1013970028 +y_0=0.02346964693929388" + r + u + e, 1, a + Dk + Px + " +k=1.0000373868 +x_0=185623.5715519431 +y_0=0.005181610363220727" + r + u + e, 1, l + Rk + Lk + Tx + " +k_0=1.0000573461 +x_0=216713.2337312675 +y_0=120734.1631699263" + r + u + e, 1, a + qu + Bx + " +k=1.000032144 +x_0=262433.3251714504 +y_0=0.009448818897637795" + r + u + e, 1, a + qu + lu + " +k=1.0000381803 +x_0=165506.7300990602 +y_0=0.01036322072644145" + r + u + e, 1, l + Pk + Tk + Qx + " +k_0=1.0000597566 +x_0=187147.5742951486 +y_0=107746.7521463043" + r + u + e, 1, a + Bk + Fx + " +k=1.0000361538 +x_0=256946.9138938278" + Yx + r + u + e, 1, l + Qk + Fk + qx + " +k_0=1.0000408158 +x_0=222504.44500889 +y_0=47532.0603505207" + r + u + e, 1, l + qk + Uk + Ux + " +k_0=1.0000730142 +x_0=134417.0688341377 +y_0=50337.10927101854" + r + u + e, 1, l + zk + Hk + zx + " +k_0=1.0000367192 +x_0=232562.8651257302 +y_0=111088.2224028448" + r + u + e, 1, l + Zk + Xk + Hx + " +k_0=1.0000475376 +x_0=234086.8681737363 +y_0=188358.6059436119" + r + u + e, 1, a + Jk + Zx + " +k=1.00003738 +x_0=120091.4414020828" + ll + r + u + e, 1, a + Wk + Xx + " +k=1.0000346179 +x_0=208788.4178816358" + p_ + r + u + e, 1, a + Vk + Jx + " +k=1.0000333645 +x_0=185013.9709423419 +y_0=0.007010414020828041" + r + u + e, 1, l + Yk + Kk + su + " +k_0=1.0000392096" + KM + " +y_0=45069.7588011176" + r + u + e, 1, l + $k + tM + Ue + " +k_0=1.0000421209 +x_0=208483.6172720346 +y_0=134589.7539243078" + r + u + e, 41, c + r + e, 6, a + f + " +lon_0=68.51666666666667 +k=1 +x_0=1300000" + Hy + r + i + e, 1, a + f + " +lon_0=71.51666666666667 +k=1" + iC + Hy + r + i + e, 1, a + f + " +lon_0=74.51666666666667 +k=1" + oC + Hy + r + i + e, 1, a + f + " +lon_0=77.51666666666667 +k=1" + sC + Hy + r + i + e, 1, a + f + " +lon_0=80.51666666666667 +k=1 +x_0=5300000" + Hy + r + i + e, 12308, a + f + Eo + " +k=1" + hr + _ + d + s + i + e, 1, a + f + es + " +k=1" + wa + _ + d + s + i + e, 1, a + f + Hs + " +k=1" + Ah + _ + d + s + i + e, 1, a + f + Zu + " +k=1" + Ys + _ + d + s + i + e, 1, a + f + eh + " +k=1" + Wc + _ + d + s + i + e, 1, a + f + z_ + " +k=1" + Vc + _ + d + s + i + e, 1, a + f + Gy + " +k=1" + rc + _ + d + s + i + e, 1, a + f + Zp + " +k=1" + wh + _ + d + s + i + e, 1, a + f + Dy + " +k=1" + ac + _ + d + s + i + e, 1, a + f + ns + " +k=1" + ss + _ + d + s + i + e, 1, a + f + rs + " +k=1" + Po + _ + d + s + i + e, 1, a + f + ys + " +k=1" + Gs + _ + d + s + i + e, 1, a + f + as + " +k=1" + Ds + _ + d + s + i + e, 1, a + f + is + " +k=1" + Ol + _ + d + s + i + e, 1, a + f + ia + " +k=1" + js + _ + d + s + i + e, 1, a + f + Qi + " +k=1" + Ns + _ + d + s + i + e, 1, a + f + Ai + " +k=1" + ls + _ + d + s + i + e, 1, a + f + Gi + " +k=1" + Rs + _ + d + s + i + e, 1, a + f + ba + " +k=1" + hs + _ + d + s + i + e, 1, a + f + Ii + " +k=1" + Ls + _ + d + s + i + e, 1, a + f + rp + " +k=1" + ic + _ + d + s + i + e, 1, a + f + r_ + " +k=1" + Ps + _ + d + s + i + e, 1, a + f + td + " +k=1" + Ts + _ + d + s + i + e, 1, a + f + ap + " +k=1" + Bs + _ + d + s + i + e, 1, a + f + ed + " +k=1" + Qs + _ + d + s + i + e, 1, a + f + uc + " +k=1" + To + _ + d + s + i + e, 1, a + f + Fh + " +k=1" + al + _ + d + s + i + e, 1, a + f + qh + " +k=1" + go + _ + d + s + i + e, 1, a + f + fc + " +k=1" + il + _ + d + s + i + e, 103, h + pu + I + us + i + e, 1, h + hf + I + us + i + e, 1, h + Th + I + us + i + e, 1, h + lh + I + us + i + e, 111, h + ff + F + V + z + i + e, 1, h + Jf + F + V + z + i + e, 1, h + uf + F + V + z + i + e, 1, h + Wf + F + V + z + i + e, 1, h + v_ + F + V + z + i + e, 1, h + Md + F + V + z + i + e, 1, h + T_ + F + V + z + i + e, 1, h + Ky + F + V + z + i + e, 1, h + Ng + F + V + z + i + e, 1, h + jc + F + V + z + i + e, 91, h + ff + F + V + Ve + i + e, 1, h + Jf + F + V + Ve + i + e, 1, h + uf + F + V + Ve + i + e, 1, h + Wf + F + V + Ve + i + e, 1, h + v_ + F + V + Ve + i + e, 1, h + Md + F + V + Ve + i + e, 1, h + T_ + F + V + Ve + i + e, 1, h + Ky + F + V + Ve + i + e, 80, h + hf + m + Dn + i + e, 1, h + Th + m + Dn + i + e, 1, h + lh + m + Dn + i + e, 1, h + Wl + m + Dn + i + e, 1, h + lf + m + Dn + i + e, 59, h + Wl + m + Dn + i + e, 39, h + lh + d + Ff + i + e, 1, h + Wl + d + Ff + i + e, 251, a + be + " +lon_0=1 +k=1" + D + Ms + m + da + Gw + i + e, 1, a + be + " +lon_0=1 +k=1" + H + _ + m + da + Gw + i + e, 31, h + Cl + F + m + xa + i + e, 1, h + Nc + F + m + xa + i + e, 1, h + Cd + F + m + xa + i + e, 110, h + Xf + F + Ce + pe + wl + i + e, 1, h + pu + F + Ce + pe + wl + i + e, 1, h + hf + F + Ce + pe + wl + i + e, 99, h + pu + F + I + ha + i + e, 1, h + hf + F + I + ha + i + e, 1, h + Th + F + I + ha + i + e, 58, h + pu + I + ha + i + e, 1, h + hf + I + ha + i + e, 1, h + Th + I + ha + i + e, 51, h + cf + F + C + jn + i + e, 1, h + ff + F + C + jn + i + e, 1, h + Jf + F + C + jn + i + e, 141, a + f + Vf + sa + X + _ + I + jh + i + e, 1, a + " +lat_0=13.17638888888889 +lon_0=-59.55972222222222 +k=0.9999986" + Uw + " +y_0=75000" + I + jh + i + e, 121, a + f + ns + " +k=1" + ss + _ + d + b + i + e, 1, a + f + rs + " +k=1" + Po + _ + d + b + i + e, 1, a + f + ys + " +k=1" + Gs + _ + d + b + i + e, 1, a + f + as + " +k=1" + Ds + _ + d + b + i + e, 1, a + f + is + " +k=1" + Ol + _ + d + b + i + e, 1, a + f + ia + " +k=1" + js + _ + d + b + i + e, 1, a + f + Qi + " +k=1" + Ns + _ + d + b + i + e, 1, a + f + Ai + " +k=1" + ls + _ + d + b + i + e, 1, a + f + Gi + " +k=1" + Rs + _ + d + b + i + e, 1, a + f + ba + " +k=1" + hs + _ + d + b + i + e, 1, a + f + Ii + " +k=1" + Ls + _ + d + b + i + e, 30, a + f + ns + " +k=1" + p + _ + d + b + i + e, 1, a + f + rs + " +k=1" + p + _ + d + b + i + e, 1, a + f + ys + " +k=1" + p + _ + d + b + i + e, 1, a + f + as + " +k=1" + p + _ + d + b + i + e, 1, a + f + is + " +k=1" + p + _ + d + b + i + e, 1, a + f + ia + " +k=1" + p + _ + d + b + i + e, 1, a + f + Qi + " +k=1" + p + _ + d + b + i + e, 1, a + f + Ai + " +k=1" + p + _ + d + b + i + e, 1, a + f + Gi + " +k=1" + p + _ + d + b + i + e, 1, a + f + ba + " +k=1" + p + _ + d + b + i + e, 1, a + f + Ii + " +k=1" + p + _ + d + b + i + e, 37, l + Cu + Eu + Os + ts + Le + " +y_0=5400000" + m + " +pm=brussels" + i + e, 280, mp + yu + ts + " +k_0=1" + H + _ + C + xo + " +pm=bern" + i + e, 1, mp + yu + k_ + " +k_0=1" + S + Ws + C + xo + i + e, 1, mp + yu + k_ + " +k_0=1" + H + _ + C + xo + i + e, 36, h + Fs + m + ua + i + e, 78, a + Uu + " +lon_0=-77.08091666666667 +k=1" + ke + ot + m + ua + i + e, 1, a + Uu + " +lon_0=-74.08091666666667 +k=1" + ke + ot + m + ua + i + e, 1, a + Uu + " +lon_0=-71.08091666666667 +k=1" + ke + ot + m + ua + i + e, 1, a + Uu + " +lon_0=-68.08091666666667 +k=1" + ke + ot + m + ua + i + e, 133, h + Vl + F + I + no + i + e, 1, h + Ph + F + I + no + i + e, 58, a + f + " +lon_0=11.5" + _t + p + Rt + I + no + i + e, 1, a + f + Zs + _t + p + Rt + I + no + i + e, 79, a + B + Nv + " +k=1" + xt + _ + r + n + i + e, 1, a + B + Zc + " +k=1" + On + _ + r + n + i + e, 1, a + B + np + " +k=1" + Pe + _ + r + n + i + e, 1, a + B + oy + " +k=1" + hr + _ + r + n + i + e, 1, a + B + Dv + " +k=1" + wa + _ + r + n + i + e, 1, a + B + Dw + " +k=1" + Ah + _ + r + n + i + e, 1, a + B + rd + " +k=1" + Ys + _ + r + n + i + e, 4, a + B + Nv + " +k=1" + xt + _ + L + n + i + e, 1, a + B + Zc + " +k=1" + On + _ + L + n + i + e, 1, a + B + np + " +k=1" + Pe + _ + L + n + i + e, 1, a + B + oy + " +k=1" + hr + _ + L + n + i + e, 1, a + B + Dv + " +k=1" + wa + _ + L + n + i + e, 1, a + B + Dw + " +k=1" + Ah + _ + L + n + i + e, 1, a + B + rd + " +k=1" + Ys + _ + L + n + i + e, 4, a + B + Nv + " +k=1" + xt + _ + m + Fe + i + e, 1, a + B + Zc + " +k=1" + On + _ + m + Fe + i + e, 1, a + B + np + " +k=1" + Pe + _ + m + Fe + i + e, 1, a + B + oy + " +k=1" + hr + _ + m + Fe + i + e, 1, a + B + Dv + " +k=1" + wa + _ + m + Fe + i + e, 1, a + B + Dw + " +k=1" + Ah + _ + m + Fe + i + e, 1, a + B + rd + " +k=1" + Ys + _ + m + Fe + i + e, 37, h + Xf + F + Ce + pe + Jt + i + e, 1, h + pu + F + Ce + pe + Jt + i + e, 40, a + f + wo + " +k=1" + H + _ + Co + Ce + pe + Jt + i + e, 2, a + f + xv + " +k=1" + H + _ + Co + Ce + pe + Jt + i + e, 2, a + f + Oy + " +k=1" + H + _ + Co + Ce + pe + Jt + i + e, 2, a + f + Eo + " +k=1" + H + _ + Co + Ce + pe + Jt + i + e, 2, a + f + Rg + " +k=1" + H + _ + Co + Ce + pe + Jt + i + e, 2, a + f + jy + " +k=1" + H + _ + Co + Ce + pe + Jt + i + e, 2, a + f + es + " +k=1" + H + _ + Co + Ce + pe + Jt + i + e, 2, a + f + " +lon_0=29 +k=1" + H + _ + Co + Ce + pe + Jt + i + e, 2, a + f + Qp + " +k=1" + H + _ + Co + Ce + pe + Jt + i + e, 2, a + f + Hs + " +k=1" + H + _ + Co + Ce + pe + Jt + i + e, 39, h + Vl + vt + ue + Mo + i + e, 59, l + " +lat_1=36" + to + " +lon_0=9.9" + Rp + p + Ms + vt + ue + Mo + i + e, 1, l + Wg + Vg + " +lon_0=9.9" + fd + p + Ms + vt + ue + Mo + i + e, 129, h + qs + F + m + io + i + e, 1, h + Cl + F + m + io + i + e, 1, h + Nc + F + m + io + i + e, 1, h + Cd + F + m + io + i + e, 1, h + vd + F + m + io + i + e, 175, l + pC + " +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256" + st + Ms + vt + ue + Wo + i + e, 70, l + pC + " +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256" + st + Ms + vt + ue + Wo + i + e, 10, lo + " +lat_0=34.2 +lon_0=39.15 +k=0.9995341" + H + _ + vt + ue + Wo + i + e, 211, a + So + " +lon_0=35 +k=1" + st + " +y_0=1100000" + Ao + cs + i + e, 1, a + So + Qp + " +k=1 +x_0=615000 +y_0=810000" + Ao + cs + i + e, 1, a + So + es + " +k=1" + _a + Ws + Ao + cs + i + e, 1, a + So + es + " +k=1" + _a + $m + Ao + cs + i + e, 34, h + hh + m + Q + i + e, 1, h + Rh + m + Q + i + e, 1, h + y_ + m + Q + i + e, 1, h + Sp + m + Q + i + e, 1, h + Vl + m + Q + i + e, 1, h + Ph + m + Q + i + e, 1, h + Xf + m + Q + i + e, 1, h + pu + m + Q + i + e, 1, h + hf + m + Q + i + e, 1, h + Th + m + Q + i + e, 1, h + lh + m + Q + i + e, 52, a + f + ts + _t + p + _ + m + Q + i + e, 5, a + f + " +lon_0=5" + _t + p + _ + m + Q + i + e, 144, h + Wl + I + qf + i + e, 1, h + lf + I + qf + i + e, 460, mp + " +lat_0=47.14439372222222 +lon_0=19.04857177777778 +k_0=0.99993 +x_0=650000" + Ws + _C + Ey + i + e, 130, a + f + " +lon_0=94.5" + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=97.5" + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=100.5" + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=103.5" + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=106.5" + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=109.5" + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=112.5" + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=115.5" + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=118.5" + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=121.5" + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=124.5" + k + D + ur + L + n + i + e, 1, a + f + sp + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=130.5" + k + D + ur + L + n + i + e, 1, a + f + tv + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=136.5" + k + D + ur + L + n + i + e, 1, a + f + " +lon_0=139.5" + k + D + ur + L + n + i + e, 1, h + Ip + nl + Oe + Zt + i + e, 1, h + Ed + nl + Oe + Zt + i + e, 1, h + cf + nl + Oe + Zt + i + e, 1, h + ff + nl + Oe + Zt + i + e, 1, h + Jf + nl + Oe + Zt + i + e, 1, h + uf + nl + Oe + Zt + i + e, 1, h + Wf + nl + Oe + Zt + i + e, 14, h + Ip + L + n + i + e, 1, h + Ed + L + n + i + e, 1, h + cf + L + n + i + e, 1, h + ff + L + n + i + e, 1, h + Jf + L + n + i + e, 1, h + uf + L + n + i + e, 1, h + Wf + L + n + i + e, 5, h + Ed + F + L + n + i + e, 1, h + cf + F + L + n + i + e, 1, h + ff + F + L + n + i + e, 1, h + Jf + F + L + n + i + e, 1, h + uf + F + L + n + i + e, 1, h + Wf + F + L + n + i + e, 1, h + v_ + F + L + n + i + e, 1, h + Md + F + L + n + i + e, 3, h + Ed + F + nl + Oe + Zt + i + e, 1, h + cf + F + nl + Oe + Zt + i + e, 1, h + ff + F + nl + Oe + Zt + i + e, 1, h + Jf + F + nl + Oe + Zt + i + e, 1, h + uf + F + nl + Oe + Zt + i + e, 1, h + Wf + F + nl + Oe + Zt + i + e, 1, h + v_ + F + nl + Oe + Zt + i + e, 1, h + Md + F + nl + Oe + Zt + i + e, 52, h + Ip + Xe + Wt + th + i + e, 1, h + Ed + Xe + Wt + th + i + e, 1, h + cf + Xe + Wt + th + i + e, 99, h + Ed + Xe + Wt + Uf + i + e, 1, h + cf + Xe + Wt + Uf + i + e, 52, l + " +lat_1=18" + Yd + lc + " +k_0=1 +x_0=167638.49597 +y_0=121918.90616" + My + wy + qc + e, 100, l + " +lat_1=18" + Yd + lc + " +k_0=1" + ze + " +y_0=150000" + R + wm + i + e, 105, h + Jm + Xe + Wt + $l + i + e, 1, h + Ip + Xe + Wt + $l + i + e, 5, h + Wy + xc + As + ao + i + e, 1, h + Vy + xc + As + ao + i + e, 1, h + Dg + xc + As + ao + i + e, 29, h + Vy + Io + pn + ye + i + e, 1, h + Dg + Io + pn + ye + i + e, 1, h + Xm + Io + pn + ye + i + e, 1, h + Jm + Io + pn + ye + i + e, 1, h + Ip + Io + pn + ye + i + e, 1, h + Ed + Io + pn + ye + i + e, 23, l + Jg + " +lat_0=39.5 +lon_0=68 +k_0=0.99846154 +x_0=2153865.73916853 +y_0=2368292.194628102" + Yo + Lo + so + e, 1, l + fy + dc + " +lon_0=68" + Fi + oh + sh + Yo + Lo + so + e, 1, l + Av + el + " +lon_0=74" + Fi + oh + sh + Yo + Lo + so + e, 1, l + " +lat_1=19 +lat_0=19 +lon_0=80" + Fi + oh + sh + Yo + Lo + so + e, 1, l + " +lat_1=12 +lat_0=12 +lon_0=80" + Fi + oh + sh + Yo + Lo + so + e, 1, l + Av + el + Is + Fi + " +x_0=2743185.69 +y_0=914395.23" + Xe + Wt + $l + i + e, 1, l + fy + dc + " +lon_0=68" + Fi + " +x_0=2743196.4 +y_0=914398.8" + xc + As + ao + i + e, 1, l + Av + el + " +lon_0=74" + Fi + " +x_0=2743196.4 +y_0=914398.8" + xc + As + ao + i + e, 1, l + fy + dc + " +lon_0=68" + Fi + W_ + Vp + Io + pn + ye + i + e, 1, l + Av + el + " +lon_0=74" + Fi + W_ + Vp + Io + pn + ye + i + e, 1, l + Av + el + Is + Fi + W_ + Vp + Io + pn + ye + i + e, 1, l + " +lat_1=19 +lat_0=19 +lon_0=80" + Fi + W_ + Vp + Io + pn + ye + i + e, 1, l + Av + el + Is + Fi + oh + sh + Yo + Lo + so + e, 1, l + " +lat_1=12 +lat_0=12 +lon_0=80" + Fi + W_ + Vp + Io + pn + ye + i + e, 117, Nn + " +lat_0=1.287646666666667 +lon_0=103.8530022222222" + Uw + " +y_0=30000" + $i + Je + me + i + e, 47, h + Ed + $i + Je + me + i + e, 1, h + cf + $i + Je + me + i + e, 52, l + fy + dc + eh + Y_ + xt + uC + I + ry + i + e, 118, h + Fs + m + ps + i + e, 1, h + bs + m + ps + i + e, 1, h + Qo + m + ps + i + e, 97, h + bl + m + kt + i + e, 1, h + Fs + m + kt + i + e, 1, h + bs + m + kt + i + e, 1, h + Qo + m + kt + i + e, 1, h + qs + m + kt + i + e, 56, h + bl + F + m + kt + i + e, 1, h + Fs + F + m + kt + i + e, 1, h + bs + F + m + kt + i + e, 1, h + Qo + F + m + kt + i + e, 1, h + qs + F + m + kt + i + e, 1, h + Cl + F + m + kt + i + e, 9, a + " +lat_0=-6 +lon_0=-80.5 +k=0.99983008 +x_0=222000 +y_0=1426834.743" + m + kt + i + e, 1, a + " +lat_0=-9.5 +lon_0=-76 +k=0.99932994 +x_0=720000 +y_0=1039979.159" + m + kt + i + e, 1, a + " +lat_0=-9.5" + Vs + " +k=0.99952992 +x_0=1324000 +y_0=1040084.558" + m + kt + i + e, 107, a + eb + " +lon_0=-1" + pg + " +x_0=274319.51" + _ + I + Rm + i + e, 231, h + Sp + vt + ue + i + e, 160, a + f + Ai + cn + p + _ + R + zi + i + e, 1, a + f + Ew + cn + p + _ + R + zi + i + e, 1, a + f + Sw + cn + p + _ + R + zi + i + e, 1, a + f + Gi + cn + p + _ + R + zi + i + e, 1, a + f + _g + cn + p + _ + R + zi + i + e, 433, h + hh + r + n + i + e, 1, h + Rh + r + n + i + e, 1, h + y_ + r + n + i + e, 1, h + Sp + r + n + i + e, 1, h + Vl + r + n + i + e, 1, h + Ph + r + n + i + e, 1, h + Xf + r + n + i + e, 1, h + pu + r + n + i + e, 1, h + hf + r + n + i + e, 1, h + Th + r + n + i + e, 47, a + f + Xs + _t + p + _ + r + n + i + e, 48, h + Vl + F + m + $p + i + e, 259, l + Wg + Vg + zM + fd + p + Ms + vt + ue + $s + i + e, 1, l + " +lat_1=29.7 +lat_0=29.7" + zM + " +k_0=0.9996155960000001" + p + Ms + vt + ue + $s + i + e, 2, l + " +lat_1=26.1 +lat_0=26.1" + zM + " +k_0=0.999616304 +x_0=1200000" + Il + vt + ue + $s + i + e, 1, l + " +lat_1=22.5 +lat_0=22.5" + zM + " +k_0=0.999616437" + xt + Il + vt + ue + $s + i + e, 42, h + Th + C + Zm + i + e, 94, h + Sp + I + oo + i + e, 1, h + Vl + I + oo + i + e, 59, a + ay + " +lon_0=4.5" + pg + " +x_0=230738.26" + _ + I + oo + i + e, 1, a + ay + " +lon_0=8.5" + pg + " +x_0=670553.98" + _ + I + oo + i + e, 1, a + ay + " +lon_0=12.5" + pg + " +x_0=1110369.7" + _ + I + oo + i + e, 239, h + Vl + vt + ue + zf + i + e, 60, h + Vl + F + vt + ue + zf + i + e, 9, h + Og + w + i + e, 1, h + Bm + w + i + e, 1, h + sM + w + i + e, 1, h + qm + w + i + e, 1, h + Ay + w + i + e, 1, h + lg + w + i + e, 1, h + Iy + w + i + e, 1, h + Qm + w + i + e, 1, h + Fm + w + i + e, 1, h + Ap + w + i + e, 1, h + xd + w + i + e, 1, h + bd + w + i + e, 1, h + kd + w + i + e, 1, h + wd + w + i + e, 1, h + Hf + w + i + e, 1, h + Zf + w + i + e, 1, h + bl + w + i + e, 1, h + Fs + w + i + e, 1, h + bs + w + i + e, 1, h + Qo + w + i + e, 1, h + qs + w + i + e, 1, h + Cl + w + i + e, 7, a + hl + ol + tp + j + _ + w + u + e, 1, a + So + Zd + re + j + _ + w + u + e, 1, yn + " +lat_0=57" + Su + Au + k + " +x_0=5000000.001016002 +y_0=-5000000.001016002" + Bh + _o + w + u + e, 1, a + Ri + bM + k + j + _ + w + u + e, 1, a + Ri + kM + k + j + _ + w + u + e, 1, a + Ri + Fd + k + j + _ + w + u + e, 1, a + Ri + kf + k + j + _ + w + u + e, 1, a + Ri + Uh + k + j + _ + w + u + e, 1, a + Ri + MM + k + " +x_0=213360.4267208534" + _ + w + u + e, 1, a + Ri + wM + k + j + _ + w + u + e, 1, a + Ri + qg + k + bp + _ + w + u + e, 1, l + Iu + Ou + Ev + CM + He + _ + w + u + e, 1, l + yr + kh + Y + Fo + E + _ + w + u + e, 1, l + gr + mr + $ + Fo + E + _ + w + u + e, 1, l + Qt + vr + pf + lt + E + _ + w + u + e, 1, l + Xu + qp + xr + yf + E + _ + w + u + e, 1, l + br + kr + gf + Al + E + _ + w + u + e, 1, l + Mr + wr + Cr + Gl + E + _ + w + u + e, 2, a + De + Rn + k + j + _ + w + u + e, 1, a + De + Ln + k + j + _ + w + u + e, 1, a + De + Nl + re + j + _ + w + u + e, 1, l + Ur + zr + $t + zs + E + _ + w + u + e, 1, l + Hr + xf + Zr + zs + E + _ + w + u + e, 1, l + " +lat_1=39.71666666666667 +lat_2=40.78333333333333" + Y + Me + E + _ + w + u + e, 1, l + Ju + Wu + xn + Me + E + _ + w + u + e, 1, l + Qt + Er + N + Me + E + _ + w + u + e, 1, l + Sr + mf + Ar + Ch + bp + _ + w + u + e, 1, a + In + Pn + vf + j + _ + w + u + e, 1, a + Ft + dn + Pt + j + _ + w + u + e, 1, a + Ft + e_ + Pt + j + _ + w + u + e, 1, l + Vu + Ir + Up + Yu + E + _ + w + u + e, 6, a + So + Tn + k + j + _ + w + u + e, 1, a + So + Bn + k + j + _ + w + u + e, 1, a + q + Qn + oe + j + _ + w + u + e, 1, a + q + uh + oe + j + _ + w + u + e, 1, a + q + Dl + re + j + _ + w + u + e, 1, a + N + Xn + la + j + _ + w + u + e, 1, a + N + Jn + Pt + j + _ + w + u + e, 1, a + or + Wn + dt + j + _ + w + u + e, 1, a + or + Vn + dt + j + _ + w + u + e, 1, l + Xr + Jr + Oi + Ji + E + _ + w + u + e, 1, l + Mt + Wr + Di + Ji + E + _ + w + u + e, 1, l + Vr + Yr + pt + Si + E + _ + w + u + e, 1, l + Kr + $r + N + gn + E + _ + w + u + e, 1, l + Vt + pr + or + Mh + E + _ + w + u + e, 1, l + " +lat_1=36.73333333333333 +lat_2=37.93333333333333" + tt + ya + E + _ + w + u + e, 1, l + " +lat_1=31.16666666666667 +lat_2=32.66666666666666 +lat_0=30.66666666666667" + vs + E + _ + w + u + e, 1, l + " +lat_1=29.3 +lat_2=30.7 +lat_0=28.66666666666667" + je + E + _ + w + u + e, 1, a + ut + Vo + k + j + _ + w + u + e, 1, a + te + Yn + dt + j + _ + w + u + e, 1, l + " +lat_1=38.3 +lat_2=39.45" + xn + lc + " +x_0=243840.4876809754" + _ + w + u + e, 1, l + " +lat_1=41.71666666666667 +lat_2=42.68333333333333" + El + Zi + bp + _ + w + u + e, 1, l + " +lat_1=41.28333333333333 +lat_2=41.48333333333333" + El + Vs + " +x_0=60960.12192024384" + _ + w + u + e, 4, l + " +lat_1=47.03333333333333 +lat_2=48.63333333333333" + Sl + Kn + E + _ + w + u + e, 1, l + " +lat_1=45.61666666666667 +lat_2=47.05" + tl + Sh + E + _ + w + u + e, 1, l + " +lat_1=43.78333333333333 +lat_2=45.21666666666667" + cd + nd + E + _ + w + u + e, 1, a + Mn + Fn + tp + j + _ + w + u + e, 1, a + hl + Ze + Pt + j + _ + w + u + e, 1, a + Cn + Qy + re + j + _ + w + u + e, 1, a + Cn + vs + re + j + _ + w + u + e, 1, a + _l + Fy + Pt + j + _ + w + u + e, 1, l + " +lat_1=34.41666666666666 +lat_2=33.86666666666667 +lat_0=34.13333333333333" + sl + " +x_0=1276106.450596901 +y_0=1268253.006858014" + w + u + e, 48, a + ht + Vo + k + ne + _ + r + n + u + e, 1, a + te + Yn + dt + os + _ + r + n + u + e, 1, l + ui + ci + Sl + Kn + Tt + Bt + r + n + u + e, 1, l + rf + fi + tl + Sh + Tt + Bt + r + n + u + e, 1, l + di + _i + cd + nd + Tt + Bt + r + n + u + e, 1, l + nh + kh + pi + _n + it + _ + r + n + u + e, 1, l + af + Ry + bf + po + S + _ + r + n + u + e, 1, l + ki + Mi + Xp + dn + S + _ + r + n + u + e, 1, a + ht + Vo + k + ne + _ + r + n + u + e, 1, a + te + Yn + dt + os + _ + r + n + u + e, 1, l + ui + ci + Sl + Kn + Tt + Bt + r + n + u + e, 1, l + rf + fi + tl + Sh + Tt + Bt + r + n + u + e, 1, l + di + _i + cd + nd + Tt + Bt + r + n + u + e, 1, l + nh + kh + pi + _n + it + _ + r + n + u + e, 1, l + af + Ry + bf + po + S + _ + r + n + u + e, 1, l + ki + Mi + Xp + dn + S + _ + r + n + u + e, 1, a + ht + Vo + k + ne + _ + r + n + u + e, 1, a + te + Yn + dt + os + _ + r + n + u + e, 1, l + ui + ci + Sl + Kn + Tt + Bt + r + n + u + e, 1, l + rf + fi + tl + Sh + Tt + Bt + r + n + u + e, 1, l + di + _i + cd + nd + Tt + Bt + r + n + u + e, 1, l + nh + kh + pi + _n + it + _ + r + n + u + e, 1, l + af + Ry + bf + po + S + _ + r + n + u + e, 1, l + ki + Mi + Xp + dn + S + _ + r + n + u + e, 21, a + f + ca + k + Et + _ + r + n + i + e, 1, a + f + dn + k + Et + _ + r + n + i + e, 1, a + f + Yf + k + Et + _ + r + n + i + e, 1, a + f + yh + k + Et + _ + r + n + i + e, 1, a + f + Ue + k + Et + _ + r + n + i + e, 1, a + f + fg + k + Et + _ + r + n + i + e, 1, a + f + $d + k + Et + _ + r + n + i + e, 1, a + f + " +lon_0=-53" + k + Et + _ + r + n + i + e, 1, a + f + Rw + k + Et + _ + r + n + i + e, 2, h + Og + r + n + i + e, 1, h + Bm + r + n + i + e, 1, h + sM + r + n + i + e, 1, h + qm + r + n + i + e, 1, h + Ay + r + n + i + e, 1, h + lg + r + n + i + e, 1, h + Iy + r + n + i + e, 1, h + Qm + r + n + i + e, 1, h + Fm + r + n + i + e, 1, h + Ap + r + n + i + e, 1, h + xd + r + n + i + e, 1, h + bd + r + n + i + e, 1, h + kd + r + n + i + e, 1, h + wd + r + n + i + e, 1, h + Hf + r + n + i + e, 1, h + Zf + r + n + i + e, 1, h + bl + r + n + i + e, 1, h + Fs + r + n + i + e, 1, h + bs + r + n + i + e, 1, h + Qo + r + n + i + e, 1, h + qs + r + n + i + e, 1, h + Cl + r + n + i + e, 1, h + Nc + r + n + i + e, 6, a + hl + ol + tp + D + _ + r + n + i + e, 1, a + So + Zd + re + S + _ + r + n + i + e, 1, yn + " +lat_0=57" + Su + Au + k + nc + oa + Bh + _o + r + n + i + e, 1, a + Ri + bM + k + p + _ + r + n + i + e, 1, a + Ri + kM + k + p + _ + r + n + i + e, 1, a + Ri + Fd + k + p + _ + r + n + i + e, 1, a + Ri + kf + k + p + _ + r + n + i + e, 1, a + Ri + Uh + k + p + _ + r + n + i + e, 1, a + Ri + MM + k + p + _ + r + n + i + e, 1, a + Ri + wM + k + p + _ + r + n + i + e, 1, a + Ri + qg + k + p + _ + r + n + i + e, 1, l + Iu + Ou + Ev + CM + ke + _ + r + n + i + e, 1, l + yr + kh + Y + Fo + Ee + It + r + n + i + e, 1, l + gr + mr + $ + Fo + Ee + It + r + n + i + e, 1, l + Qt + vr + pf + lt + Ee + It + r + n + i + e, 1, l + Xu + qp + xr + yf + Ee + It + r + n + i + e, 1, l + br + kr + gf + Al + Ee + It + r + n + i + e, 1, l + Mr + wr + Cr + Gl + Ee + It + r + n + i + e, 2, a + De + Rn + k + pa + _ + r + n + i + e, 1, a + De + Ln + k + pa + _ + r + n + i + e, 1, a + De + Nl + re + pa + _ + r + n + i + e, 1, l + Ur + zr + $t + zs + X + _ + r + n + i + e, 1, l + Hr + xf + Zr + zs + X + Il + r + n + i + e, 1, l + Ca + Ea + Y + Me + Ti + Bi + r + n + i + e, 1, l + Ju + Wu + xn + Me + Ti + Bi + r + n + i + e, 1, l + Qt + Er + N + Me + Ti + Bi + r + n + i + e, 1, l + Sr + mf + Ar + Ch + Op + jp + r + n + i + e, 1, a + In + Pn + vf + D + _ + r + n + i + e, 1, a + Ft + dn + Pt + D + _ + r + n + i + e, 1, a + Ft + e_ + Pt + D + _ + r + n + i + e, 1, l + Vu + Ir + Up + Yu + S + _ + r + n + i + e, 1, a + xu + Yg + dt + p + _ + r + n + i + e, 1, a + bu + Wh + dt + p + _ + r + n + i + e, 1, a + ho + Uh + xh + p + _ + r + n + i + e, 1, a + ku + Kg + xh + p + _ + r + n + i + e, 1, a + Mu + Vh + " +k=1" + p + _ + r + n + i + e, 1, a + So + Tn + k + D + _ + r + n + i + e, 1, a + So + Bn + k + _a + _ + r + n + i + e, 1, a + q + Qn + oe + D + _ + r + n + i + e, 1, a + q + uh + oe + p + _ + r + n + i + e, 1, a + q + Dl + re + vn + _ + r + n + i + e, 1, a + N + Xn + la + st + _ + r + n + i + e, 1, a + N + Jn + Pt + _a + _ + r + n + i + e, 1, a + or + Wn + dt + ge + zh + r + n + i + e, 1, a + or + Vn + dt + os + zh + r + n + i + e, 1, l + Xr + Jr + Oi + Ji + xt + ot + r + n + i + e, 1, l + Mt + Wr + Di + Ji + p + _ + r + n + i + e, 1, l + Vr + Yr + pt + Si + X + _ + r + n + i + e, 1, l + Kr + $r + N + gn + X + Il + r + n + i + e, 2, l + Sa + Aa + tt + ya + p + It + r + n + i + e, 1, l + li + hi + hl + vs + ke + _ + r + n + i + e, 1, l + Rd + Ld + Pd + je + ke + _ + r + n + i + e, 1, a + ht + Vo + k + st + _ + r + n + i + e, 1, a + te + Yn + dt + os + _ + r + n + i + e, 1, l + Yc + Sd + $ + lc + X + _ + r + n + i + e, 1, l + Ia + Or + El + Zi + D + _f + r + n + i + e, 1, l + Oa + ja + El + Vs + p + _ + r + n + i + e, 1, l + Na + Ga + Da + yh + ev + _ + r + n + i + e, 1, l + Ad + Ra + La + ee + lp + _ + r + n + i + e, 1, l + Be + Id + Oi + ee + $u + _ + r + n + i + e, 1, l + ui + ci + Sl + Kn + vn + na + r + n + i + e, 1, l + rf + fi + tl + Sh + vn + na + r + n + i + e, 1, l + di + _i + cd + nd + vn + na + r + n + i + e, 1, a + ks + Fn + cn + st + _ + r + n + i + e, 1, a + ks + Ze + cn + _a + _ + r + n + i + e, 1, a + Cn + Qy + re + ze + _ + r + n + i + e, 1, a + Cn + vs + re + p + _ + r + n + i + e, 1, a + _l + Fy + Pt + uM + _ + r + n + i + e, 41, h + Wl + I + lr + i + e, 1, h + lf + I + lr + i + e, 80, h + Qo + m + Lm + i + e, 80, "+proj=nzmg +lat_0=-41 +lon_0=173 +x_0=2510000 +y_0=6023150" + m + M + i + e, 5, a + " +lat_0=-36.87986527777778 +lon_0=174.7643393611111" + k + st + sr + m + M + i + e, 1, a + " +lat_0=-37.76124980555556 +lon_0=176.46619725 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-38.62470277777778 +lon_0=177.8856362777778 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-39.65092930555556 +lon_0=176.6736805277778 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-39.13575830555556 +lon_0=174.22801175 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-39.51247038888889 +lon_0=175.6400368055556 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-40.24194713888889 +lon_0=175.4880996111111 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-40.92553263888889 +lon_0=175.6473496666667 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-41.30131963888888 +lon_0=174.7766231111111 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-40.71475905555556 +lon_0=172.6720465 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-41.27454472222222 +lon_0=173.2993168055555 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-41.28991152777778 +lon_0=172.1090281944444 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-41.81080286111111 +lon_0=171.5812600555556 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-42.33369427777778 +lon_0=171.5497713055556 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-42.68911658333333 +lon_0=173.0101333888889 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-41.54448666666666 +lon_0=173.8020741111111 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-42.88632236111111 +lon_0=170.9799935 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-43.11012813888889 +lon_0=170.2609258333333 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-43.97780288888889 +lon_0=168.606267 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-43.59063758333333 +lon_0=172.7271935833333 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-43.74871155555556 +lon_0=171.3607484722222 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-44.40222036111111 +lon_0=171.0572508333333 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-44.73526797222222 +lon_0=169.4677550833333 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-45.13290258333333 +lon_0=168.3986411944444 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-45.56372616666666 +lon_0=167.7388617777778 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-45.81619661111111 +lon_0=170.6285951666667 +k=1" + st + sr + m + M + i + e, 1, a + " +lat_0=-45.86151336111111 +lon_0=170.2825891111111" + tp + st + sr + m + M + i + e, 1, a + " +lat_0=-46.60000961111111 +lon_0=168.342872 +k=1 +x_0=300002.66 +y_0=699999.58" + m + M + i + e, 26, h + jc + F + m + M + i + e, 1, h + md + F + m + M + i + e, 1, h + P_ + F + m + M + i + e, 31, a + " +lat_0=-39 +lon_0=175.5 +k=1 +x_0=274319.5243848086 +y_0=365759.3658464114" + m + M + Tm + e, 1, a + Nw + " +lon_0=171.5 +k=1 +x_0=457199.2073080143 +y_0=457199.2073080143" + m + M + Tm + e, 99, a + Ei + " +lon_0=-4.666666666666667 +k=1" + H + _ + Es + ra + Ct + Gg + i + e, 1, a + Ei + " +lon_0=-2.333333333333333 +k=1" + H + _ + Es + ra + Ct + Gg + i + e, 1, a + Ei + ts + " +k=1" + H + _ + Es + ra + Ct + Gg + i + e, 1, a + Ei + " +lon_0=2.5 +k=1" + H + _ + Es + ra + Ct + Gg + i + e, 1, a + Ei + rb + " +k=1" + H + _ + Es + ra + Ct + Gg + i + e, 1, a + Ei + " +lon_0=10.16666666666667 +k=1" + H + _ + Es + ra + Ct + Gg + i + e, 1, a + Ei + " +lon_0=14.16666666666667 +k=1" + H + _ + Es + ra + Ct + Gg + i + e, 1, a + Ei + " +lon_0=18.33333333333333 +k=1" + H + _ + Es + ra + Ct + Gg + i + e, 31, h + Rh + m + Jl + i + e, 64, a + be + Fv + " +k=1 +x_0=180.598 +y_0=-86.98999999999999" + m + Jl + i + e, 7, l + I_ + O_ + " +lon_0=5.399999999999999 +k_0=0.99950908" + p + Ms + " +a=6376523" + ky + mw + i + e, 61, l + I_ + O_ + ts + " +k_0=0.999877341" + S + Ws + vt + ue + Ge + Ec + i + e, 1, l + " +lat_1=46.8 +lat_0=46.8" + ts + " +k_0=0.99987742" + S + Ws + vt + ue + Ge + Ec + i + e, 1, l + eM + nM + ts + " +k_0=0.999877499" + S + Ws + vt + ue + Ge + Ec + i + e, 1, l + rM + aM + ts + " +k_0=0.99994471 +x_0=234.358 +y_0=185861.369" + vt + ue + Ge + Ec + i + e, 7, l + I_ + O_ + ts + " +k_0=0.999877341" + S + $m + vt + ue + Ge + Ec + i + e, 1, l + " +lat_1=46.8 +lat_0=46.8" + ts + " +k_0=0.99987742" + S + " +y_0=2200000" + vt + ue + Ge + Ec + i + e, 1, l + eM + nM + ts + " +k_0=0.999877499" + S + " +y_0=3200000" + vt + ue + Ge + Ec + i + e, 1, l + rM + aM + ts + " +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369" + vt + ue + Ge + Ec + i + e, 126, a + " +lat_0=49 +lon_0=-2 +k=0.9996012717" + X + " +y_0=-100000" + X_ + Ac + i + e, 491, Nn + Qu + Fu + vy + " +y_0=126867.909" + ad + id + fr + i + e, 1, a + Qu + Fu + " +k=1" + vy + " +y_0=1126867.909" + ad + id + fr + i + e, 1, Nn + Qu + Fu + vy + " +y_0=1126867.909" + ad + id + fr + i + e, 39, h + Vl + F + vt + ue + Cm + i + e, 116, h + cf + F + r + n + i + e, 1, h + ff + F + r + n + i + e, 1, h + Jf + F + r + n + i + e, 1, h + uf + F + r + n + i + e, 1, h + Wf + F + r + n + i + e, 1, h + v_ + F + r + n + i + e, 1, h + Md + F + r + n + i + e, 1, h + T_ + F + r + n + i + e, 1, h + Ky + F + r + n + i + e, 1, h + Ng + F + r + n + i + e, 1, h + jc + F + r + n + i + e, 46, a + f + Eo + " +k=1" + hr + _ + d + o + i + e, 1, a + f + es + " +k=1" + wa + _ + d + o + i + e, 1, a + f + Hs + " +k=1" + Ah + _ + d + o + i + e, 1, a + f + Zu + " +k=1" + Ys + _ + d + o + i + e, 1, a + f + eh + " +k=1" + Wc + _ + d + o + i + e, 1, a + f + z_ + " +k=1" + Vc + _ + d + o + i + e, 1, a + f + Gy + " +k=1" + rc + _ + d + o + i + e, 1, a + f + Zp + " +k=1" + wh + _ + d + o + i + e, 1, a + f + Dy + " +k=1" + ac + _ + d + o + i + e, 1, a + f + ns + " +k=1" + ss + _ + d + o + i + e, 1, a + f + rs + " +k=1" + Po + _ + d + o + i + e, 1, a + f + ys + " +k=1" + Gs + _ + d + o + i + e, 1, a + f + as + " +k=1" + Ds + _ + d + o + i + e, 1, a + f + is + " +k=1" + Ol + _ + d + o + i + e, 1, a + f + ia + " +k=1" + js + _ + d + o + i + e, 1, a + f + Qi + " +k=1" + Ns + _ + d + o + i + e, 1, a + f + Ai + " +k=1" + ls + _ + d + o + i + e, 1, a + f + Gi + " +k=1" + Rs + _ + d + o + i + e, 1, a + f + ba + " +k=1" + hs + _ + d + o + i + e, 1, a + f + Ii + " +k=1" + Ls + _ + d + o + i + e, 1, a + f + rp + " +k=1" + ic + _ + d + o + i + e, 1, a + f + r_ + " +k=1" + Ps + _ + d + o + i + e, 1, a + f + td + " +k=1" + Ts + _ + d + o + i + e, 1, a + f + ap + " +k=1" + Bs + _ + d + o + i + e, 1, a + f + ed + " +k=1" + Qs + _ + d + o + i + e, 1, a + f + uc + " +k=1" + To + _ + d + o + i + e, 1, a + f + Fh + " +k=1" + al + _ + d + o + i + e, 1, a + f + qh + " +k=1" + go + _ + d + o + i + e, 1, a + f + fc + " +k=1" + il + _ + d + o + i + e, 168, a + " +lat_0=24.45" + sb + xh + D + Ms + m + Tp + i + e, 391, lo + iM + JM + " +k=0.9999079" + H + _ + C + Pi + i + e, 1, lo + iM + JM + " +k=0.9999079 +x_0=155000 +y_0=463000" + C + Pi + i + e, 109, Lv + f + rd + nc + Rt + V + Lt + i + e, 67, h + Fs + V + Lt + i + e, 1, h + bs + V + Lt + i + e, 1, h + Qo + V + Lt + i + e, 1, h + qs + V + Lt + i + e, 1, h + Cl + V + Lt + i + e, 15, h + bl + F + V + Lt + i + e, 1, h + Fs + F + V + Lt + i + e, 1, h + bs + F + V + Lt + i + e, 1, h + Qo + F + V + Lt + i + e, 1, h + qs + F + V + Lt + i + e, 1, h + Cl + F + V + Lt + i + e, 1, h + Nc + F + V + Lt + i + e, 1, h + Cd + F + V + Lt + i + e, 1, h + vd + F + V + Lt + i + e, 25, h + Qo + F + m + pd + i + e, 1, h + qs + F + m + pd + i + e, 112, h + Ph + F + qo + qe + i + e, 38, a + op + " +lon_0=11 +k=1" + H + _ + Co + qo + qe + Ki + e, 2, a + op + " +lon_0=13 +k=1" + H + _ + Co + qo + qe + Ki + e, 2, a + op + wo + " +k=1" + H + _ + Co + qo + qe + Ki + e, 2, a + op + xv + " +k=1" + H + _ + Co + qo + qe + Ki + e, 2, a + op + Oy + " +k=1" + H + _ + Co + qo + qe + Ki + e, 2, a + op + Eo + " +k=1" + H + _ + Co + qo + qe + Ki + e, 2, a + op + Rg + " +k=1" + H + _ + Co + qo + qe + Ki + e, 2, a + op + jy + " +k=1" + H + _ + Co + qo + qe + Ki + e, 317, yn + " +lat_0=-18.9 +lonc=44.10000000000001 +alpha=18.9" + sa + X + un + " +gamma=18.9" + m + zo + Ec + i + e, 36, h + lh + F + m + zo + i + e, 1, h + Wl + F + m + zo + i + e, 110, h + ff + vc + Hi + i + e, 1, h + Jf + vc + Hi + i + e, 21, yn + ay + iw + j_ + ip + " +x_0=590476.8714630401 +y_0=442857.653094361" + yl + vc + Hi + " +to_meter=20.11676512155263" + e, 1, yn + ay + iw + j_ + ip + " +x_0=590476.8727431979 +y_0=442857.6545573985" + yl + vc + Hi + " +to_meter=0.3047994715386762" + e, 1, yn + ay + iw + j_ + ip + " +x_0=590476.87 +y_0=442857.65" + yl + vc + Hi + i + e, 28, a + lM + " +lon_0=-8 +k=1" + D + zh + X_ + we + i + e, 1, a + lM + " +lon_0=-8 +k=1.000035" + D + zh + u_ + we + i + e, 1, a + lM + " +lon_0=-8 +k=1.000035" + D + zh + u_ + we + i + e, 258, a + H_ + rC + k + H + _ + C + G + i + e, 1, a + H_ + $f + k + H + _ + C + G + i + e, 1, a + to + M_ + k + H + _ + C + G + i + e, 1, a + H_ + tv + k + H + _ + C + G + i + e, 1, a + to + w_ + k + H + _ + C + G + i + e, 1, a + to + yg + k + H + _ + C + G + i + e, 1, a + to + C_ + k + H + _ + C + G + i + e, 1, a + to + aC + k + H + _ + C + G + i + e, 1, a + to + E_ + k + H + _ + C + G + i + e, 1, a + Di + S_ + k + H + _ + C + G + i + e, 1, a + ul + dw + k + H + _ + C + G + i + e, 1, a + ul + _w + k + H + _ + C + G + i + e, 1, a + ul + pw + k + H + _ + C + G + i + e, 1, a + el + " +lon_0=142" + k + H + _ + C + G + i + e, 1, a + el + sp + k + H + _ + C + G + i + e, 1, a + el + " +lon_0=124" + k + H + _ + C + G + i + e, 1, a + el + $f + k + H + _ + C + G + i + e, 1, a + " +lat_0=20" + yg + k + H + _ + C + G + i + e, 1, a + el + Mw + k + H + _ + C + G + i + e, 21, Nn + ab + Bv + " +x_0=86501.46392051999" + kC + ka + Ma + Xl + tb + e, 139, h + Wl + Ao + i + e, 1, h + lf + Ao + i + e, 151, l + " +lat_1=36" + to + kg + Rp + p + Ms + vt + ue + Bl + i + e, 1, l + Wg + Vg + kg + fd + p + Ms + vt + ue + Bl + i + e, 1, l + " +lat_1=36" + to + kg + Rp + p + Ms + vt + ue + i + e, 1, l + Wg + Vg + kg + fd + p + Ms + vt + ue + i + e, 235, h + Rh + I + Ot + i + e, 1, h + y_ + I + Ot + i + e, 1, h + Sp + I + Ot + i + e, 1, h + Vl + I + Ot + i + e, 59, l + " +lat_1=36" + to + kg + Rp + " +x_0=500135 +y_0=300090" + I + Ot + i + e, 1, l + Wg + Vg + kg + fd + " +x_0=500135 +y_0=300090" + I + Ot + i + e, 236, h + hh + vt + ue + i + e, 93, h + qs + m + Ho + i + e, 33, a + f + rd + _t + p + _ + m + Ho + i + e, 16, a + f + $x + _t + p + _ + m + Ho + i + e, 1, a + f + $x + k + p + _ + m + Ho + i + e, 80, a + f + Py + " +k=1" + H + oa + C + Xt + Mc + i + e, 1, a + f + Qp + " +k=1" + H + oa + C + Xt + Mc + i + e, 1, a + f + fw + " +k=1" + H + oa + C + Xt + Mc + i + e, 1, a + f + N_ + " +k=1" + H + oa + C + K + i + e, 1, a + f + gl + " +k=1" + H + oa + C + K + i + e, 1, a + f + G_ + " +k=1" + H + oa + C + K + i + e, 1, a + f + N_ + " +k=1" + Le + oa + C + K + i + e, 1, a + f + gl + " +k=1 +x_0=450000" + oa + C + K + i + e, 1, a + f + G_ + " +k=1" + vM + oa + C + K + i + e, 22, a + f + Py + " +k=1" + H + _ + C + Xt + Mc + i + e, 1, a + f + Qp + " +k=1" + H + _ + C + Xt + Mc + i + e, 1, a + f + fw + " +k=1" + H + _ + C + Xt + Mc + i + e, 1, a + f + N_ + " +k=1" + Le + _ + C + K + i + e, 1, a + f + gl + " +k=1 +x_0=450000" + _ + C + K + i + e, 1, a + f + G_ + " +k=1" + vM + _ + C + K + i + e, 1, l + Hu + hd + " +lat_0=47.5" + gl + X + Il + C + K + i + e, 1, a + f + Py + " +k=1" + Le + _ + C + Xt + Mc + i + e, 1, a + f + Qp + " +k=1 +x_0=450000" + _ + C + Xt + Mc + i + e, 1, a + f + fw + " +k=1" + vM + _ + C + Xt + Mc + i + e, 10, l + Cu + Eu + Os + " +lon_0=4.356939722222222 +x_0=150000.01256 +y_0=5400088.4378" + m + ro + i + e, 70, l + " +lat_1=51.16666723333333 +lat_2=49.8333339" + Os + " +lon_0=4.367486666666666 +x_0=150000.013 +y_0=5400088.438" + m + ro + i + e, 96, a + f + xw + " +k=1" + On + _ + C + et + i + e, 1, a + f + Lh + " +k=1" + Pe + _ + C + et + i + e, 1, a + f + Zs + " +k=1" + hr + _ + C + et + i + e, 1, a + f + wo + " +k=1" + wa + _ + C + et + i + e, 59, h + hh + vt + ue + yd + i + e, 1, h + Rh + vt + ue + yd + i + e, 71, lo + " +lat_0=45.9 +lon_0=25.39246588888889 +k=0.9996667" + p + It + m + Bp + i + e, 238, h + lh + L + Jc + i + e, 1, h + Wl + L + Jc + i + e, 62, a + f + Lg + " +k=1" + p + _ + r + cg + i + e, 64, h + xd + r + n + i + e, 1, h + bd + r + n + i + e, 1, h + kd + r + n + i + e, 1, h + wd + r + n + i + e, 1, h + Hf + r + n + i + e, 1, h + Zf + r + n + i + e, 1, h + bl + r + n + i + e, 1, h + Fs + r + n + i + e, 1, h + bs + r + n + i + e, 1, h + Qo + r + n + i + e, 1, h + qs + r + n + i + e, 1, h + Cl + r + n + i + e, 1, h + bl + F + r + n + i + e, 1, h + Fs + F + r + n + i + e, 1, h + bs + F + r + n + i + e, 1, h + Qo + F + r + n + i + e, 1, h + qs + F + r + n + i + e, 1, h + Cl + F + r + n + i + e, 1, h + Nc + F + r + n + i + e, 1, h + Cd + F + r + n + i + e, 1, h + vd + F + r + n + i + e, 1, h + bl + r + n + i + e, 1, h + Fs + r + n + i + e, 1, h + bs + r + n + i + e, 1, h + Qo + r + n + i + e, 1, h + qs + r + n + i + e, 1, h + Cl + r + n + i + e, 1, h + bl + F + r + n + i + e, 1, h + Fs + F + r + n + i + e, 1, h + bs + F + r + n + i + e, 1, h + Qo + F + r + n + i + e, 1, h + qs + F + r + n + i + e, 1, h + Cl + F + r + n + i + e, 1, h + Nc + F + r + n + i + e, 1, h + Cd + F + r + n + i + e, 1, h + vd + F + r + n + i + e, 1, l + " +lat_1=48.71666666666667 +lat_2=47.85" + fl + rl + E + _ + w + u + e, 1, l + " +lat_1=47.88333333333333 +lat_2=46.45 +lat_0=45.83333333333334" + rl + E + _ + w + u + e, 1, l + " +lat_1=46.4 +lat_2=44.86666666666667" + ul + rl + E + _ + w + u + e, 2, l + " +lat_1=41.85 +lat_2=42.81666666666667 +lat_0=41.33333333333334" + _n + E + _ + w + u + e, 1, l + " +lat_1=40.28333333333333" + Or + be + " +lon_0=-99.5" + E + _ + w + u + e, 1, a + fn + $n + k + j + _ + w + u + e, 1, a + fn + tr + k + j + _ + w + u + e, 1, a + fn + er + k + j + _ + w + u + e, 1, a + ji + nr + dt + j + _ + w + u + e, 1, a + Yt + " +lon_0=-74.66666666666667" + la + E + _ + w + u + e, 1, a + De + qn + Cs + j + _ + w + u + e, 1, a + De + Rl + k + j + _ + w + u + e, 1, a + De + Un + Ll + j + _ + w + u + e, 1, a + Di + " +lon_0=-74.33333333333333" + dt + j + _ + w + u + e, 1, a + Di + zn + At + j + _ + w + u + e, 1, a + Di + Hn + At + j + _ + w + u + e, 2, l + " +lat_1=34.33333333333334 +lat_2=36.16666666666666" + Ku + Kf + E + _ + w + u + e, 1, l + " +lat_1=47.43333333333333" + oM + fl + ga + E + _ + w + u + e, 1, l + " +lat_1=46.18333333333333 +lat_2=47.48333333333333" + Se + ga + E + _ + w + u + e, 1, l + " +lat_1=40.43333333333333 +lat_2=41.7" + be + ca + E + _ + w + u + e, 1, l + " +lat_1=38.73333333333333 +lat_2=40.03333333333333" + In + ca + E + _ + w + u + e, 1, l + " +lat_1=35.56666666666667" + Qr + zp + Si + E + _ + w + u + e, 1, l + " +lat_1=33.93333333333333 +lat_2=35.23333333333333" + Dr + Si + E + _ + w + u + e, 1, l + " +lat_1=44.33333333333334" + hd + ht + lt + E + _ + w + u + e, 1, l + " +lat_1=42.33333333333334 +lat_2=44" + q + lt + E + _ + w + u + e, 1, l + " +lat_1=40.88333333333333 +lat_2=41.95" + Kt + ma + E + _ + w + u + e, 2, a + ta + Zi + " +k=0.9999938" + j + _ + w + u + e, 1, l + " +lat_1=33.76666666666667 +lat_2=34.96666666666667" + H_ + dn + E + _ + w + u + e, 2, l + " +lat_1=32.33333333333334 +lat_2=33.66666666666666" + Pr + dn + E + _ + w + u + e, 1, l + " +lat_1=44.41666666666666 +lat_2=45.68333333333333" + ut + _n + E + _ + w + u + e, 1, l + " +lat_1=42.83333333333334 +lat_2=44.4" + ea + jt + E + _ + w + u + e, 2, l + pC + " +lat_2=36.18333333333333" + Hp + Eh + E + _ + w + u + e, 1, l + " +lat_1=32.13333333333333 +lat_2=33.96666666666667" + Tr + " +lon_0=-97.5" + E + _ + w + u + e, 1, l + " +lat_1=30.11666666666667 +lat_2=31.88333333333333" + Mn + jt + E + _ + w + u + e, 1, l + " +lat_1=28.38333333333333 +lat_2=30.28333333333333" + Br + gh + E + _ + w + u + e, 1, l + " +lat_1=26.16666666666667 +lat_2=27.83333333333333" + wn + gn + E + _ + w + u + e, 1, l + " +lat_1=40.71666666666667 +lat_2=41.78333333333333" + Qe + ie + E + _ + w + u + e, 1, l + " +lat_1=39.01666666666667 +lat_2=40.65" + pt + ie + E + _ + w + u + e, 1, l + " +lat_1=37.21666666666667 +lat_2=38.35" + N + ie + E + _ + w + u + e, 1, a + ji + ec + Pl + j + _ + w + u + e, 1, l + " +lat_1=38.03333333333333 +lat_2=39.2" + $ + Xi + E + _ + w + u + e, 1, l + Gr + " +lat_2=37.96666666666667" + tt + Xi + E + _ + w + u + e, 1, l + " +lat_1=47.5" + oM + fl + Zn + E + _ + w + u + e, 1, l + " +lat_1=45.83333333333334 +lat_2=47.33333333333334" + Fr + lt + E + _ + w + u + e, 1, l + " +lat_1=39 +lat_2=40.25" + bf + po + E + _ + w + u + e, 1, l + " +lat_1=37.48333333333333 +lat_2=38.88333333333333" + Xp + dn + E + _ + w + u + e, 1, l + " +lat_1=45.56666666666667 +lat_2=46.76666666666667" + qr + Ue + E + _ + w + u + e, 1, l + " +lat_1=44.25" + ws + ut + Ue + E + _ + w + u + e, 1, l + " +lat_1=42.73333333333333 +lat_2=44.06666666666667" + U_ + Ue + E + _ + w + u + e, 1, a + zu + rr + Pt + j + _ + w + u + e, 1, a + zu + ar + Pt + j + _ + w + u + e, 1, a + zu + Tl + Pt + j + _ + w + u + e, 1, a + zu + ir + Pt + j + _ + w + u + e, 6, a + f + gh + _t + P + _ + w + u + e, 1, a + f + fg + _t + P + _ + w + u + e, 1, a + f + yh + _t + P + _ + w + u + e, 1, a + f + dn + _t + P + _ + w + u + e, 14, a + f + " +lon_0=-53" + k + Et + _ + w + i + e, 1, a + f + Rw + k + Et + _ + w + i + e, 1, a + f + Wm + k + Et + _ + w + i + e, 1, a + f + Ty + k + Et + _ + w + i + e, 1, a + f + By + k + Et + _ + w + i + e, 1, a + f + Vm + k + Et + _ + w + i + e, 12, l + bv + hd + ul + Vo + H + _ + w + i + e, 1, l + Ke + $e + wn + je + E + _ + w + u + e, 1, l + Hu + Ny + Kc + rl + S + _ + r + n + i + e, 4, l + nh + kh + pi + _n + p + _ + r + n + i + e, 3, a + fn + $n + k + D + nv + r + n + i + e, 1, a + fn + tr + k + p + xs + r + n + i + e, 1, a + fn + er + k + vn + tc + r + n + i + e, 1, a + ji + nr + dt + st + _ + r + n + i + e, 1, a + Yt + Oo + k + Le + _ + r + n + i + e, 1, a + De + qn + Cs + Od + _ + r + n + i + e, 1, a + De + Rl + k + p + _ + r + n + i + e, 1, a + De + Un + Ll + cM + _ + r + n + i + e, 1, a + Yt + Oo + k + Le + _ + r + n + i + e, 1, a + Di + zn + At + ze + _ + r + n + i + e, 1, a + Di + Hn + At + uy + _ + r + n + i + e, 1, l + jr + Nr + Kt + n_ + st + _ + r + n + i + e, 1, l + Pa + Ta + Ku + Kf + eg + _ + r + n + i + e, 1, l + ae + Ba + fl + ga + S + _ + r + n + i + e, 1, l + Qa + Fa + Se + ga + S + _ + r + n + i + e, 1, l + Td + yi + be + ca + S + _ + r + n + i + e, 1, l + gi + mi + In + ca + S + _ + r + n + i + e, 1, l + Gr + qa + zp + Si + S + _ + r + n + i + e, 1, l + Ua + za + Dr + Si + S + _ + r + n + i + e, 1, l + F_ + bn + ht + lt + On + _ + r + n + i + e, 1, l + q_ + kn + q + lt + xt + _ + r + n + i + e, 1, l + $c + Ha + Kt + ma + S + _ + r + n + i + e, 1, l + Rr + Lr + Y + ma + S + _ + r + n + i + e, 1, a + ta + Zi + oc + ge + _ + r + n + i + e, 3, l + Za + jd + Pr + dn + Nd + _ + r + n + i + e, 1, l + vi + xi + ut + _n + S + _ + r + n + i + e, 1, l + Bd + bi + ea + jt + S + _ + r + n + i + e, 1, l + Xa + tf + $t + Xc + S + _ + r + n + i + e, 1, l + Ja + ef + Hp + Eh + D + ot + r + n + i + e, 1, l + Wa + Va + Tr + gn + S + Gn + r + n + i + e, 1, l + Ya + Ka + Mn + jt + _a + Ni + r + n + i + e, 1, l + $a + ti + Br + gh + S + tc + r + n + i + e, 1, l + Ke + $e + wn + gn + st + Ih + r + n + i + e, 1, l + Mt + tn + Qe + ie + p + ot + r + n + i + e, 1, l + ql + en + pt + ie + p + Gn + r + n + i + e, 1, l + Ul + nn + N + ie + p + Ni + r + n + i + e, 1, a + ji + ec + Pl + p + _ + r + n + i + e, 1, l + Gd + ei + $ + Xi + Pe + Gn + r + n + i + e, 1, l + Vt + Qr + tt + Xi + Pe + ot + r + n + i + e, 1, l + ae + Dd + fl + Zn + p + _ + r + n + i + e, 1, l + ni + ri + Fr + lt + p + _ + r + n + i + e, 1, l + af + Ry + bf + po + S + _ + r + n + i + e, 1, l + ki + Mi + Xp + dn + S + _ + r + n + i + e, 1, l + ai + ii + qr + Ue + S + _ + r + n + i + e, 1, l + ch + nf + ut + Ue + S + _ + r + n + i + e, 1, l + oi + si + U_ + Ue + S + _ + r + n + i + e, 1, a + We + rr + At + D + _ + r + n + i + e, 1, a + We + ar + At + X + na + r + n + i + e, 1, a + We + Tl + At + S + _ + r + n + i + e, 1, a + We + ir + At + vn + na + r + n + i + e, 3, l + uo + co + fo + qi + D + Ws + r + n + i + e, 3, a + f + gh + _t + P + _ + r + n + u + e, 1, a + f + fg + _t + P + _ + r + n + u + e, 1, a + f + yh + _t + P + _ + r + n + u + e, 1, a + f + dn + _t + P + _ + r + n + u + e, 14, a + f + " +lon_0=-53" + k + Et + _ + r + n + i + e, 1, a + f + Rw + k + Et + _ + r + n + i + e, 1, a + f + Wm + k + Et + _ + r + n + i + e, 1, a + f + Ty + k + Et + _ + r + n + i + e, 1, a + f + By + k + Et + _ + r + n + i + e, 1, a + f + Vm + k + Et + _ + r + n + i + e, 1, a + f + Vs + k + Et + _ + r + n + i + e, 1, a + f + Ym + k + Et + _ + r + n + i + e, 1, a + f + Km + k + Et + _ + r + n + i + e, 1, a + f + po + k + Et + _ + r + n + i + e, 1, a + f + ca + k + Et + _ + r + n + i + e, 1, a + f + dn + k + Et + _ + r + n + i + e, 1, a + f + Yf + k + Et + _ + r + n + i + e, 1, a + f + yh + k + Et + _ + r + n + i + e, 1, a + f + Ue + k + Et + _ + r + n + i + e, 1, a + f + fg + k + Et + _ + r + n + i + e, 1, a + f + $d + k + Et + _ + r + n + i + e, 1, l + bv + hd + ul + Vo + H + _ + r + n + i + e, 1, l + Ke + $e + " +lat_0=25.5" + je + ke + _ + r + n + i + e, 2, h + Og + x + y + i + e, 1, h + Bm + x + y + i + e, 1, h + sM + x + y + i + e, 1, h + qm + x + y + i + e, 1, h + Ay + x + y + i + e, 1, h + lg + x + y + i + e, 1, h + Iy + x + y + i + e, 1, h + Qm + x + y + i + e, 1, h + Fm + x + y + i + e, 1, h + Ap + x + y + i + e, 1, h + xd + x + y + i + e, 1, h + bd + x + y + i + e, 1, h + kd + x + y + i + e, 1, h + wd + x + y + i + e, 1, h + Hf + x + y + i + e, 1, h + Zf + x + y + i + e, 1, h + bl + x + y + i + e, 1, h + Fs + x + y + i + e, 1, h + bs + x + y + i + e, 1, h + Qo + x + y + i + e, 1, h + qs + x + y + i + e, 1, h + Cl + x + y + i + e, 1, h + Nc + x + y + i + e, 1, h + Cd + x + y + i + e, 1, h + vd + x + y + i + e, 1, h + m_ + x + y + i + e, 1, h + jg + x + y + i + e, 1, h + hh + x + y + i + e, 1, h + Rh + x + y + i + e, 1, h + y_ + x + y + i + e, 1, h + Sp + x + y + i + e, 1, h + Vl + x + y + i + e, 1, h + Ph + x + y + i + e, 1, h + Xf + x + y + i + e, 1, h + pu + x + y + i + e, 1, h + hf + x + y + i + e, 1, h + Th + x + y + i + e, 1, h + lh + x + y + i + e, 1, h + Wl + x + y + i + e, 1, h + lf + x + y + i + e, 1, h + Wy + x + y + i + e, 1, h + Vy + x + y + i + e, 1, h + Dg + x + y + i + e, 1, h + Xm + x + y + i + e, 1, h + Jm + x + y + i + e, 1, h + Ip + x + y + i + e, 1, h + Ed + x + y + i + e, 1, h + cf + x + y + i + e, 1, h + ff + x + y + i + e, 1, h + Jf + x + y + i + e, 1, h + uf + x + y + i + e, 1, h + Wf + x + y + i + e, 1, h + v_ + x + y + i + e, 1, h + Md + x + y + i + e, 1, h + T_ + x + y + i + e, 1, h + Ky + x + y + i + e, 1, h + Ng + x + y + i + e, 1, h + jc + x + y + i + e, 1, h + md + x + y + i + e, 1, h + P_ + x + y + i + e, 41, h + Og + F + x + y + i + e, 1, h + Bm + F + x + y + i + e, 1, h + sM + F + x + y + i + e, 1, h + qm + F + x + y + i + e, 1, h + Ay + F + x + y + i + e, 1, h + lg + F + x + y + i + e, 1, h + Iy + F + x + y + i + e, 1, h + Qm + F + x + y + i + e, 1, h + Fm + F + x + y + i + e, 1, h + Ap + F + x + y + i + e, 1, h + xd + F + x + y + i + e, 1, h + bd + F + x + y + i + e, 1, h + kd + F + x + y + i + e, 1, h + wd + F + x + y + i + e, 1, h + Hf + F + x + y + i + e, 1, h + Zf + F + x + y + i + e, 1, h + bl + F + x + y + i + e, 1, h + Fs + F + x + y + i + e, 1, h + bs + F + x + y + i + e, 1, h + Qo + F + x + y + i + e, 1, h + qs + F + x + y + i + e, 1, h + Cl + F + x + y + i + e, 1, h + Nc + F + x + y + i + e, 1, h + Cd + F + x + y + i + e, 1, h + vd + F + x + y + i + e, 1, h + m_ + F + x + y + i + e, 1, h + jg + F + x + y + i + e, 1, h + hh + F + x + y + i + e, 1, h + Rh + F + x + y + i + e, 1, h + y_ + F + x + y + i + e, 1, h + Sp + F + x + y + i + e, 1, h + Vl + F + x + y + i + e, 1, h + Ph + F + x + y + i + e, 1, h + Xf + F + x + y + i + e, 1, h + pu + F + x + y + i + e, 1, h + hf + F + x + y + i + e, 1, h + Th + F + x + y + i + e, 1, h + lh + F + x + y + i + e, 1, h + Wl + F + x + y + i + e, 1, h + lf + F + x + y + i + e, 1, h + Wy + F + x + y + i + e, 1, h + Vy + F + x + y + i + e, 1, h + Dg + F + x + y + i + e, 1, h + Xm + F + x + y + i + e, 1, h + Jm + F + x + y + i + e, 1, h + Ip + F + x + y + i + e, 1, h + Ed + F + x + y + i + e, 1, h + cf + F + x + y + i + e, 1, h + ff + F + x + y + i + e, 1, h + Jf + F + x + y + i + e, 1, h + uf + F + x + y + i + e, 1, h + Wf + F + x + y + i + e, 1, h + v_ + F + x + y + i + e, 1, h + Md + F + x + y + i + e, 1, h + T_ + F + x + y + i + e, 1, h + Ky + F + x + y + i + e, 1, h + Ng + F + x + y + i + e, 1, h + jc + F + x + y + i + e, 1, h + md + F + x + y + i + e, 1, h + P_ + F + x + y + i + e, 41, h + Og + x + g + i + e, 1, h + Bm + x + g + i + e, 1, h + sM + x + g + i + e, 1, h + qm + x + g + i + e, 1, h + Ay + x + g + i + e, 1, h + lg + x + g + i + e, 1, h + Iy + x + g + i + e, 1, h + Qm + x + g + i + e, 1, h + Fm + x + g + i + e, 1, h + Ap + x + g + i + e, 1, h + xd + x + g + i + e, 1, h + bd + x + g + i + e, 1, h + kd + x + g + i + e, 1, h + wd + x + g + i + e, 1, h + Hf + x + g + i + e, 1, h + Zf + x + g + i + e, 1, h + bl + x + g + i + e, 1, h + Fs + x + g + i + e, 1, h + bs + x + g + i + e, 1, h + Qo + x + g + i + e, 1, h + qs + x + g + i + e, 1, h + Cl + x + g + i + e, 1, h + Nc + x + g + i + e, 1, h + Cd + x + g + i + e, 1, h + vd + x + g + i + e, 1, h + m_ + x + g + i + e, 1, h + jg + x + g + i + e, 1, h + hh + x + g + i + e, 1, h + Rh + x + g + i + e, 1, h + y_ + x + g + i + e, 1, h + Sp + x + g + i + e, 1, h + Vl + x + g + i + e, 1, h + Ph + x + g + i + e, 1, h + Xf + x + g + i + e, 1, h + pu + x + g + i + e, 1, h + hf + x + g + i + e, 1, h + Th + x + g + i + e, 1, h + lh + x + g + i + e, 1, h + Wl + x + g + i + e, 1, h + lf + x + g + i + e, 1, h + Wy + x + g + i + e, 1, h + Vy + x + g + i + e, 1, h + Dg + x + g + i + e, 1, h + Xm + x + g + i + e, 1, h + Jm + x + g + i + e, 1, h + Ip + x + g + i + e, 1, h + Ed + x + g + i + e, 1, h + cf + x + g + i + e, 1, h + ff + x + g + i + e, 1, h + Jf + x + g + i + e, 1, h + uf + x + g + i + e, 1, h + Wf + x + g + i + e, 1, h + v_ + x + g + i + e, 1, h + Md + x + g + i + e, 1, h + T_ + x + g + i + e, 1, h + Ky + x + g + i + e, 1, h + Ng + x + g + i + e, 1, h + jc + x + g + i + e, 1, h + md + x + g + i + e, 1, h + P_ + x + g + i + e, 41, h + Og + F + x + g + i + e, 1, h + Bm + F + x + g + i + e, 1, h + sM + F + x + g + i + e, 1, h + qm + F + x + g + i + e, 1, h + Ay + F + x + g + i + e, 1, h + lg + F + x + g + i + e, 1, h + Iy + F + x + g + i + e, 1, h + Qm + F + x + g + i + e, 1, h + Fm + F + x + g + i + e, 1, h + Ap + F + x + g + i + e, 1, h + xd + F + x + g + i + e, 1, h + bd + F + x + g + i + e, 1, h + kd + F + x + g + i + e, 1, h + wd + F + x + g + i + e, 1, h + Hf + F + x + g + i + e, 1, h + Zf + F + x + g + i + e, 1, h + bl + F + x + g + i + e, 1, h + Fs + F + x + g + i + e, 1, h + bs + F + x + g + i + e, 1, h + Qo + F + x + g + i + e, 1, h + qs + F + x + g + i + e, 1, h + Cl + F + x + g + i + e, 1, h + Nc + F + x + g + i + e, 1, h + Cd + F + x + g + i + e, 1, h + vd + F + x + g + i + e, 1, h + m_ + F + x + g + i + e, 1, h + jg + F + x + g + i + e, 1, h + hh + F + x + g + i + e, 1, h + Rh + F + x + g + i + e, 1, h + y_ + F + x + g + i + e, 1, h + Sp + F + x + g + i + e, 1, h + Vl + F + x + g + i + e, 1, h + Ph + F + x + g + i + e, 1, h + Xf + F + x + g + i + e, 1, h + pu + F + x + g + i + e, 1, h + hf + F + x + g + i + e, 1, h + Th + F + x + g + i + e, 1, h + lh + F + x + g + i + e, 1, h + Wl + F + x + g + i + e, 1, h + lf + F + x + g + i + e, 1, h + Wy + F + x + g + i + e, 1, h + Vy + F + x + g + i + e, 1, h + Dg + F + x + g + i + e, 1, h + Xm + F + x + g + i + e, 1, h + Jm + F + x + g + i + e, 1, h + Ip + F + x + g + i + e, 1, h + Ed + F + x + g + i + e, 1, h + cf + F + x + g + i + e, 1, h + ff + F + x + g + i + e, 1, h + Jf + F + x + g + i + e, 1, h + uf + F + x + g + i + e, 1, h + Wf + F + x + g + i + e, 1, h + v_ + F + x + g + i + e, 1, h + Md + F + x + g + i + e, 1, h + T_ + F + x + g + i + e, 1, h + Ky + F + x + g + i + e, 1, h + Ng + F + x + g + i + e, 1, h + jc + F + x + g + i + e, 1, h + md + F + x + g + i + e, 1, h + P_ + F + x + g + i + e, 41, h + Og + v + i + e, 1, h + Bm + v + i + e, 1, h + sM + v + i + e, 1, h + qm + v + i + e, 1, h + Ay + v + i + e, 1, h + lg + v + i + e, 1, h + Iy + v + i + e, 1, h + Qm + v + i + e, 1, h + Fm + v + i + e, 1, h + Ap + v + i + e, 1, h + xd + v + i + e, 1, h + bd + v + i + e, 1, h + kd + v + i + e, 1, h + wd + v + i + e, 1, h + Hf + v + i + e, 1, h + Zf + v + i + e, 1, h + bl + v + i + e, 1, h + Fs + v + i + e, 1, h + bs + v + i + e, 1, h + Qo + v + i + e, 1, h + qs + v + i + e, 1, h + Cl + v + i + e, 1, h + Nc + v + i + e, 1, h + Cd + v + i + e, 1, h + vd + v + i + e, 1, h + m_ + v + i + e, 1, h + jg + v + i + e, 1, h + hh + v + i + e, 1, h + Rh + v + i + e, 1, h + y_ + v + i + e, 1, h + Sp + v + i + e, 1, h + Vl + v + i + e, 1, h + Ph + v + i + e, 1, h + Xf + v + i + e, 1, h + pu + v + i + e, 1, h + hf + v + i + e, 1, h + Th + v + i + e, 1, h + lh + v + i + e, 1, h + Wl + v + i + e, 1, h + lf + v + i + e, 1, h + Wy + v + i + e, 1, h + Vy + v + i + e, 1, h + Dg + v + i + e, 1, h + Xm + v + i + e, 1, h + Jm + v + i + e, 1, h + Ip + v + i + e, 1, h + Ed + v + i + e, 1, h + cf + v + i + e, 1, h + ff + v + i + e, 1, h + Jf + v + i + e, 1, h + uf + v + i + e, 1, h + Wf + v + i + e, 1, h + v_ + v + i + e, 1, h + Md + v + i + e, 1, h + T_ + v + i + e, 1, h + Ky + v + i + e, 1, h + Ng + v + i + e, 1, h + jc + v + i + e, 1, h + md + v + i + e, 1, h + P_ + v + i + e, 1, fe + Os + ly + ts + Yy + Ee + Gn + v + i + e, 3, a + f + gh + _t + P + _ + v + u + e, 1, a + f + fg + _t + P + _ + v + u + e, 1, a + f + yh + _t + P + _ + v + u + e, 1, a + f + dn + _t + P + _ + v + u + e, 34, h + Og + F + v + i + e, 1, h + Bm + F + v + i + e, 1, h + sM + F + v + i + e, 1, h + qm + F + v + i + e, 1, h + Ay + F + v + i + e, 1, h + lg + F + v + i + e, 1, h + Iy + F + v + i + e, 1, h + Qm + F + v + i + e, 1, h + Fm + F + v + i + e, 1, h + Ap + F + v + i + e, 1, h + xd + F + v + i + e, 1, h + bd + F + v + i + e, 1, h + kd + F + v + i + e, 1, h + wd + F + v + i + e, 1, h + Hf + F + v + i + e, 1, h + Zf + F + v + i + e, 1, h + bl + F + v + i + e, 1, h + Fs + F + v + i + e, 1, h + bs + F + v + i + e, 1, h + Qo + F + v + i + e, 1, h + qs + F + v + i + e, 1, h + Cl + F + v + i + e, 1, h + Nc + F + v + i + e, 1, h + Cd + F + v + i + e, 1, h + vd + F + v + i + e, 1, h + m_ + F + v + i + e, 1, h + jg + F + v + i + e, 1, h + hh + F + v + i + e, 1, h + Rh + F + v + i + e, 1, h + y_ + F + v + i + e, 1, h + Sp + F + v + i + e, 1, h + Vl + F + v + i + e, 1, h + Ph + F + v + i + e, 1, h + Xf + F + v + i + e, 1, h + pu + F + v + i + e, 1, h + hf + F + v + i + e, 1, h + Th + F + v + i + e, 1, h + lh + F + v + i + e, 1, h + Wl + F + v + i + e, 1, h + lf + F + v + i + e, 1, h + Wy + F + v + i + e, 1, h + Vy + F + v + i + e, 1, h + Dg + F + v + i + e, 1, h + Xm + F + v + i + e, 1, h + Jm + F + v + i + e, 1, h + Ip + F + v + i + e, 1, h + Ed + F + v + i + e, 1, h + cf + F + v + i + e, 1, h + ff + F + v + i + e, 1, h + Jf + F + v + i + e, 1, h + uf + F + v + i + e, 1, h + Wf + F + v + i + e, 1, h + v_ + F + v + i + e, 1, h + Md + F + v + i + e, 1, h + T_ + F + v + i + e, 1, h + Ky + F + v + i + e, 1, h + Ng + F + v + i + e, 1, h + jc + F + v + i + e, 1, h + md + F + v + i + e, 1, h + P_ + F + v + i + e, 1, fe + B + " +lat_ts=-90" + ts + Yy + Ee + Gn + v + i + e, 5, a + f + B_ + _t + p + Rt + v + i + e].reduce(function (t, e, n) {
            if (n % 2 == 0) {
              var r = t.prev + e,
                a = "EPSG:" + r;
              t.defs.push([a]), t.prev = r;
            } else t.defs[t.defs.length - 1].push(e);
            return t;
          }, {
            defs: [],
            prev: 0
          }).defs;
        },
        3736: function _(t, e, n) {
          var r;
          function a(t) {
            return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, a(t);
          }
          function i(t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
              if (null != n) {
                var r,
                  a,
                  i = [],
                  o = !0,
                  s = !1;
                try {
                  for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                    ;
                  }
                } catch (t) {
                  s = !0, a = t;
                } finally {
                  try {
                    o || null == n.return || n.return();
                  } finally {
                    if (s) throw a;
                  }
                }
                return i;
              }
            }(t, e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return o(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? o(t, e) : void 0;
              }
            }(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function o(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          function s(t) {
            return t;
          }
          function l(t, e, n, r, a) {
            return n + r * (a - t) / e;
          }
          function h(t, e, n, r, a) {
            return n - r * (a - t) / e;
          }
          function u(t, e, n, r, a) {
            return Math.round(n + r * (a - t) / e);
          }
          function c(t, e, n, r, a) {
            return Math.round(n - r * (a - t) / e);
          }
          t = n.nmd(t);
          var f = {
            _identity: s,
            _scale: function _scale(t) {
              for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) {
                n[r - 1] = arguments[r];
              }
              return create(n)(t);
            },
            _scale_number: l,
            _scale_and_flip_number: h,
            _scale_and_round_number: u,
            _scale_and_flip_and_round_number: c,
            createScaleFunction: function createScaleFunction(t, e) {
              var n = i(t, 2),
                r = n[0],
                a = n[1],
                o = i(e, 2),
                f = o[0],
                d = o[1],
                _ = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                p = _.flip,
                y = _.no_range_value,
                g = _.no_range_value_strategy,
                m = void 0 === g ? "highest" : g,
                v = _.round,
                x = void 0 !== v && v,
                b = a - r,
                k = d - f;
              if (0 === b) {
                if ("number" == typeof y) return s.bind(null, y);
                if ("highest" === m) return s.bind(null, d);
                if ("lowest" === m) return s.bind(null, f);
                if ("middle" === m) {
                  var M = (d - f) / 2;
                  return x && (M = Math.round(M)), s.bind(null, M);
                }
              }
              return p ? x ? c.bind(null, r, b, d, k) : h.bind(null, r, b, d, k) : x ? u.bind(null, r, b, f, k) : l.bind(null, r, b, f, k);
            }
          };
          "object" === a(n.amdD) && (void 0 === (r = function () {
            return f;
          }.call(e, n, e, t)) || (t.exports = r)), "object" === a(t) && (t.exports = f), "object" === ("undefined" == typeof window ? "undefined" : a(window)) && (window.quickScale = f), "object" === ("undefined" == typeof self ? "undefined" : a(self)) && (self.quickScale = f);
        },
        3238: function _(t, e, n) {
          function r(t) {
            return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, r(t);
          }
          var a = function (t) {
            "use strict";

            var e,
              n = Object.prototype,
              a = n.hasOwnProperty,
              i = "function" == typeof Symbol ? Symbol : {},
              o = i.iterator || "@@iterator",
              s = i.asyncIterator || "@@asyncIterator",
              l = i.toStringTag || "@@toStringTag";
            function h(t, e, n) {
              return Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }), t[e];
            }
            try {
              h({}, "");
            } catch (t) {
              h = function h(t, e, n) {
                return t[e] = n;
              };
            }
            function u(t, e, n, r) {
              var a = e && e.prototype instanceof g ? e : g,
                i = Object.create(a.prototype),
                o = new I(r || []);
              return i._invoke = function (t, e, n) {
                var r = f;
                return function (a, i) {
                  if (r === _) throw new Error("Generator is already running");
                  if (r === p) {
                    if ("throw" === a) throw i;
                    return j();
                  }
                  for (n.method = a, n.arg = i;;) {
                    var o = n.delegate;
                    if (o) {
                      var s = E(o, n);
                      if (s) {
                        if (s === y) continue;
                        return s;
                      }
                    }
                    if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                      if (r === f) throw r = p, n.arg;
                      n.dispatchException(n.arg);
                    } else "return" === n.method && n.abrupt("return", n.arg);
                    r = _;
                    var l = c(t, e, n);
                    if ("normal" === l.type) {
                      if (r = n.done ? p : d, l.arg === y) continue;
                      return {
                        value: l.arg,
                        done: n.done
                      };
                    }
                    "throw" === l.type && (r = p, n.method = "throw", n.arg = l.arg);
                  }
                };
              }(t, n, o), i;
            }
            function c(t, e, n) {
              try {
                return {
                  type: "normal",
                  arg: t.call(e, n)
                };
              } catch (t) {
                return {
                  type: "throw",
                  arg: t
                };
              }
            }
            t.wrap = u;
            var f = "suspendedStart",
              d = "suspendedYield",
              _ = "executing",
              p = "completed",
              y = {};
            function g() {}
            function m() {}
            function v() {}
            var x = {};
            h(x, o, function () {
              return this;
            });
            var b = Object.getPrototypeOf,
              k = b && b(b(O([])));
            k && k !== n && a.call(k, o) && (x = k);
            var M = v.prototype = g.prototype = Object.create(x);
            function w(t) {
              ["next", "throw", "return"].forEach(function (e) {
                h(t, e, function (t) {
                  return this._invoke(e, t);
                });
              });
            }
            function C(t, e) {
              function n(i, o, s, l) {
                var h = c(t[i], t, o);
                if ("throw" !== h.type) {
                  var u = h.arg,
                    f = u.value;
                  return f && "object" === r(f) && a.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
                    n("next", t, s, l);
                  }, function (t) {
                    n("throw", t, s, l);
                  }) : e.resolve(f).then(function (t) {
                    u.value = t, s(u);
                  }, function (t) {
                    return n("throw", t, s, l);
                  });
                }
                l(h.arg);
              }
              var i;
              this._invoke = function (t, r) {
                function a() {
                  return new e(function (e, a) {
                    n(t, r, e, a);
                  });
                }
                return i = i ? i.then(a, a) : a();
              };
            }
            function E(t, n) {
              var r = t.iterator[n.method];
              if (r === e) {
                if (n.delegate = null, "throw" === n.method) {
                  if (t.iterator.return && (n.method = "return", n.arg = e, E(t, n), "throw" === n.method)) return y;
                  n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
                }
                return y;
              }
              var a = c(r, t.iterator, n.arg);
              if ("throw" === a.type) return n.method = "throw", n.arg = a.arg, n.delegate = null, y;
              var i = a.arg;
              return i ? i.done ? (n[t.resultName] = i.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, y) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, y);
            }
            function S(t) {
              var e = {
                tryLoc: t[0]
              };
              1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
            }
            function A(t) {
              var e = t.completion || {};
              e.type = "normal", delete e.arg, t.completion = e;
            }
            function I(t) {
              this.tryEntries = [{
                tryLoc: "root"
              }], t.forEach(S, this), this.reset(!0);
            }
            function O(t) {
              if (t) {
                var n = t[o];
                if (n) return n.call(t);
                if ("function" == typeof t.next) return t;
                if (!isNaN(t.length)) {
                  var r = -1,
                    i = function n() {
                      for (; ++r < t.length;) {
                        if (a.call(t, r)) return n.value = t[r], n.done = !1, n;
                      }
                      return n.value = e, n.done = !0, n;
                    };
                  return i.next = i;
                }
              }
              return {
                next: j
              };
            }
            function j() {
              return {
                value: e,
                done: !0
              };
            }
            return m.prototype = v, h(M, "constructor", v), h(v, "constructor", m), m.displayName = h(v, l, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
              var e = "function" == typeof t && t.constructor;
              return !!e && (e === m || "GeneratorFunction" === (e.displayName || e.name));
            }, t.mark = function (t) {
              return Object.setPrototypeOf ? Object.setPrototypeOf(t, v) : (t.__proto__ = v, h(t, l, "GeneratorFunction")), t.prototype = Object.create(M), t;
            }, t.awrap = function (t) {
              return {
                __await: t
              };
            }, w(C.prototype), h(C.prototype, s, function () {
              return this;
            }), t.AsyncIterator = C, t.async = function (e, n, r, a, i) {
              void 0 === i && (i = Promise);
              var o = new C(u(e, n, r, a), i);
              return t.isGeneratorFunction(n) ? o : o.next().then(function (t) {
                return t.done ? t.value : o.next();
              });
            }, w(M), h(M, l, "Generator"), h(M, o, function () {
              return this;
            }), h(M, "toString", function () {
              return "[object Generator]";
            }), t.keys = function (t) {
              var e = [];
              for (var n in t) {
                e.push(n);
              }
              return e.reverse(), function n() {
                for (; e.length;) {
                  var r = e.pop();
                  if (r in t) return n.value = r, n.done = !1, n;
                }
                return n.done = !0, n;
              };
            }, t.values = O, I.prototype = {
              constructor: I,
              reset: function reset(t) {
                if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(A), !t) for (var n in this) {
                  "t" === n.charAt(0) && a.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
                }
              },
              stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(t) {
                if (this.done) throw t;
                var n = this;
                function r(r, a) {
                  return s.type = "throw", s.arg = t, n.next = r, a && (n.method = "next", n.arg = e), !!a;
                }
                for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                  var o = this.tryEntries[i],
                    s = o.completion;
                  if ("root" === o.tryLoc) return r("end");
                  if (o.tryLoc <= this.prev) {
                    var l = a.call(o, "catchLoc"),
                      h = a.call(o, "finallyLoc");
                    if (l && h) {
                      if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                      if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                    } else if (l) {
                      if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                    } else {
                      if (!h) throw new Error("try statement without catch or finally");
                      if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(t, e) {
                for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                  var r = this.tryEntries[n];
                  if (r.tryLoc <= this.prev && a.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                    var i = r;
                    break;
                  }
                }
                i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                var o = i ? i.completion : {};
                return o.type = t, o.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(o);
              },
              complete: function complete(t, e) {
                if ("throw" === t.type) throw t.arg;
                return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
              },
              finish: function finish(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var n = this.tryEntries[e];
                  if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), A(n), y;
                }
              },
              catch: function _catch(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var n = this.tryEntries[e];
                  if (n.tryLoc === t) {
                    var r = n.completion;
                    if ("throw" === r.type) {
                      var a = r.arg;
                      A(n);
                    }
                    return a;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(t, n, r) {
                return this.delegate = {
                  iterator: O(t),
                  resultName: n,
                  nextLoc: r
                }, "next" === this.method && (this.arg = e), y;
              }
            }, t;
          }("object" === r(t = n.nmd(t)) ? t.exports : {});
          try {
            regeneratorRuntime = a;
          } catch (t) {
            "object" === ("undefined" == typeof globalThis ? "undefined" : r(globalThis)) ? globalThis.regeneratorRuntime = a : Function("r", "regeneratorRuntime = r")(a);
          }
        },
        9006: function _(t, e, n) {
          var r;
          function a(t) {
            return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, a(t);
          }
          function i(t) {
            return function (t) {
              if (Array.isArray(t)) return s(t);
            }(t) || function (t) {
              if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || o(t) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function o(t, e) {
            if (t) {
              if ("string" == typeof t) return s(t, e);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? s(t, e) : void 0;
            }
          }
          function s(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          function l(t) {
            var e,
              n,
              r = t.bbox,
              a = t.reproject,
              s = (n = 4, function (t) {
                if (Array.isArray(t)) return t;
              }(e = r) || function (t, e) {
                var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != n) {
                  var r,
                    a,
                    i = [],
                    o = !0,
                    s = !1;
                  try {
                    for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                      ;
                    }
                  } catch (t) {
                    s = !0, a = t;
                  } finally {
                    try {
                      o || null == n.return || n.return();
                    } finally {
                      if (s) throw a;
                    }
                  }
                  return i;
                }
              }(e, n) || o(e, n) || function () {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }()),
              l = s[0],
              h = s[1],
              u = s[2],
              c = s[3],
              f = [a([l, c]), a([u, c]), a([l, h]), a([u, h])],
              d = f.map(function (t) {
                return t[0];
              }),
              _ = f.map(function (t) {
                return t[1];
              });
            return [Math.min.apply(Math, i(d)), Math.min.apply(Math, i(_)), Math.max.apply(Math, i(d)), Math.max.apply(Math, i(_))];
          }
          t = n.nmd(t), void 0 === (r = function () {
            return l;
          }.call(e, n, e, t)) || (t.exports = r), "object" === a(t) && (t.exports = l, t.exports.default = l), "object" === ("undefined" == typeof window ? "undefined" : a(window)) && (window.reprojectBoundingBoxPluggable = l), "object" === ("undefined" == typeof self ? "undefined" : a(self)) && (self.reprojectBoundingBoxPluggable = l);
        },
        2977: function _(t, e, n) {
          var r;
          function a(t) {
            return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, a(t);
          }
          t = n.nmd(t);
          var i = n(9260),
            o = n(3759),
            s = n(9006);
          function l(t) {
            var e = t.bbox,
              n = t.from,
              r = t.proj4,
              l = t.to;
            "number" == typeof n && (n = "EPSG:" + n), "number" == typeof l && (l = "EPSG:" + l);
            var h = [r, o];
            "object" === ("undefined" == typeof window ? "undefined" : a(window)) && window.proj4 && h.push(window.proj4), "object" === ("undefined" == typeof self ? "undefined" : a(self)) && self.proj4 && h.push(self.proj4);
            var u = i(h)(n, l).forward;
            return s({
              bbox: e,
              reproject: u
            });
          }
          "function" != typeof i && console.warn("[reproject-bbox] failed to import proj4-merge"), void 0 === (r = function () {
            return l;
          }.call(e, n, e, t)) || (t.exports = r), "object" === a(t) && (t.exports = l, t.exports.default = l), "object" === ("undefined" == typeof window ? "undefined" : a(window)) && (window.reprojectBoundingBox = l), "object" === ("undefined" == typeof self ? "undefined" : a(self)) && (self.reprojectBoundingBox = l);
        },
        1398: function _(t, e, n) {
          var r;
          function a(t) {
            return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, a(t);
          }
          function i(t, e) {
            var n = e.in_place,
              r = void 0 !== n && n,
              a = e.reproject;
            if ("function" != typeof a) throw new Error("[reproject-geojson] you must specify a reproject function");
            return !0 !== r && (t = function (t) {
              return JSON.parse(JSON.stringify(t));
            }(t)), "FeatureCollection" === t.type ? t.features = t.features.map(function (t) {
              return i(t, {
                in_place: r,
                reproject: a
              });
            }) : "Feature" === t.type ? t.geometry = i(t.geometry, {
              in_place: r,
              reproject: a
            }) : "LineString" === t.type ? t.coordinates = t.coordinates.map(function (t) {
              return a(t);
            }) : "MultiLineString" === t.type ? t.coordinates = t.coordinates.map(function (t) {
              return t.map(function (t) {
                return a(t);
              });
            }) : "MultiPoint" === t.type ? t.coordinates = t.coordinates.map(function (t) {
              return a(t);
            }) : "MultiPolygon" === t.type ? t.coordinates = t.coordinates.map(function (t) {
              return t.map(function (t) {
                return t.map(function (t) {
                  return a(t);
                });
              });
            }) : "Point" === t.type ? t.coordinates = a(t.coordinates) : "Polygon" === t.type && (t.coordinates = t.coordinates.map(function (t) {
              return t.map(function (t) {
                return a(t);
              });
            })), t;
          }
          t = n.nmd(t), void 0 === (r = function () {
            return i;
          }.call(e, n, e, t)) || (t.exports = r), "object" === a(t) && (t.exports = i), "object" === ("undefined" == typeof window ? "undefined" : a(window)) && (window.reprojectGeoJSONPluggable = i), "object" === ("undefined" == typeof self ? "undefined" : a(self)) && (self.reprojectGeoJSONPluggable = i);
        },
        9768: function _(t, e, n) {
          var r;
          function a(t) {
            return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, a(t);
          }
          t = n.nmd(t);
          var i = n(8896),
            o = n(1398);
          function s(t, e) {
            var n = e.from,
              r = void 0 === n ? "EPSG:4326" : n,
              a = e.in_place,
              s = void 0 !== a && a,
              l = e.to,
              h = void 0 === l ? "EPSG:4326" : l;
            return ("number" == typeof r || r.match(/^\d+$/)) && (r = "EPSG:" + r), ("number" == typeof h || h.match(/^\d+$/)) && (h = "EPSG:" + h), o(t, {
              in_place: s,
              reproject: i(r, h).forward
            });
          }
          void 0 === (r = function () {
            return s;
          }.call(e, n, e, t)) || (t.exports = r), "object" === a(t) && (t.exports = s), "object" === ("undefined" == typeof window ? "undefined" : a(window)) && (window.reprojectGeoJSON = s), "object" === ("undefined" == typeof self ? "undefined" : a(self)) && (self.reprojectGeoJSON = s);
        },
        1959: function _(t, e, n) {
          var r;
          function a(t) {
            return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, a(t);
          }
          function i(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          function o(t) {
            var e = t.segments,
              n = t.min,
              r = void 0 === n ? -1 / 0 : n,
              a = t.max,
              o = void 0 === a ? 1 / 0 : a,
              s = t.debug,
              l = void 0 !== s && s;
            if (l && console.log("[segflip] segs:", e), null == e || Array.isArray(e) && 0 === e.length) return l && console.log("[segflip] segments are empty so return the whole row flipped"), [[r, o]];
            var h = e.map(function (t) {
              var e = function (t, e) {
                return function (t) {
                  if (Array.isArray(t)) return t;
                }(t) || function (t, e) {
                  var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                  if (null != n) {
                    var r,
                      a,
                      i = [],
                      o = !0,
                      s = !1;
                    try {
                      for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                        ;
                      }
                    } catch (t) {
                      s = !0, a = t;
                    } finally {
                      try {
                        o || null == n.return || n.return();
                      } finally {
                        if (s) throw a;
                      }
                    }
                    return i;
                  }
                }(t, e) || function (t, e) {
                  if (t) {
                    if ("string" == typeof t) return i(t, e);
                    var n = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? i(t, e) : void 0;
                  }
                }(t, e) || function () {
                  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
              }(t, 2);
              return [e[0] - 1, e[1] + 1];
            }).flat();
            h.unshift(r), h.push(o), l && console.log("flattened nums:", h);
            for (var u = [], c = 1; c < h.length; c += 2) {
              var f = h[c - 1],
                d = h[c];
              f > d || u.push([f, d]);
            }
            return u;
          }
          t = n.nmd(t), void 0 === (r = function () {
            return o;
          }.call(e, n, e, t)) || (t.exports = r), "object" === a(t) && (t.exports = o), "object" === ("undefined" == typeof window ? "undefined" : a(window)) && (window.segflip = o), "object" === ("undefined" == typeof self ? "undefined" : a(self)) && (self.segflip = o);
        },
        3401: function _(t) {
          function e(t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
              if (null != n) {
                var r,
                  a,
                  i = [],
                  o = !0,
                  s = !1;
                try {
                  for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                    ;
                  }
                } catch (t) {
                  s = !0, a = t;
                } finally {
                  try {
                    o || null == n.return || n.return();
                  } finally {
                    if (s) throw a;
                  }
                }
                return i;
              }
            }(t, e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return n(t, e);
                var r = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(t, e) : void 0;
              }
            }(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function n(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          t.exports = function (t) {
            var n = t.bbox,
              r = t.container,
              a = t.debug,
              i = t.origin,
              o = t.padding,
              s = t.scale;
            a && console.log("[snap-bbox] starting"), a && console.log("[snap-bbox] bbox:", n), a && console.log("[snap-bbox] debug:", a), a && console.log("[snap-bbox] origin:", i), a && console.log("[snap-bbox] padding:", o), a && console.log("[snap-bbox] scale:", s);
            var l = e(i, 2),
              h = l[0],
              u = l[1];
            a && console.log("[snap-bbox] originX:", h), a && console.log("[snap-bbox] originY:", u);
            var c = e(o || [0, 0], 2),
              f = c[0],
              d = c[1];
            a && console.log("[snap-bbox] padX:", f), a && console.log("[snap-bbox] padY:", d);
            var _ = e(s, 2),
              p = _[0],
              y = _[1];
            a && console.log("[snap-bbox] scale_x:", p), a && console.log("[snap-bbox] scale_y:", y);
            var g = Math.sign(p),
              m = Math.sign(y);
            a && console.log("[snap-bbox] sign_scale_x:", g), a && console.log("[snap-bbox] sign_scale_y:", m);
            var v = e(n, 4),
              x = v[0],
              b = v[1],
              k = v[2],
              M = v[3];
            a && console.log("[snap-bbox] xmin:", x), a && console.log("[snap-bbox] ymin:", b), a && console.log("[snap-bbox] xmax:", k), a && console.log("[snap-bbox] ymax:", M);
            var w = (x - h) / p,
              C = (k - h) / p,
              E = (M - u) / y,
              S = (b - u) / y;
            a && console.log("[snap-bbox] left:", w), a && console.log("[snap-bbox] right:", C), a && console.log("[snap-bbox] top:", E), a && console.log("[snap-bbox] bottom:", S);
            var A = Math.floor(w) - f,
              I = Math.ceil(C) + f,
              O = Math.floor(E) - d,
              j = Math.ceil(S) + d;
            if (a && console.log("[snap-bbox] left_int:", A), a && console.log("[snap-bbox] right_int:", I), a && console.log("[snap-bbox] top_int:", O), a && console.log("[snap-bbox] bottom_int:", j), r) {
              a && console.log("[snap-bbox] container:", r);
              var N = (r[0] - h) / p,
                G = (r[2] - h) / p,
                D = (r[3] - u) / y,
                R = (r[1] - u) / y;
              a && console.log("[snap-bbox] min_left:", N), a && console.log("[snap-bbox] max_right:", G), a && console.log("[snap-bbox] min_top:", D), a && console.log("[snap-bbox] max_bottom:", R);
              var L = Math.ceil(N),
                P = Math.floor(G),
                T = Math.ceil(D),
                B = Math.floor(R);
              a && console.log("[snap-bbox] min_left_int:", L), a && console.log("[snap-bbox] max_right_int:", P), a && console.log("[snap-bbox] min_top_int:", T), a && console.log("[snap-bbox] max_bottom_int:", B), A = Math.max(A, L), I = Math.min(I, P), O = Math.max(O, T), j = Math.min(j, B), a && console.log("[snap-bbox] after containment, left_int:", A), a && console.log("[snap-bbox] after containment, right_int:", I), a && console.log("[snap-bbox] after containment, top_int:", O), a && console.log("[snap-bbox] after containment, bottom_int:", j);
            }
            var Q = [0 === A ? 0 : A, 0 === j ? 0 : j, 0 === I ? 0 : I, 0 === O ? 0 : O];
            return a && console.log("[snap-bbox] bbox_in_grid_cells:", Q), {
              bbox_in_coordinate_system: [h + A * p, u + j * y, h + I * p, u + O * y],
              bbox_in_grid_cells: Q
            };
          };
        },
        6200: function _(t) {
          t.exports = function (t) {
            var e = t.toString();
            return e.startsWith("326") ? "N" : e.startsWith("327") ? "S" : void 0;
          };
        },
        4365: function _(t, e, n) {
          var r = n(4947),
            a = n(6200);
          t.exports = function (t) {
            var e = r(t),
              n = a(t);
            return "+proj=utm +zone=".concat(e).concat("S" === n ? " +south " : " ", "+ellps=WGS84 +datum=WGS84 +units=m +no_defs");
          };
        },
        4947: function _(t) {
          t.exports = function (t) {
            return Number.parseInt(t.toString().substring(3));
          };
        },
        6544: function _(t) {
          t.exports = function (t) {
            var e = t.toString();
            return e.startsWith("326") || e.startsWith("327");
          };
        },
        5942: function _(t) {
          t.exports = {
            1: function _(t) {
              var e = t.point,
                n = this.data,
                r = e[this.d0v0];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            2: function _(t) {
              var e = t.point,
                n = this.data,
                r = this.m0v0 * e[this.d0v0] + this.m0v1 * e[this.d0v1];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            3: function _(t) {
              var e = t.point,
                n = this.data,
                r = this.m0v0 * e[this.d0v0] + this.m0v1 * e[this.d0v1] + this.m0v2 * e[this.d0v2];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            4: function _(t) {
              var e = t.point,
                n = this.data,
                r = this.m0v0 * e[this.d0v0] + this.m0v1 * e[this.d0v1] + this.m0v2 * e[this.d0v2] + this.m0v3 * e[this.d0v3];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            5: function _(t) {
              var e = t.point,
                n = this.data,
                r = this.m0v0 * e[this.d0v0] + this.m0v1 * e[this.d0v1] + this.m0v2 * e[this.d0v2] + this.m0v3 * e[this.d0v3] + this.m0v4 * e[this.d0v4];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]],
                r = e[this.d1v0];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,2": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]],
                r = this.m1v0 * e[this.d1v0] + this.m1v1 * e[this.d1v1];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,3": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]],
                r = this.m1v0 * e[this.d1v0] + this.m1v1 * e[this.d1v1] + this.m1v2 * e[this.d1v2];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,4": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]],
                r = this.m1v0 * e[this.d1v0] + this.m1v1 * e[this.d1v1] + this.m1v2 * e[this.d1v2] + this.m1v3 * e[this.d1v3];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,5": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]],
                r = this.m1v0 * e[this.d1v0] + this.m1v1 * e[this.d1v1] + this.m1v2 * e[this.d1v2] + this.m1v3 * e[this.d1v3] + this.m1v4 * e[this.d1v4];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,1": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]],
                r = e[this.d2v0];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,2": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]],
                r = this.m2v0 * e[this.d2v0] + this.m2v1 * e[this.d2v1];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,3": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]],
                r = this.m2v0 * e[this.d2v0] + this.m2v1 * e[this.d2v1] + this.m2v2 * e[this.d2v2];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,4": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]],
                r = this.m2v0 * e[this.d2v0] + this.m2v1 * e[this.d2v1] + this.m2v2 * e[this.d2v2] + this.m2v3 * e[this.d2v3];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,5": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]],
                r = this.m2v0 * e[this.d2v0] + this.m2v1 * e[this.d2v1] + this.m2v2 * e[this.d2v2] + this.m2v3 * e[this.d2v3] + this.m2v4 * e[this.d2v4];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,1,1": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]],
                r = e[this.d3v0];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,1,2": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]],
                r = this.m3v0 * e[this.d3v0] + this.m3v1 * e[this.d3v1];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,1,3": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]],
                r = this.m3v0 * e[this.d3v0] + this.m3v1 * e[this.d3v1] + this.m3v2 * e[this.d3v2];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,1,4": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]],
                r = this.m3v0 * e[this.d3v0] + this.m3v1 * e[this.d3v1] + this.m3v2 * e[this.d3v2] + this.m3v3 * e[this.d3v3];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,1,5": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]],
                r = this.m3v0 * e[this.d3v0] + this.m3v1 * e[this.d3v1] + this.m3v2 * e[this.d3v2] + this.m3v3 * e[this.d3v3] + this.m3v4 * e[this.d3v4];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,1,1,1": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][e[this.d3v0]],
                r = e[this.d4v0];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,1,1,2": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][e[this.d3v0]],
                r = this.m4v0 * e[this.d4v0] + this.m4v1 * e[this.d4v1];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,1,1,3": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][e[this.d3v0]],
                r = this.m4v0 * e[this.d4v0] + this.m4v1 * e[this.d4v1] + this.m4v2 * e[this.d4v2];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,1,1,4": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][e[this.d3v0]],
                r = this.m4v0 * e[this.d4v0] + this.m4v1 * e[this.d4v1] + this.m4v2 * e[this.d4v2] + this.m4v3 * e[this.d4v3];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            },
            "1,1,1,1,5": function _(t) {
              var e = t.point,
                n = this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][e[this.d3v0]],
                r = this.m4v0 * e[this.d4v0] + this.m4v1 * e[this.d4v1] + this.m4v2 * e[this.d4v2] + this.m4v3 * e[this.d4v3] + this.m4v4 * e[this.d4v4];
              return {
                parent: n,
                index: r,
                value: n[r]
              };
            }
          };
        },
        9611: function _(t) {
          t.exports = {
            1: function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]] = n;
            },
            2: function _(t) {
              var e = t.point,
                n = t.value;
              this.data[this.m0v0 * e[this.d0v0] + this.m0v1 * e[this.d0v1]] = n;
            },
            3: function _(t) {
              var e = t.point,
                n = t.value;
              this.data[this.m0v0 * e[this.d0v0] + this.m0v1 * e[this.d0v1] + this.m0v2 * e[this.d0v2]] = n;
            },
            4: function _(t) {
              var e = t.point,
                n = t.value;
              this.data[this.m0v0 * e[this.d0v0] + this.m0v1 * e[this.d0v1] + this.m0v2 * e[this.d0v2] + this.m0v3 * e[this.d0v3]] = n;
            },
            5: function _(t) {
              var e = t.point,
                n = t.value;
              this.data[this.m0v0 * e[this.d0v0] + this.m0v1 * e[this.d0v1] + this.m0v2 * e[this.d0v2] + this.m0v3 * e[this.d0v3] + this.m0v4 * e[this.d0v4]] = n;
            },
            "1,1": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]] = n;
            },
            "1,2": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][this.m1v0 * e[this.d1v0] + this.m1v1 * e[this.d1v1]] = n;
            },
            "1,3": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][this.m1v0 * e[this.d1v0] + this.m1v1 * e[this.d1v1] + this.m1v2 * e[this.d1v2]] = n;
            },
            "1,4": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][this.m1v0 * e[this.d1v0] + this.m1v1 * e[this.d1v1] + this.m1v2 * e[this.d1v2] + this.m1v3 * e[this.d1v3]] = n;
            },
            "1,5": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][this.m1v0 * e[this.d1v0] + this.m1v1 * e[this.d1v1] + this.m1v2 * e[this.d1v2] + this.m1v3 * e[this.d1v3] + this.m1v4 * e[this.d1v4]] = n;
            },
            "1,1,1": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]] = n;
            },
            "1,1,2": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][this.m2v0 * e[this.d2v0] + this.m2v1 * e[this.d2v1]] = n;
            },
            "1,1,3": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][this.m2v0 * e[this.d2v0] + this.m2v1 * e[this.d2v1] + this.m2v2 * e[this.d2v2]] = n;
            },
            "1,1,4": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][this.m2v0 * e[this.d2v0] + this.m2v1 * e[this.d2v1] + this.m2v2 * e[this.d2v2] + this.m2v3 * e[this.d2v3]] = n;
            },
            "1,1,5": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][this.m2v0 * e[this.d2v0] + this.m2v1 * e[this.d2v1] + this.m2v2 * e[this.d2v2] + this.m2v3 * e[this.d2v3] + this.m2v4 * e[this.d2v4]] = n;
            },
            "1,1,1,1": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][e[this.d3v0]] = n;
            },
            "1,1,1,2": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][this.m3v0 * e[this.d3v0] + this.m3v1 * e[this.d3v1]] = n;
            },
            "1,1,1,3": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][this.m3v0 * e[this.d3v0] + this.m3v1 * e[this.d3v1] + this.m3v2 * e[this.d3v2]] = n;
            },
            "1,1,1,4": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][this.m3v0 * e[this.d3v0] + this.m3v1 * e[this.d3v1] + this.m3v2 * e[this.d3v2] + this.m3v3 * e[this.d3v3]] = n;
            },
            "1,1,1,5": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][this.m3v0 * e[this.d3v0] + this.m3v1 * e[this.d3v1] + this.m3v2 * e[this.d3v2] + this.m3v3 * e[this.d3v3] + this.m3v4 * e[this.d3v4]] = n;
            },
            "1,1,1,1,1": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][e[this.d3v0]][e[this.d4v0]] = n;
            },
            "1,1,1,1,2": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][e[this.d3v0]][this.m4v0 * e[this.d4v0] + this.m4v1 * e[this.d4v1]] = n;
            },
            "1,1,1,1,3": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][e[this.d3v0]][this.m4v0 * e[this.d4v0] + this.m4v1 * e[this.d4v1] + this.m4v2 * e[this.d4v2]] = n;
            },
            "1,1,1,1,4": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][e[this.d3v0]][this.m4v0 * e[this.d4v0] + this.m4v1 * e[this.d4v1] + this.m4v2 * e[this.d4v2] + this.m4v3 * e[this.d4v3]] = n;
            },
            "1,1,1,1,5": function _(t) {
              var e = t.point,
                n = t.value;
              this.data[e[this.d0v0]][e[this.d1v0]][e[this.d2v0]][e[this.d3v0]][this.m4v0 * e[this.d4v0] + this.m4v1 * e[this.d4v1] + this.m4v2 * e[this.d4v2] + this.m4v3 * e[this.d4v3] + this.m4v4 * e[this.d4v4]] = n;
            }
          };
        },
        1135: function _(t, e, n) {
          function r(t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
              if (null != n) {
                var r,
                  a,
                  i = [],
                  o = !0,
                  s = !1;
                try {
                  for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                    ;
                  }
                } catch (t) {
                  s = !0, a = t;
                } finally {
                  try {
                    o || null == n.return || n.return();
                  } finally {
                    if (s) throw a;
                  }
                }
                return i;
              }
            }(t, e) || a(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function a(t, e) {
            if (t) {
              if ("string" == typeof t) return i(t, e);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? i(t, e) : void 0;
            }
          }
          function i(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, r = new Array(e); n < e; n++) {
              r[n] = t[n];
            }
            return r;
          }
          var o = {},
            s = n(2835).wrapNextFunction,
            l = n(5942),
            h = n(9611),
            u = function u(t) {
              return t.match(/\[[^\]]+\]/g);
            },
            c = function c(t) {
              return t.startsWith("[") && t.endsWith("]") ? t.substring(1, t.length - 1) : t;
            },
            f = function f(t) {
              return t.startsWith("(") && t.endsWith(")") ? t.substring(1, t.length - 1) : t;
            },
            d = function d(t) {
              return t.match(/(\(.*?\)|[^\(,\s]+)(?=\s*,|\s*$)/g);
            },
            _ = function t(e) {
              e = c(e), e = f(e);
              var n = d(e);
              return 1 === n.length ? {
                type: "Vector",
                dim: n[0]
              } : {
                type: "Matrix",
                parts: n.map(t)
              };
            };
          function p(t) {
            var e = t.match(/[^ A-Za-z,\[\]]/g);
            if (e) throw new Error("The following invalid characters were used: " + e.map(function (t) {
              return '"'.concat(t, '"');
            }).join(", "));
            return !0;
          }
          function y(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                useLayoutCache: !0
              },
              n = e.useLayoutCache,
              r = void 0 === n || n;
            if (r && t in o) return o[t];
            p(t);
            var a = u(t),
              i = a.map(_),
              s = {
                type: "Layout",
                summary: i.map(function (t) {
                  return "Matrix" === t.type ? t.parts.length : 1;
                }),
                dims: i
              };
            return r && (o[t] = s), s;
          }
          function g(t) {
            var e = t.useLayoutCache,
              n = void 0 === e || e,
              r = t.data,
              a = t.layout,
              i = t.sizes,
              o = void 0 === i ? {} : i;
            "string" == typeof a && (a = y(a, {
              useLayoutCache: n
            }));
            var s = a.dims,
              l = s.length,
              u = v({
                useLayoutCache: n,
                layout: a,
                sizes: o
              }),
              c = l - 1,
              f = a.summary.toString();
            if (f in h) {
              var d = {
                data: r
              };
              return a.dims.map(function (t, e) {
                "Vector" === t.type ? d["d".concat(e, "v0")] = t.dim : "Matrix" === t.type && t.parts.forEach(function (t, n) {
                  d["d".concat(e, "v").concat(n)] = t.dim, d["m".concat(e, "v").concat(n)] = u[t.dim];
                });
              }), h[f].bind(d);
            }
            return function (t) {
              for (var e = t.point, n = t.value, a = r, i = 0; i < l; i++) {
                var o,
                  h = i === c,
                  f = s[i];
                o = "Vector" === f.type ? e[f.dim] : f.parts.reduce(function (t, n) {
                  var r = n.dim;
                  return t + u[r] * e[r];
                }, 0), h ? a[o] = n : a = a[o];
              }
            };
          }
          function m(t) {
            var e = t.rect,
              n = void 0 === e ? {} : e;
            if (n) for (var a in n) {
              var i = n[a];
              if (2 !== i.length) throw new Error("[xdim] uh oh. invalid hyper-rectangle");
              var o = r(i, 2),
                s = o[0],
                l = o[1];
              if (s > l) throw new Error('[xdim] uh oh. invalid range for "'.concat(a, '".  Start of ').concat(s, " can't be greater than end of ").concat(l, "."));
              if (s < 0) throw new Error("[xdim] uh oh. invalid hyper-rectangle with start ".concat(s));
            }
          }
          function v(t) {
            var e = t.useLayoutCache,
              n = void 0 === e || e,
              r = t.layout,
              a = t.sizes;
            "string" == typeof r && (r = y(r, {
              useLayoutCache: n
            }));
            for (var i = r.dims, o = i.length, s = {}, l = 0; l < o; l++) {
              var h = i[l];
              if ("Vector" === h.type) s[h.dim] = 1;else for (var u = h.parts, c = 1, f = u.length - 1; f >= 0; f--) {
                s[u[f].dim] = c, c *= a[u[f].dim];
              }
            }
            return s;
          }
          function x(t) {
            var e,
              n,
              r = t.useLayoutCache,
              a = void 0 === r || r,
              i = t.data,
              o = t.layout,
              s = t.point,
              l = t.sizes,
              h = void 0 === l ? {} : l;
            "string" == typeof o && (o = y(o, {
              useLayoutCache: a
            }));
            for (var u = i, c = o.dims, f = c.length, d = 0; d < f; d++) {
              var _ = c[d];
              if ("Vector" === _.type) {
                var p = s[_.dim];
                e = u, n = p, u = u[p];
              } else {
                for (var g = _.parts, m = 0, v = 1, x = g.length - 1; x >= 0; x--) {
                  var b = g[x];
                  if ("Vector" === b.type) {
                    var k = b.dim;
                    if (m += v * s[k], x > 0) {
                      if (!(k in h)) throw new Error('you cannot calculate the location without knowing the size of the "'.concat(k, '" dimension.'));
                      v *= h[k];
                    }
                  }
                }
                e = u, n = m, u = u[m];
              }
            }
            return {
              index: n,
              value: u,
              parent: e
            };
          }
          function b(t) {
            var e = t.arr,
              n = t.fill,
              r = void 0 === n ? void 0 : n,
              a = t.lens;
            if (0 === a.length) return e;
            var i = a[0];
            if (0 === a.length) for (var o = 0; o < e.length; o++) {
              e[o] = new Array(i).fill(r);
            } else for (var s = 0; s < e.length; s++) {
              var l = new Array(i).fill(r);
              e[s] = l, b({
                arr: l,
                lens: a.slice(1)
              });
            }
            return e;
          }
          function k(t) {
            var e = t.fill,
              n = void 0 === e ? void 0 : e,
              r = t.shape,
              a = r[0];
            return b({
              arr: new Array(a).fill(n),
              fill: n,
              lens: r.slice(1)
            });
          }
          function M(t) {
            var e = t.fill,
              n = void 0 === e ? void 0 : e,
              r = t.layout,
              a = t.useLayoutCache,
              i = void 0 === a || a,
              o = t.sizes;
            "string" == typeof r && (r = y(r, {
              useLayoutCache: i
            }));
            var s = r.dims.map(function (t) {
              return "Vector" === t.type ? o[t.dim] : "Matrix" === t.type ? t.parts.reduce(function (t, e) {
                if (console.log("part.dim:", e.dim), !(e.dim in o)) throw new Error('[xdim] could not find "'.concat(e.dim, '" in sizes: { ').concat(Object.keys(o).join(", "), " }"));
                return t * o[e.dim];
              }, 1) : void 0;
            });
            return {
              data: k({
                fill: n,
                shape: s
              }),
              shape: s
            };
          }
          function w(t) {
            var e = t.start,
              n = void 0 === e ? 0 : e,
              r = t.end,
              a = void 0 === r ? 100 : r,
              i = n - 1;
            return a += 1, s(function () {
              return ++i === a ? {
                done: !0
              } : {
                done: !1,
                value: i
              };
            });
          }
          function C(t) {
            for (var e = t.order, n = t.sizes, a = t.rect, i = void 0 === a ? {} : a, o = Array.isArray(e) ? e : Object.keys(n).sort(function (t, e) {
                return n[t] - n[e];
              }), l = new Array(o.length), h = {}, u = 0; u < o.length - 1; u++) {
              var c = o[u],
                f = r(i[c] || [0, n[c] - 1], 2),
                d = f[0],
                _ = f[1];
              l[u] = w({
                start: d + 1,
                end: _
              }), h[c] = d;
            }
            var p = o[o.length - 1],
              y = r(i[p] || [0, n[p] - 1], 2),
              g = y[0],
              m = y[1];
            return l[l.length - 1] = w({
              start: g,
              end: m
            }), h[p] = g - 1, s(function () {
              for (var t = l.length - 1; t >= 0; t--) {
                var e = l[t].next(),
                  a = e.value;
                if (!e.done) {
                  for (var s = t + 1; s < l.length; s++) {
                    var u = o[s],
                      c = r(i[u] || [0, n[u] - 1], 2),
                      f = c[0],
                      d = c[1];
                    l[s] = w({
                      start: f + 1,
                      end: d
                    }), h[u] = f;
                  }
                  return h[o[t]] = a, {
                    value: h,
                    done: !1
                  };
                }
                if (0 === t) return {
                  done: !0
                };
              }
            });
          }
          t.exports = {
            checkValidity: p,
            createMatrix: k,
            iterClip: function iterClip(t) {
              var e = t.data,
                n = t.layout,
                r = t.order,
                a = t.rect,
                i = void 0 === a ? {} : a,
                o = t.sizes,
                l = void 0 === o ? {} : o,
                h = t.useLayoutCache,
                u = void 0 === h || h;
              if (!e) throw new Error("[xdim] must specify data");
              if (!n) throw new Error("[xdim] must specify layout");
              var c = C({
                order: r,
                sizes: l,
                rect: i
              });
              return s(function () {
                var t = c.next(),
                  r = t.value;
                return t.done ? {
                  done: !0
                } : {
                  done: !1,
                  value: x({
                    data: e,
                    layout: n,
                    point: r,
                    sizes: l,
                    useLayoutCache: u
                  }).value
                };
              });
            },
            iterRange: w,
            iterPoints: C,
            matchSequences: d,
            parse: y,
            parseDimensions: function parseDimensions(t) {
              for (var e, n = {}, a = /[A-Za-z]+/g; null !== (e = a.exec(t));) {
                var i = r(e, 1)[0];
                n[i] = {
                  name: i
                };
              }
              return n;
            },
            parseSequences: _,
            parseVectors: u,
            prepareData: M,
            prepareSelect: function prepareSelect(t) {
              var e = t.useLayoutCache,
                n = void 0 === e || e,
                r = t.data,
                a = t.layout,
                i = t.sizes,
                o = void 0 === i ? {} : i;
              "string" == typeof a && (a = y(a, {
                useLayoutCache: n
              }));
              var s = a.dims,
                h = s.length,
                u = v({
                  useLayoutCache: n,
                  layout: a,
                  sizes: o
                }),
                c = h - 1,
                f = a.summary.toString();
              if (f in l) {
                var d = {
                  data: r
                };
                return a.dims.map(function (t, e) {
                  "Vector" === t.type ? d["d".concat(e, "v0")] = t.dim : "Matrix" === t.type && t.parts.forEach(function (t, n) {
                    d["d".concat(e, "v").concat(n)] = t.dim, d["m".concat(e, "v").concat(n)] = u[t.dim];
                  });
                }), l[f].bind(d);
              }
              return function (t) {
                for (var e = t.point, n = r, a = 0; a < h; a++) {
                  var i,
                    o = a === c,
                    l = s[a];
                  if (i = "Vector" === l.type ? e[l.dim] : l.parts.reduce(function (t, n) {
                    var r = n.dim;
                    return t + u[r] * e[r];
                  }, 0), o) return {
                    index: i,
                    parent: n,
                    value: n[i]
                  };
                  n = n[i];
                }
              };
            },
            prepareUpdate: g,
            removeBraces: c,
            removeParentheses: f,
            select: x,
            transform: function transform(t) {
              var e = t.data,
                n = t.fill,
                r = void 0 === n ? void 0 : n,
                i = t.from,
                o = t.to,
                s = t.sizes,
                l = t.useLayoutCache,
                h = void 0 === l || l;
              "string" == typeof i && (i = y(i, {
                useLayoutCache: h
              })), "string" == typeof o && (o = y(o, {
                useLayoutCache: h
              }));
              var u,
                c = M({
                  fill: r,
                  layout: o,
                  sizes: s
                }).data,
                f = g({
                  useLayoutCache: h,
                  data: c,
                  layout: o,
                  sizes: s
                }),
                d = function (t, e) {
                  var _n2 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                  if (!_n2) {
                    if (Array.isArray(t) || (_n2 = a(t))) {
                      _n2 && (t = _n2);
                      var r = 0,
                        i = function i() {};
                      return {
                        s: i,
                        n: function n() {
                          return r >= t.length ? {
                            done: !0
                          } : {
                            done: !1,
                            value: t[r++]
                          };
                        },
                        e: function e(t) {
                          throw t;
                        },
                        f: i
                      };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }
                  var o,
                    s = !0,
                    l = !1;
                  return {
                    s: function s() {
                      _n2 = _n2.call(t);
                    },
                    n: function n() {
                      var t = _n2.next();
                      return s = t.done, t;
                    },
                    e: function e(t) {
                      l = !0, o = t;
                    },
                    f: function f() {
                      try {
                        s || null == _n2.return || _n2.return();
                      } finally {
                        if (l) throw o;
                      }
                    }
                  };
                }(C({
                  sizes: s
                }));
              try {
                for (d.s(); !(u = d.n()).done;) {
                  point = u.value;
                  var _ = x({
                    data: e,
                    layout: i,
                    point: point,
                    sizes: s
                  }).value;
                  f({
                    point: point,
                    value: _
                  });
                }
              } catch (t) {
                d.e(t);
              } finally {
                d.f();
              }
              return {
                data: c
              };
            },
            update: function update(t) {
              var e = t.useLayoutCache,
                n = void 0 === e || e,
                r = t.data,
                a = t.layout,
                i = t.point,
                o = t.sizes,
                s = void 0 === o ? {} : o,
                l = t.value;
              "string" == typeof a && (a = y(a, {
                useLayoutCache: n
              }));
              for (var h = a.dims, u = 0; u < h.length; u++) {
                var c = u === h.length - 1,
                  f = h[u],
                  d = void 0;
                if ("Vector" === f.type) d = i[f.dim];else {
                  var _ = f.parts;
                  d = 0;
                  for (var p = 1, g = _.length - 1; g >= 0; g--) {
                    var m = _[g].dim;
                    if (d += p * i[m], g > 0) {
                      if (!(m in s)) throw new Error('you cannot calculate the location without knowing the size of the "'.concat(m, '" dimension.'));
                      p *= s[m];
                    }
                  }
                }
                c ? r[d] = l : r = r[d];
              }
            },
            clip: function clip(t) {
              var e = t.useLayoutCache,
                n = void 0 === e || e,
                a = t.data,
                i = t.layout,
                o = t.rect,
                s = t.sizes,
                l = void 0 === s ? {} : s,
                h = t.flat,
                u = void 0 !== h && h,
                c = t.validate;
              (void 0 === c || c) && m({
                rect: o
              }), "string" == typeof i && (i = y(i, {
                useLayoutCache: n
              }));
              var f = [a];
              if (i.dims.forEach(function (t) {
                var e = [];
                f.forEach(function (n) {
                  if ("Vector" === t.type) {
                    var a = r(o[t.dim], 2),
                      i = a[0],
                      s = a[1];
                    e = e.concat(n.slice(i, s + 1));
                  } else !function () {
                    for (var a = t.parts, i = [0], s = 1, h = function h(t) {
                        for (var e = a[t].dim, n = r(o[e], 2), h = n[0], u = n[1], c = [], f = function f(t) {
                            i.forEach(function (e) {
                              c.push(e + s * t);
                            });
                          }, d = h; d <= u; d++) {
                          f(d);
                        }
                        i = c, s *= l[e];
                      }, u = a.length - 1; u >= 0; u--) {
                      h(u);
                    }
                    i.forEach(function (t) {
                      e.push(n[t]);
                    });
                  }();
                }), f = e;
              }), u) return {
                data: f
              };
              var d = M({
                  layout: i,
                  sizes: Object.fromEntries(Object.entries(o).map(function (t) {
                    var e = r(t, 2),
                      n = e[0],
                      a = r(e[1], 2),
                      i = a[0];
                    return [n, a[1] - i + 1];
                  }))
                }).data,
                _ = i.dims.length;
              return function t(e, n) {
                if (n === _) for (var r = 0; r < e.length; r++) {
                  e[r] = f.shift();
                } else e.forEach(function (e) {
                  return t(e, n + 1);
                });
              }(d, 1), {
                data: d
              };
            },
            validateRect: m
          };
        },
        7748: function _(e) {
          "use strict";

          e.exports = t;
        }
      },
      n = {};
    function r(t) {
      var a = n[t];
      if (void 0 !== a) return a.exports;
      var i = n[t] = {
        id: t,
        loaded: !1,
        exports: {}
      };
      return e[t].call(i.exports, i, i.exports, r), i.loaded = !0, i.exports;
    }
    r.amdD = function () {
      throw new Error("define cannot be used indirect");
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, {
        a: e
      }), e;
    }, r.d = function (t, e) {
      for (var n in e) {
        r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
          enumerable: !0,
          get: e[n]
        });
      }
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.nmd = function (t) {
      return t.paths = [], t.children || (t.children = []), t;
    };
    var a = {};
    return function () {
      "use strict";

      r.d(a, {
        default: function _default() {
          return yt;
        }
      }), r(3238);
      var t,
        e,
        n = r(7748),
        i = r(774),
        o = r.n(i),
        s = r(7942),
        l = r.n(s),
        h = (r(1135), r(3736));
      function u(t, e, n, r) {
        if (r.includes(t)) return e;
        var a = n(r[0]);
        return [a, a, a];
      }
      function c(t, e, n, r) {
        if (r.includes(t)) return e;
        var a = n(r[0]);
        return "rgb(" + a + ", " + a + ", " + a + ")";
      }
      function f(t, e, n, r, a) {
        return a.includes(t) ? e : [n(a[0]), r(a[1]), 0];
      }
      function d(t, e, n, r, a) {
        return a.includes(t) ? e : "rgb(" + n(a[0]) + ", " + r(a[1]) + ", 0)";
      }
      function _(t, e, n, r, a, i) {
        return i.includes(t) ? e : [n(i[0]), r(i[1]), a(i[2])];
      }
      function p(t, e, n, r, a, i) {
        return i.includes(t) ? e : "rgb(" + n(i[0]) + ", " + r(i[1]) + ", " + a(i[2]) + ")";
      }
      function y(t, e, n, r, a, i) {
        return (i = i.slice(0, 3)).includes(t) ? e : [n(i[0]), r(i[1]), a(i[2])];
      }
      function g(t, e, n, r, a, i) {
        return (i = i.slice(0, 3)).includes(t) ? e : "rgb(" + n(i[0]) + ", " + r(i[1]) + ", " + a(i[2]) + ")";
      }
      function m(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) {
          r[n] = t[n];
        }
        return r;
      }
      function v(t) {
        var e,
          n,
          r = (n = 3, function (t) {
            if (Array.isArray(t)) return t;
          }(e = t) || function (t, e) {
            var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (null != n) {
              var r,
                a,
                i = [],
                o = !0,
                s = !1;
              try {
                for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                  ;
                }
              } catch (t) {
                s = !0, a = t;
              } finally {
                try {
                  o || null == n.return || n.return();
                } finally {
                  if (s) throw a;
                }
              }
              return i;
            }
          }(e, n) || function (t, e) {
            if (t) {
              if ("string" == typeof t) return m(t, e);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? m(t, e) : void 0;
            }
          }(e, n) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }());
        return "rgb(" + r[0] + ", " + r[1] + ", " + r[2] + ")";
      }
      function x(t) {
        return function (t) {
          if (Array.isArray(t)) return b(t);
        }(t) || function (t) {
          if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(t) || function (t, e) {
          if (t) {
            if ("string" == typeof t) return b(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? b(t, e) : void 0;
          }
        }(t) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function b(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) {
          r[n] = t[n];
        }
        return r;
      }
      function k(t) {
        var e,
          n = t.format,
          r = void 0 === n ? "array" : n,
          a = t.ranges,
          i = t.flip,
          o = t.new_no_data_pixel,
          s = t.new_no_data_value,
          l = t.no_range_value,
          m = t.no_range_value_strategy,
          b = t.old_no_data_value,
          k = t.round,
          M = void 0 === k || k,
          w = a.length;
        if (o && s) throw new Error("[pixel-utils/raw-to-rgb] can't specify both new_no_data_pixel and new_no_data_value");
        if (null == o && (o = [e = null == s ? null : s, e, e]), void 0 === o) throw new Error("[raw-to-rgb] undefined new_no_data_pixel");
        var C = [0 === s ? 1 : 0, 255 === s ? 254 : 255],
          E = {
            flip: i,
            no_range_value: l,
            no_range_value_strategy: m,
            round: M
          },
          S = a.slice(0, 3).map(function (t) {
            return (0, h.createScaleFunction)(t, C, E);
          });
        if (1 === w) return "string" === r ? c.bind.apply(c, [null, b, v(o)].concat(x(S))) : u.bind.apply(u, [null, b, o].concat(x(S)));
        if (2 === w) return "string" === r ? d.bind.apply(d, [null, b, v(o)].concat(x(S))) : f.bind.apply(f, [null, b, o].concat(x(S)));
        if (3 === w) return "string" === r ? p.bind.apply(p, [null, b, v(o)].concat(x(S))) : _.bind.apply(_, [null, b, o].concat(x(S)));
        if (w >= 4) return "string" === r ? g.bind.apply(g, [null, b, v(o)].concat(x(S))) : y.bind.apply(y, [null, b, o].concat(x(S)));
        throw new Error("[pixel-utils/raw-to-rgb] invalid number of bands: " + w);
      }
      (e = t || (t = {}))["[band][row][column]"] = "[band][row][column]", e["[band][row,column]"] = "[band][row,column]", e["[band,row,column]"] = "[band,row,column]", e["[row,column,band]"] = "[row,column,band]", e["[row,column][band]"] = "[row,column][band]", e["[row][column][band]"] = "[row][column][band]", e["[row][column,band]"] = "[row][column,band]";
      var M = r(6544),
        w = r.n(M),
        C = r(4365),
        E = r.n(C),
        S = r(3759),
        A = r.n(S),
        I = r(9627),
        O = r(7493),
        j = r(5739),
        N = r(8508),
        G = r(8180),
        D = r(2977);
      var R = function R(t, e) {
          return O(I(t.toString(), e.toString()), "2");
        },
        L = function L(t) {
          return Array.isArray(t);
        },
        P = function P(t) {
          return null != t && "" !== t;
        },
        T = function T(t) {
          return "function" == typeof t;
        },
        B = function B(t) {
          return "object" == typeof t;
        },
        Q = function Q(t) {
          return "string" == typeof t;
        },
        F = function F(t) {
          return "number" == typeof t;
        },
        q = function q(t) {
          return B(t) && z(t, ["getEast", "getNorth", "getSouth", "getWest"]);
        },
        U = function U(t, e) {
          return B(t) && B(t[e]);
        },
        z = function z(t, e) {
          return e.every(function (e) {
            return function (t, e) {
              return B(t) && T(t[e]);
            }(t, e);
          });
        },
        H = function H(t, e) {
          return B(t) && void 0 !== t[e] && null !== t[e];
        },
        Z = function Z(t, e) {
          return e.every(function (e) {
            return H(t, e);
          });
        },
        X = function X(t) {
          return L(t) && t.every(F);
        },
        J = function J(t) {
          if (!t) return t;
          if (Q(t) && t.startsWith("EPSG:")) return t;
          if (Q(t) && t.match(/^\d+$/)) return "EPSG:" + t;
          if (F(t)) return "EPSG:" + t;
          var e = G(t);
          return F(e) ? "EPSG:" + e : t;
        };
      var W = /*#__PURE__*/function () {
        function W(t) {
          var _t2, _t5, _t6, _t$map, _t$map2;
          var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            e = _ref.srs;
          _classCallCheck(this, W);
          var n, r, a, i, o, s, l, h;
          if (this.srs = J(e), ("object" == typeof obj && "function" == typeof obj.constructor || void 0) === this.constructor && ((_t2 = t, n = _t2.xmin, r = _t2.xmax, a = _t2.ymin, i = _t2.ymax, _t2), P(t.srs) && (this.srs = J(t.srs))), function (t) {
            return Q(t) && !!t.match(/^[-|+]?[\d\.]+(, ?[-|+]?[\d\.]+){3}$/);
          }(t) && (t = t.split(/, ?/)), L(t) && 4 === t.length && X(t)) {
            var _t3 = t;
            var _t4 = _slicedToArray(_t3, 4);
            n = _t4[0];
            a = _t4[1];
            r = _t4[2];
            i = _t4[3];
          } else if (L(t) && 4 === t.length && L(u = t) && u.every(Q)) (_t5 = t, _t6 = _slicedToArray(_t5, 4), o = _t6[0], l = _t6[1], s = _t6[2], h = _t6[3], _t5), (_t$map = t.map(function (t) {
            return Number(t);
          }), _t$map2 = _slicedToArray(_t$map, 4), n = _t$map2[0], a = _t$map2[1], r = _t$map2[2], i = _t$map2[3], _t$map);else if (L(t) && 2 === t.length && t.every(L) && t.every(function (t) {
            return 2 === t.length && X(t);
          })) {
            var _t7 = t;
            var _t8 = _slicedToArray(_t7, 2);
            var _t8$ = _slicedToArray(_t8[0], 2);
            a = _t8$[0];
            n = _t8$[1];
            var _t8$2 = _slicedToArray(_t8[1], 2);
            i = _t8$2[0];
            r = _t8$2[1];
          } else if (q(t)) n = t.getWest(), r = t.getEast(), a = t.getSouth(), i = t.getNorth(), P(this.srs) || (this.srs = "EPSG:4326");else if (L(t) && 2 === t.length && t.every(function (t) {
            return Z(t, ["x", "y"]);
          })) {
            var _t9 = t;
            var _t10 = _slicedToArray(_t9, 2);
            var _t10$ = _t10[0];
            n = _t10$.x;
            a = _t10$.y;
            var _t10$2 = _t10[1];
            r = _t10$2.x;
            i = _t10$2.y;
          } else if (B(t) && Z(t, ["x", "y"]) && F(t.x) && F(t.y)) n = r = t.x, a = i = t.y, H(t, "spatialReference") && H(t.spatialReference, "wkid") && (P(this.srs) || (this.srs = J(t.spatialReference.wkid)));else if (B(t) && Z(t, ["xmin", "xmax", "ymin", "ymax"])) {
            var _t11 = t;
            n = _t11.xmin;
            r = _t11.xmax;
            a = _t11.ymin;
            i = _t11.ymax;
            var _e2 = ["srs", "crs", "proj", "projection"];
            for (var _n3 = 0; _n3 < _e2.length; _n3++) {
              var _r2 = t[_e2[_n3]],
                _a3 = J(_r2);
              if (_a3) {
                this.srs = _a3;
                break;
              }
            }
            !this.srs && P(t.srs) && (this.srs = t.srs);
          } else if (L(t) && 2 === t.length && X(t)) n = r = t[0], a = i = t[1];else if (B(t) && z(t, ["getCoordinates"])) {
            var _e3 = t.getCoordinates();
            n = r = _e3[0], a = i = _e3[1];
          } else if (B(t) && H(t, "bbox") && 4 === t.bbox.length && X(t)) {
            var _t$bbox = _slicedToArray(t.bbox, 4);
            n = _t$bbox[0];
            a = _t$bbox[1];
            r = _t$bbox[2];
            i = _t$bbox[3];
          } else if (U(t, "_bounds") && q(t._bounds)) {
            var _t12 = t,
              _e4 = _t12._bounds;
            n = _e4.getWest(), r = _e4.getEast(), a = _e4.getSouth(), i = _e4.getNorth(), this.srs || (this.srs = "EPSG:4326");
          } else {
            var _t$_bounds$_southWest, _t$_bounds$_northEast;
            if (!(B(t) && B(t._bounds) && function (t, e) {
              return ["_southWest", "_northEast"].every(function (e) {
                return U(t, e);
              });
            }(t._bounds))) throw new Error("[geo-extent] unknown format");
            (_t$_bounds$_southWest = t._bounds._southWest, a = _t$_bounds$_southWest.lat, n = _t$_bounds$_southWest.lng, _t$_bounds$_southWest), (_t$_bounds$_northEast = t._bounds._northEast, i = _t$_bounds$_northEast.lat, r = _t$_bounds$_northEast.lng, _t$_bounds$_northEast), P(this.srs) || (this.srs = "EPSG:4326");
          }
          var u;
          this.xmin = n, this.xmin_str = o || n.toString(), this.ymin = a, this.ymin_str = l || a.toString(), this.xmax = r, this.xmax_str = s || r.toString(), this.ymax = i, this.ymax_str = h || i.toString(), this.width_str = N(this.xmax_str, this.xmin_str), this.width = Number(this.width_str), this.height_str = N(this.ymax_str, this.ymin_str), this.height = Number(this.height_str), this.bottomLeft = {
            x: n,
            y: a
          }, this.bottomRight = {
            x: r,
            y: a
          }, this.topLeft = {
            x: n,
            y: i
          }, this.topRight = {
            x: r,
            y: i
          }, this.leafletBounds = [[this.ymin, this.xmin], [this.ymax, this.xmax]], this.area_str = j(this.width_str, this.height_str), this.area = Number(this.area_str), this.perimeter_str = I(j(this.width_str, "2"), j(this.height_str, "2")), this.perimeter = Number(this.perimeter_str), this.bbox = [n, a, r, i], this.bbox_str = [this.xmin_str, this.ymin_str, this.xmax_str, this.ymax_str], this.center_str = {
            x: R(o || n, s || r),
            y: R(l || a, h || i)
          }, this.center = {
            x: Number(this.center_str.x),
            y: Number(this.center_str.y)
          }, this.str = this.bbox_str.join(",");
        }
        _createClass(W, [{
          key: "_pre",
          value: function _pre(t, e) {
            if (e = new this.constructor(e), P(t.srs) || P(e.srs)) if (P(t.srs) && !P(e.srs)) e = new t.constructor(_objectSpread({}, e, {
              srs: t.srs
            }));else if (!P(t.srs) && P(e.srs)) t = new t.constructor(_objectSpread({}, t, {
              srs: e.srs
            }));else if (P(t.srs) && P(e.srs) && t.srs !== e.srs) e = e.reproj(t.srs);else if (!P(t.srs) || !P(e.srs) || t.srs !== e.srs) throw "UH OH";
            return [t, e];
          }
        }, {
          key: "clone",
          value: function clone() {
            return new this.constructor(this);
          }
        }, {
          key: "contains",
          value: function contains(t) {
            var _this$_pre = this._pre(this, t),
              _this$_pre2 = _slicedToArray(_this$_pre, 2),
              e = _this$_pre2[0],
              n = _this$_pre2[1],
              r = n.xmin >= e.xmin && n.xmax <= e.xmax,
              a = n.ymin >= e.ymin && n.ymax <= e.ymax;
            return r && a;
          }
        }, {
          key: "crop",
          value: function crop(t) {
            var _this = this;
            if (t = new this.constructor(t), !1 === this.overlaps(t, {
              quiet: !0
            }) && !1 === t.overlaps(this, {
              quiet: !0
            })) return null;
            if (t.contains(this)) return this.clone();
            if ("EPSG:4326" === t.srs && (t.xmin < -180 || t.xmax > 180)) {
              var _e5 = t.unwrap().map(function (t) {
                return _this.crop(t);
              });
              if (_e5 = _e5.filter(Boolean), 0 === _e5.length) return null;
              var _n4 = _e5[0];
              for (var _t13 = 1; _t13 < _e5.length; _t13++) {
                _n4 = _n4.combine(_e5[_t13]);
              }
              return _n4;
            }
            var e = P(this.srs) && P(t.srs) ? t.reproj(this.srs, {
              quiet: !0
            }) : t.clone();
            if (e) {
              if (!this.overlaps(e)) return null;
              var _t14 = Math.max(this.xmin, e.xmin),
                _n5 = Math.max(this.ymin, e.ymin),
                _r3 = Math.min(this.xmax, e.xmax),
                _a4 = Math.min(this.ymax, e.ymax);
              return new this.constructor([_t14, _n5, _r3, _a4], {
                srs: this.srs
              });
            }
            var n = P(this.srs) ? this.reproj(4326) : this,
              r = P(t.srs) ? t.reproj(4326) : t,
              _n$bbox = _slicedToArray(n.bbox, 4),
              a = _n$bbox[0],
              i = _n$bbox[1],
              o = _n$bbox[2],
              s = _n$bbox[3],
              _r$bbox = _slicedToArray(r.bbox, 4),
              l = _r$bbox[0],
              h = _r$bbox[1],
              u = _r$bbox[2],
              c = _r$bbox[3];
            if (!n.overlaps(r)) return null;
            var f = Math.max(a, l),
              d = Math.max(i, h),
              _ = Math.min(o, u),
              p = Math.min(s, c);
            return new this.constructor([f, d, _, p], {
              srs: 4326
            }).reproj(this.srs);
          }
        }, {
          key: "combine",
          value: function combine(t) {
            P(this.srs) && P(t.srs) && (t = t.reproj(this.srs));
            var e = Math.min(this.xmin, t.xmin),
              n = Math.max(this.xmax, t.xmax),
              r = Math.min(this.ymin, t.ymin),
              a = Math.max(this.ymax, t.ymax);
            return new this.constructor({
              xmin: e,
              xmax: n,
              ymin: r,
              ymax: a,
              srs: this.srs
            });
          }
        }, {
          key: "equals",
          value: function equals(t) {
            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                digits: 13,
                strict: !0
              },
              _ref2$digits = _ref2.digits,
              e = _ref2$digits === void 0 ? 13 : _ref2$digits,
              _ref2$strict = _ref2.strict,
              n = _ref2$strict === void 0 ? !0 : _ref2$strict;
            if (t = new this.constructor(t), P(this.srs) && P(t.srs)) t = t.reproj(this.srs);else if (n && P(this.srs) !== !P(this.srs)) return !1;
            return this.bbox.map(function (t) {
              return t.toFixed(e);
            }).join(",") === t.bbox.map(function (t) {
              return t.toFixed(e);
            }).join(",");
          }
        }, {
          key: "overlaps",
          value: function overlaps(t) {
            var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                quite: !1
              },
              _ref3$quiet = _ref3.quiet,
              e = _ref3$quiet === void 0 ? !1 : _ref3$quiet;
            try {
              var _this$_pre3 = this._pre(this, t),
                _this$_pre4 = _slicedToArray(_this$_pre3, 2),
                _e6 = _this$_pre4[0],
                _n6 = _this$_pre4[1],
                _r4 = _n6.ymin <= _e6.ymax && _n6.ymax >= _e6.ymin;
              return _n6.xmin <= _e6.xmax && _n6.xmax >= _e6.xmin && _r4;
            } catch (t) {
              if (e) return;
              throw t;
            }
          }
        }, {
          key: "reproj",
          value: function reproj(t) {
            var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                quiet: !1
              },
              _ref4$quiet = _ref4.quiet,
              e = _ref4$quiet === void 0 ? !1 : _ref4$quiet;
            if (t = J(t), P(this.srs) && this.srs === J(t)) return this.clone();
            if (!P(this.srs)) {
              if (e) return;
              throw new Error("[geo-extent] cannot reproject ".concat(this.bbox, " without a projection set"));
            }
            if ("EPSG:4326" === this.srs && (this.xmin < -180 || this.xmax > 180)) try {
              var _e7 = this.unwrap().map(function (e) {
                return e.reproj(t);
              });
              var _n7 = _e7[0];
              for (var _t15 = 1; _t15 < _e7.length; _t15++) {
                _n7 = _n7.combine(_e7[_t15]);
              }
              return _n7;
            } catch (t) {
              if (e) return;
              throw t;
            }
            var n = D({
              bbox: this.bbox,
              from: this.srs,
              to: t
            });
            if (n.some(isNaN)) {
              if (e) return;
              throw new Error("[geo-extent] failed to reproject ".concat(this.bbox, " from ").concat(this.srs, " to ").concat(t));
            }
            return new W(n, {
              srs: t
            });
          }
        }, {
          key: "unwrap",
          value: function unwrap() {
            var t = this.xmin,
              e = this.ymin,
              n = this.xmax,
              r = this.ymax,
              a = this.srs;
            if ("EPSG:4326" !== a) return [this.clone()];
            if (t > -180 && n < 180) return [this.clone()];
            if (t < -180 && n >= t + 360) return [new this.constructor([-180, e, 180, r], {
              srs: 4326
            })];
            if (n > 180 && t <= n - 360) return [new this.constructor([-180, e, 180, r], {
              srs: 4326
            })];
            var i = [];
            return t < -180 && i.push(new this.constructor([t + 360, e, 180, r], {
              srs: a
            })), i.push(new this.constructor([t < -180 ? -180 : t, e, n > 180 ? 180 : n, r], {
              srs: a
            })), this.xmax > 180 && i.push(new this.constructor([-180, e, n - 360, r], {
              srs: a
            })), i;
          }
        }, {
          key: "asEsriJSON",
          value: function asEsriJSON() {
            return {
              xmin: this.xmin,
              ymin: this.ymin,
              xmax: this.xmax,
              ymax: this.ymax,
              spatialReference: {
                wkid: this.srs
              }
            };
          }
        }, {
          key: "asGeoJSON",
          value: function asGeoJSON() {
            var _ref5 = "EPSG:4326" === this.srs ? this : this.reproj(4326),
              t = _ref5.xmin,
              e = _ref5.ymin,
              n = _ref5.xmax,
              r = _ref5.ymax;
            return {
              type: "Feature",
              geometry: {
                type: "Polygon",
                coordinates: [[[t, r], [n, r], [n, e], [t, e], [t, r]]]
              }
            };
          }
        }, {
          key: "asObj",
          value: function asObj() {
            var t = {};
            for (var _e8 in this) {
              var _n8 = this[_e8];
              T(_n8) || (t[_e8] = _n8);
            }
            return t;
          }
        }]);
        return W;
      }();
      "function" == typeof define && define.amd && define(function () {
        return W;
      }), "object" == typeof self && (self.GeoExtent = W), "object" == typeof window && (window.GeoExtent = W);
      var V = r(3401),
        Y = r.n(V);
      function K(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function $(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? K(Object(n), !0).forEach(function (e) {
            tt(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : K(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      function tt(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }
      function et(t, e) {
        return function (t) {
          if (Array.isArray(t)) return t;
        }(t) || function (t, e) {
          var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
          if (null != n) {
            var r,
              a,
              i = [],
              o = !0,
              s = !1;
            try {
              for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                ;
              }
            } catch (t) {
              s = !0, a = t;
            } finally {
              try {
                o || null == n.return || n.return();
              } finally {
                if (s) throw a;
              }
            }
            return i;
          }
        }(t, e) || function (t, e) {
          if (t) {
            if ("string" == typeof t) return nt(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? nt(t, e) : void 0;
          }
        }(t, e) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function nt(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) {
          r[n] = t[n];
        }
        return r;
      }
      function rt() {
        rt = function rt() {
          return t;
        };
        var t = {},
          e = Object.prototype,
          n = e.hasOwnProperty,
          r = "function" == typeof Symbol ? Symbol : {},
          a = r.iterator || "@@iterator",
          i = r.asyncIterator || "@@asyncIterator",
          o = r.toStringTag || "@@toStringTag";
        function s(t, e, n) {
          return Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }
        try {
          s({}, "");
        } catch (t) {
          s = function s(t, e, n) {
            return t[e] = n;
          };
        }
        function l(t, e, n, r) {
          var a = e && e.prototype instanceof c ? e : c,
            i = Object.create(a.prototype),
            o = new M(r || []);
          return i._invoke = function (t, e, n) {
            var r = "suspendedStart";
            return function (a, i) {
              if ("executing" === r) throw new Error("Generator is already running");
              if ("completed" === r) {
                if ("throw" === a) throw i;
                return {
                  value: void 0,
                  done: !0
                };
              }
              for (n.method = a, n.arg = i;;) {
                var o = n.delegate;
                if (o) {
                  var s = x(o, n);
                  if (s) {
                    if (s === u) continue;
                    return s;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                  if ("suspendedStart" === r) throw r = "completed", n.arg;
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                r = "executing";
                var l = h(t, e, n);
                if ("normal" === l.type) {
                  if (r = n.done ? "completed" : "suspendedYield", l.arg === u) continue;
                  return {
                    value: l.arg,
                    done: n.done
                  };
                }
                "throw" === l.type && (r = "completed", n.method = "throw", n.arg = l.arg);
              }
            };
          }(t, n, o), i;
        }
        function h(t, e, n) {
          try {
            return {
              type: "normal",
              arg: t.call(e, n)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }
        t.wrap = l;
        var u = {};
        function c() {}
        function f() {}
        function d() {}
        var _ = {};
        s(_, a, function () {
          return this;
        });
        var p = Object.getPrototypeOf,
          y = p && p(p(w([])));
        y && y !== e && n.call(y, a) && (_ = y);
        var g = d.prototype = c.prototype = Object.create(_);
        function m(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function v(t, e) {
          function r(a, i, o, s) {
            var l = h(t[a], t, i);
            if ("throw" !== l.type) {
              var u = l.arg,
                c = u.value;
              return c && "object" == ot(c) && n.call(c, "__await") ? e.resolve(c.__await).then(function (t) {
                r("next", t, o, s);
              }, function (t) {
                r("throw", t, o, s);
              }) : e.resolve(c).then(function (t) {
                u.value = t, o(u);
              }, function (t) {
                return r("throw", t, o, s);
              });
            }
            s(l.arg);
          }
          var a;
          this._invoke = function (t, n) {
            function i() {
              return new e(function (e, a) {
                r(t, n, e, a);
              });
            }
            return a = a ? a.then(i, i) : i();
          };
        }
        function x(t, e) {
          var n = t.iterator[e.method];
          if (void 0 === n) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = void 0, x(t, e), "throw" === e.method)) return u;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return u;
          }
          var r = h(n, t.iterator, e.arg);
          if ("throw" === r.type) return e.method = "throw", e.arg = r.arg, e.delegate = null, u;
          var a = r.arg;
          return a ? a.done ? (e[t.resultName] = a.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, u) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, u);
        }
        function b(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }
        function k(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }
        function M(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(b, this), this.reset(!0);
        }
        function w(t) {
          if (t) {
            var e = t[a];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var r = -1,
                i = function e() {
                  for (; ++r < t.length;) {
                    if (n.call(t, r)) return e.value = t[r], e.done = !1, e;
                  }
                  return e.value = void 0, e.done = !0, e;
                };
              return i.next = i;
            }
          }
          return {
            next: C
          };
        }
        function C() {
          return {
            value: void 0,
            done: !0
          };
        }
        return f.prototype = d, s(g, "constructor", d), s(d, "constructor", f), f.displayName = s(d, o, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === f || "GeneratorFunction" === (e.displayName || e.name));
        }, t.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, d) : (t.__proto__ = d, s(t, o, "GeneratorFunction")), t.prototype = Object.create(g), t;
        }, t.awrap = function (t) {
          return {
            __await: t
          };
        }, m(v.prototype), s(v.prototype, i, function () {
          return this;
        }), t.AsyncIterator = v, t.async = function (e, n, r, a, i) {
          void 0 === i && (i = Promise);
          var o = new v(l(e, n, r, a), i);
          return t.isGeneratorFunction(n) ? o : o.next().then(function (t) {
            return t.done ? t.value : o.next();
          });
        }, m(g), s(g, o, "Generator"), s(g, a, function () {
          return this;
        }), s(g, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (t) {
          var e = [];
          for (var n in t) {
            e.push(n);
          }
          return e.reverse(), function n() {
            for (; e.length;) {
              var r = e.pop();
              if (r in t) return n.value = r, n.done = !1, n;
            }
            return n.done = !0, n;
          };
        }, t.values = w, M.prototype = {
          constructor: M,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(k), !t) for (var e in this) {
              "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;
            function r(n, r) {
              return o.type = "throw", o.arg = t, e.next = n, r && (e.method = "next", e.arg = void 0), !!r;
            }
            for (var a = this.tryEntries.length - 1; a >= 0; --a) {
              var i = this.tryEntries[a],
                o = i.completion;
              if ("root" === i.tryLoc) return r("end");
              if (i.tryLoc <= this.prev) {
                var s = n.call(i, "catchLoc"),
                  l = n.call(i, "finallyLoc");
                if (s && l) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                } else {
                  if (!l) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var a = this.tryEntries[r];
              if (a.tryLoc <= this.prev && n.call(a, "finallyLoc") && this.prev < a.finallyLoc) {
                var i = a;
                break;
              }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var o = i ? i.completion : {};
            return o.type = t, o.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, u) : this.complete(o);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), u;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var n = this.tryEntries[e];
              if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), k(n), u;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var n = this.tryEntries[e];
              if (n.tryLoc === t) {
                var r = n.completion;
                if ("throw" === r.type) {
                  var a = r.arg;
                  k(n);
                }
                return a;
              }
            }
            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, n) {
            return this.delegate = {
              iterator: w(t),
              resultName: e,
              nextLoc: n
            }, "next" === this.method && (this.arg = void 0), u;
          }
        }, t;
      }
      function at(t, e, n, r, a, i, o) {
        try {
          var s = t[i](o),
            l = s.value;
        } catch (t) {
          return void n(t);
        }
        s.done ? e(l) : Promise.resolve(l).then(r, a);
      }
      function it(t) {
        return function () {
          var e = this,
            n = arguments;
          return new Promise(function (r, a) {
            var i = t.apply(e, n);
            function o(t) {
              at(i, r, a, o, s, "next", t);
            }
            function s(t) {
              at(i, r, a, o, s, "throw", t);
            }
            o(void 0);
          });
        };
      }
      function ot(t) {
        return ot = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, ot(t);
      }
      var st = 4326,
        lt = new Set([3785, 3857, 4269, 4326, 900913, 102113]),
        ht = 1e3,
        ut = 1e3,
        ct = [0, 0],
        ft = function ft(t) {
          return console.log("[georaster-layer-for-leaflet] ", t);
        },
        dt = function dt(t) {
          var e, r, a, i;
          return t === n.CRS.Simple || !t.code && t.infinite && 1 === (null == t || null === (e = t.transformation) || void 0 === e ? void 0 : e._a) && 0 === (null == t || null === (r = t.transformation) || void 0 === r ? void 0 : r._b) && -1 === (null == t || null === (a = t.transformation) || void 0 === a ? void 0 : a._c) && 0 === (null == t || null === (i = t.transformation) || void 0 === i ? void 0 : i._d);
        };
      n || console.warn("[georaster-layer-for-leaflet] can't find Leaflet.  If you are loading via <script>, please add the GeoRasterLayer script after the LeafletJS script.");
      var _t = function _t(t, e) {
          return t.map(function (t, n) {
            return [t, e[n]];
          });
        },
        pt = n.GridLayer.extend({
          options: {
            updateWhenIdle: !0,
            updateWhenZooming: !1,
            keepBuffer: 25,
            resolution: Math.pow(2, 5),
            debugLevel: 0
          },
          initialize: function initialize(t) {
            var e = this;
            try {
              if (t.georasters) this.georasters = t.georasters;else {
                if (!t.georaster) throw new Error("You initialized a GeoRasterLayer without a georaster or georasters value.");
                this.georasters = [t.georaster];
              }
              "url" === this.sourceType && (t.updateWhenIdle = !1, t.updateWhenZooming = !0, t.keepBuffer = 16), t.resampleMethod && (this.resampleMethod = t.resampleMethod);
              var r = ["height", "width", "noDataValue", "palette", "pixelHeight", "pixelWidth", "projection", "sourceType", "xmin", "xmax", "ymin", "ymax"];
              this.georasters.length > 1 ? r.forEach(function (t) {
                if (!e.same(e.georasters, t)) throw new Error("all GeoRasters must have the same " + t);
                e[t] = e.georasters[0][t];
              }) : 1 === this.georasters.length && r.forEach(function (t) {
                e[t] = e.georasters[0][t];
              }), this._cache = {
                innerTile: {},
                tile: {}
              }, this.extent = new W([this.xmin, this.ymin, this.xmax, this.ymax], {
                srs: this.projection
              }), this.ratio = this.height / this.width, this.debugLevel = t.debugLevel, this.debugLevel >= 1 && ft({
                options: t
              }), this.georasters.every(function (t) {
                return "object" === ot(t.values);
              }) && (this.rasters = this.georasters.reduce(function (t, e) {
                if (e.values) return t.concat(e.values);
              }, []), this.debugLevel > 1 && console.log("this.rasters:", this.rasters)), t.mask && ("string" == typeof t.mask ? this.mask = fetch(t.mask).then(function (t) {
                return t.json();
              }) : "object" === ot(t.mask) && (this.mask = Promise.resolve(t.mask)), this.mask_srs = t.mask_srs || "EPSG:4326"), this.mask_strategy = t.mask_strategy || "outside", this.chroma = o(), this.scale = o().scale(), n.Util.setOptions(this, t);
              var a = this.getTileSize();
              if (this.tileHeight = a.y, this.tileWidth = a.x, this.georasters.length >= 4 && !t.pixelValuesToColorFn) throw "you must pass in a pixelValuesToColorFn if you are combining rasters";
              if (this.numBands = this.georasters.reduce(function (t, e) {
                return t + e.numberOfRasters;
              }, 0), this.debugLevel > 1 && console.log("this.numBands:", this.numBands), this.currentStats = {
                mins: new Array(this.numBands),
                maxs: new Array(this.numBands),
                ranges: new Array(this.numBands)
              }, [1, 2, 3].includes(this.georasters.length) && this.georasters.every(function (t) {
                return "url" === t.sourceType;
              }) && this.georasters.every(function (t) {
                return 1 === t.numberOfRasters;
              }) && !t.pixelValuesToColorFn) try {
                this.calcStats = !0, this._dynamic = !0, this.options.pixelValuesToColorFn = function (t) {
                  if (t.every(function (t) {
                    return void 0 !== t && t !== e.noDataValue;
                  })) return e.rawToRgb(t);
                };
              } catch (t) {
                console.error("[georaster-layer-for-leaflet]", t);
              }
              this.checkIfYCbCr = new Promise(function () {
                var t = it(rt().mark(function t(n) {
                  var r, a, i;
                  return rt().wrap(function (t) {
                    for (;;) {
                      switch (t.prev = t.next) {
                        case 0:
                          if (!e.options.pixelValuesToColorFn) {
                            t.next = 2;
                            break;
                          }
                          return t.abrupt("return", n(!0));
                        case 2:
                          if (1 !== e.georasters.length || 3 !== e.georasters[0].numberOfRasters) {
                            t.next = 7;
                            break;
                          }
                          return t.next = 5, null === (r = e.georasters[0]._geotiff) || void 0 === r ? void 0 : r.getImage();
                        case 5:
                          6 === (null == (i = t.sent) || null === (a = i.fileDirectory) || void 0 === a ? void 0 : a.PhotometricInterpretation) && (e.options.pixelValuesToColorFn = function (t) {
                            var e = Math.round(t[0] + 1.402 * (t[2] - 128)),
                              n = Math.round(t[0] - .34414 * (t[1] - 128) - .71414 * (t[2] - 128)),
                              r = Math.round(t[0] + 1.772 * (t[1] - 128));
                            return "rgb(".concat(e, ",").concat(n, ",").concat(r, ")");
                          });
                        case 7:
                          return t.abrupt("return", n(!0));
                        case 8:
                        case "end":
                          return t.stop();
                      }
                    }
                  }, t);
                }));
                return function (e) {
                  return t.apply(this, arguments);
                };
              }());
            } catch (t) {
              console.error("ERROR initializing GeoTIFFLayer", t);
            }
          },
          getRasters: function getRasters(t) {
            var e = this,
              r = t.innerTileTopLeftPoint,
              a = t.heightOfSampleInScreenPixels,
              i = t.widthOfSampleInScreenPixels,
              o = t.zoom,
              s = t.numberOfSamplesAcross,
              l = t.numberOfSamplesDown,
              h = t.ymax,
              u = t.xmin;
            this.debugLevel >= 1 && console.log("starting getRasters with options:", t);
            var c = function c(t, s) {
                var l = r.x + s * i,
                  c = r.y + t * a,
                  f = n.point(l, c);
                e.debugLevel >= 1 && ft({
                  mapPoint: f
                });
                var d = e.getMap().unproject(f, o),
                  _ = d.lat,
                  p = d.lng;
                if (e.projection === st) return {
                  y: Math.round((h - _) / e.pixelHeight),
                  x: Math.round((p - u) / e.pixelWidth)
                };
                if (e.getProjector()) {
                  var y = et(e.getProjector().inverse([p, _]), 2),
                    g = y[0],
                    m = y[1];
                  return g !== 1 / 0 && m !== 1 / 0 || e.debugLevel >= 1 && console.error("projector converted", [p, _], "to", [g, m]), {
                    y: Math.round((h - m) / e.pixelHeight),
                    x: Math.round((g - u) / e.pixelWidth)
                  };
                }
                return null;
              },
              f = c(0, 0),
              d = c(l, s),
              _ = {
                bottom: null == d ? void 0 : d.y,
                height: l,
                left: null == f ? void 0 : f.x,
                right: null == d ? void 0 : d.x,
                top: null == f ? void 0 : f.y,
                width: s
              };
            if (Object.values(_).every(function (t) {
              return void 0 !== t && isFinite(t);
            })) return Promise.all(this.georasters.map(function (t) {
              return t.getValues($($({}, _), {}, {
                resampleMethod: e.resampleMethod || "nearest"
              }));
            })).then(function (t) {
              return t.reduce(function (t, e) {
                return t.concat(e);
              }, []);
            });
            console.error("getRasters failed because not all values are finite:", _);
          },
          createTile: function createTile(t, e) {
            var r = n.DomUtil.create("canvas", "leaflet-tile");
            r.style.boxSizing = "content-box", r.style.visibility = "hidden";
            var a = r.getContext("2d");
            return this.drawTile({
              tile: r,
              coords: t,
              context: a,
              done: e
            }), r;
          },
          drawTile: function drawTile(t) {
            var e = this,
              r = t.tile,
              a = t.coords,
              i = t.context,
              o = t.done;
            try {
              var s,
                h = this.debugLevel,
                u = void 0 === h ? 0 : h;
              u >= 2 && console.log("starting drawTile with", {
                tile: r,
                coords: a,
                context: i,
                done: o
              });
              var c = a.z,
                f = [a.x, a.y, a.z].join(",");
              u >= 2 && ft({
                cacheKey: f
              });
              var d = this.getMapCRS();
              u >= 2 && ft({
                mapCRS: d
              });
              var _ = dt(d);
              u >= 2 && ft({
                inSimpleCRS: _
              });
              var p = this.rasters,
                y = this.xmin,
                g = this.xmax,
                m = this.ymin,
                v = this.ymax,
                x = this.height,
                b = this.width,
                M = new W(this.getBounds(), {
                  srs: _ ? "simple" : 4326
                });
              u >= 2 && ft({
                extentOfLayer: M
              });
              var w = _ ? M.height / x : this.pixelHeight,
                C = _ ? M.width / b : this.pixelWidth;
              u >= 2 && ft({
                pixelHeight: w,
                pixelWidth: C
              });
              var E = this.xMinOfLayer,
                S = this.xMaxOfLayer,
                A = this.yMinOfLayer,
                I = this.yMaxOfLayer,
                O = this._tileCoordsToBounds(a);
              u >= 2 && ft({
                boundsOfTile: O
              });
              var j = d.code;
              u >= 2 && ft({
                code: j
              });
              var N = new W(O, {
                srs: _ ? "simple" : 4326
              });
              u >= 2 && ft({
                extentOfTile: N
              }), u >= 4 && (this._cache.tile[f] || (this._cache.tile[f] = n.rectangle(N.leafletBounds, {
                fillOpacity: 0
              }).addTo(this.getMap()).bindTooltip(f, {
                direction: "center",
                permanent: !0
              })));
              var G = _ ? N : N.reproj(j);
              u >= 2 && ft({
                extentOfTileInMapCRS: G
              });
              var D = G.crop(_ ? M : this.extent);
              if (u >= 2 && console.log("[georaster-layer-for-leaflet] extentOfInnerTileInMapCRS", D.reproj(_ ? "simple" : 4326)), u >= 2 && ft({
                coords: a,
                extentOfInnerTileInMapCRS: D,
                extent: this.extent
              }), u >= 4 && !this._cache.innerTile[f]) {
                var R = _ ? D : D.reproj(4326);
                this._cache.innerTile[f] = n.rectangle(R.leafletBounds, {
                  color: "#F00",
                  dashArray: "5, 10",
                  fillOpacity: 0
                }).addTo(this.getMap());
              }
              var L = G.width / this.tileWidth,
                P = G.height / this.tileHeight;
              u >= 3 && ft({
                heightOfScreenPixelInMapCRS: P,
                widthOfScreenPixelInMapCRS: L
              });
              var T = _ ? D : D.reproj(this.projection),
                B = Y()({
                  bbox: T.bbox,
                  container: _ ? [M.xmin, M.ymin - .25 * w, M.xmax + .25 * C, M.ymax] : [y, m - .25 * w, g + .25 * C, v],
                  debug: u >= 2,
                  origin: _ ? [M.xmin, M.ymax] : [y, v],
                  scale: [C, -w]
                }),
                Q = new W(B.bbox_in_coordinate_system, {
                  srs: _ ? "simple" : this.projection
                }),
                F = B.bbox_in_grid_cells,
                q = Math.abs(F[2] - F[0]),
                U = Math.abs(F[3] - F[1]),
                z = Math.ceil(T.width / C),
                H = Math.ceil(T.height / w),
                Z = this.options.resolution,
                X = _ ? M : this.extent,
                J = T.crop(X),
                V = 1,
                K = 1;
              if (null !== J) {
                var $ = (_ ? J : J.reproj(j)).crop(G);
                null !== $ && (V = Math.ceil(Z * ($.width / G.width)), K = Math.ceil(Z * ($.height / G.height)));
              }
              var tt = z < V,
                et = H < K,
                nt = tt ? q : V,
                at = et ? U : K;
              u >= 3 && console.log("[georaster-layer-for-leaflet] extent of inner tile before snapping " + D.reproj(_ ? "simple" : 4326).bbox.toString());
              var lt = new W(T.bbox),
                ht = new W(Q.bbox),
                ut = new W(D.bbox);
              if (0 !== lt.width && 0 !== lt.height) {
                var ct = (ht.xmin - lt.xmin) / lt.width * ut.width,
                  pt = (ht.ymin - lt.ymin) / lt.height * ut.height,
                  yt = (ht.xmax - lt.xmax) / lt.width * ut.width,
                  gt = (ht.ymax - lt.ymax) / lt.height * ut.height;
                tt || (ct = Math.max(ct, 0), yt = Math.min(yt, 0)), et || (pt = Math.max(pt, 0), gt = Math.min(gt, 0));
                var mt = [ut.xmin + ct, ut.ymin + pt, ut.xmax + yt, ut.ymax + gt];
                D = new W(mt, {
                  srs: D.srs
                });
              }
              if (u >= 4 && !this._cache.innerTile[f]) {
                var vt = _ ? D : D.reproj(4326);
                this._cache.innerTile[f] = n.rectangle(vt.leafletBounds, {
                  color: "#F00",
                  dashArray: "5, 10",
                  fillOpacity: 0
                }).addTo(this.getMap());
              }
              u >= 3 && console.log("[georaster-layer-for-leaflet] extent of inner tile after snapping " + D.reproj(_ ? "simple" : 4326).bbox.toString());
              var xt = {
                left: Math.round((D.xmin - G.xmin) / L),
                right: Math.round((G.xmax - D.xmax) / L),
                top: Math.round((G.ymax - D.ymax) / P),
                bottom: Math.round((D.ymin - G.ymin) / P)
              };
              u >= 3 && ft({
                padding: xt
              });
              var bt = this.tileHeight - xt.top - xt.bottom,
                kt = this.tileWidth - xt.left - xt.right;
              if (u >= 3 && ft({
                innerTileHeight: bt,
                innerTileWidth: kt
              }), u >= 4) {
                var Mt = G.xmin + xt.left * L,
                  wt = G.ymin + xt.bottom * P,
                  Ct = G.xmax - xt.right * L,
                  Et = G.ymax - xt.top * P;
                ft({
                  xMinOfInnerTileInMapCRS: Mt,
                  yMinOfInnerTileInMapCRS: wt,
                  xMaxOfInnerTileInMapCRS: Ct,
                  yMaxOfInnerTileInMapCRS: Et
                });
              }
              var St = {
                  left: Math.max(xt.left, 0),
                  right: Math.max(xt.right, 0),
                  top: Math.max(xt.top, 0),
                  bottom: Math.max(xt.bottom, 0)
                },
                At = this.tileHeight - St.top - St.bottom,
                It = this.tileWidth - St.left - St.right;
              r.style.paddingTop = St.top + "px", r.style.paddingRight = St.right + "px", r.style.paddingBottom = St.bottom + "px", r.style.paddingLeft = St.left + "px", r.height = At, r.style.height = At + "px", r.width = It, r.style.width = It + "px", u >= 3 && console.log("setting tile height to " + At + "px"), u >= 3 && console.log("setting tile width to " + It + "px");
              var Ot = bt / at,
                jt = Math.ceil(Ot),
                Nt = kt / nt,
                Gt = Math.ceil(Nt),
                Dt = this.getMap(),
                Rt = this.getTileSize(),
                Lt = a.scaleBy(Rt);
              u >= 4 && ft({
                tileNwPoint: Lt
              });
              var Pt = Lt.x + xt.left,
                Tt = Lt.y + xt.top,
                Bt = {
                  x: Pt,
                  y: Tt
                };
              return u >= 4 && ft({
                innerTileTopLeftPoint: Bt
              }), setTimeout(it(rt().mark(function t() {
                var a, h, u, f, d, g, m, M, O, j, N, G, R, L;
                return rt().wrap(function (t) {
                  for (;;) {
                    switch (t.prev = t.next) {
                      case 0:
                        if (t.prev = 0, a = null, p) {
                          t.next = 7;
                          break;
                        }
                        return t.next = 5, e.getRasters({
                          innerTileTopLeftPoint: Bt,
                          heightOfSampleInScreenPixels: Ot,
                          widthOfSampleInScreenPixels: Nt,
                          zoom: c,
                          pixelHeight: w,
                          pixelWidth: C,
                          numberOfSamplesAcross: nt,
                          numberOfSamplesDown: at,
                          ymax: v,
                          xmin: y
                        });
                      case 5:
                        if ((a = t.sent) && e.calcStats) {
                          for (h = e.noDataValue, u = 0; u < a.length; u++) {
                            for (f = e.currentStats.mins[u], d = e.currentStats.maxs[u], g = a[u], m = 0; m < g.length; m++) {
                              for (M = g[m], O = 0; O < M.length; O++) {
                                (j = M[O]) !== h && ((void 0 === f || j < f) && (f = j), (void 0 === d || j > d) && (d = j));
                              }
                            }
                            e.currentStats.mins[u] = f, e.currentStats.maxs[u] = d, e.currentStats.ranges[u] = d - f;
                          }
                          if (e._dynamic) try {
                            N = k.default || k, e.rawToRgb = N({
                              format: "string",
                              flip: 1 === e.currentStats.mins.length,
                              ranges: _t(e.currentStats.mins, e.currentStats.maxs),
                              round: !0
                            });
                          } catch (t) {
                            console.error(t);
                          }
                        }
                      case 7:
                        return t.next = 9, e.checkIfYCbCr;
                      case 9:
                        G = function G(t) {
                          var r = Tt + (t + .5) * Ot,
                            s = n.point(Pt, r),
                            l = Dt.unproject(s, c).lat;
                          if (l > A && l < I) {
                            var h = function () {
                              var s = Math.round(t * Ot) + Math.min(xt.top, 0),
                                h = 0;
                              (_ || e.projection === st) && (h = Math.floor((I - l) / w));
                              for (var u = function u(_u2) {
                                  var f = n.point(Pt + (_u2 + .5) * Nt, r),
                                    d = Dt.unproject(f, c).lng;
                                  if (d > E && d < S) {
                                    var g = 0;
                                    if (_ || e.projection === st) g = Math.floor((d - E) / C);else if (e.getProjector()) {
                                      var m = e.getProjector().inverse({
                                          x: d,
                                          y: l
                                        }),
                                        k = m.y;
                                      if ((h = Math.floor((v - k) / w)) < 0 || h >= x) return "continue";
                                      var M = m.x;
                                      if ((g = Math.floor((M - y) / C)) < 0 || g >= b) return "continue";
                                    }
                                    var A = null;
                                    if (a) A = a.map(function (e) {
                                      return e[t][_u2];
                                    });else {
                                      if (!p) return o && o(Error("no rasters are available for, so skipping value generation")), {
                                        v: {
                                          v: {
                                            v: void 0
                                          }
                                        }
                                      };
                                      A = p.map(function (t) {
                                        return t[h][g];
                                      });
                                    }
                                    var I = Math.round(_u2 * Nt) + Math.min(xt.left, 0),
                                      O = s,
                                      j = Gt,
                                      N = jt;
                                    if (e.options.customDrawFunction) e.options.customDrawFunction({
                                      values: A,
                                      context: i,
                                      x: I,
                                      y: O,
                                      width: j,
                                      height: N,
                                      rasterX: g,
                                      rasterY: h,
                                      sampleX: _u2,
                                      sampleY: t,
                                      sampledRaster: a
                                    });else {
                                      var G = e.getColor(A);
                                      G && i && (i.fillStyle = G, i.fillRect(I, O, j, N));
                                    }
                                  }
                                }, f = 0; f < nt; f++) {
                                var d = u(f);
                                if ("continue" !== d && "object" === ot(d)) return d.v;
                              }
                            }();
                            if ("object" === ot(h)) return h.v;
                          }
                        }, R = 0;
                      case 11:
                        if (!(R < at)) {
                          t.next = 18;
                          break;
                        }
                        if ("object" !== ot(L = G(R))) {
                          t.next = 15;
                          break;
                        }
                        return t.abrupt("return", L.v);
                      case 15:
                        R++, t.next = 11;
                        break;
                      case 18:
                        e.mask && (_ ? console.warn("[georaster-layer-for-leaflet] mask is not supported when using simple projection") : e.mask.then(function (t) {
                          l().maskCanvas({
                            canvas: r,
                            canvas_bbox: D.bbox,
                            canvas_srs: 3857,
                            mask: t,
                            mask_srs: e.mask_srs,
                            strategy: e.mask_strategy
                          });
                        })), r.style.visibility = "visible", t.next = 26;
                        break;
                      case 22:
                        t.prev = 22, t.t0 = t.catch(0), console.error(t.t0), s = t.t0;
                      case 26:
                        o && o(s, r);
                      case 27:
                      case "end":
                        return t.stop();
                    }
                  }
                }, t, null, [[0, 22]]);
              })), 0), r;
            } catch (s) {
              console.error(s), o && o(s, r);
            }
          },
          _initTile: function _initTile(t) {
            n.DomUtil.addClass(t, "leaflet-tile"), t.onselectstart = n.Util.falseFn, t.onmousemove = n.Util.falseFn, n.Browser.ielt9 && this.options.opacity < 1 && n.DomUtil.setOpacity(t, this.options.opacity), n.Browser.android && !n.Browser.android23 && (t.style.WebkitBackfaceVisibility = "hidden");
          },
          getBounds: function getBounds() {
            return this.initBounds(), this._bounds;
          },
          getMap: function getMap() {
            return this._map || this._mapToAdd;
          },
          getMapCRS: function getMapCRS() {
            var t;
            return (null === (t = this.getMap()) || void 0 === t ? void 0 : t.options.crs) || n.CRS.EPSG3857;
          },
          _tileCoordsToNwSe: function _tileCoordsToNwSe(t) {
            var e = this.getMap(),
              n = this.getTileSize(),
              r = t.scaleBy(n),
              a = r.add(n);
            return [e.unproject(r, t.z), e.unproject(a, t.z)];
          },
          _tileCoordsToBounds: function _tileCoordsToBounds(t) {
            var e = et(this._tileCoordsToNwSe(t), 2),
              r = e[0],
              a = e[1],
              i = new n.LatLngBounds(r, a);
            return this.options.noWrap || (i = this.getMap().options.crs.wrapLatLngBounds(i)), i;
          },
          _isValidTile: function _isValidTile(t) {
            var e = this.getMapCRS();
            if (!e.infinite) {
              var r = this._globalTileRange;
              if (!e.wrapLng && (t.x < r.min.x || t.x > r.max.x) || !e.wrapLat && (t.y < r.min.y || t.y > r.max.y)) return !1;
            }
            var a = this.getBounds();
            if (!a) return !0;
            var i = t.x,
              o = t.y,
              s = t.z,
              l = new W(a, {
                srs: 4326
              }),
              h = this._tileCoordsToBounds(t);
            if (l.overlaps(h)) return !0;
            if (dt(e)) return !1;
            var u = Math.pow(2, s),
              c = n.point(i - u, o);
            c.z = s;
            var f = this._tileCoordsToBounds(c);
            if (l.overlaps(f)) return !0;
            var d = n.point(i + u, o);
            d.z = s;
            var _ = this._tileCoordsToBounds(d);
            return !!l.overlaps(_);
          },
          getColor: function getColor(t) {
            var e = this;
            if (this.options.pixelValuesToColorFn) return this.options.pixelValuesToColorFn(t);
            var n = t.length,
              r = t.every(function (t) {
                return void 0 !== t && t !== e.noDataValue;
              });
            if (r) if (1 == n) {
              var a = t[0];
              if (this.palette) {
                var i = et(this.palette[a], 4),
                  o = i[0],
                  s = i[1],
                  l = i[2],
                  h = i[3];
                return "rgba(".concat(o, ",").concat(s, ",").concat(l, ",").concat(h / 255, ")");
              }
              if (this.georasters[0].mins) {
                var u = this.georasters[0],
                  c = u.mins,
                  f = u.ranges;
                return this.scale((t[0] - c[0]) / f[0]).hex();
              }
              if (this.currentStats.mins) {
                var d = this.currentStats.mins[0],
                  _ = this.currentStats.ranges[0];
                return this.scale((t[0] - d) / _).hex();
              }
            } else {
              if (2 === n) return "rgb(".concat(t[0], ",").concat(t[1], ",0)");
              if (3 === n) return "rgb(".concat(t[0], ",").concat(t[1], ",").concat(t[2], ")");
              if (4 === n) return "rgba(".concat(t[0], ",").concat(t[1], ",").concat(t[2], ",").concat(t[3] / 255, ")");
            }
          },
          updateColors: function updateColors(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                debugLevel: -1
              },
              r = n.debugLevel,
              a = void 0 === r ? -1 : r;
            if (!t) throw new Error("Missing pixelValuesToColorFn function");
            -1 === a && (a = this.debugLevel), a >= 1 && console.log("Start updating active tile pixel values"), this.options.pixelValuesToColorFn = t;
            var i = this.getActiveTiles();
            return i ? (a >= 1 && console.log("Active tiles fetched", i), i.forEach(function (t) {
              var n = t.coords,
                r = t.el;
              e.drawTile({
                tile: r,
                coords: n,
                context: r.getContext("2d")
              });
            }), a >= 1 && console.log("Finished updating active tile colours"), this) : (console.error("No active tiles available"), this);
          },
          getTiles: function getTiles() {
            return Object.values(this._tiles);
          },
          getActiveTiles: function getActiveTiles() {
            var t = this;
            return this.getTiles().filter(function (e) {
              return t._isValidTile(e.coords);
            });
          },
          isSupportedProjection: function isSupportedProjection() {
            if (void 0 === this._isSupportedProjection) {
              var t = this.projection;
              w()(t) || lt.has(t) || "function" == typeof A() && "EPSG:".concat(t) in A().defs || "function" == typeof proj4 && void 0 !== proj4.defs && "EPSG:".concat(t) in proj4.defs ? this._isSupportedProjection = !0 : this._isSupportedProjection = !1;
            }
            return this._isSupportedProjection;
          },
          getProjectionString: function getProjectionString(t) {
            return w()(t) ? E()(t) : "EPSG:".concat(t);
          },
          initBounds: function initBounds(t) {
            if (t || (t = this.options), !this._bounds) {
              var e = this.debugLevel,
                r = this.height,
                a = this.width,
                i = this.projection,
                o = this.xmin,
                s = this.xmax,
                l = this.ymin,
                h = this.ymax;
              if (dt(this.getMapCRS())) r === a ? this._bounds = n.latLngBounds([ct, [ht, ut]]) : r > a ? this._bounds = n.latLngBounds([ct, [ht, ut / this.ratio]]) : a > r && (this._bounds = n.latLngBounds([ct, [ht * this.ratio, ut]]));else if (i === st) {
                e >= 1 && console.log("georaster projection is in ".concat(st));
                var u = n.latLng(l, o),
                  c = n.latLng(h, s);
                this._bounds = n.latLngBounds(u, c);
              } else {
                if (!this.getProjector()) throw "function" != typeof A() ? "You are using the lite version of georaster-layer-for-leaflet, which does not support rasters with the projection ".concat(i, ".  Please try using the default build or add the projection definition to your global proj4.") : "GeoRasterLayer does not provide built-in support for rasters with the projection ".concat(i, ".  Add the projection definition to your global proj4.");
                e >= 1 && console.log("projection is UTM or supported by proj4");
                var f = this.getProjector().forward({
                    x: o,
                    y: l
                  }),
                  d = n.latLng(f.y, f.x),
                  _ = this.getProjector().forward({
                    x: s,
                    y: h
                  }),
                  p = n.latLng(_.y, _.x);
                this._bounds = n.latLngBounds(d, p);
              }
              this.xMinOfLayer = this._bounds.getWest(), this.xMaxOfLayer = this._bounds.getEast(), this.yMaxOfLayer = this._bounds.getNorth(), this.yMinOfLayer = this._bounds.getSouth(), t.bounds = this._bounds;
            }
          },
          getProjector: function getProjector() {
            if (this.isSupportedProjection()) {
              if (!A() && !proj4) throw "proj4 must be found in the global scope in order to load a raster that uses this projection";
              if (!this._projector) {
                var t,
                  e = this.getProjectionString(this.projection);
                if (this.debugLevel >= 1 && ft({
                  projString: e
                }), e.startsWith("EPSG")) {
                  if ("function" == typeof proj4 && "function" == typeof proj4.defs && e in proj4.defs) t = proj4;else {
                    if ("function" != typeof A() || "function" != typeof A().defs || !(e in A().defs)) throw "[georaster-layer-for-leaflet] projection not found in proj4 instance";
                    t = A();
                  }
                } else if ("function" == typeof proj4) t = proj4;else {
                  if ("function" != typeof A()) throw "[georaster-layer-for-leaflet] projection not found in proj4 instance";
                  t = A();
                }
                this._projector = t(e, "EPSG:".concat(st)), this.debugLevel >= 1 && console.log("projector set");
              }
              return this._projector;
            }
          },
          same: function same(t, e) {
            return 1 === new Set(t.map(function (t) {
              return t[e];
            })).size;
          }
        });
      "object" === ("undefined" == typeof window ? "undefined" : ot(window)) && (window.GeoRasterLayer = pt), "undefined" != typeof self && (self.GeoRasterLayer = pt);
      var yt = pt;
    }(), a.default;
  }();
});